<template>
  <div class="acitvityAll" :style="{
    padding: activeName == 'firstNew' ? '16px 0' : '16px',
  }">
    <!-- <div class="backBox" style="border-bottom: 0"> -->
      <!-- <jd-button type="blue" :styleTextObj="{width:'44px',height: '24px','line-height': '24px',padding: '0 8px','min-width': '44px'}" @click="toSetting()">返回</jd-button>
      <span class="backBox_name">数据统计</span> -->
      <div :style="{
        padding: activeName == 'firstNew' ? '0 16px' : '',
      }">
        <jd-back
          @back="toSetting()"
          :title="['活动管理']"
          subTitle="数据统计"
        ></jd-back>
      </div>
    <!-- </div> -->
    <div class="actName" :class="activeName == 'firstNew' ? 'pl16' : ''">
      <img
        class="actName_img"
        src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/icon_lw.png"
        style="margin-right: 20px"
        alt=""
      />
      <div class="actName_info">
        <span>活动名称：{{ rowData.activityName }}</span>
        <div v-if="fitersChooseIF([35], '!=')">
          活动时间：{{ rowData.startTime }} 至 {{ rowData.endTime }}
        </div>
        <template v-else-if="rowData.ruleDto">
          <div>
            确权时间：{{ rowData.ruleDto.lockStartTime }} 至
            {{ rowData.ruleDto.lockEndTime }}
          </div>
          <div>
            下单时间：{{ rowData.ruleDto.orderStartTime }} 至
            {{ rowData.ruleDto.orderEndTime }}
          </div>
          <div>
            确认收货时间：{{ rowData.ruleDto.finishStartTime }} 至
            {{ rowData.ruleDto.finishEndTime }}
          </div>
        </template>
        <div>活动类型：{{rowData.activityType==45 ? '锁权有礼'  : rowData.activityTypeStr }}</div>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="formSty" :class="activeName == 'firstNew' ? 'firstNewTab' : ''">
      <el-tab-pane label="活动统计（云起)" name="firstNew" v-if="isShowYunqi&&rowData.activityType!=89">
        <statistics-yunqi :rowData="rowData"></statistics-yunqi>
      </el-tab-pane>
      <!-- 1已改 -->
      <el-tab-pane label="活动统计（京东)" name="first">
        <div class="section-right-content-box">
          <jd-tip>
            <div>
              2024-11-12(含)之后创建的互动活动以新的数据展示方式呈现，2024-11-12之前创建的活动不可用新版数据内容，可点击
              返回旧版/新版 进行切换
            </div>
            <div>数据均为为京东官方返回数据，活动数据 更新方式为 T+1</div>
            <div>
              部分数据统计维度为零的情况，可能是因为该活动类型无相关数据或无需这些数据统计维度。
            </div>
          </jd-tip>
          <div style="margin: 16px 0">
            <jd-form
              :form-info="myFormInfo"
              :formData.sync="queryForm"
              @search="querySeach"
              :emitReset="true"
              :btn30="true"
              ref="statiscFormRef"
              @reset="queryOne"
            >
              <template #evaluateTime>
                <div class="flex-box">
                  <jd-radio
                    :recentList="options.evaluateTimeOpt"
                    :defaultIndex="defaultIndex"
                    @change="timeChange"
                  />
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="postForm.startDate"
                      type="date"
                      :placeholder="'选择日期时间'"
                      size="small"
                      :disabled="
                        queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                      "
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 120px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                    ></el-date-picker>
                    <div
                      class="time_to_text"
                      :class="{
                        to_text_disabled:
                          queryForm.evaluateTime != 0 ||
                          !queryForm.evaluateTime,
                      }"
                    >
                      至
                    </div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="postForm.endDate"
                      type="date"
                      :placeholder="'选择日期时间'"
                      size="small"
                      :disabled="
                        queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                      "
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 145px; font-size: 12px"
                      class="time2"
                      :clearable="true"
                    ></el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      @click="clearTimeSendTime()"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt
                      class="date_icon2"
                    />
                  </div>
                </div>
              </template>
              <template #deliveryChannelCustomize>
                <el-select
                    size="small"
                    v-model="postForm.channelCode"
                    style="width: 290px"
                  >
                    <el-option
                      v-for="(item, index) in batchTypeList"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
              </template>
            </jd-form>
          </div>
          <div class="flex-end mb12">
            <div v-if="fitersChooseIF([35])">
              <jd-button type="text" @click="export_get" v-preventReClick>
                导出</jd-button
              >
            </div>

            <!-- 打榜有礼导出功能 -->
            <!-- <div v-if="fitersChooseIF([36])">
              <jd-button type="text" @click="export_get">导出</jd-button>
            </div> -->
            <!-- 派样回购礼导出功能 -->
            <div v-if="fitersChooseIF([37])">
              <jd-button type="text" @click="export_get">导出</jd-button>
            </div>
            <!-- 除了一些特殊活动外, 其他活动的数据统计-导出 -->
            <div
              v-if="fitersChooseIF([37, 35, 39], '!=')"
              class="export-style"
            >
              <el-dropdown @command="exportRule($event)">
                <jd-button type="text"
                  >导出 <i class="el-icon-arrow-down ml-5"></i
                ></jd-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="setting" v-if="fitersChooseIF([52],'!=')" 
                    >导出字段设置</el-dropdown-item
                  >
                  <el-dropdown-item command="exportAll"
                    >导出数据（全部）</el-dropdown-item
                  >
                  <el-dropdown-item command="exportSetting" v-if="fitersChooseIF([52],'!=')" 
                    >导出数据（按设置）</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="data-title-wrap">
            <jd-title label="转化分析"></jd-title>
            <jd-button type="blueText" class="back_text" @click="triggerVersion">返回旧版</jd-button>
          </div>
          <!-- 下单转化 -->
          <div
            v-if="fitersChooseIF([35])"
            style="font-size: 12px; margin-bottom: 4px; color: #999"
          >
            * 该数据不区分渠道
          </div>
          <div class="titClass" v-if="fitersChooseIF([25, 26, 32, 33], '!=')">
            <div class="down">
              下单转化
              <el-popover
                placement="top-start"
                width="400"
                offset="100"
                trigger="hover"
                data-html="true"
              >
                <span>转化分析数据说明：</span><br />
                <span>统计参与活动的用户，在京东店铺的订单转化情况</span><br />
                <span> 1、人群:参与活动的用户。</span><br />
                <span>
                  2、时间:活动开始至T+1
                  (昨日)的累计成交数据，每天中午12:30后更新。</span
                ><br />
                <span>
                  3、订单维度:已付款的在线支付订单或者选择货到付款的订单。</span
                ><br />
                <span>
                  4、备注:活动结束后15天内的数据都可以统计，超过15天的数据将无法统计。</span
                ><br />
                <span>
                  与数据总览-下单数据不同，下单数据为满足活动的解锁订单或冲榜类活动的累计订单</span
                ><br />
                <span class="new-icon-box" slot="reference"></span>
                <!-- <span style="float: right" slot="reference">
                  <p class="question_iconOne">?</p>
                </span> -->
              </el-popover>
            </div>
            <div class="borderU"></div>
            <div
              class="titClassOne"
              v-for="(v, index) in hostList"
              :key="index"
            >
              <div style="color: #333333; font-size: 14px">
                {{ v.name }}
              </div>
              <div style="color: #1f1f1f; font-size: 18px; font-weight: 600">
                {{
                  index == 0
                    ? tatal_num.users
                    : index == 1
                    ? tatal_num.ordNum
                    : index == 2
                    ? tatal_num.gmv
                    : (tatal_num.ordRate * 100).toFixed(2)
                }}
                <span style="color: #999999; font-size: 14px; font-weight: 400">
                  {{
                    index == 0
                      ? "人"
                      : index == 1
                      ? "单"
                      : index == 2
                      ? "元"
                      : "%"
                  }}
                </span>
              </div>
            </div>
          </div>
          <jd-title label="数据总览"></jd-title>
          <div class="switch" v-if="fitersChooseIF([52],'!=')">
            <el-tabs v-model="switchIndex" class="switch-tabs">
              <el-tab-pane label="互动参与" name="1"></el-tab-pane>
              <el-tab-pane label="浏览店铺" name="2"></el-tab-pane>
              <el-tab-pane label="浏览商品" name="3"></el-tab-pane>
              <el-tab-pane label="下单" name="4"></el-tab-pane>
              <el-tab-pane label="入会" name="5"></el-tab-pane>
              <el-tab-pane label="中奖" name="6"></el-tab-pane>
            </el-tabs>
          </div>
          <div v-if="fitersChooseIF([52],'!=')" style="position: relative; min-height: 100px;">
            <div v-if="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 10; background: #fff; display: flex; align-items: center; justify-content: center;">
              <jd-loading-new v-if="loading"/> 
            </div>
            <div
              v-else
              class="overview1"
              style="float: left"
              v-for="(item, index) in dataSummary"
              :key="index + item.value"
            >
              <div>
                <span class="fontClass">{{ item.name }}</span>
                <el-popover
                  v-if="item.tipsName"
                  placement="top-start"
                  offset="100"
                  trigger="hover"
                  :content="item.tipsName"
                >
                  <span
                    class="new-icon-box"
                    style="margin-left: 5px"
                    slot="reference"
                  ></span>
                </el-popover>
              </div>
              <div class="num">
                {{ tableTotal[item.value]
                }}{{
                  fitersChooseIF([25, 26, 32, 33]) &&
                  (item.value == "orderRate" ||
                    item.value == "cartRate" ||
                    item.value == "clickRate" ||
                    item.value == "payOrderRate" ||
                    item.value == "visitUsrPayOrderRate")
                    ? "%"
                    : ""
                }}{{
                  fitersChooseIF([37]) &&
                  (item.value == "enterReBuyRate" ||
                    item.value == "orderReBuyRate")
                    ? "%"
                    : ""
                }}
              </div>
            </div>
          </div>
          <!-- 试样回购礼-活动统计(单独展示) -->
          <div v-if="fitersChooseIF([52])" style="position: relative; min-height: 100px;">
            <div v-if="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 10; background: #fff; display: flex; align-items: center; justify-content: center;">
              <jd-loading-new v-if="loading" />
            </div>
            <div
              v-else
              class="overview1"
              style="float: left"
              v-for="(item, index) in trialRebuySummary"
              :key="index + item.value"
            >
              <div>
                <span class="fontClass">{{ item.name }}</span>
                <el-popover
                  v-if="item.tipsName"
                  placement="top-start"
                  offset="100"
                  trigger="hover"
                  :content="item.tipsName"
                >
                <span class="new-icon-box" style="margin-left: 5px;" slot="reference"></span>
                </el-popover>
              </div>
              <div class="num">
                {{ tableTotal[item.value] }}
              </div>
            </div>
          </div>
          <!-- 折线图 -->
          <div style="clear: left; position: relative;">
            <div v-if="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 10; background: #fff; display: flex; align-items: center; justify-content: center;">
              <jd-loading-new v-if="loading" />
            </div>
            <div
              ref="payRemindChart"
              class="chart"
            ></div>
          </div>
          <div style="margin-top: 30px">
            <div v-if="fitersChooseIF([52])" class="flex-end mb12 mt16">
              <jd-button @click="export_static" type="text" v-preventReClick
                >导出</jd-button
              >
            </div>
            <!-- <div v-if="fitersChooseIF([52])" class="flex-end mb12 mt16">
              <jd-button @click="export_static" type="text" v-preventReClick
                >导出</jd-button
              >
            </div> -->
            <div v-if="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 10; background: #fff; display: flex; align-items: center; justify-content: center;">
              <jd-loading-new v-if="loading" />
            </div>
            <jd-table
              v-else
              :tableInfo="chartEffectDetailInfo"
              :tableData="chartEffectDetail"
              :pageInfo="{
                pageNum: formList.current,
                pageSize: formList.size,
                total: totalNum,
              }"
              @handlePage="handlePage"
            >
            </jd-table>
          </div>
          <!-- <div class="new-pagination-page" style="margin-top: 16px">
            <el-pagination
              style="text-align: right;"
              @size-change="handleSizeChange"
              background
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="formList.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              :current-page="formList.current"
            ></el-pagination>

          </div> -->
        </div>
      </el-tab-pane>

      <el-tab-pane label="晒图记录" name="photoContestRecord" v-if="fitersChooseIF([83])">
        <photoContestRecord           
          v-if="activeName == 'photoContestRecord'"
          ref="photoContestRecordRef"
          :activityId="rowData.id"
          :sellerLinkList="sellerLinkList">
        </photoContestRecord>
      </el-tab-pane>
      <!-- 派样付款列表 -->
      <!-- 2已改 -->
      <!-- v-if="fitersChooseIF([37])" -->
      <el-tab-pane
        label="派样付款列表"
        name="sendReBuyPay"
        v-if="fitersChooseIF([37])"
      >
        <!-- <input-form
          :inputData="inputSendBuyPay"
          @toParentVal="searchSendBuyPay"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form> -->
        <jd-form :form-info="inputSendBuyPay" @search="searchSendBuyPay" />
        <div class="flex-end mb12 mt16">
          <jd-button @click="export_get" type="text" v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :loading="loading"
          :tableData="sendBuyPayTable"
          :pageInfo="{
            pageSize: formList.size,
            pageNum: formList.current,
            total: totalSendBuyPayCount,
          }"
          @handlePage="handleBuyPayPage"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.sellerLinkName || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shopNameDetail" label="商品信息">
            <template slot-scope="scope">
              <div>{{ scope.row.skuName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :width="item.width ? item.width : '160'"
            :key="index"
            v-for="(item, index) in sendBuyList"
          >
          </el-table-column>
          <el-table-column prop="isCommitAddress" label="是否录入收货信息">
            <template slot-scope="scope">
              <div>{{ scope.row.isCommitAddressStr }}</div>
            </template>
          </el-table-column>
        </jd-table>
        <!-- <el-pagination
          style="text-align: right;"
          @size-change="handleSizeSendBuyPay"
          background
          @current-change="handleCurrentSendBuyPay"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSendBuyPayCount"
          :current-page="formList.current"
        ></el-pagination> -->
      </el-tab-pane>
      <!-- 2已改 -->
      <!-- 回购付款列表 -->
      <!-- v-if="fitersChooseIF([37])" -->
      <el-tab-pane
        label="回购付款列表"
        name="sendReBuyRePay"
        v-if="fitersChooseIF([37])"
      >
        <!-- <input-form
          :inputData="inputSendBuyRePay"
          @toParentVal="searchSendBuyRePay"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form> -->
        <jd-form :form-info="inputSendBuyRePay" @search="searchSendBuyRePay" />
        <div class="flex-end mb12 mt16">
          <jd-button @click="export_get" type="text" v-preventReClick
            >导出</jd-button
          >
        </div>

        <jd-table
          :loading="loading"
          :tableData="sendBuyRePayTable"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalSendBuyRePayCount,
          }"
          @handlePage="handleBuyRePayPage"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          <el-table-column
            prop="orderPayment"
            label="商品金额"
          ></el-table-column>
          <el-table-column prop="shopNameDetail" label="商品信息">
            <template slot-scope="scope">
              <div>{{ scope.row.skuName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :width="item.width ? item.width : '160'"
            :key="index"
            v-for="(item, index) in sendReBuyList"
          >
          </el-table-column>
          <el-table-column prop="isCommitAddress" label="是否录入收货信息">
            <template slot-scope="scope">
              <div>{{ scope.row.isCommitAddressStr }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="isWin" label="是否中奖">
            <template slot-scope="scope">
              <div>{{ scope.row.isWin == 1 ? "是" : "否" }}</div>
            </template>
          </el-table-column>
        </jd-table>
        <!-- <el-pagination
          style="text-align: right;"
          @size-change="handleSizeSendBuyRePay"
          background
          @current-change="handleCurrentSendBuyRePay"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSendBuyRePayCount"
          :current-page="formList.current"
        ></el-pagination> -->
      </el-tab-pane>
      <!-- 1已改 -->
      <!-- 调查问卷-问卷调查记录 -->
      <el-tab-pane
        label="问卷调查记录"
        name="questionnaire"
        v-if="fitersChooseIF([47])"
      >
        <questionnaireRecords
          v-if="activeName == 'questionnaire'"
          ref="questionnaireRecordsRef"
          :activityId="rowData.id"
          :sellerLinkList="sellerLinkList"
        />
      </el-tab-pane>
      <!-- 1已改 -->
      <!-- 积分锁权-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="lockJoinRecord"
        v-if="fitersChooseIF([45])"
      >
        <jd-form
          :form-info="inputParticipatLockInfo"
          @search="searchParticipationLockForm"
          class="mb16"
        >
        </jd-form>
        <div class="flex-spc-x mb12">
          <jd-button @click="addCrowd(26)">按查询结果生成人群</jd-button>
          <jd-button type="text" @click="exportFn" v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :loading="loading"
          :pageInfo="{
            pageNum: formListLock.current,
            pageSize: formListLock.size,
            total: totalParticipatLock,
          }"
          :tableData="ParticipatLockTable"
          @handlePage="handlePageParticipatLock"
        >
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column
            prop="sellerLinkName"
            label="投放渠道"
          ></el-table-column>
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="chaosPin" label="锁权类型" width="150">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.lockType == 0
                    ? "积分锁权"
                    : scope.row.lockType == 1
                    ? "N元锁权"
                    : "-"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="chaosPin" label="锁权条件" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.lockType == 0">
                积分：{{ scope.row.point }}
              </div>
              <jd-button type="blueText" v-else-if="scope.row.lockType == 1" @click="handleCheckOrderDetail(scope.row,1)">订单详情</jd-button>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="参与时间">
          </el-table-column>
          <el-table-column prop="isPass" label="是否符合中奖条件">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isPass == 1
                    ? "符合"
                    : scope.row.isPass == 0
                    ? "不符合"
                    : "-"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="buyMoney" label="订单金额"> </el-table-column>
          <el-table-column prop="itemTotal" label="商品件数"> </el-table-column>
          <el-table-column prop="isWin" label="是否领取奖品">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isWin == 1
                    ? "已领取"
                    : scope.row.isWin == 0
                    ? "未领取"
                    : "-"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="winTime" label="领奖时间"> </el-table-column>
        </jd-table>
      </el-tab-pane>

      <!-- 试用复购-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="lockJoinRecordTrial"
        v-if="fitersChooseIF([52])"
      >
        <jd-form
          class="mb16"
          :form-info="inputParticipatLockTrial"
          @search="searchParticipationLockFormTrial"
          ref="participatLockTrialRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(37)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportFnTrial"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="ParticipatLockTableTrial"
            :pageInfo="{
              pageNum: formListLockTrial.current,
              pageSize: formListLockTrial.size,
              total: totalParticipatLockTrial,
            }"
            @handlePage="handleCurrentParticipatLockTri"
          >
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"   width="150">
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="firstOrderTime" label="首次满足订单时间">
              <template slot="header" slot-scope="scope">
                  <div>
                    满足试用礼订单时间
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="进入活动的用户满足试用礼订单的时间（订单已确认收货）；"
                      placement="top-start"
                    >
                      <div class="new-icon-box" style="margin: -3px 2px"></div>
                    </el-tooltip>
                  </div>
                </template>
             </el-table-column>
            <el-table-column prop="orderAmount" label="参与订单总金额"> </el-table-column>
            <el-table-column prop="isWin" label="参与订单">
              <template slot-scope="scope">
                <jd-button
                   type="blueText"
                   style="margin-bottom: 16px;color:#3159ff"
                   @click="trialDetail(scope.row.orderDetails)"
                  >详情</jd-button>
              </template>
            </el-table-column>
            <el-table-column prop="isPass" label="是否获得试用礼">
              <template slot="header" slot-scope="scope">
                  <div>
                    是否获得试用礼
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                    >
                    <div slot="content"> 
                       <div>若情况为否时，存在两种情况：</div>
                       <div>情况1：奖品库存充足，用户未领取奖励</div>
                       <div>情况2：奖品库存不足，无法领奖</div>
                    </div>
                      <div class="new-icon-box" style="margin: -3px 2px"></div>
                    </el-tooltip>
                  </div>
                </template>
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.trialGiftStatus == 1
                      ? "是"
                      : scope.row.trialGiftStatus == 0
                      ? "否"
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="isPass" label="是否获得正装礼">
              <template slot="header" slot-scope="scope">
                  <div>
                    是否获得正装礼
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                    >
                    <div slot="content"> 
                       <div>若情况为否时，存在两种情况：</div>
                       <div>情况1：奖品库存充足，用户未领取奖励</div>
                       <div>情况2：奖品库存不足，无法领奖</div>
                    </div>
                      <div class="new-icon-box" style="margin: -3px 2px"></div>
                    </el-tooltip>
                  </div>
                </template>
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.testGiftStatus == 1
                      ? "是"
                      : scope.row.testGiftStatus == 0
                      ? "否"
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 打包一口价参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="lockJoinRecordFixedPrice"
        v-if="fitersChooseIF([78])"
      >
        <jd-form
          class="mb16"
          :form-info="inputParticipatLockFixedPrice"
          @search="searchParticipationLockFormFixedPrice"
          ref="participatLockFixedPriceRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(6)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportFnFixedPrice"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="ParticipatLockTableFixedPrice"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: totalParticipatLockFixedPrice,
            }"
            @handlePage="handleCurrentParticipatLockFixedPrice"
          >
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"   width="150">
            </el-table-column>
            <el-table-column prop="joinTime" label="参与时间">
            </el-table-column>
            <el-table-column prop="couponReceived" label="是否领取优惠劵">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.couponReceived == 1
                      ? "是"
                      : scope.row.couponReceived == 0
                      ? "否"
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="goodsCount" label="商品数量"> </el-table-column>
            <el-table-column prop="cartAddCount" label="加购次数"> </el-table-column>
            <el-table-column prop="orderId" label="订单号">
                <template slot-scope="scope">
                  <div>{{ scope.row.orderId? scope.row.orderId : '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="orderTime" label="下单时间">
                <template slot-scope="scope">
                  <div>{{ scope.row.orderTime? scope.row.orderTime : '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="orderStateRemark" label="订单状态"> </el-table-column>
            <el-table-column prop="payTime" label="付款时间"> </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>


      <!-- TODO:粉丝瓜分 -->
      <el-tab-pane
        label="参与记录"
        name="lockJoinRecordFans"
        v-if="fitersChooseIF([65])"
      >
        <jd-form
          class="mb16"
          :form-info="inputParticipatLockFans"
          @search="searchParticipationLockFormFans"
          ref="participatLockFansRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(6)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportFans"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="ParticipatLockTableFans"
            :pageInfo="{
              pageNum: formListLockFans.current,
              pageSize: formListLockFans.size,
              total: totalParticipatLockFans,
            }"
            @handlePage="handleCurrentParticipatLockFans"
          >
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"   width="150">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="punchModeStr" label="打卡模式"> </el-table-column>
            <el-table-column prop="prizeTypeStr" label="奖品类型"> </el-table-column>
            <el-table-column prop="prizeName" label="奖品名称"> </el-table-column>
            <el-table-column prop="isWinStr" label="是否领取奖品"> </el-table-column>
            <el-table-column prop="createTime" label="参与时间"> </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- TODO:入会有礼 -->
      <el-tab-pane
        label="参与记录"
        name="lockJoinRecordGift"
        v-if="fitersChooseIF([66])"
      >
        <jd-form
          class="mb18"
          :form-info="inputParticipatLockGift"
          @search="searchParticipationLockFormGift"
          ref="participatLockGiftRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(6)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exporGift"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="ParticipatLockTableGift"
            :pageInfo="{
              pageNum: formListLockFans.current,
              pageSize: formListLockFans.size,
              total: totalParticipatLockGift,
            }"
            @handlePage="handleCurrentParticipatLockGift"
          >
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"   width="150">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="orderIdsStr" label="关联订单号"> </el-table-column>
            <el-table-column prop="isPassStr" label="是否符合中奖条件"> </el-table-column>
            <el-table-column prop="isWinStr" label="是否领取奖品"> </el-table-column>
            <el-table-column prop="createTime" label="参与时间"> </el-table-column>
            <el-table-column prop="firstJoinTime" label="首次入会时间"> </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 榜单实况 -->
      <el-tab-pane
        label="榜单实况"
        name="rankingUpdates"
        v-if="fitersChooseIF([67])"
      >
        <!-- 销售数据概览 -->
        <div style='background-color:#ccc;padding:40px'>
              <el-row>
               <el-col :span="2"><div class="grid-content bg-purple-light" style='margin-top:7px'>销售数据</div></el-col>
               <el-col :span="6"><div class="grid-content bg-purple-light">订单数量</div><div class="grid-content bg-purple">{{salesRankSummaryTable.orderTotalCount}}单</div></el-col>
               <el-col :span="6"><div class="grid-content bg-purple-light">订单金额</div><div class="grid-content bg-purple">{{salesRankSummaryTable.orderTotalAmount}}元</div></el-col>
               <el-col :span="6"><div class="grid-content bg-purple-light">商品件数</div><div class="grid-content bg-purple">{{salesRankSummaryTable.itemTotalCount}}件</div></el-col>
             </el-row>
        </div>  
    <div class="new-table-box">
      <div style="margin:10px 0 10px 0;text-align:right">
          <jd-button type="text" size="small" @click="exportRanksTable">导出</jd-button>
      </div>    
      <jd-table
        :tableData="ranksTable"
        style="width: 100%;margin-bottom: 20px;"
        border
        row-key="id"
        :default-expand-all="false"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
    <el-table-column
      prop="rank"
      label="榜单排名"
      width="180">
    </el-table-column>
    <el-table-column
      prop="rankName"
      label="榜单名称"
      width="180">
    </el-table-column>
    <el-table-column
      prop="ability"
      label="能力值">
    </el-table-column>
      <el-table-column
      prop="skuIdList"
      label="关联商品SKU"
      width="180">
      <template slot-scope="scope">
        {{ scope.row.skuIdList ? scope.row.skuIdList.join(', ') : '' }}
      </template>
    </el-table-column>
        <el-table-column
      prop="skuNameList"
      label="商品名称"
      width="180">
      <template slot-scope="scope">
        {{ scope.row.skuNameList ? scope.row.skuNameList.join(', ') : '' }}
      </template>
    </el-table-column>

     <el-table-column
      prop="orderAmount"
      label="订单金额"
      width="180">
    </el-table-column>
        <el-table-column
      prop="orderCount"
      label="订单数量"
      width="180">
    </el-table-column>
     <el-table-column
      prop="itemCount"
      label="商品件数"
      width="180">
     </el-table-column>
       </jd-table>
        </div>
      </el-tab-pane>

      <!-- TODO: 销售打榜参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="rankParticipation"
        v-if="fitersChooseIF([67])"
      >
        <jd-form
          class="mb16"
          :form-info="inputParticipatSalesRanking"
          @search="showOrderDetailsOne"
          ref="participatSalesRankingRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(6)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportRanks"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="rankingRecordsTable"
            :pageInfo="{
              pageNum: formListLockFans.current,
              pageSize: formListLockFans.size,
              total: totalRankingRecords,
            }"
            @handlePage="handleCurrentrank"
          >
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"   width="150">
            </el-table-column>
            <el-table-column prop="joinTime" label="参与时间"> </el-table-column>
            <el-table-column prop="orderAmount" label="订单金额"> </el-table-column>
            <el-table-column prop="orderCount" label="订单数量"> </el-table-column>
            <el-table-column prop="itemCount" label="商品件数"> </el-table-column>
            <!-- 销售打榜动态列处理 -->
            <el-table-column
                v-for="(item, index) in abilityVOList"
                :key="index"
                :label="item.rankName"
                :width="item.width ? item.width : '160'"
              >
                <template slot-scope="scope">
                  {{ scope.row.abilityValues[item.rankName].ability }}
                </template>
              </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 生命周期参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="lifeParticipationRecord"
        v-if="fitersChooseIF([68])"
      >
        <jd-form
          class="mb16"
          :form-info="inputParticipatSaleslife"
          @search="showOrderDetailsLife"
          ref="participatSalesLife"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(6)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportLifes"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="goodsRecordTableCardLife"
            :pageInfo="{
              pageNum: formListLockFans.current,
              pageSize: formListLockFans.size,
              total: totalLifeRecords,
            }"
            @handlePage="handleCurrentrank"
          >
            <el-table-column prop="memberNick" label="用户昵称"   width="150">
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
            </el-table-column>
            <el-table-column prop="joinTime" label="参与时间"> </el-table-column>
             <!-- 动态卡片列 -->
            <el-table-column
              v-for="card in uniqueCardNamesLife"
              :key="card.columnName"
              :label="card.columnName"
              :min-width="card.columnName != '付款时间'? '188px': '158px'"
              align="center"
            >
             <template slot-scope="scope">
              <span v-if="getRowstageName(scope.row,card.stageIndex).includes(card.columnName)">{{ getstageName(scope.row.stages,card.stageIndex, card.columnName) }}</span>
             </template>
           </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>


      <!-- 1.58参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="funGameRecord"
        v-if="fitersChooseIF([71])"
      >
        <jd-form
          class="mb16"
          :form-info="inputFunGameInfo"
          @search="inputFunGameSearch"
          ref="funGameRecordRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(51)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportFunGame"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="joinGameRecordTable"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: joinGameRecordTotal,
            }"
            @handlePage="handleCurrentJoinGameRecord"
          >
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称"   width="150">
            </el-table-column>
            <el-table-column prop="sellerLinkName" min-width="150" label="投放渠道">
            </el-table-column>
            <el-table-column prop="memberLevel" label="会员等级">
                <template slot-scope="scope">
                  <span>{{levelMap[scope.row.memberLevel] || ''}}</span>
               </template>
           </el-table-column>
            <el-table-column prop="totalGameCount" label="累计游戏次数">
               <template slot-scope="scope">
                   <jd-button type="blueText" @click="numbersGams(scope.row)">{{scope.row.totalGameCount}}</jd-button>
               </template>
            </el-table-column>
            <el-table-column prop="remainGameCount" label="剩余游戏次数"> </el-table-column>
            <el-table-column prop="firstJoinTime" label="首次参与时间"> </el-table-column>
            <el-table-column prop="latestJoinTime" label="最新参与时间"> </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 1.71购物车锦鲤 -->
      <el-tab-pane
        label="参与记录"
        name="cardRecord"
        v-if="fitersChooseIF([77])"
      >
        <jd-form
          class="mb16"
          :form-info="inputCardInfo"
          @search="inputCardSearch"
          ref="cardRecordRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(6)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportCardRecord"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="inputCardListTableChange"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: inputCardTotal,
            }"
            @handlePage="handleCurrentInputCardList"
          >
            <el-table-column prop="memberNick" label="用户昵称" width="150">
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
            </el-table-column>
            <el-table-column prop="joinTime" label="参与时间"> </el-table-column>
            <el-table-column prop="cartAddCount" label="加购商品数量"> </el-table-column>
            <el-table-column prop="unlockCount" label="解锁商品数量"> </el-table-column>
            <el-table-column prop="isPass" label="是否满足抽奖条件">
               <template slot-scope="scope">
                  <span>{{scope.row.isPass == 0?'否':'是'}}</span>
               </template>
            </el-table-column>
            <el-table-column prop="isEnter" label="是否预留地址">
               <template slot-scope="scope">
                  <span>{{scope.row.isEnter == 0?'否':'是'}}</span>
               </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 购物车锦鲤-邀请记录 -->
      <el-tab-pane
        label="邀请记录"
        name="cardInviteRecord"
        v-if="fitersChooseIF([77])"
      >
        <jd-form
          class="mb16"
          :form-info="inputCardInviteInfo"
          @search="inputCardInviteSearch"
          ref="cardInviteRecordRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button
            @click="addCrowd(53)"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"
            @click="exportCardInvite"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="cardInviteRecordTable"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: cardInviteRecordTotal,
            }"
            @handlePage="handleCurrentCardInviteRecord"
          >
            <el-table-column prop="inviteNick" label="用户名称" width="150">
            </el-table-column>
            <el-table-column :prop="inviteParams" :label="`用户${grayId}`" width="150">
            </el-table-column>
            <el-table-column prop="assistNick" label="被邀请用户名称" width="150">
            </el-table-column>
            <el-table-column :prop="assistChaos" :label="`被邀请用户${grayId}`" width="150">
            </el-table-column>
            <el-table-column prop="assistTime" label="助力时间">
            </el-table-column>
            <el-table-column prop="assistHasParticipated" label="被邀请用户是否参与活动">
              <template slot-scope="scope">
                <span>{{ scope.row.assistHasParticipated == 1 ? "是" : "否" }}</span>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 时光许愿池-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="wishingPoolRecord"
        v-if="fitersChooseIF([76])"
      >
        <wishingPoolRecord v-if="activeName == 'wishingPoolRecord'" :rowData="rowData" :inputWishingPoolInfo.sync="inputWishingPoolInfo"/>
      </el-tab-pane>

     <!-- 盖楼有礼-参与记录 -->
     <el-tab-pane
        label="参与记录"
        name="buildingGiftRecord"
        v-if="fitersChooseIF([79])"
      >
        <buildingGiftRecord v-if="activeName == 'buildingGiftRecord'" :rowData="rowData" :inputBuildingGiftInfo.sync="inputBuildingGiftInfo"/>
      </el-tab-pane>

      <!-- 定时开奖-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="openWinRecord"
        v-if="fitersChooseIF([48])"
      >
        <jd-form
          :form-info="inputOpenWinInfo"
          ref="openWinRecordRef"
          @search="searchParticipationOpenWinForm"
          class="mb16"
        >
        </jd-form>
        <div class="flex-spc-x mb12">
          <jd-button type="break" @click="addCrowd(29)"
            >按查询结果生成人群</jd-button
          >
          <jd-button type="text" @click="exportFn" v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :loading="loading"
          :pageInfo="{
            pageNum: formOpenWin.current,
            pageSize: formOpenWin.size,
            total: totalParticipatOpenWin,
          }"
          :tableData="ParticipatOpenWinTable"
          @handlePage="handlePageParticipatOpenWin"
        >
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column :prop="pinToXid" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="sellerLinkName" min-width="150" label="投放渠道">
          </el-table-column>
          <el-table-column prop="unlockPrizeType" label="解锁方式">
            <template slot-scope="scope">
              <span v-if="scope.row.unlockPrizeType == 0"
                >符合参与对象直接解锁</span
              >
              <span v-else-if="scope.row.unlockPrizeType == 1">下单解锁</span>
              <span v-else-if="scope.row.unlockPrizeType == 2"
                >完成任务解锁</span
              >
              <span v-else-if="scope.row.unlockPrizeType == 3">消耗积分</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="unlockOrderIdStr"
            label="关联订单"
          ></el-table-column>
          <el-table-column prop="luckValue" label="幸运值">
            <template slot-scope="scope">
              <jd-button
                type="blueText"
                v-if="scope.row.luckValue || scope.row.luckValue == 0"
                @click="goToLuckList(scope.row)"
                >{{ scope.row.luckValue }}</jd-button
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 会员等级 -->
          <el-table-column label="会员等级" min-width="120">
              <template slot-scope="scope">
                <span>{{levelMap[scope.row.level] || ''}}</span>
              </template>
            </el-table-column>
          <el-table-column prop="isPass" label="是否中奖">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isPass == 1
                    ? "是"
                    : scope.row.isPass == 0
                    ? "否"
                    : "-"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeType" label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
              <span v-else-if="scope.row.prizeType == 2"> 京豆 </span>
              <span v-else-if="scope.row.prizeType == 3"> 实物 </span>
              <span v-else-if="scope.row.prizeType == 4"> 店铺积分 </span>
              <span v-else-if="scope.row.prizeType == 5"> E卡 </span>
              <span v-else-if="scope.row.prizeType == 6"> 爱奇艺会员 </span>
              <span v-else-if="scope.row.prizeType == 7"> 京豆PlUS会员 </span>
              <span v-else-if="scope.row.prizeType == 8"> 红包 </span>
              <span v-else-if="scope.row.prizeType == 9"> 谢谢参与 </span>
              <span v-else-if="scope.row.prizeType == 10"> 礼品卡 </span>
              <span v-else-if="scope.row.prizeType == 13">令牌</span>
              <span v-else-if="scope.row.prizeType == 12">专享价</span>
              <span v-else-if="scope.row.prizeType == 14">实物（随单发）</span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称"></el-table-column>
          <el-table-column prop="isWin" label="是否领取奖品">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isWin == 1
                    ? "已领取"
                    : scope.row.isWin == 0
                    ? "未领取"
                    : "-"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="isPass" label="是否填写地址">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.isEnter == 1
                    ? "已填写"
                    : scope.row.isPass == 0
                    ? "未填写"
                    : "-"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="参与时间" width="160px">
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <jd-button
                type="blueText"
                :disabled="scope.row.isPass == 1"
                @click="showWinDialog(scope.row)"
                >标识为中奖</jd-button
              >
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="eleven"
        v-if="fitersChooseIF([23, 24])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="inputParticipat"
          @search="searchParticipationForm"
          :formData.sync="formList"
        ></jd-form>
        <jd-button style="margin-bottom: 12px" @click="addCrowd(6)"
          >按查询结果生成人群</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="ParticipatTable"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalParticipat,
            }"
            @handlePage="handlePageParticipat"
          >
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="joinTime" label="参与时间">
            </el-table-column>
            <el-table-column
              v-if="fitersChooseIF([23])"
              prop="score"
              label="得分"
            >
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.score || scope.row.score == 0
                      ? scope.row.score
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="isPass" label="是否通关">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.isPass == 1
                      ? "是"
                      : scope.row.isPass == 0
                      ? "否"
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="isDraw" label="是否抽奖">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.isDraw == 1
                      ? "是"
                      : scope.row.isDraw == 0
                      ? "否"
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="isWin" label="是否中奖">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.isWin == 1
                      ? "是"
                      : scope.row.isWin == 0
                      ? "否"
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 参与记录(会员升级礼) -->
      <el-tab-pane
        label="参与记录"
        name="MemberUpGrade"
        v-if="fitersChooseIF([44])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="inputMemberUpGrade2"
          @search="searchMemberUpGrade"
          :formData.sync="formList"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px"
          @click="addCrowd(25)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          style="float: right; margin-top: 16px"
          @click="exportFn2"
          v-preventReClick
          :disabled="!MemberUpGradeTable.length"
          >导出</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="MemberUpGradeTable"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalMemberUpGrade,
            }"
            @handlePage="handlePageMemberUpGrade"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道" ></el-table-column>
            <el-table-column prop="createTime" label="参与时间">
            </el-table-column>
            <el-table-column
              prop="memberInitialLevel"
              label="初始会员等级"
              align="right"
            >
            </el-table-column>
            <el-table-column prop="latestJoinTime" label="最新访问活动时间">
            </el-table-column>
            <el-table-column
              prop="memberLatestLevel"
              label="最新会员等级"
              align="right"
            >
            </el-table-column>
            <el-table-column prop="isUpgrades" label="是否发生升级">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.isUpgrades == 1
                      ? "已升级"
                      : scope.row.isUpgrades == 0
                      ? "未升级"
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="upLevelNumber"
              label="升级级数"
              align="right"
            >
            </el-table-column>
            <el-table-column prop="isWin" label="是否领取奖品">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.isWin == 1
                      ? "已领取"
                      : scope.row.isWin == 0
                      ? "未领取"
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 参与记录(0元试用) -->
      <el-tab-pane
        label="参与记录"
        name="zeroTrial"
        v-if="fitersChooseIF([51])"
      >
        <jd-form :form-info="zeroTrialForm" ref="zeroTrialRef" :hideMunicipalityChildren="true" :emitReset="true" :formData.sync="formZeroList" @search="searchZeroTrial"  @reset="resetZeroTrial" class="mb16">
          <template #mobileSlot>
            <el-input
              size="small"
              style="width: 290px;"
              v-model="formDataPhoneStr"
              @input="formDataPhoneStr = formDataPhoneStr.replace(/[^\d,]/g, '')"
              placeholder="请输入手机号号，多个请用','隔开"
              slot="reference"
            >
            <template slot="suffix">
              <el-popover
                placement="bottom"
                trigger="click"
                width="350"
                ref="idPopper"
                :visible-arrow="false"
              >
                <img
                  slot="reference"
                  class="id-icon"
                  src="https://cdn-image.yucrm.cn/images/dyAssets/images/public/list.png"
                  alt=""
                  @click="handleBatchQuery"
                />
                <div
                  ref="goodsIdBox"
                >
                  <el-input
                    type="textarea"
                    :autosize="{
                      minRows: 4,
                      maxRows: 6,
                    }"
                    placeholder="请换行输入手机号，最多可以输入3000个"
                    v-model="searPhoneStr"
                    @input="handlePhoneInput"

                  >
                  </el-input>
                  <div class="upload-box">
                    <el-upload
                        ref="uploadXls"
                        class="uploadFile"
                        action=""
                        :show-file-list="false"
                        accept=".xls, .xlsx"
                        :limit="1"
                        :before-upload="beforeUploadXlsZeroTrial"
                    >
                      <jd-button type="blueText" style="margin-right: 12px"
                        >批量上传</jd-button
                      >
                    </el-upload>
                    <jd-button type="blueText" @click="handleDownloadPhoneTemplate"
                      >下载模板</jd-button
                    >
                    <jd-button
                      type="blueText"
                      @click="complate"
                      >完成</jd-button
                    >
                  </div>
                </div>
              </el-popover>
            </template>
            </el-input>
          </template>
        </jd-form>
        <jd-button
          style="margin-bottom: 12px;"
          @click="addCrowd(34)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          style="float: right;"
          @click="exportZeroTrialFn"
          v-preventReClick
          :disabled="!zeroTrialTable.length"
          >导出</jd-button
          >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="zeroTrialTable"
            :pageInfo="{
              pageSize: formZeroList.size,
              pageNum: formZeroList.current,
              total: totalZeroTrial,
            }"
            @handlePage="handleSizeZeroTrial"
          >
            <el-table-column prop="memberNick" min-width="150" label="用户昵称">
            </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              min-width="150"
            >
            </el-table-column>
            <el-table-column prop="sellerLinkName" min-width="150" label="投放渠道">
            </el-table-column>
            <el-table-column label="会员等级" min-width="120">
              <template slot-scope="scope">
                <span>{{levelMap[scope.row.level] || ''}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="prizeName"
              label="报名奖品名称"
              min-width="200"
            ></el-table-column>
            <el-table-column prop="joinTime" label="报名时间" min-width="170">
            </el-table-column>
            <el-table-column prop="usePoint" label="消耗积分" min-width="120">
            </el-table-column>
            <el-table-column
              prop="applyReason"
              label="申请理由"
              min-width="150"
            >
              <template slot-scope="scope">
                <div>
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="click"
                    :content="scope.row.applyReason"
                  >
                    <el-button
                      slot="reference"
                      :disabled="!scope.row.applyReason"
                      >查看理由</el-button
                    >
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="是否填写地址" min-width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.isAddress == 1">已填写</span>
                <span v-else>未填写</span>
              </template>
            </el-table-column>
            <el-table-column label="地址填写时间" min-width="170">
              <template slot-scope="scope">
                <span v-if="scope.row.addressCreateTime">{{
                  scope.row.addressCreateTime
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="填写手机号" min-width="170">
              <template slot-scope="scope">
                <span v-if="scope.row.receiverMobile">{{
                  scope.row.receiverMobile
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="中奖状态" min-width="120">
              <template slot-scope="scope">
                <div class="flexc-cen-x" v-if="scope.row.isWin == 1">
                  <i class="new-green-icon-box"></i>
                  <span class="ml2">已中奖</span>
                </div>
                <div class="flexc-cen-x" v-else-if="scope.row.isWin == 0">
                  <i class="new-gley-icon-box"></i>
                  <span class="ml2">未中奖</span>
                </div>
                <div class="flexc-cen-x" v-else>
                  <i class="new-yellow-icon-box"></i>
                  <span class="ml2">待开奖</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="中奖时间" min-width="170">
              <template slot-scope="scope">
                <span v-if="scope.row.winTime">{{ scope.row.winTime }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="发放状态" min-width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.status == -1">
                  <i class="new-yellow-icon-box"></i>
                  <span class="ml2">待领取</span>
                </div>
                <div
                  v-else-if="
                    scope.row.status == 3 ||
                    scope.row.status == 5 ||
                    scope.row.status == 6
                  "
                >
                  <i class="new-green-icon-box"></i>
                  <span>已发放</span>
                </div>
                <div v-else-if="scope.row.status == 4">
                  <i class="new-red-icon-box"></i>
                  <span class="ml2">发放失败</span>
                </div>
                <div v-else-if="scope.row.status == 7">
                  <i class="new-yellow-icon-box"></i>
                  <span class="ml2">待发放</span>
                </div>
                <div v-else-if="scope.row.status == 8">
                  <i class="new-gley-icon-box"></i>
                  <span class="ml2">已失效</span>
                </div>
                <span v-else>-</span>
                <el-tooltip
                  effect="dark"
                  v-if="scope.row.status == 4 || scope.row.status == 8"
                  :content="scope.row.failReason"
                  placement="top-start"
                >
                  <span
                    class="new-icon-box"
                    style="margin: -2px 0 -2px 6px"
                  ></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="grantTime" label="发放时间" min-width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.grantTime">{{
                  scope.row.grantTime
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="report" label="试用报告" min-width="150">
              <template slot-scope="scope">
                <jd-button
                  type="blueText"
                  v-if="scope.row.isFillReport"
                  @click="openDialog(scope.row)"
                  >查看报告</jd-button
                >
                <span v-else>暂无报告</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="200">
              <template slot-scope="scope">
                <jd-button
                  type="blueText"
                  :disabled="scope.row.markWinAction == 2||scope.row.isWin == 1"
                  v-if="scope.row.markWinAction == 0"
                  @click="
                    freeTrialStatusRow = scope.row;
                    freeTrialStatusVisible = true;
                  "
                  >标记中奖</jd-button
                >
                <jd-button
                  type="blueText"
                  v-if="scope.row.markWinAction == 1"
                  @click="handleCancelMarkWin(scope.row)"
                  >取消标记中奖</jd-button
                >
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 4 || scope.row.status == 7"
                  :disabled="
                    !(scope.row.isWin == 1 && scope.row.isAddress == 1)
                  "
                  @click="recordMark(scope.row)"
                  >标记发放</jd-button
                >
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 6"
                  @click="recordMark(scope.row)"
                  >取消发放</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 参与记录(情书贺卡) -->
      <el-tab-pane
        label="参与记录"
        name="BilletDoux"
        v-if="fitersChooseIF([50])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formBilletDoux"
          @search="searchBilletDoux"
          :formData.sync="formList"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px"
          @click="addCrowd(31)"
          >按查询结果生成人群</jd-button
        >
        <el-button
          type="text"
          style="float: right; margin-top: 16px"
          @click="exportFn3('1')"
          v-preventReClick
          :disabled="!BilletDouxTable.length"
          >导出</el-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="BilletDouxTable"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalBilletDoux,
            }"
            @handlePage="handlePageBilletDoux"
          >
            <el-table-column type="selection"> </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column :prop="pinToXid" :label="`用户${grayId}`">
            </el-table-column>
            <el-table-column prop="sellerLinkName" min-width="150" label="投放渠道">
            </el-table-column>
            <el-table-column prop="joinTime" label="参与时间">
            </el-table-column>
            <el-table-column prop="isFinish" label="是否完成情书制作">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.isFinish == 1
                      ? "已完成"
                      : scope.row.isFinish == 0
                      ? "未完成"
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="receiverMobile" label="接受者手机号">
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 参与记录(购物打卡) -->
      <el-tab-pane label="参与记录" name="shopCheckApply" v-if="fitersChooseIF([53])">
        <shopCheckInApply
          v-if="activeName == 'shopCheckApply'"
          :activityId="activityId"
          @handleOpenDetail="goToCheckInDetail"
        ></shopCheckInApply>
      </el-tab-pane>

      <!-- 小红书晒单礼-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="xhsRecord"
        v-if="fitersChooseIF([80])"
      >
        <xhsParticipateRecord v-if="activeName == 'xhsRecord'" :rowData="rowData" :inputXhsInfo.sync="inputXhsInfo"/>
      </el-tab-pane>

      <!-- 集分冲榜/粉丝集分应援-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="collectPointRecord"
        v-if="fitersChooseIF([81,82])"
      >
        <participateRecord v-if="activeName == 'collectPointRecord'" :levelMap="levelMap" :rowData="rowData" :inputInfo.sync="inputCollectPointInfo"/>
      </el-tab-pane>

      <!-- 日历打卡-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="calendarCheckIn"
        v-if="fitersChooseIF([84])"
      >
        <calendarCheckIn v-if="activeName == 'calendarCheckIn'" @handleToTabCb="handleToTabCb" :rowData="rowData" :inputInfo.sync="inputCalendarCheckInInfo"/>
      </el-tab-pane>

      <!-- 百变答题-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="versatileAnswers"
        v-if="fitersChooseIF([85])"
      >
        <versatileAnswersRecord v-if="activeName == 'versatileAnswers'" :rowData="rowData" :inputInfo.sync="inputVersatileAnswersInfo"/>
      </el-tab-pane>

      <!-- 答题导购-参与记录 -->
      <el-tab-pane
        label="参与记录"
        name="answerQuestionSparticipationRecord"
        v-if="fitersChooseIF([87])"
      >
      <answerQuestionSparticipationRecord v-if="activeName == 'answerQuestionSparticipationRecord'" :rowData="rowData" :inputInfo.sync="inputAnswerQuestionSparticipationRecordInfo"/>
      </el-tab-pane>

      <el-tab-pane
        label="商品推荐明细"
        name="recommendedDetails"
        v-if="fitersChooseIF([87])"
      >
        <recommendedDetails v-if="activeName == 'recommendedDetails'" :rowData="rowData" :inputInfo.sync="inputRecommendedDetailsInfo"/>
      </el-tab-pane>

      <!-- 日历打卡-打卡明细 -->
      <el-tab-pane
        label="打卡明细"
        name="clockInDetails"
        v-if="fitersChooseIF([84])"
      >
        <clockInDetails v-if="activeName == 'clockInDetails'" :rowData="rowData" :inputInfo.sync="inputClockInDetailsInfo"/>
      </el-tab-pane>

      <!-- 参与赠送记录 -->
      <el-tab-pane
        label="补签卡获取记录"
        name="twelve"
        v-if="fitersChooseIF([84])"
      >
        <jd-form
          :form-info="inputResignRecordInfo"
          @search="searchGiftrecord"
          ref="twelveRef"
          :formData.sync="formList"
          class="mb16"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <div>
            <jd-button
              type="blueLine"
              @click="addCrowd(7)"
              >按查询结果生成人群</jd-button
            >
            <jd-button @click="isShowAddGiftNumberBatch = true">补签次数变更（批量）</jd-button>
          </div>
          <jd-button type="text" @click="exportTask">导出</jd-button>
        </div>
        <jd-table
          :loading="loading"
          :tableData="GiftrecordList"
          :pageInfo="{
            pageSize: formList.size,
            pageNum: formList.current,
            total: totalGiftrecord,
          }"
          @handlePage="handlePageGiftrecord"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道"> </el-table-column>
          <el-table-column prop="taskType" label="获赠类型">
            <template slot-scope="scope">
              <span>{{fitersTypeValue2(scope.row.taskType)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="关联订单号"> 
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                v-if="scope.row.taskType == 17"
                popper-class="new-tooltip-width"
              >
                <div slot="content">
                  <div
                    v-for="(fitem, findex) in fitersTypeValue4(scope.row)"
                    :key="'fitersTypeValue4' + findex"
                  >
                    {{ fitem }}
                  </div>
                </div>
                <div
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                >
                订单号：{{ fitersTypeValue3(scope.row) }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="giveTimes"
            label="赠送次数"
          >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <span>{{ scope.row.giveTimes }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="获赠时间"></el-table-column>
        </jd-table>
      </el-tab-pane>

      <!-- 打卡明细(购物打卡) -->
      <el-tab-pane label="打卡明细" name="checkInDetail" v-if="fitersChooseIF([53])">
        <checkInDetail
          ref="checkInDetailRef"
          :activityId="activityId"
        ></checkInDetail>
      </el-tab-pane>

      <!-- 购物打卡-订单明细 -->
      <el-tab-pane label="订单明细" name="orderTable" v-if="fitersChooseIF([53])">
        <orderTable
          ref="orderTableDetailRef"
          :activityId="activityId"
          :rowData="rowData"
        ></orderTable>
      </el-tab-pane>





      <!-- 获取记录(情书贺卡) -->
      <el-tab-pane
        label="获取记录"
        name="BilletDouxReceive"
        v-if="fitersChooseIF([50])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formBilletReceive"
          @search="searchBilletReceive"
          :formData.sync="formList"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px"
          @click="addCrowd(32)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          style="float: right; margin-top: 16px"
          @click="exportFn3('2')"
          v-preventReClick
          :disabled="!BilletReceiveTable.length"
          >导出</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="BilletReceiveTable"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalBilletReceive,
            }"
            @handlePage="handlePageBilletReceive"
          >
            <el-table-column type="selection"> </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column :prop="pinToXid" :label="`用户${grayId}`">
            </el-table-column>
            <el-table-column prop="sellerLinkName" min-width="150" label="投放渠道">
            </el-table-column>
            <el-table-column prop="createTime" label="获取时间">
            </el-table-column>
            <el-table-column prop="num" label="获取情书数量"> </el-table-column>
            <el-table-column prop="receiverMobile" label="获取手机号">
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 1已改 -->
      <!-- 签到纪录 -->
      <el-tab-pane label="签到记录" name="second" v-if="fitersChooseIF([1])">
        <jd-form
          :form-info="inputDataList"
          @search="searchForm"
          :btn30="true"
          class="mb16"
        >
        </jd-form>
        <jd-button style="margin-bottom: 12px" @click="addCrowd(1)"
          >按查询结果生成人群</jd-button
        >
        <jd-table
          :tableInfo="signInTableInfo"
          :loading="loading"
          :tableData="signInTable"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalSignIn,
          }"
          @handlePage="handlePageSignIn"
        >
        </jd-table>
      </el-tab-pane>

      <!-- TODO:日历签到添加补签卡记录 -->
       <el-tab-pane label="补签卡获取记录" name="secondBu" v-if="fitersChooseIF([1])">
        <jd-form
          :form-info="inputDataListSupplementary"
          ref="secondBuRef"
          @search="searchFormBu"
          :btn30="true"
          class="mb16"
        >
        </jd-form>
   
        <jd-table
          :tableInfo="signInTableInfoSupplementary"
          :loading="loading"
          :tableData="signInTableSupplementary"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalSignInSupplementary,
          }"
          @handlePage="handlePageSignInSupplementary"
        >
        </jd-table>
       </el-tab-pane>
      <!-- end -->

      <!-- 3已改 -->
      <!-- 预约记录 -->
      <el-tab-pane label="预约记录" name="fifteen" v-if="fitersChooseIF([33])">
        <!-- 头部表单查询 -->
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThir3"
          @search="searchFormThir2"
          :formData.sync="formList"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px"
          @click="addCrowd(13)"
          >按查询结果生成人群</jd-button
        >
        <!-- 表格 -->
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="exchangeList"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalMail,
            }"
            @handlePage="handlePageExchange2"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column prop="joinTime" label="预约时间"></el-table-column>
            <el-table-column prop="isWin" label="中奖状态">
              <template slot-scope="scope">
                <span v-if="scope.row.isWin == 1"><jd-status :status="0">已中奖</jd-status></span>
                <span v-if="scope.row.isWin == 0"><jd-status :status="4">未中奖</jd-status></span>
                <span v-if="scope.row.isWin == 2"><jd-status :status="2">待开奖</jd-status></span>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 加购记录 -->
      <!-- 1已改 -->
      <el-tab-pane
        label="加购记录"
        name="thirtyFour"
        v-if="fitersChooseIF([34])"
      >
        <!-- <input-form
          :inputData="inputDataAddCart"
          @toParentVal="searchAddCart"
          :btnPosition2="true"
          :defaultSelectArr="true"
        ></input-form> -->
        <!-- :formData.sync="formList" -->
        <jd-form
          :form-info="inputDataAddCart"
          @search="searchAddCart"
          ref="inputFormRef1"
          class="mb16"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <jd-button type="blue" @click="addCrowd(2)"
            >按查询结果生成人群</jd-button
          >
          <jd-button @click="export_get(formList)">导出</jd-button>
        </div>
        <div class="new-table-box">
          <jd-table :loading="loading" :tableData="addCartTable">
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="memberNick"
              label="用户昵称"
            ></el-table-column>
            <el-table-column
              prop="addCartTime"
              label="加购时间"
            ></el-table-column>
            <el-table-column
              prop="addCartNum"
              label="当前加购件数"
            ></el-table-column>
            <el-table-column label="投放渠道">
              <template slot-scope="scope">
                <span>{{ scope.row.sellerLinkName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否满足领奖条件">
              <template slot-scope="scope">
                <span>{{ scope.row.isAllowGetPrize ? "满足" : "不满足" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否中奖">
              <template slot-scope="scope">
                <span>{{ scope.row.isWin ? "已中奖" : "未中奖" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <jd-button type="blueText" @click="checkCartDetail(scope.row)"
                  >查看详情</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
        <div
          class="new-pagination-page"
          style="margin-top: 16px"
          v-if="totalAddCart > 10"
        >
          <el-pagination
            style="text-align: right"
            @size-change="handleSizeAddCart"
            background
            @current-change="handleCurrentAddCart"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalAddCart"
            :current-page="formList.current"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <!-- 锁权记录 -->
      <!-- 1已改 -->
      <!-- v-if="fitersChooseIF([35])" -->
      <el-tab-pane label="锁权记录" name="eighteen" v-if="fitersChooseIF([35])">
        <!-- <input-form
          :inputData="inputLockRight"
          ref="export_fun18"
          @toParentVal="searchLockRight"
          :btnPosition1="true"
          style="margin: 20px 0"
        ></input-form> -->
        <jd-form
          :form-info="inputLockRight"
          @search="searchLockRight"
          ref="inputFormRef2"
        ></jd-form>
        <div class="flex-end mb12 mt16">
          <el-button type="text" @click="export_get" v-preventReClick
            >导出</el-button
          >
        </div>
        <jd-table :loading="loading" :tableData="lockRightTable">
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column prop="point" label="锁权积分"></el-table-column>
          <el-table-column prop="buyMoney" label="活动下单期间购买金额">
          </el-table-column>
          <el-table-column
            prop="buyOrder"
            label="活动下单期间购买订单数"
          ></el-table-column>
          <el-table-column
            prop="isPassStr"
            label="是否符合中奖门槛"
          ></el-table-column>
          <el-table-column
            prop="isEnterStr"
            label="是否录入收货信息"
          ></el-table-column>
          <el-table-column prop="createTime" label="锁权时间"></el-table-column>
        </jd-table>
        <el-pagination
          v-if="this.totalLockRight > 10"
          style="text-align: right; margin: 25px"
          @size-change="handleSizeLockRight"
          background
          @current-change="handleCurrentLockRight"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.totalLockRight"
          :current-page="formList.current"
        ></el-pagination>
      </el-tab-pane>

      <!-- 用户资料 -晒单有礼 -->
      <!-- 1已改 -->
      <!-- v-if="fitersChooseIF([41])" -->
      <el-tab-pane
        label="用户资料"
        name="thirty-one"
        v-if="fitersChooseIF([41])"
      >
        <div class="user-info-statics">
          用户资料
          <div class="user-info-statics-item">
            共提交{{ postUserStaticsInfo.totalSubmitNum || 0 }}份
          </div>
          <div class="user-info-statics-item">
            昨日提交{{ postUserStaticsInfo.lastSubmitNum || 0 }}份
          </div>
          <div class="user-info-statics-item">
            累计审核通过{{ postUserStaticsInfo.passNum || 0 }}份
          </div>
          <div class="user-info-statics-item">
            待审核{{ postUserStaticsInfo.unProcessNum || 0 }}份
          </div>
          <div class="user-info-statics-item">
            驳回{{ postUserStaticsInfo.failNum || 0 }}份
          </div>
        </div>
        <!-- <input-form
          :inputData="postOrdersInfoInput"
          @toParentVal="searchPostUserInfo"
          :btnPosition="true"
          style="margin: 20px 0"
        ></input-form> -->
        <jd-form
          :form-info="postOrdersInfoInput"
          @search="searchPostUserInfo"
          ref="inputFormRef3"
          style="margin-bottom: 16px"
        ></jd-form>
        <div class="operate-wrap flex-spc-x">
          <div>
            <jd-button
              type="blue"
              @click="addCrowd(20)"
              :disabled="!postOrderInfoTable.length"
              >按查询结果生成人群</jd-button
            >
            <jd-button
              @click="onHandleProcess()"
              :disabled="!proccessSelectionArr.length"
              >批量审核</jd-button
            >
            <jd-button
              @click="isShowUploadProccess = true"
              :disabled="permissions.indexOf('interact:show:product:audit:permission') == -1 || !postOrderInfoTable.length"
              >上传审核结果</jd-button
            >&nbsp;
            <el-dropdown :disabled="permissions.indexOf('interact:show:product:add:permission') == -1">
              <span class="el-dropdown-link">
                <jd-button type="text" :disabled="permissions.indexOf('interact:show:product:add:permission') == -1">添加晒单资料<i class="el-icon-arrow-down el-icon--right"></i></jd-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- 使用@click.native确保点击事件在Vue 2中正确触发 -->
                <el-dropdown-item @click.native="addShowData()">手动添加</el-dropdown-item>
                <!-- 使用@click.native确保点击事件在Vue 2中正确触发 -->
                <el-dropdown-item @click.native="uploadShowData()">批量上传</el-dropdown-item>
                
        
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <jd-button
            typr="text"
            @click="getphone()"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :loading="loading"
          :tableData="postOrderInfoTable"
          @selection-change="handlePoccessSelectionChange"
          :pageInfo="{
            pageSize: formList.size,
            pageNum: formList.current,
            total: totalPostOrderUserInfo,
          }"
          @handlePage="handlePagePostOrder"
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="onPoccessSelectable"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="提交记录id"
            minWidth="150"
            width="150"
          >
          </el-table-column>
          <el-table-column
            :prop="chaosParams"
            :label="`用户${grayId}`"
            minWidth="150"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="chaosMemberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道">
          </el-table-column>
          <el-table-column prop="createTime" label="提交时间">
          </el-table-column>
          <template v-for="val in postRuleFieldsList">
            <el-table-column
              v-if="val == '姓名'"
              prop="chaosName"
              label="姓名"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosName }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.chaosName &&
                      scope.row.chaosName.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'chaosName',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '订单号'"
              prop="orderId"
              label="订单号"
              :key="val"
            >
            </el-table-column>
            <el-table-column
              v-if="val == '评价截图'"
              prop="commentImage"
              label="评价截图"
              minWidth="300"
              :key="val"
            >
              <template slot-scope="{ row }">
                <div class="commend-img-list">
                  <el-image
                    class="commend-img"
                    :src="item"
                    v-for="(item, index) in row.commentImage.split(',')"
                    :key="index"
                    @click="onHandleProcess(row)"
                  ></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '手机号'"
              prop="chaosMobile"
              label="手机号"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosMobile }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.chaosMobile &&
                      scope.row.chaosMobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'chaosMobile',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '地址'"
              prop="chaosAddress"
              label="地址"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.chaosAddress &&
                      scope.row.chaosAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'chaosAddress',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="val == '详细地址'"
              prop="chaosDetailedAddress"
              label="详细地址"
              :key="val"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.chaosDetailedAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.chaosDetailedAddress &&
                      scope.row.chaosDetailedAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'chaosDetailedAddress',
                        'postOrderInfoTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column v-if="val == '扩展信息'" minWidth="0" width="0" :key=val>
            <template slot-scope="scope1">
            <el-table-column
              minWidth="150"
              v-for="(item,index) in formatExtendInfo(scope1.row.extendInfo)" 
              :key="index"
              prop="value"
              :label="item.name"
            >
              <template slot-scope="scope">
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="info">
                    <template v-if="item.type==2">
                      <div class="img-parent" v-for="(child,cIndex) in item.value.split(',')" :key="cIndex">
                        <el-image class="info-img" :src="child" :preview-src-list="[child]"></el-image>                  
                      </div>
                    </template>
                    <span v-else style="margin-left: 4px;">{{item.value}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
           </el-table-column> -->
          </template>

          <!-- 扩展信息 -->
          <template
            v-for="(item, index) in postOrderInfoTable.length
              ? postOrderInfoTable[0].staticInfoNames
              : []"
          >
            <el-table-column :label="item.name" minWidth="300">
              <template slot-scope="scope">
                <div style="display: flex; flex-wrap: wrap">
                  <div class="info">
                    <template v-if="item.type == 2">
                      <div
                        class="img-parent"
                        v-for="(child, cIndex) in getStaticInfoNames(
                          item,
                          scope.row.staticInfoNames
                        ).split(',')"
                        :key="cIndex"
                        @click="onHandleProcess(scope.row)"
                      >
                        <el-image class="info-img" v-if="child" :src="child"></el-image>
                      </div>
                    </template>
                    <span v-else style="margin-left: 4px">{{
                      getStaticInfoNames(item, scope.row.staticInfoNames)
                    }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>

          <el-table-column prop="processStatus" label="审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.processStatus == '-1'"><jd-status :status="2">待参与</jd-status></span>
              <span v-if="scope.row.processStatus == 0"><jd-status :status="2">待审核</jd-status></span>
              <span v-if="scope.row.processStatus == 1"><jd-status :status="0">已通过</jd-status></span>
              <span v-if="scope.row.processStatus == 2"><jd-status :status="3">已驳回</jd-status></span>
            </template>
          </el-table-column>
          <el-table-column label="审核备注" width="200">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.processRemark"
                placement="top-start"
              >
                <div class="remark-tip">{{ scope.row.processRemark }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orderStateRemark" label="订单状态">
          </el-table-column>
          <el-table-column prop="processTime" label="审核时间">
          </el-table-column>
          <el-table-column label="操作" width="160">
            <!-- v-if="scope.row.processStatus == '-1'" -->
            <template slot-scope="scope">
              <jd-button
                type="blueText"
                :disabled="permissions.indexOf('interact:show:product:audit:permission') == -1||scope.row.processStatus == 1"
                @click="onHandleProcess(scope.row)"
                >审核</jd-button
              >
              <jd-button
                type="blueText"
                @click="editShowData(scope.row, scope.$index)"
                :disabled="permissions.indexOf('interact:show:product:edit:permission') == -1"
                >修改资料</jd-button
              >
            </template>
          </el-table-column>
        </jd-table>
        <!-- <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizePostUserInfo"
          background
          @current-change="handleCurrentPostUserInfo"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPostOrderUserInfo"
          :current-page="formList.current"
        ></el-pagination> -->
      </el-tab-pane>

           <!-- TODO:1.51组队瓜分奖品记录 -->
      <el-tab-pane
        :label="'开团记录'"
        name="twenty14"
        v-if="fitersChooseIF([64])"
      >
        <jd-form
          :form-info="inputInkindInfo8"
          @search="teamSpoils"
          :btn30="false"
          ref="inputAwardTeam"
          class="mt16 mb16"
        />
           <div class="mb12 flex-spc-x">
          <div>
            <jd-button @click="addCrowd(43)"
              >按查询结果生成人群</jd-button
            >
          </div>
          <jd-button type="text" @click="exportFnGachaTeam" v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :tableData="teamList"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalTeam,
          }"
          @handlePage="handlePageGoodsGachaTeam"
          :loading="loading"
        >
        <el-table-column
            prop="memberNick"
            label="用户昵称"
          ></el-table-column>
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" >
          </el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道" >
          </el-table-column>
          <el-table-column prop="prizeTypeName" label="奖品类型" >
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="开团时间"
          ></el-table-column>
         <el-table-column
            prop="requireMembersNum"
            label="成团人数"
          ></el-table-column>
          <el-table-column
            prop="teamName"
            label="团队名称"
          ></el-table-column>
           <el-table-column
            prop="isFinishText"
            label="是否成团"
          ></el-table-column>
              <el-table-column
            prop="finishTime"
            label="成团时间"
          ></el-table-column>
              <el-table-column
            prop="finishMembersNum"
            label="团员人数"
          >
            <template slot-scope="scope">
              <span style="cursor: pointer; color: #1890ff; text-decoration: underline;" @click="goToInviteDetail(scope.row)">
                {{ scope.row.finishMembersNum || 0 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="isWinText"
            label="是否领取奖品"
          ></el-table-column>
        </jd-table>
      </el-tab-pane>
      
            <!-- TODO:1.61 -->
      <!-- 门票支付记录 -->
      <el-tab-pane
        label="门票支付记录"
        name="payRecord"
        v-if="fitersChooseIF([70])"
      >
        <!-- 头部表单查询 -->
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThir10"
          @search="searchFormTen"
          :formData.sync="formList"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px; margin-right: 8px"
          @click="addCrowd(48)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          @click="getphone_29()"
          style="float: right; margin-top: 16px"
          >导出</jd-button
        >
        <!-- 表格 -->
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="exchangeListTen"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalMailTen,
            }"
            @handlePage="handlePageExchangeTen"
            rowKey="id"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="memberNick" label="用户昵称" >
            </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
            >
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="ticketPoints" label="门票价格"> </el-table-column>
            <el-table-column prop="createTime" label="门票支付时间" >
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 出价记录 -->
      <el-tab-pane
        label="出价记录"
        name="outRecord"
        v-if="fitersChooseIF([70])"
      >
        <!-- 头部表单查询 -->
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThir11"
          @search="searchFormEleven"
          :formData.sync="formListEleven"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px; margin-right: 8px"
          @click="addCrowd(46)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          @click="getphone_30()"
          style="float: right; margin-top: 16px"
          >导出</jd-button
        >
        <!-- 表格 -->
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="exchangeListEleven"
            :pageInfo="{
              pageSize: formListEleven.size,
              pageNum: formListEleven.current,
              total: totalMailEleven,
            }"
            @handlePage="handlePageExchangeEleven"
            rowKey="id"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="memberNick" label="用户昵称" >
            </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
            >
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="bidPoints" label="出价积分"> </el-table-column>
            <el-table-column prop="createTime" label="出价时间" >
            </el-table-column>
            <el-table-column prop="isPassStr" label="是否成交" >
            </el-table-column>
            <el-table-column prop="passTime" label="成交时间" >
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>


      <!-- 成交记录 -->
      <el-tab-pane
        label="成交记录"
        name="dealRecord"
        v-if="fitersChooseIF([70])"
      >
        <!-- 头部表单查询 -->
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThir12"
          @search="searchFormTwelve"
          :formData.sync="formListTwelve"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px; margin-right: 8px"
          @click="addCrowd(47)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          @click="getphone_31()"
          style="float: right; margin-top: 16px"
          >导出</jd-button
        >
        <!-- 表格 -->
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="exchangeListTwelve"
            :pageInfo="{
              pageSize: formListTwelve.size,
              pageNum: formListTwelve.current,
              total: totalMailTwelve,
            }"
            @handlePage="handlePageExchangeTwelve"
            rowKey="id"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="memberNick" label="用户昵称" >
            </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
            >
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="prizeTypeStr" label="奖品类型"> </el-table-column>
            <el-table-column prop="prizeName" label="奖品名称" >
            </el-table-column>
            <el-table-column prop="bidPoints" label="成交价格" >
            </el-table-column>
            <el-table-column prop="passTime" label="成交时间" >
            </el-table-column>
            <el-table-column prop="payStatusStr" label="支付状态" >
            </el-table-column>
            <el-table-column prop="payTime" label="支付时间" >
            </el-table-column>
            <el-table-column prop="payDeadline" label="支付截止时间" >
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <el-tab-pane v-if="fitersChooseIF([89])" name="redemptionHistory" label="兑换记录">
        <redemptionHistory  v-if="activeName == 'redemptionHistory'" :rowData="rowData" :inputInfo.sync="inputredemptionHistory"/>
      </el-tab-pane>













      <!-- 1已改 -->
       <!-- TODO:实物奖品名单 -->
      <el-tab-pane
        :label="
          fitersRepurchase([16, 17, 18, 23, 24, 27, 28, 44, 45, 47, 48, 53,68,66,69,70,78,79,80,81,82,83,84,85,87], '领奖记录', '中奖记录')
        "
        name="third"
        v-if="
          fitersChooseIF(
            [
              13, 14, 15, 21, 25, 9, 10, 29, 30, 31, 32, 33, 35, 36, 37, 38, 39,
              46, 50, 51, 52,55,58,59,60,61,63,67,74,75,89
            ],
            '!='
          )
        "
      >
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'third'" :activityId="rowData.id" :showAmount="fitersChooseIF([48],'!=') ? true : JSON.parse(JSON.parse(rowData.ruleInfo).customerPaperwork).templateType == 1 ? false : true" />
        <!-- 明细 -->
        <jd-title
          :label="`${fitersRepurchase(
            [16, 17, 18, 23, 24, 27, 28, 45, 47, 48,79,80,81,82,83,84,85],
            '领奖记录',
            '中奖记录'
          )}明细`"
        ></jd-title>

        <jd-form
          class="mt16 mb16"
          :form-info="getNewRewardInputData()"
          @search="searchAwardOne"
          ref="inputAwardOneRef"/>
        <div class="mb12 flex-spc-x">
          <div>
            <jd-button @click="addCrowd(3)" :disabled="!awardTable.length"
              >按查询结果生成人群</jd-button
            >
            <jd-button
              @click="fitersChooseIF([45]) ? batchMark(1) : batchMark(2)"
              v-preventReClick
              :disabled="!awardTable.length"
              >批量标记发放</jd-button
            >
            <jd-button
              @click="handleSendPrize"
              >补发奖品</jd-button
            >
          </div>
          <div>
            <jd-button
              type="text"
              @click="exportFn"
              v-preventReClick
              :disabled="!awardTable.length"
              >导出</jd-button
              >
          </div>
        </div>
        <div class="mb12">总计中奖人数：{{allWinPeoples}}人（去重）</div>
        <jd-table
          :loading="loading"
          :tableData="awardTable"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward,
          }"
          rowKey="unlockOrderId"
          @selection-change="handleSelectionChange"
          @handlePage="handlePageAward"
        >
        <!-- limitSelectable -->
        <el-table-column type="selection" width="55" :selectable="limitSelectable"> </el-table-column>
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="210">
          </el-table-column>
          <el-table-column prop="id" label="中奖ID" width="210">
          </el-table-column>
          <el-table-column prop="memberLevel" label="会员等级">
            <template slot-scope="scope">
              <span>{{ levelMap[scope.row.memberLevel] || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="activityName"
            label="活动名称"
            width="146"
            v-if="fitersChooseIF([5, 6, 47, 48, 53], '!=')"
          >
          </el-table-column>
          <el-table-column label="奖品类型" width="146">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 3">实物</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
              <span v-if="scope.row.prizeType == 5">京豆E卡</span>
              <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
              <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
              <span v-if="scope.row.prizeType == 8">现金红包</span>
              <span v-if="scope.row.prizeType == 9">谢谢参与</span>
              <span v-if="scope.row.prizeType == 10">礼品卡</span>
              <span v-else-if="scope.row.prizeType == 13">令牌</span>
              <span v-else-if="scope.row.prizeType == 12">专享价</span>
              <span v-else-if="scope.row.prizeType == 14">实物（随单发）</span>
            </template>
          </el-table-column>
          <el-table-column prop="achieveCondition" label="达成领奖条件" width="150" v-if="fitersChooseIF([53])">
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" width="210">
          </el-table-column>
          <el-table-column prop="compensationPrizeName" label="补发奖品名称" width="210">
          </el-table-column>
          <el-table-column label="随单发订单号" width="210">
            <template slot-scope="{ row }">
              <span>{{ row.orderId || '-' }}</span>
            </template>
          </el-table-column>
          <!-- 下单抽奖 -->
           <!-- v-if="fitersChooseIF([19])" -->
          <el-table-column
            label="投放渠道"
            prop="sellerLinkName"
            width="100"
          >
          <!-- 1.58 -->
          </el-table-column>
          <el-table-column
            v-if="fitersChooseIF([71])"
            label="核减分值"
            width="100"
          >
          <template slot-scope="scope">
            {{scope.row.deductPoint ? scope.row.deductPoint : '-'}}
          </template>
          </el-table-column>
           <el-table-column
            label="下单店铺"
            prop="orderSellerNick"
            v-if="fitersChooseIF([19])"
            width="200"
          >
          </el-table-column>
          <!-- end -->

          <template v-if="fitersChooseIF([16, 17, 18, 19, 27, 28])">
            <el-table-column width="210">
              <template slot="header">
                <div style="display: flex; align-items: center">
                  订单号
                  <el-tooltip
                    v-if="rowData.activityType == 16"
                    placement="bottom"
                    width="100%"
                    trigger="hover"
                  >
                    <div slot="content">
                      <span
                        >梯度奖品会显示所有解锁成功且满足领奖条件的订单号</span
                      >
                    </div>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tips.svg"
                      style="
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                        margin-left: 4px;
                      "
                      alt=""
                    />
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <!-- 下单有礼页面 -->
                <el-popover
                  v-if="rowData.activityType == 16"
                  placement="bottom"
                  width="100%"
                  trigger="hover"
                >
                  <div
                    class="referencePopover"
                    v-for="(item, idx) in scope.row.orderList"
                    :key="idx"
                  >
                    <span>订单号：{{ item.orderId }}</span>
                    <span>订单金额：{{ item.price }}元</span>
                    <span>订单状态：{{ item.orderState }}</span>
                  </div>
                  <span class="referenceButton" slot="reference">{{
                    scope.row.unlockOrderIdStr
                  }}</span>
                </el-popover>
                <!-- 非下单有礼页面 -->
                <el-popover
                  v-else
                  placement="bottom"
                  width="100%"
                  trigger="hover"
                >
                  <div
                    class="referencePopover"
                    v-for="(item, idx) in scope.row.orderList"
                    :key="idx"
                  >
                    <span>订单号：{{ item.orderId }}</span>
                    <span>订单金额：{{ item.price }}元</span>
                    <span>订单状态：{{ item.orderState }}</span>
                  </div>
                  <span class="referenceButton" slot="reference">{{
                    scope.row.unlockOrderId
                  }}</span>
                </el-popover>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            label="订单号"
            prop="unlockOrderId"
            v-if="fitersChooseIF([41])"
            width="100"
          >
          </el-table-column>

          <!-- 生命周期68 -->
          <el-table-column
            label="中奖阶段"
            prop="stageName"
            v-if="fitersChooseIF([68])"
            width="100"
          >
          </el-table-column>
          <el-table-column
            label="关联订单"
            prop="winOrderIds"
            v-if="fitersChooseIF([68])"
            width="100"
          >
          </el-table-column>

          <!-- 下单抽奖-白名单 -->
          <el-table-column
            label="是否白名单"
            v-if="fitersChooseIF([19])"
            width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.isWhite == 1">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="rowData.activityType != 5 && rowData.activityType != 6"
            :label="
              fitersRepurchase(
                [16, 17, 18, 27, 44, 47, 48, 53 ,69,78,79,80,81,82,83,84,85],
                '领奖时间',
                '参与时间'
              )
            "
            width="210"
          >
            <template slot-scope="scope">
              {{ scope.row.joinTime || "--" }}
            </template>
          </el-table-column>

          <!-- Note----参与时间改为奖时间 -->
          <el-table-column
            v-if="rowData.activityType == 5 || rowData.activityType == 6"
            label="中奖时间"
            width="210"
          >
            <template slot-scope="scope">
              {{
                rowData.activityType == 6
                  ? scope.row.joinTime
                  : scope.row.grantTime || "--"
              }}
            </template>
          </el-table-column>

          <el-table-column
            label="发放时间"
            width="210"
            v-if="fitersChooseIF([16, 17, 18, 19, 27, 28, 41, 44, 47, 48, 53,79,81,82,83,84,85])"
          >
            <template slot-scope="scope">
              {{ scope.row.grantTime || "-" }}
            </template>
          </el-table-column>
          <!-- Note--C端优化邀请开发有礼去除 -->
          <el-table-column
            :label="rowData.activityType==79 ? '奖品状态' : fitersRepurchase([16, 17, 18, 27,81,82,83,84,85], '发放状态', '中奖状态')"
            width="130"
          >
            <!-- <template slot-scope="scope">
                <span v-if="scope.row.status == -1" class="y2">
                  {{ fitersChooseIF([44], '!=')?'待领取':'' }}
                  </span>
                <span v-if="scope.row.status == 0">-</span>
                <span v-if="scope.row.status == 1 && rowData.activityType != 44" class="y1">未中奖</span>
                <span v-if="scope.row.status == 2" class="y2">
                  {{ fitersChooseIF([16, 17, 18, 27]) ? "待发放" : "已中奖" }}
                </span>
                <span v-if="scope.row.status == 3" class="y4">已发放</span>
                <span v-if="scope.row.status == 4" class="y3">发放失败</span>
                <span v-if="scope.row.status == 5" class="y4">已发放</span>
                <span v-if="scope.row.status == 6" class="y4">已发放</span>
                <span v-if="scope.row.status == 7" class="y2">待发放</span>
                <span v-if="scope.row.status == 8" class="y1">已失效</span>
                <el-tooltip effect="dark" v-if="scope.row.status == 4" :content="scope.row.failReason" placement="top-start">
                  <i
                    style="color: #ccc"
                    v-if="scope.row.status == 4"
                    class="el-icon-question"
                  ></i>
                </el-tooltip>
              </template> -->
            <template slot-scope="scope">
              <div v-if="scope.row.status == -1">
                <jd-status :status="2" v-if="fitersChooseIF([44, 53], '!=')">
                  待领取
                </jd-status>
                <span v-else> </span>
              </div>
              <span v-if="scope.row.status == 0">-</span>
              <jd-status
                :status="3"
                v-if="scope.row.status == 1 && rowData.activityType != 44"
                >未中奖</jd-status
              >
              <div v-if="scope.row.status == 2">
                <jd-status :status="2" v-if="fitersChooseIF([16, 17, 18, 27])">
                  待发放
                </jd-status>
                <jd-status :status="0" v-else> 已中奖 </jd-status>
              </div>
              <jd-status :status="0" v-if="scope.row.status == 3"
                >已发放</jd-status
              >
              <jd-status :status="0" v-if="scope.row.status == 5"
                >已发放</jd-status
              >
              <jd-status :status="0" v-if="scope.row.status == 6"
                >已发放</jd-status
              >
              <jd-status :status="3" v-if="scope.row.status == 7"
                >待发放</jd-status
              >
              <jd-status :status="4" v-if="scope.row.status == 8"
                >已失效</jd-status
              >
              <div
                v-if="scope.row.status == 4"
                style="display: flex; align-items: center"
              >
                <jd-status :status="3" class="mr5">发放失败</jd-status>
                <el-tooltip
                  effect="dark"
                  :content="scope.row.failReason"
                  placement="top-start"
                >
                  <i class="el-icon-question" style="color: #ccc"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="220"
            fixed="right"
            v-if="fitersChooseIF([16, 17, 18, 19, 27, 28], '!=')"
          >
            <template slot-scope="scope">
              <jd-button
                type="blueText"
                v-if="scope.row.status == 4"
                @click="markIss(scope.row,scope.row.prizeType)"
                >标记发放</jd-button
              >
              <jd-button
                type="blueText"
                v-if="scope.row.status == 6"
                @click="markIss(scope.row)"
                >取消发放</jd-button
              >
              <jd-button
                type="blueText"
                v-loading="reissuePointsLoading"
                v-if="rowData.activityType == 8 && scope.row.status == 4 && scope.row.prizeType == 4"
                @click="reissuePoints(scope.row)"
                >补发积分</jd-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right" v-else>
            <template slot-scope="scope">
              <jd-button
                type="blueText"
                v-if="scope.row.status == 4"
                @click="markIss(scope.row,scope.row.prizeType)"
                >标记发放</jd-button
              >
              <jd-button
                type="blueText"
                v-if="scope.row.status == 6"
                @click="markIss(scope.row)"
                >取消发放</jd-button
              >
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>
      <!-- 中奖纪录 -->
      <!-- 1已改 -->
      <!-- v-if="fitersChooseIF([33])" -->
      <el-tab-pane label="中奖记录" name="third" v-if="fitersChooseIF([33])">
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'third'" :activityId="rowData.id" />
        <!-- 明细 -->
        <div class="award-title">
          <span>中奖记录明细</span>
        </div>
        <!-- <input-form
          :inputData="inputAwardTwo"
          ref="export_fun33"
          @toParentVal="searchAwardOne"
          :btnPosition2="true"
        ></input-form> -->
        <jd-form
          :form-info="inputAwardTwo"
          @search="searchAwardOne"
          ref="inputThirdRef"
          style="margin-bottom: 16px"
        ></jd-form>
        <jd-button type="blue" style="margin-bottom: 16px" @click="addCrowd(3)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 16px; margin-left: 8px"
          @click="batchMark(1)"
          v-preventReClick
          >批量标记发货</jd-button
        >
        <!-- <el-button style="float: left; margin-bottom: 20px" @click="getApi_Exprot" v-preventReClick>导出</el-button> -->
        <jd-button
          type="text"
          width="80px"
          style="float: right; margin-top: 20px"
          @click="export_get"
          v-preventReClick
          >导出字段加载状态</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="awardTable"
            @selection-change="handleSelectionChange"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: totalAward,
            }"
            @handlePage="handleAwardTabPage"
          >
            <el-table-column type="selection" width="55" :selectable="limitSelectable"> </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称" width="180">
            </el-table-column>
            <el-table-column prop="memberLevel" label="会员等级">
              <template slot-scope="scope">
                <span>{{ levelMap[scope.row.memberLevel] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="prizeTitle" label="奖品名称" width="180">
            </el-table-column>
            <el-table-column
              prop="isFillAddress"
              label="是否填写地址"
              width="180"
            ></el-table-column>
            <el-table-column prop="joinTime" label="预约时间" width="280">
            </el-table-column>
            <el-table-column prop="grantTime" label="发货时间" width="280">
            </el-table-column>
            <el-table-column prop="grantTime" label="发货状态">
              <template slot-scope="scope">
                <jd-status :status="scope.row.status == 5 ?0:4">{{ scope.row.status == 5 ? "已发货" : "未发货" }}</jd-status>
              </template>
            </el-table-column>
            <el-table-column prop="receiverName" label="收件人">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.receiverName }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.receiverName &&
                      scope.row.receiverName.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'receiverName',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="receiverMobile"
              label="收件人手机号"
              width="120"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.receiverMobile }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.receiverMobile &&
                      scope.row.receiverMobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'receiverMobile',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="receiverAddress"
              label="收件人地址"
              width="210"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.receiverAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.receiverAddress &&
                      scope.row.receiverAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'receiverAddress',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="detailedAddress"
              label="收件人详细地址"
              width="210"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.detailedAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.detailedAddress &&
                      scope.row.detailedAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'detailedAddress',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              v-if="fitersChooseIF([16, 17, 18, 19, 27, 28], '!=')"
            >
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.status == 1"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
                > -->
                <jd-button
                  type="blueText"
                  v-if="
                    (scope.row.status == 2 || scope.row.status == 7) &&
                    scope.row.recordId
                  "
                  @click="markIss(scope.row,row.prizeType)"
                  style="margin-right: 8px"
                  >标记发货</jd-button
                >
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 5"
                  @click="markIss(scope.row)"
                  style="margin-right: 8px"
                  >取消发货</jd-button
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" v-else>
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.status == 1"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
                > -->
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 4 || scope.row.status == 7"
                  @click="markIss(scope.row,scope.row.prizeType)"
                  style="margin-right: 8px"
                  >标记发放</jd-button
                >
                <jd-button
                  type="blueText"
                  style="margin-right: 8px"
                  v-if="scope.row.status == 6 || scope.row.status == 5"
                  @click="markIss(scope.row)"
                  >取消发放</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
        <!-- <div class="new-pagination-page" style="margin-top: 20px">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeAward"
            background
            @current-change="handleCurrentAward"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalAward"
            :current-page="formList.current"
          ></el-pagination>
        </div> -->
      </el-tab-pane>


      <!-- 试用复购-试用礼领奖记录 -->
      <el-tab-pane label="试用礼领奖记录" name="thirdTis" v-if="fitersChooseIF([52])">
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'thirdTis'" :activityId="rowData.id"/>
        <!-- 明细 -->
        <div class="award-title">
          <span>领奖记录明细</span>
        </div>
        <jd-form
          class="mb16"
          :form-info="inputAwardTrial"
          @search="searchAwardOneTrial"
          ref="inputAwardTrialRef"
        ></jd-form>
        <div class="flex-spc-x mb12">
          <div>
            <jd-button
              type="blueLine"
              @click="addCrowd(38)"
              >按查询结果生成人群</jd-button
            >
            <jd-button
              style="margin-left: 8px"
              @click="batchMark(1)"
              v-preventReClick
              >批量标记发放</jd-button
            >
            <jd-button
              @click="handleSendPrize"
              >补发奖品</jd-button
            >
          </div>
          <jd-button
            type="text"
            width="80px"
            style="float: right;margin-top: 20px;"
            @click="export_get_trial"
            v-preventReClick
            >导出</jd-button
          >
        </div>
        <!-- <el-button style="float: left; margin-bottom: 20px" @click="getApi_Exprot" v-preventReClick>导出</el-button> -->
        <div class="mb12">总计中奖人数：{{trialWinPeoples}}人（去重）</div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="awardTableTrial"
            :pageInfo="{
              pageNum: formListTras.current,
              pageSize: formListTras.size,
              total: totalAwardTs,
            }"
            @handlePage="handlePageAwardTs"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"  width="150">
            </el-table-column>
            <el-table-column prop="nickName" label="用户昵称" width="180">
            </el-table-column>
            <el-table-column prop="id" label="中奖ID" width="180">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道" width="180">
            </el-table-column>
            <el-table-column prop="activityName" label="活动名称" width="180">
            </el-table-column>
            <el-table-column prop="prizeType" label="奖品类型">
              <template slot-scope="scope">
                {{ getPrizeTypeName(scope.row.prizeType) }}
              </template>
            </el-table-column>
            <el-table-column prop="prizeName" label="奖品名称" width="180">
            </el-table-column>
            <el-table-column prop="compensationPrizeName" label="补发奖品名称" width="180">
            </el-table-column>
            <el-table-column label="随单发订单号" width="210">
              <template slot-scope="{ row }">
                <span v-if="row.prizeType == 14">{{ row.orderId || '-' }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="订单号" width="280">
              <!-- <template slot="header" slot-scope="scope">
                  <div>
                    订单号
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="此处统计为：用户进入活动后，首次满足订单要求的时间。"
                      placement="top-start"
                    >
                      <div class="new-icon-box" style="margin: -3px 2px"></div>
                    </el-tooltip>
                  </div>
                </template> -->
              <template slot-scope="scope">
                {{ scope.row.orderId }}
              </template>
            </el-table-column>
            <el-table-column prop="isWin" label="是否获得正装礼" width="280">
              <template slot-scope="scope">
                {{ scope.row.isWin == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column prop="winTime" label="领奖时间" width="280">
            </el-table-column>
            <el-table-column prop="grantTime" label="发货时间">
            </el-table-column>
            <el-table-column prop="status" label="发放状态">
              <template slot-scope="scope">
                <jd-status :status="getStatus(scope.row.status)">{{ scope.row.statusStr }}</jd-status>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              v-if="fitersChooseIF([50])"
            >
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.status == 1"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
                > -->
                <jd-button
                  type="blueText"
                  v-if="
                    (scope.row.status == 2 || scope.row.status == 7) &&
                    scope.row.recordId
                  "
                  @click="markIss(scope.row,scope.row.prizeType)"
                  style="margin-right: 8px"
                  >标记发货</jd-button
                >
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 5"
                  @click="markIss(scope.row)"
                  style="margin-right: 8px"
                  >取消发货</jd-button
                >
              </template>
            </el-table-column>
            <el-table-column label="操作"  v-else>
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.status == 1"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
                > -->
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 4 || scope.row.status == 7"
                  @click="markIss(scope.row,scope.row.prizeType)"
                  style="margin-right: 8px"
                  >标记发放</jd-button
                >
                <jd-button
                  type="blueText"
                  style="margin-right: 8px"
                  v-if="scope.row.status == 6 || scope.row.status == 5"
                  @click="markIss(scope.row)"
                  >取消发放</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 试用复购-正装礼领奖记录 -->
      <el-tab-pane label="正装礼领奖记录" name="thirdTisOne" v-if="fitersChooseIF([52])">
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'thirdTisOne'" :activityId="rowData.id"/>
        <!-- 明细 -->
        <div class="award-title">
          <span>领奖记录明细</span>
        </div>
        <jd-form
          class="mb16"
          :form-info="inputAwardTrialOne"
          @search="searchAwardOneTrialOne"
          :btnPosition2="true"
          :defaultSelectArr="true"
          ref="inputAwardTrialOneRef"
        ></jd-form>
        <jd-button
          type="blueLine"
          style="margin-bottom: 16px;"
          @click="addCrowd(38)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 16px; margin-left: 8px"
          @click="batchMark(1)"
          v-preventReClick
          >批量标记发放</jd-button
        >
        <jd-button
          @click="handleSendPrize"
          >补发奖品</jd-button
        >
        <!-- <el-button style="float: left; margin-bottom: 20px" @click="getApi_Exprot" v-preventReClick>导出</el-button> -->
        <jd-button
          type="text"
          width="80px"
          style="float: right;margin-top: 20px;"
          @click="export_get_trial_one"
          v-preventReClick
          >导出</jd-button
        >
        <div class="mb12">总计中奖人数：{{trialWinPeoples}}人（去重）</div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="awardTableTrialOne"
            :pageInfo="{
              pageNum: formListTrasOne.current,
              pageSize: formListTrasOne.size,
              total: totalAwardTsOne,
            }"
            @handlePage="handleSizeAwardTsOne"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"  width="150">
            </el-table-column>
            <el-table-column prop="nickName" label="用户昵称" width="180">
            </el-table-column>
            <el-table-column prop="id" label="中奖ID" width="180">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道" width="180">
            </el-table-column>
            <el-table-column prop="activityName" label="活动名称" width="180">
            </el-table-column>
            <el-table-column prop="prizeType" label="奖品类型">
              <template slot-scope="scope">
                <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
                <span v-else-if="scope.row.prizeType == 2"> 京豆 </span>
                <span v-else-if="scope.row.prizeType == 3"> 实物 </span>
                <span v-else-if="scope.row.prizeType == 4"> 店铺积分 </span>
                <span v-else-if="scope.row.prizeType == 5"> E卡 </span>
                <span v-else-if="scope.row.prizeType == 6"> 爱奇艺会员 </span>
                <span v-else-if="scope.row.prizeType == 7"> 京豆PlUS会员 </span>
                <span v-else-if="scope.row.prizeType == 8"> 红包 </span>
                <span v-else-if="scope.row.prizeType == 9"> 谢谢参与 </span>
                <span v-else-if="scope.row.prizeType == 10"> 礼品卡 </span>
                <span v-else-if="scope.row.prizeType == 13">令牌</span>
                <span v-else-if="scope.row.prizeType == 12">专享价</span>
                <span v-else-if="scope.row.prizeType == 14">实物（随单发）</span>
                <span v-else> - </span>
              </template>
            </el-table-column>
            <el-table-column prop="prizeName" label="奖品名称" width="180">
            </el-table-column>
            <el-table-column prop="compensationPrizeName" label="补发奖品名称" width="180">
            </el-table-column>
       
            <el-table-column prop="joinTime" label="订单号" width="280">
              <!-- <template slot="header" slot-scope="scope">
                  <div>
                    订单号
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="此处统计为：用户进入活动后，首次满足订单要求的时间。"
                      placement="top-start"
                    >
                      <div class="new-icon-box" style="margin: -3px 2px"></div>
                    </el-tooltip>
                  </div>
                </template> -->
              <template slot-scope="scope">
                {{ scope.row.orderId }}
              </template>
            </el-table-column>
            <el-table-column prop="isWin" label="是否获得试用礼" width="280">
              <template slot-scope="scope">
                {{ scope.row.isWin == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column prop="winTime" label="领奖时间" width="280">
            </el-table-column>
            <el-table-column prop="grantTime" label="发货时间">
            </el-table-column>
            <el-table-column prop="status" label="发放状态">
              <template slot-scope="scope">
                <jd-status :status="getStatus(scope.row.status)">{{ scope.row.statusStr }}</jd-status>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              v-if="fitersChooseIF([50])"
            >
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.status == 1"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
                > -->
                <jd-button
                  type="blueText"
                  v-if="
                    (scope.row.status == 2 || scope.row.status == 7) &&
                    scope.row.recordId
                  "
                  @click="markIss(scope.row,scope.row.prizeType)"
                  style="margin-right: 8px"
                  >标记发货</jd-button
                >
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 5"
                  @click="markIss(scope.row)"
                  style="margin-right: 8px"
                  >取消发货</jd-button
                >
              </template>
            </el-table-column>
            <el-table-column label="操作"  v-else>
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.status == 1"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
                > -->
                <jd-button
                  type="blueText"
                  v-if="scope.row.status == 4 || scope.row.status == 7"
                  @click="markIss(scope.row,scope.row.prizeType)"
                  style="margin-right: 8px"
                  >标记发放</jd-button
                >
                <jd-button
                  type="blueText"
                  style="margin-right: 8px"
                  v-if="scope.row.status == 6 || scope.row.status == 5"
                  @click="markIss(scope.row)"
                  >取消发放</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
        
      </el-tab-pane>
 

      <!-- 中奖纪录 积分锁权 -->
      <!-- v-if="fitersChooseIF([35,37])" -->
      <!-- 1已改 -->
      <el-tab-pane
        label="中奖记录"
        name="sixteen"
        v-if="fitersChooseIF([35, 37])"
      >
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'sixteen'" :activityId="rowData.id" />
        <!-- 明细 -->
        <div class="award-title">
          <span>中奖记录明细</span>
        </div>
        <!-- <input-form
          :inputData="inputAwardFour"  
          ref="export_fun16"
          @toParentVal="searchAwardFour"
          :btnPosition2="true"
        ></input-form> -->
        <jd-form
          :form-info="inputAwardFour"
          @search="searchAwardFour"
          ref="sixteenInputRef"
          style="margin-bottom: 16px"
        ></jd-form>
        <jd-button
          type="blue"
          style="margin-bottom: 16px"
          @click="batchLock()"
          v-preventReClick
          >批量发货</jd-button
        >
        <!-- <el-button style="float: left; margin-bottom: 20px" @click="getApi_Exprot" v-preventReClick>导出</el-button> -->
        <jd-button
          type="text"
          style="float: right; margin-top: 20px"
          @click="export_get"
          v-preventReClick
          >导出</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="awardTable"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column prop="pin" label="用户PIN" width="120">
            </el-table-column> -->
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="activityName" label="活动名称">
            </el-table-column>
            <el-table-column prop="memberLevel" label="会员等级">
              <template slot-scope="scope">
                <span>{{ levelMap[scope.row.memberLevel] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="memberNick" label="姓名">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.memberNick }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.memberNick &&
                      scope.row.memberNick.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'memberNick',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="120">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.mobile }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.mobile && scope.row.mobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'mobile',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receiverAddress" label="地区" width="210">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.receiverAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.receiverAddress &&
                      scope.row.receiverAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'receiverAddress',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="detailedAddress"
              label="详细地址"
              width="210"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.detailedAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.detailedAddress &&
                      scope.row.detailedAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'detailedAddress',
                        'awardTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="sendStatusStr" label="发放状态">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
            </el-table-column>
            <el-table-column prop="sendTime" label="发放时间">
            </el-table-column>
            <el-table-column prop="deliveryStatusStr" label="发货状态">
            </el-table-column>
            <el-table-column prop="billCode" label="快递单号">
            </el-table-column>
            <el-table-column prop="deliveryTime" label="发货时间">
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.status == 1"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
                > -->
                <jd-button
                  type="blueText"
                  v-if="scope.row.sendStatus == 1"
                  @click="sendGoods(scope.row)"
                  style="text-align: left; margin-right: 8px"
                  >发货</jd-button
                >
                <jd-button
                  type="blueText"
                  v-else
                  style="text-align: left; margin-right: 8px"
                  disabled
                  >发货</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
        <div
          class="new-pagination-page"
          style="margin-top: 20px"
          v-if="totalAward > 10"
        >
          <el-pagination
            style="text-align: right"
            @size-change="handleSizeAward"
            background
            @current-change="handleCurrentAward"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalAward"
            :current-page="formList.current"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <!-- 领奖记录 打榜有礼  -->
      <el-tab-pane
        label="领奖记录(冲榜)"
        name="twenty-one"
        v-if="fitersChooseIF([36])"
      >
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'twenty-one'" :activityId="rowData.id" />
        <!-- 明细 -->
        <div class="award-title">
          <span>领奖记录明细</span>
        </div>
        <!-- <input-form
          :inputData="inputAwardFiften"
          :defaultSelectArr="true"
          ref="export_fun_lj2"
          @toParentVal="searchAwardFifteen"
          :btnPosition2="true"
        ></input-form> -->
        <jd-form
          ref="export_fun_lj2"
          :form-info="inputAwardFiften"
          @search="searchAwardFifteen"
          style="margin-bottom: 16px"
        >
        </jd-form>
        <div class="flex-spc-x mb12 mt16">
         <div>
          <jd-button @click="addCrowd(3)">按查询结果生成人群</jd-button>
          <jd-button
              @click="handleSendPrize"
              >补发奖品</jd-button
            >
         </div>
          <jd-button type="text" @click="control3 = true" v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="mb12">总计中奖人数：{{rankWinPeoples}}人（去重）</div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="activityTable"
            ref="awardTableRef"
          >
            <!-- <el-table-column
              prop="pin"
              label="用户PIN"
              width="150"
            >
            </el-table-column> -->
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}）`"
              width="150"
            >
            </el-table-column>
            <el-table-column
              :prop="item.prop"
              :label="item.label"
              :width="item.width ? item.width : '160'"
              :key="index"
              v-for="(item, index) in chongBangAwardList"
            >
              <template
                slot="header"
                v-if="
                  item.prop == 'totalPayMoney' ||
                  item.prop == 'totalFinishMoney'
                "
              >
                <span>{{ item.label }}</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="自营店铺为订单金额，POP店铺统计规则以活动实际设置为准"
                  placement="top"
                >
                  <span class="question_iconOne">?</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-tooltip
                  effect="light"
                  :content="scope.row.orderIdStr"
                  placement="top"
                  v-if="item.prop == 'orderIdStr'"
                >
                  <div class="two-line">{{ scope.row.orderIdStr }}</div>
                </el-tooltip>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <jd-button
                  type="blueText"
                  @click="chongBangAwardMark(scope.row)"
                  v-if="scope.row.status == 4"
                >
                  标记发放</jd-button
                >
                <jd-button
                  type="blueText"
                  @click="chongBangAwardMark(scope.row)"
                  v-if="scope.row.status == 6"
                >
                  取消发放</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
        <div
          class="new-pagination-page"
          style="margin-top: 20px"
          v-if="totalAward > 10"
        >
          <el-pagination
            style="text-align: right"
            @size-change="handleFifteenWinRecordSize"
            background
            @current-change="handleFifteenWinCurrent"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalAward"
            :current-page="formList.current"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="领奖记录(额外奖品)"
        name="twenty-two"
        v-if="fitersChooseIF([36])&&isShowExtraWinRecord"
      >
        <!-- 奖品预览 -->
        <!-- <prizeList v-if="activeName == 'twenty-two'" :activityId="rowData.id" /> -->
        <!-- 明细 -->
        <!-- <div class="award-title">
          <span>领奖记录明细</span>
        </div> -->
        <jd-form
          ref="export_fun_extra"
          :form-info="inputAwardExtra"
          @search="searchAwardExtra"
          style="margin-bottom: 16px"
        >
        </jd-form>
        <div class="flex-spc-x mb12 mt16">
          <div>
            <jd-button @click="addCrowd(3)">按查询结果生成人群</jd-button>
            <jd-button
                @click="handleSendPrize"
                >补发奖品</jd-button
              >
          </div>
          <jd-button type="text" @click="control3 = true" v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="mb12">总计中奖人数：{{rankWinPeoples}}人（去重）</div>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="activityTable"
            ref="awardTableRef"
          >
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
            >
            </el-table-column>
            <el-table-column
              :prop="item.prop"
              :label="item.label"
              :width="item.width ? item.width : '160'"
              :key="index"
              v-for="(item, index) in chongBangExraAwardList"
            >
            </el-table-column>
            <!-- 操作 -->
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <jd-button
                  type="blueText"
                  @click="chongBangAwardMark(scope.row)"
                  v-if="scope.row.status == 4"
                >
                  标记发放</jd-button
                >
                <jd-button
                  type="blueText"
                  @click="chongBangAwardMark(scope.row)"
                  v-if="scope.row.status == 6"
                >
                  取消发放</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
        <div
          class="new-pagination-page"
          style="margin-top: 20px"
          v-if="totalAward > 10"
        >
          <el-pagination
            style="text-align: right"
            @size-change="handleFifteenWinRecordSize"
            background
            @current-change="handleFifteenWinCurrent"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formExtra.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalAward"
            :current-page="formExtra.current"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <!-- 收货信息 锁权和派样回购-->
      <!-- 2已改 -->
      <!-- v-if="fitersChooseIF([35, 37])" -->
      <el-tab-pane
        label="收货信息"
        name="seventeen"
        v-if="fitersChooseIF([35, 37])"
      >
        <!-- <input-form
          :inputData="inputTakeGoods"
          ref="export_fun17"
          @toParentVal="searchTakeGoods"
          :btnPosition2="true"
        ></input-form> -->
        <jd-form
          :form-info="inputTakeGoods"
          @search="searchTakeGoods"
        ></jd-form>
        <jd-button
          style="float: right; margin-top: 16px; margin-bottom: 12px"
          @click="export_get"
          v-preventReClick
          >导出</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="takeGoodsTable"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: totalTakeGoods,
            }"
            @handlePage="handleSizeTakeGoodsPages"
          >
            <!-- <el-table-column prop="pin" label="用户PIN" width="120">
            </el-table-column> -->
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="activityName" label="活动名称">
            </el-table-column>
            <el-table-column prop="memberNick" label="姓名">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.memberNick }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.memberNick &&
                      scope.row.memberNick.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'memberNick',
                        'takeGoodsTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="120">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.mobile }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.mobile && scope.row.mobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'mobile',
                        'takeGoodsTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receiverAddress" label="地区" width="210">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.receiverAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.receiverAddress &&
                      scope.row.receiverAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'receiverAddress',
                        'takeGoodsTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="detailedAddress"
              label="详细地址"
              width="210"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.detailedAddress }}
                  <div
                    class="openHover"
                    v-if="
                      scope.row.detailedAddress &&
                      scope.row.detailedAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt(
                        'detailedAddress',
                        'takeGoodsTable',
                        scope.row,
                        scope.$index
                      )
                    "
                  >
                    展开
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="inputTime"
              label="录入时间"
            ></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <jd-button
                  type="blueText"
                  @click="editAddress(scope.row)"
                  style="text-align: left"
                  >修改</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
        <!-- <div class="new-pagination-page" style="margin-top: 16px">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeTakeGoods"
            background
            @current-change="handleCurrentTakeGoods"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="this.totalTakeGoods"
            :current-page="formList.current"
          ></el-pagination>
        </div> -->
      </el-tab-pane>
      <!-- 1已改 -->
      <!-- 实物奖品 -->
      <!-- <el-tab-pane label="实物奖品名单" name="four" v-if="fitersChooseIF([1, 3, 4, 5, 6, 7, 8, 16, 17, 18, 19, 20, 22, 23, 24, 26])"> -->
      <el-tab-pane
        label="实物奖品名单"
        name="four"
        v-if="
          fitersChooseIF(
            [
              13, 14, 15, 21, 25, 9, 10, 29, 30, 31, 32, 33, 35, 36, 37, 38, 39,
              46, 50,55,58,59,60,61,62,63,67,69,74,75,78,89
            ],
            '!='
          )
        "
      >
        <jd-form
          :form-info="getNewMaterialInputData"
          @search="searchInkind"
          ref="export_fun_swRef"
          class="mb16"
        />
        <div class="flex-spc-x mb12">
          <div>
            <jd-button
              v-if="fitersChooseIF([51])"
              type="break"
              @click="addCrowd(35)"
              :disabled="!inkindTable.length"
              >按查询结果生成人群</jd-button
            >
            <jd-button
              v-if="fitersChooseIF([52])"
              type="break"
              @click="addCrowd(39)"
              :disabled="!inkindTable.length"
              >按查询结果生成人群</jd-button
            >
            <jd-button
              type="break"
              v-else
              @click="addCrowd(4)"
              :disabled="!inkindTable.length"
              >按查询结果生成人群</jd-button
            >
            <jd-button
              @click="batchMarkForShipment"
              v-preventReClick
              :disabled="!inkindTable.length"
              >批量标记发货</jd-button
            >
          </div>
          <div>
            <jd-button
              type="text"
              @click="searchInkind_export_fun"
              v-preventReClick
              >导出</jd-button
            >
          </div>
        </div>
        <jd-table
          :loading="loading"
          :tableData="inkindTable"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalInkind,
          }"
          rowKey="id"
          :selection="true"
          @selection-change="handleSelectionChange"
          @handlePage="handlePageInkind"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="180">
          </el-table-column>
          <el-table-column prop="memberLevel" label="会员等级">
            <template slot-scope="scope">
              <span>{{ levelMap[scope.row.memberLevel] || '' }}</span>
            </template>
          </el-table-column>
          <!-- v-if="fitersChooseIF([19])" -->
          <el-table-column  prop="sellerLinkName" label="投放渠道" width="180"></el-table-column>
          <el-table-column prop="recordId" label="中奖ID" width="180">
          </el-table-column>
          <el-table-column label="中奖订单" width="160">
            <template slot-scope="{ row }">
              <div v-if="row.winOrders && row.winOrders.length > 0">
                <div v-for="(order, index) in row.winOrders" :key="index" style="margin-bottom: 5px;">
                  <el-tooltip effect="light" placement="top-start">
                    <template slot="content">
                      <div class="order-info">
                        <div>订单号：{{ order.orderId || '-' }}</div>
                        <div>订单金额：{{ order.orderPayment ? order.orderPayment + '元' : '-' }}</div>
                        <div>订单状态：{{ order.orderStateRemark || '-' }}</div>
                      </div>
                    </template>
                    <span style="color: #3159ff; cursor: pointer;">{{ order.orderId || "-" }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="winOrderBelongShopNameStr" label="下单店铺" width="180">
            <template slot-scope="{ row }">
              {{ row.winOrderBelongShopNameStr || '-' }}
            </template>
          </el-table-column>
          <el-table-column  prop="orderPriceSum" label="订单金额" width="180"></el-table-column>
          <el-table-column prop="prizeTitle" label="奖品名称" width="180">
          </el-table-column>
          <el-table-column prop="winOrderStr" label="中奖订单" width="180" v-if="actTypeMap.includes(rowData.activityType)">
            <template slot-scope="scope">
              <div v-if="scope.row.winOrderStr">{{ scope.row.winOrderStr }}</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="winOrderBelongShopNameStr" label="下单店铺" width="180" v-if="actTypeMap.includes(rowData.activityType)">
          </el-table-column>
          <el-table-column prop="orderPriceSum" label="订单金额" width="180" v-if="actTypeMap.includes(rowData.activityType)">
          </el-table-column> -->
          <el-table-column
            prop="prizeTitle"
            label="附加信息"
            width="200"
          >
           <template slot="header" slot-scope="scope">
            <span>附加信息</span>
           </template>
           <template slot-scope="scope">
            <div v-if="scope.row.shouldCollectExtraData==1">
              <div v-html="getAnswerText(scope.row)"></div>
            </div>
            <div v-else>-</div>
           </template>
          </el-table-column>
          <el-table-column
            label="商品信息"
            v-if="!fitersChooseIF([44, 47, 48, 52, 53])"
            width="300"
          >
            <template slot-scope="scope">
              <div class="goodsInfo">
                <div class="goodsInfo_logo">
                  <img :src="scope.row.logo" alt="" />
                </div>
                <template v-if="scope.row.isGoodManage != 1">
                  <div
                    class="goodsInfo_text"
                    @click="jumpTo"
                    v-if="scope.row.skuId"
                  >
                    <a
                      :href="`http://item.jd.com/${scope.row.skuId}.html`"
                      target="_blank"
                      >{{ scope.row.skuName }}<br />
                      <span style="color: #666666"
                        >skuId:{{ scope.row.skuId }}</span
                      >
                    </a>
                  </div>
                  <div class="goodsInfo_text" v-else>
                    <div>{{ scope.row.skuName }}</div>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="goodsInfo_text"
                    @click="jumpTo"
                    v-if="scope.row.assetsId"
                  >
                    <a
                      @click="handleToGoods(scope.row.assetsId)"
                      target="_blank"
                      >{{ scope.row.title }}<br />
                      <span style="color: #666666"
                        >id:{{ scope.row.assetsId }}</span
                      >
                    </a>
                  </div>
                  <div class="goodsInfo_text" v-else>
                    <div>{{ scope.row.title }}</div>
                  </div>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="fitersChooseIF([41, 44, 47, 48, 52, 53], '!=')"
            prop="sendTime"
            :label="
              fitersRepurchase([16, 17, 18, 19, 27, 28], '领奖时间', '中奖时间')
            "
            width="280"
          >
          </el-table-column>
          <el-table-column
            prop="prizeStatus"
            v-if="fitersChooseIF([16, 18, 17, 19, 27, 28])"
            :label="fitersChooseIF([16, 18, 17, 27]) ? '发放状态' : '中奖状态'"
            width="280"
          >
            <template slot-scope="scope">
              <jd-status v-if="scope.row.prizeStatus == -1" :status="2"
                >待领取</jd-status
              >
              <span v-if="scope.row.prizeStatus == 0">-</span>
              <jd-status v-if="scope.row.prizeStatus == 1" :status="4"
                >未中奖</jd-status
              >
              <jd-status
                v-if="scope.row.prizeStatus == 2"
                :status="fitersChooseIF([19]) ? 0 : 2"
              >
                {{ fitersChooseIF([19]) ? "已中奖" : "待发放" }}
              </jd-status>
              <jd-status v-if="scope.row.prizeStatus == 3" :status="0"
                >已发放</jd-status
              >
              <jd-status v-if="scope.row.prizeStatus == 4" :status="4"
                >发放失败</jd-status
              >
              <jd-status v-if="scope.row.prizeStatus == 5" :status="0"
                >已发放</jd-status
              >
              <jd-status v-if="scope.row.prizeStatus == 6" :status="0"
                >已发放</jd-status
              >
              <jd-status v-if="scope.row.prizeStatus == 7" :status="2"
                >待发放</jd-status
              >
              <jd-status v-if="scope.row.prizeStatus == 8" :status="4"
                >已失效</jd-status
              >
            </template>
          </el-table-column>
          <el-table-column prop="grantTime" label="发货时间" width="280">
          </el-table-column>
          <el-table-column prop="grantTime" label="发货状态">
            <template slot-scope="scope">
               <jd-status :status="scope.row.status == 5?0:4">{{ scope.row.status == 5 ? "已发货" : "未发货" }}</jd-status>
            </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="收件人">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName ? scope.row.receiverName : "-" }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverName &&
                    scope.row.receiverName.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverName',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverMobile"
            label="收件人手机号"
            width="120"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile ? scope.row.receiverMobile : "-" }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverMobile',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverAddress"
            label="收件人地区"
            width="210"
          >
            <template slot-scope="scope">
              <div class="open">
                {{
                  scope.row.receiverAddress ? scope.row.receiverAddress : "-"
                }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverAddress',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="detailedAddress"
            label="收件人详细地址"
            width="210"
          >
            <template slot-scope="scope">
              <div class="open">
                {{
                  scope.row.detailedAddress ? scope.row.detailedAddress : "-"
                }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'detailedAddress',
                      'inkindTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiverCode"
            label="邮编"
            v-if="fitersChooseIF([41, 44, 47, 48, 52, 53], '!=')"
          >
          </el-table-column>
          <el-table-column prop="billCode" label="快递单号"> </el-table-column>
          <el-table-column label="操作" min-width="240">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 5" @click="markIss(scope.row)"><i class="y4"></i>取消发货</span>
                <span v-if="scope.row.status == '2,7'" @click="markIss(scope.row)"><i class="y3"></i>标记发货</span> -->
              <jd-button
                type="blueText"
                v-if="scope.row.status == 5"
                @click="markIss(scope.row)"
                >取消发货</jd-button
              >
              <jd-button
                type="blueText"
                v-if="scope.row.status == '2' || scope.row.status == '7'"
                @click="markIss(scope.row)"
                :disabled="!scope.row.id"
                >标记发货</jd-button
              >
              <!-- <jd-button
                type="blueText"
                :disabled="
                  (scope.row.status == '2' || scope.row.status == '7') &&
                  !scope.row.id
                "
                v-if="
                  (scope.row.status == '2' || scope.row.status == '7') &&
                  !scope.row.id
                "
              >
                标记发货
              </jd-button> -->
              <!-- 京获客v2.5迭代：快递单号登记 -->
              <jd-button
                type="blueText"
                @click="handleEnterCoutierNum(scope.row)"
                v-if="scope.row.id"
                >录入快递单号</jd-button
              >
              <jd-button type="blueText" :disabled="!scope.row.id" v-else
                >录入快递单号</jd-button
              >
              <jd-button
                type="blueText"
                @click="editAddress(scope.row)"
                v-if="
                  fitersChooseIF([16]) &&
                  (scope.row.prizeStatus == 2 ||
                    scope.row.prizeStatus == 3 ||
                    scope.row.prizeStatus == 5 ||
                    scope.row.prizeStatus == 6 ||
                    scope.row.prizeStatus == 7)
                "
                >修改信息</jd-button
              >
              <jd-button type="greyText" v-else-if="fitersChooseIF([16])"
                >修改信息</jd-button
              >
              <jd-button
                type="blueText"
                @click="revocationDeliverGoods(scope.row)"
                v-if="
                  fitersChooseIF([45, 47, 48, 51, 53,81,82,83,84,85], '!=') &&
                  (scope.row.prizeStatus == 3 ||
                    scope.row.prizeStatus === 5 ||
                    scope.row.prizeStatus === 6 ||
                    scope.row.prizeStatus === 2 ||
                    scope.row.prizeStatus === 7)
                "
                >撤回奖品</jd-button
              >
              <jd-button
                type="blueText"
                v-if="scope.row.status != 5 && scope.row.status != 8"
                @click="editAddress(scope.row)"
              >
                修改地址
              </jd-button>
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>

      <!-- TODO:销售打榜订单明细 -->
      <el-tab-pane
        label="订单明细"
        name="orderRankDetail"
        v-if="fitersChooseIF([67,68])"
      >
        <jd-form
          class="mb16"
          :form-info="inputParticipatSalesRankingDetail"
          @search="showOrderDetails"
          ref="participatSalesRankingDetailRef"
        ></jd-form>
        <jd-button
           v-if="fitersChooseIF([67])"
          type="text"
          @click="getphone_38()"
          style="float: right; margin-top: 10px;margin-bottom:10px"
          v-permission="'hide:checkOrder:export'"
          >导出</jd-button
        >
        <jd-button
           v-if="fitersChooseIF([68])"
          type="text"
          @click="getphone_45()"
          style="float: right; margin-top: 10px;margin-bottom:10px"
          v-permission="'hide:checkOrder:export'"
          >导出</jd-button
        >
        <orderDetailOverview ref="orderDetailOverviewRef2" :rowData="rowData"></orderDetailOverview>
        <div class="new-table-box">
          <jd-table
            :key="tableKey"
            :loading="loading"
            :tableData="orderDetailTable"
            :pageInfo="{
              pageNum: formListLockFans.current,
              pageSize: formListLockFans.size,
              total: totalOrderDetail,
            }"
            @handlePage="handleCurrentParticipatRank"
          >
            <el-table-column prop="orderId" label="订单号">
            </el-table-column>
            <el-table-column prop="rootId" label="父订单号">
              <template slot-scope="scope">
                {{ scope.row.rootId || '-' }}
              </template>
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称" width="150">
            </el-table-column>
            <el-table-column prop="orderStartTime" label="下单时间"> </el-table-column>
            <el-table-column prop="paymentConfirmTime" label="付款时间"> </el-table-column>
            <el-table-column  v-if="fitersChooseIF([67])" prop="orderAmount" label="订单金额"> </el-table-column>
            <el-table-column  v-if="fitersChooseIF([68])" prop="orderPayment" label="订单金额"> </el-table-column>
            <el-table-column prop="skuNameList" label="商品名称" min-width="200">
              <template slot="header">
                <span>商品名称</span>
                <el-button 
                  type="text" 
                  class="header-expand-btn"
                  @click.stop="toggleGoodsNameExpand"
                >
                  【展开】
                </el-button>
              </template>
              <template slot-scope="scope">
                <div 
                  class="goods-name-text" 
                  :class="{ 'ellipsis-single': !goodsNameColumnExpanded}"
                >
                  {{ scope.row.itemName ? (Array.isArray(scope.row.itemName) ? scope.row.skuNameList.join('，') : scope.row.itemName) : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="orderStateRemark" label="订单状态"> </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 试用回购礼-试用订单明细 -->
      <el-tab-pane
        label="试用订单明细"
        name="lockJoinRecord1"
        v-if="fitersChooseIF([52])"
      >
        <jd-form
          :form-info="orderTrial"
          @search="searchParticipationLockFormOrder($event,0)"
          ref="lockJoinRecordRef"
          class="mb16"
        ></jd-form>
        <jd-button
          type="text"
          @click="getphone_37()"
          style="float: right; margin-top: 10px;margin-bottom:10px"
          v-permission="'hide:checkOrder:export'"
          >导出</jd-button
        >
        <orderDetailOverview ref="orderDetailOverviewRef3" :rowData="rowData"></orderDetailOverview>
        <div class="new-table-box">
          <jd-table
            :key="tableKey"
            :loading="loading"
            :tableData="ParticipatLockTableTrialOrder"
            :pageInfo="{
                pageNum: formListLockOrder.current,
                pageSize: formListLockOrder.size,
                total: totalParticipatLockOrder,
              }"
              @handlePage="handleSizeParticipatLockOrder"
          >
            <el-table-column prop="orderId" label="订单号">
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"   width="150">
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称" width="150">
            </el-table-column>
            <el-table-column prop="orderStartTime" label="下单时间">
             </el-table-column>
              <el-table-column prop="skuNameList" label="商品名称" min-width="200">
              <template slot="header">
                <span>商品名称</span>
                <el-button 
                  type="text" 
                  class="header-expand-btn"
                  @click.stop="toggleGoodsNameExpand"
                >
                  【展开】
                </el-button>
              </template>
              <template slot-scope="scope">
                <div 
                  class="goods-name-text" 
                  :class="{ 'ellipsis-single': !goodsNameColumnExpanded }"
                >
                  {{ scope.row.itemName ? (Array.isArray(scope.row.itemName) ? scope.row.skuNameList.join('，') : scope.row.itemName) : '' }}
                </div>
              </template>
            </el-table-column>
             <el-table-column prop="paymentConfirmTime" label="付款时间">
            </el-table-column>
            <el-table-column prop="orderPayment" label="订单金额"> </el-table-column>
            <el-table-column prop="orderStatus" label="订单状态">
              <template #default="{row}">
                <jd-status :status="getStatus1(row.orderStatus,row.orderState)">{{ row.orderStatus }}</jd-status> 
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 试用回购礼-正装订单明细 -->
      <el-tab-pane
        label="正装订单明细"
        name="lockJoinRecord2"
        v-if="fitersChooseIF([52])"
      >
        <jd-form
          :form-info="orderTrial"
          @search="searchParticipationLockFormOrder($event,1)"
          ref="lockJoinRecordRef2"
          class="mb16"
        ></jd-form>
        <jd-button
          type="text"
          @click="getphone_37()"
          style="float: right; margin-top: 10px;margin-bottom:10px"
          v-permission="'hide:checkOrder:export'"
          >导出</jd-button
        >
        <orderDetailOverview ref="orderDetailOverviewRef4" :rowData="rowData"></orderDetailOverview>
        <div class="new-table-box">
          <jd-table
            :key="tableKey"
            :loading="loading"
            :tableData="ParticipatLockTableTrialOrder"
            :pageInfo="{
                pageNum: formListLockOrder.current,
                pageSize: formListLockOrder.size,
                total: totalParticipatLockOrder,
              }"
              @handlePage="handleSizeParticipatLockOrder"
          >
            <el-table-column prop="orderId" label="订单号">
            </el-table-column>
            <el-table-column prop="chaosPin" label="用户pin"   width="150">
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称" width="150">
            </el-table-column>
            <el-table-column prop="orderStartTime" label="下单时间">
             </el-table-column>
              <el-table-column prop="skuNameList" label="商品名称" min-width="200">
              <template slot="header">
                <span>商品名称</span>
                <el-button 
                  type="text" 
                  class="header-expand-btn"
                  @click.stop="toggleGoodsNameExpand"
                >
                  【展开】
                </el-button>
              </template>
              <template slot-scope="scope">
                <div 
                  class="goods-name-text" 
                  :class="{ 'ellipsis-single': !goodsNameColumnExpanded, 'ellipsis-double': goodsNameColumnExpanded }"
                >
                  {{ scope.row.itemName ? (Array.isArray(scope.row.itemName) ? scope.row.skuNameList.join('，') : scope.row.itemName) : '' }}
                </div>
              </template>
            </el-table-column>
             <el-table-column prop="paymentConfirmTime" label="付款时间">
            </el-table-column>
            <el-table-column prop="orderPayment" label="订单金额"> </el-table-column>
            <el-table-column prop="orderStatus" label="订单状态">
              <template #default="{row}">
                <jd-status :status="getStatus1(row.orderStatus,row.orderState)">{{ row.orderStatus }}</jd-status> 
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 登记生日信息 -->
      <el-tab-pane
        label="登记生日信息"
        name="birthInfo"
        v-if="fitersChooseIF([39])"
      >
        <birthInfo v-if="activeName == 'birthInfo'" :activityId="rowData.id" :birthInfoFormList.sync="birthInfoFormList" @addCrowd="addCrowd"/>
      </el-tab-pane>
      <!-- 领取记录 -->
      <el-tab-pane
        label="领取记录"
        name="getRecord"
        v-if="fitersChooseIF([39])"
      >
        <!-- 奖品预览 -->
        <prizeList v-if="activeName == 'getRecord'" :activityId="rowData.id" />
        <!-- 明细 -->
        <jd-title label="领取记录明细"></jd-title>
        <jd-form
          :form-info="getRecordFormInfo"
          @search="searchFormRecord"
          ref="getRecordFormRef"
          :formData.sync="formListRecord"
          class="mt16 mb16"
        />
        <div class="mb12 flex-spc-x">
          <jd-button @click="addCrowd(3)">按查询结果生成人群</jd-button>
          <jd-button @click="getRewardExport" type="text" v-preventReClick
            >导出</jd-button
          >
        </div>
        <div class="mb12">总计中奖人数：{{allWinPeoples}}人（去重）</div>
        <!-- 表格 -->
        <jd-table
          :tableData="getRecordList"
          :pageInfo="{
            pageNum: formListRecord.current,
            pageSize: formListRecord.size,
            total: totalRecord,
          }"
          @handlePage="handlePageExchangeRecord"
          :loading="loading"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="id" label="中奖ID">
          </el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道" ></el-table-column>
          <el-table-column prop="memberNick" label="登记生日">
            <template slot-scope="scope">
              <span>{{
                scope.row.birthDay ? scope.row.birthDay.split(" ")[0] : "-"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column label="领奖类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeObjectType  == 0">生日奖品</span>
              <span v-else-if="scope.row.prizeObjectType == 1">兜底奖品</span>
              <span v-else>/</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeType" label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
              <span v-else-if="scope.row.prizeType == 2"> 京豆 </span>
              <span v-else-if="scope.row.prizeType == 3"> 实物 </span>
              <span v-else-if="scope.row.prizeType == 4"> 店铺积分 </span>
              <span v-else-if="scope.row.prizeType == 5"> E卡 </span>
              <span v-else-if="scope.row.prizeType == 6"> 爱奇艺会员 </span>
              <span v-else-if="scope.row.prizeType == 7"> 京豆PlUS会员 </span>
              <span v-else-if="scope.row.prizeType == 8"> 红包 </span>
              <span v-else-if="scope.row.prizeType == 9"> 谢谢参与 </span>
              <span v-else-if="scope.row.prizeType == 10"> 礼品卡 </span>
              <span v-else-if="scope.row.prizeType == 13">令牌</span>
              <span v-else-if="scope.row.prizeType == 12">专享价</span>
              <span v-else-if="scope.row.prizeType == 14">实物（随单发）</span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeName">
                {{ scope.row.prizeName }}
              </span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="compensationPrizeName" label="补发奖品名称">
          </el-table-column>
          <el-table-column  label="生日池奖品" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.birthGiftPrize">
                <el-tooltip
                  placement="top"
                  popper-class="new-tooltip-width"
                >
                  <div slot="content">
                    {{ scope.row.birthGiftPrize }}
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-left: 5px;
                      width: 140px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                  {{ scope.row.birthGiftPrize }}
                  </div>
                </el-tooltip>
              </span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="参与时间"></el-table-column>
          <el-table-column prop="status" label="中奖状态">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 2"><jd-status :status="0">已中奖</jd-status></span>
              <span
                v-if="
                  scope.row.status == 3 ||
                  scope.row.status == 5 ||
                  scope.row.status == 6
                "
                ><jd-status :status="0">已发放</jd-status></span
              >
              <span v-if="scope.row.status == 4"><jd-status :status="3">发放失败</jd-status></span> -->
              <span>{{scope.row.statusStr}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="winTime" label="领奖时间"> </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <jd-button
                @click="recordMark(scope.row)"
                v-if="scope.row.status == 4"
                type="blueText"
              >
                标记发放</jd-button
              >
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>
      <!-- 收集机会获取记录 -->
      <el-tab-pane
        label="收集机会获取记录"
        name="collectOpportunitiesRecord"
        v-if="fitersChooseIF([39])"
      >
        <collectOpportunitiesRecord v-if="activeName == 'collectOpportunitiesRecord'"  :activityId="rowData.id" :collectInfoFormList.sync="collectInfoFormList" @addCrowd="addCrowd" @exportTask="exportTask"/>
     </el-tab-pane>
      <!-- 1已改 -->
      <!-- 打榜有礼实物奖品名单-->
      <el-tab-pane
        :label="'实物奖品名单'"
        name="twenty"
        v-if="fitersChooseIF([36, 39,62])"
      >
        <!-- :formData.sync="formList" -->
        <jd-form
          :form-info="
            rowData.activityType == 39 ? inputInkindInfo3 : inputInkindInfo2
          "
          @search="searchGoodRecordsPage"
          ref="export_fun_sw2"
          class="mt16 mb16"
        />
        <div class="mb12 flex-spc-x">
          <div>
            <jd-button v-if="rowData.activityType != 39" @click="addCrowd(4)"
              >按查询结果生成人群</jd-button
            >
            <jd-button @click="physicalBatchShipment" v-preventReClick
              >批量发货</jd-button
            >
          </div>
          <jd-button type="text" @click="goodsExportDialog" v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :tableData="goodsRecordTable"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward,
          }"
          @handlePage="handlePageGoodsRecord"
          :loading="loading"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column
            prop="memberNick"
            label="用户昵称"
            width="200"
          ></el-table-column>
          <el-table-column
            v-if="rowData.activityType == 39"
            prop="recordId"
            label="中奖ID"
            width="200"
          ></el-table-column>
          <el-table-column label="中奖订单" width="160">
            <template slot-scope="{ row }">
              <div v-if="row.winOrders && row.winOrders.length > 0">
                <div v-for="(order, index) in row.winOrders" :key="index" style="margin-bottom: 5px;">
                  <el-tooltip effect="light" placement="top-start">
                    <template slot="content">
                      <div class="order-info">
                        <div>订单号：{{ order.orderId || '-' }}</div>
                        <div>订单金额：{{ order.orderPayment ? order.orderPayment + '元' : '-' }}</div>
                        <div>订单状态：{{ order.orderStateRemark || '-' }}</div>
                      </div>
                    </template>
                    <span style="color: #3159ff; cursor: pointer;">{{ order.orderId || "-" }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="winOrderBelongShopNameStr" label="下单店铺" width="180">
            <template slot-scope="{ row }">
              {{ row.winOrderBelongShopNameStr || '-' }}
            </template>
          </el-table-column>
          <el-table-column  prop="orderPriceSum" label="订单金额" width="180"></el-table-column>
          <el-table-column
            prop="prizeTitle"
            label="奖品名称"
            width="200"
          ></el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道" width="150"></el-table-column>
          <el-table-column
            v-if="rowData.activityType == 36"
            prop="relatedOrders"
            label="相关订单"
            width="200"
          >
            <template slot-scope="scope">
            <jd-button type="blueText" @click="handleCheckOrderDetail(scope.row)">查看详情</jd-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="prizeTitle"
            label="附加信息"
            width="200"
          >
           <template slot="header" slot-scope="scope">
            <span>附加信息</span>
           </template>
           <template slot-scope="scope">
            <div v-if="scope.row.shouldCollectExtraData==1">
              <div v-html="getAnswerText(scope.row)"></div>
            </div>
            <div v-else>-</div>
           </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="姓名" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName ? scope.row.receiverName : "-" }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverName &&
                    scope.row.receiverName.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverName',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="rowData.activityType == 39"
            prop="receiverMobile"
            label="手机号码"
            width="150"
          >
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile ? scope.row.receiverMobile : "-" }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverMobile',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else prop="mobile" label="手机号码" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile ? scope.row.mobile : "-" }}
                <!-- <div
                  class="openHover"
                  v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="
                    handleDecrypt(
                      'mobile',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="rowData.activityType == 39"
            prop="receiverAddress"
            label="地区"
            width="200"
          >
            <template slot-scope="scope">
              <div class="open">
                {{
                  scope.row.receiverAddress ? scope.row.receiverAddress : "-"
                }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'receiverAddress',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedAddress" label="详细地址" width="200">
            <template slot-scope="scope">
              <div class="open">
                {{
                  scope.row.detailedAddress ? scope.row.detailedAddress : "-"
                }}
                <!-- <div
                  class="openHover"
                  v-if="
                    scope.row.detailedAddress &&
                    scope.row.detailedAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt(
                      'detailedAddress',
                      'goodsRecordTable',
                      scope.row,
                      scope.$index
                    )
                  "
                >
                  展开
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="item.label"
            :width="item.width ? item.width : '150'"
            :key="index"
            v-for="(item, index) in commonChongBangPhysicalList"
          >
            <template slot-scope="scope">
              <div v-if="rowData.activityType != 39">
                <span v-if="item.prop == 'prizeStatus'">{{
                  scope.row.prizeStatusStr
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </div>
              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <jd-button
                type="blueText"
                @click="chongBangPhysicalMark(scope.row)"
                size="small"
              >
                发货</jd-button
              >
              <jd-button
                type="blueText"
                v-if="scope.row.status != 5 && scope.row.status != 8"
                @click="editAddress(scope.row)"
              >
                修改地址
              </jd-button>
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>



      <!-- TODO:集卡抽卡记录 -->
      <el-tab-pane
        :label="'抽卡记录'"
        name="twenty12"
        v-if="fitersChooseIF([62])"
      >
        <jd-form
          :form-info="inputInkindInfo5"
          @search="searchGachaRecordsPage"
          :btn30="false"
          ref="export_fun_sw2"
          class="mt16 mb16"
        />
        <div class="mb12 flex-spc-x">
          <div>
            <jd-button @click="addCrowd(42)"
              >按查询结果生成人群</jd-button
            >
          </div>
          <jd-button type="text" @click="exportFnGacha" v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :tableData="gachaRecoeds"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward,
          }"
          @handlePage="handlePageGoodsRecordGacha"
          :loading="loading"
        >
        <el-table-column
            prop="memberNick"
            label="用户昵称"
          ></el-table-column>
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" >
          </el-table-column>
          <el-table-column
            prop="sellerLinkName"
            label="投放渠道"
          ></el-table-column>
          <el-table-column
            prop="gachaTime"
            label="抽卡时间"
          ></el-table-column>
         <el-table-column
            prop="cardName"
            label="卡片名称"
          ></el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道"> </el-table-column>
        </jd-table>
      </el-tab-pane>
      <!-- end -->

      <!-- TODO:集卡获取抽卡机会记录 -->
       <el-tab-pane
        :label="'获取抽卡机会记录'"
        name="twenty13"
        v-if="fitersChooseIF([62])"
      >
        <jd-form
          :form-info="inputInkindInfo6"
          @search="opportunities"
          :btn30="false"
          ref="export_fun_sw2"
          class="mt16 mb16"
        />
        <jd-table
          :tableData="goodsRecordTableChange"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward,
          }"
          @handlePage="handlePageGoodsGacha"
          :loading="loading"
        >
        <el-table-column
            prop="memberNick"
            label="用户昵称"
          ></el-table-column>
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" >
          </el-table-column>
          <el-table-column label="关联订单号">
            <template slot-scope="scope">
              <el-tooltip placement="top" popper-class="new-tooltip-width">
                <div slot="content">
                  {{ scope.row.orderListStr }}
                </div>
                <div
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                >
                  {{ scope.row.orderListStr }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="joinTime"
            label="获赠时间"
          ></el-table-column>
         <el-table-column
            prop="taskTypeStr"
            label="获赠类型"
          ></el-table-column>
          <el-table-column
            prop="giveTimes"
            label="赠送次数"
          ></el-table-column>
          <el-table-column
            prop="sellerLinkName"
            label="投放渠道"
          ></el-table-column>
        </jd-table>
      </el-tab-pane>
      <!-- end -->


      <!--TODO:1.58 趣味游戏 /盖楼有礼-->
      <el-tab-pane
        :label="'机会获取记录'"
        name="funGame"
        v-if="fitersChooseIF([71,76,79])"
      >
        <jd-form
          :form-info="funGame1"
          @search="changeFunGame"
          :btn30="false"
          ref="funGames"
          class="mt16 mb16"
        />
         <div class="mb12" v-if="fitersChooseIF([79],'!=')">
            <jd-button @click="isShowAddGiftNumberOne = true"
              >{{opportunityText}}变更</jd-button
            >
            <jd-button  @click="isShowAddGiftNumberBatchOne = true"
            >{{opportunityText}}变更（批量）</jd-button
          >
        </div>
        
        <!-- <div class="mb12 export-btn" v-else>
          <jd-button @click="exportTask" type="text" v-preventReClick :disabled="opportunity.length==0"
            >导出</jd-button
          >
        </div> -->
       
        <jd-table
          :tableData="opportunity"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: opportunityTotal,
          }"
          @handlePage="handlePageFunGame"
          :loading="loading"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" >
          </el-table-column>
          <el-table-column
            prop="memberNick"
            label="用户昵称"
          ></el-table-column>
          <el-table-column
            prop="sellerLinkName"
            label="投放渠道"
          ></el-table-column>
           <el-table-column
            prop="taskTypeStr"
            label="获赠类型"
          ></el-table-column>
          <el-table-column
            label="关联订单号"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                popper-class="new-tooltip-width"
              >
                <div slot="content">
                  {{scope.row.orderListStr}}
                </div>
                <div
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                >
                {{ scope.row.orderListStr }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="giveTimes"
            label="赠送次数"
            v-if="fitersChooseIF([79],'!=')"
          ></el-table-column>
          <el-table-column
            prop="code"
            label="盖楼口令"
            v-else-if="fitersChooseIF([79])"
          ></el-table-column>
          <el-table-column
            prop="joinTime"
            label="获赠时间"
          ></el-table-column>
        </jd-table>
      </el-tab-pane>

      <!-- TODO:1.51被邀请人明细 -->
      <el-tab-pane
        label="被邀请人明细"
        name="inviteesDetail"
        v-if="fitersChooseIF([64])"
      >
        <jd-form
          ref="inputAwardTeamInvitees"
          class="mt16 mb16"
          :form-info="invitees"
          @search="inviteeDetailsSearchOne"
          :btn30="true"
        >
        </jd-form>
        <div class="mb12 flex-spc-x">
         <div>
          <jd-button
            @click="addCrowd(44)"
            >按查询结果生成人群</jd-button
          >
         </div>
        <jd-button type="text" @click="exportFnGachaTree" v-preventReClick
            >导出</jd-button
          >
          </div>
        <jd-table
          :loading="loading"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: inviteesDataTotal,
          }"
          :tableData="inviteesData"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%;"
          @handlePage="handleSizeInviteDetailAllTee"
        >
          <el-table-column
            :prop="chaosParams"
            :label="`邀请人${searchGrayId}`"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="memberNick" label="邀请人昵称" >
          </el-table-column>
          <!-- <el-table-column prop="sellerLinkName" label="投放渠道" >
          </el-table-column> -->
          <el-table-column
            prop="invitePic"
            label="被邀请人头像"
            width="200"
          >
            <template slot-scope="scope">
             <img
               v-if="scope.row.invitePic"
               :src="scope.row.invitePic"
               style="width: 80px; height: 80px"
             />
          </template>
          </el-table-column>
          <el-table-column prop="inviteNick" label="被邀请人昵称" >
          </el-table-column>
          <el-table-column :prop="inviteChaos" :label="`被邀请人${searchGrayId}`" >
          </el-table-column>
          <el-table-column
            prop="teamName"
            label="加入的团队名称"
            width="150"
          >
            <!-- <template slot-scope="scope">
              <span>{{
                Number(scope.row.isValidInvite) == 1 ? "是" : "否"
              }}</span>
              <el-tooltip
                effect="dark"
                v-if="scope.row.isValidInvite != 1"
                :content="
                  nowActType == 1
                    ? '不满足成功入会且有付款条件'
                    : nowActType == 2
                    ? '不满足成功入会且有下单条件'
                    : '不满足成功入会'
                "
                placement="top-start"
              >
                <i
                  style="color: #ccc; margin-left: 4px; cursor: pointer"
                  v-if="scope.row.isValidInvite != 1"
                  class="el-icon-question"
                ></i>
              </el-tooltip>
            </template> -->
          </el-table-column>
          <el-table-column prop="createTime" label="邀请时间" >
          </el-table-column>
        </jd-table>
      </el-tab-pane> 


      <!--  TODO:1.51组队瓜分任务完成记录 -->
      <el-tab-pane
         :label="'任务完成记录'"
         name="twenty100"
         v-if="fitersChooseIF([64,65])"
        >
        <jd-form
          :form-info="taskCompletion"
          @search="taskCompletionChange"
          :btn30="false"
          ref="inputAwardTask"
          class="mt16 mb16"
        />
           <div class="mb12 flex-spc-x">
          <div>
            <jd-button @click="addCrowd(7)"
              >按查询结果生成人群</jd-button
            >
          </div>
          <jd-button type="text" @click="exportTask" v-preventReClick
            >导出</jd-button
          >
        </div>
        <jd-table
          :tableData="completionRecord"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: completionRecordTotalAward,
          }"
          @handlePage="taskCompletionhandlePage"
          :loading="loading"
        >
        <el-table-column
            prop="memberNick"
            label="用户昵称"
          ></el-table-column>
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" >
          </el-table-column>
          <el-table-column prop="typeName" label="任务归属"      
          v-if="
          fitersChooseIF(
            [
              65
            ],
            '!='
          )
        " >
          </el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道" >
          </el-table-column>
          <el-table-column
            prop="taskTypeStr"
            label="任务类型"
          ></el-table-column>
          <el-table-column
            prop="relOrderIds"
            label="关联订单"
          ></el-table-column>
        <el-table-column
            prop="joinTime"
            label="任务完成时间"
        ></el-table-column>
        </jd-table>
      </el-tab-pane>


      <!--TODO:集卡参与用户卡片详情 -->
      <el-tab-pane
        :label="'参与用户卡片详情'"
        name="twenty16"
        v-if="fitersChooseIF([62])"
      >
        <jd-form
          :form-info="inputInkindInfo7"
          @search="searchGoodRecordsPageOne"
          :btn30="false"
          ref="export_fun_sw2"
          class="mt16 mb16"
        />
        <jd-table
          :tableData="goodsRecordTableCard"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: totalAward,
          }"
          @handlePage="handlePageGoodsRecordCard"
          :loading="loading"
        >
        <el-table-column
            prop="memberNick"
            label="用户昵称"
          ></el-table-column>
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" >
          </el-table-column>
          <el-table-column
            prop="sellerLinkName"
            label="投放渠道"
          >
        </el-table-column>
          <!-- 动态卡片列 -->
          <el-table-column
            v-for="cardName in uniqueCardNames"
            :key="cardName"
            :label="cardName"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="getRowCardNames(scope.row).includes(cardName)">{{ getCardNum(scope.row.cardList, cardName) }}</span>
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>


      <!-- 资料明细 -->
      <!-- 2已改 -->
      <el-tab-pane label="用户资料明细" name="five" v-if="fitersChooseIF([7])">
        <!-- <input-form
          :inputData="inputUserInfo"
          @toParentVal="searchUserInfo"
          :btnPosition2="true"
        ></input-form> -->
        <jd-form :form-info="inputUserInfo" @search="searchUserInfo" />
        <div class="flex-end mb12 mt16">
          <jd-button type="text" @click="getphone()" v-preventReClick
            >导出</jd-button
          >
        </div>

        <div class="new-table-box">
          <jd-table
            :tableData="userInfoTable"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalUserInfo,
            }"
            @handlePage="handleUserPage"
          >
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              minWidth="150"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称" minWidth="150">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道" ></el-table-column>
            <el-table-column
              prop="createTime"
              label="资料填写时间"
              minWidth="150"
            ></el-table-column>
            <template v-for="val in RuleFieldsList">
              <el-table-column
                v-if="val == '姓名'"
                prop="name"
                label="姓名"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.name }}
                    <!-- <div
                      class="openHover"
                      v-if="scope.row.name && scope.row.name.indexOf('*') != -1"
                      @click="
                        handleDecrypt(
                          'name',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '手机号码'"
                prop="mobile"
                label="手机号"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.mobile }}
                    <!-- <div
                      class="openHover"
                      v-if="
                        scope.row.mobile && scope.row.mobile.indexOf('*') != -1
                      "
                      @click="
                        handleDecrypt(
                          'mobile',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '生日'"
                prop="birthDay"
                label="生日"
                minWidth="200"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.birthDay }}
                    <!-- <div
                      class="openHover"
                      v-if="
                        scope.row.birthDay &&
                        scope.row.birthDay.indexOf('*') != -1
                      "
                      @click="
                        handleDecrypt(
                          'birthDay',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == 'QQ'"
                prop="qq"
                label="QQ"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.qq }}
                    <!-- <div
                      class="openHover"
                      v-if="scope.row.qq && scope.row.qq.indexOf('*') != -1"
                      @click="
                        handleDecrypt(
                          'qq',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '微信'"
                prop="weChat"
                label="微信"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.weChat }}
                    <!-- <div
                      class="openHover"
                      v-if="
                        scope.row.weChat && scope.row.weChat.indexOf('*') != -1
                      "
                      @click="
                        handleDecrypt(
                          'weChat',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '性别'"
                label="性别"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    <span v-if="scope.row.sex.indexOf('*') != -1">{{
                      scope.row.sex
                    }}</span>
                    <span v-if="scope.row.sex == 0">未知</span>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <!-- <div
                      class="openHover"
                      v-if="scope.row.sex && scope.row.sex.indexOf('*') != -1"
                      @click="
                        handleDecrypt(
                          'sex',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '职业'"
                prop="job"
                label="职业"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.job }}
                    <!-- <div
                      class="openHover"
                      v-if="scope.row.job && scope.row.job.indexOf('*') != -1"
                      @click="
                        handleDecrypt(
                          'job',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '地区'"
                prop="address"
                label="地区"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.address }}
                    <!-- <div
                      class="openHover"
                      v-if="
                        scope.row.address &&
                        scope.row.address.indexOf('*') != -1
                      "
                      @click="
                        handleDecrypt(
                          'address',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '详细地址'"
                prop="detailedAddress"
                label="详细地址"
                minWidth="150"
                :key="val"
              >
                <template slot-scope="scope">
                  <div class="open">
                    {{ scope.row.detailedAddress }}
                    <!-- <div
                      class="openHover"
                      v-if="
                        scope.row.detailedAddress &&
                        scope.row.detailedAddress.indexOf('*') != -1
                      "
                      @click="
                        handleDecrypt(
                          'detailedAddress',
                          'userInfoTable',
                          scope.row,
                          scope.$index
                        )
                      "
                    >
                      展开
                    </div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="val == '扩展信息'"
                label="扩展信息"
                :key="val"
                minWidth="300"
              >
                <template slot-scope="scope">
                  <div style="display: flex; flex-wrap: wrap">
                    <div
                      v-for="(item, index) in showextendInfo(
                        scope.row.extendInfo
                      )"
                      class="info"
                    >
                      <div style="min-width: 60px; margin-right: 8px">
                        {{ item.prop }}:
                      </div>
                      <template v-if="item.isImg">
                        <div class="img-parent" v-for="child in item.keys">
                          <img
                            class="info-img"
                            :src="child"
                            :preview-src-list="[child]"
                          />
                          <div
                            class="mask"
                            @click="handlePictureCardPreview(child)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </div>
                        </div>
                      </template>
                      <span v-else style="margin-left: 4px">{{
                        item.keys
                      }}</span>
                      <span
                        v-if="
                          index !=
                          showextendInfo(scope.row.extendInfo).length - 1
                        "
                        >；</span
                      >
                    </div>
                  </div>
                </template>
              </el-table-column>
            </template>
          </jd-table>
        </div>
        <!-- <div class="new-pagination-page" style="margin-top: 16px">
          <el-pagination
            style="text-align: right;"
            @size-change="handleSizeUserInfo"
            background
            @current-change="handleCurrentUserInfo"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalUserInfo"
            :current-page="formList.current"
          ></el-pagination>
        </div> -->
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 发放记录 -->
      <el-tab-pane
        label="发放记录"
        name="six"
        v-if="fitersChooseIF([13, 14, 15,63,74,75])"
      >
        <jd-form
          style="margin-bottom: 16px"
          ref="sendRecordRef"
          :form-info="formAwardOne"
          @search="searchAward"
          :formData.sync="formList"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px"
          @click="addCrowd(12)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          type="text"
          width="80px"
          style="float: right; margin-top: 16px"
          @click="control1 = true"
          v-preventReClick
          >导出</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="distributionTable"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalDistribution,
            }"
            @handlePage="handlePageAwardOne"
          >
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column prop="activityName" label="活动名称">
            </el-table-column>
            <template v-if="rowData.activityType == 15">
              <el-table-column prop="sceneType" label="场景">
                <template slot-scope="scope">
                  <span v-if="scope.row.sceneType == 1">未关注店铺用户</span>
                  <span v-if="scope.row.sceneType == 2">店铺新客</span>
                  <span v-if="scope.row.sceneType == 3">plus会员</span>
                  <span v-if="scope.row.sceneType == 4">关注店铺用户</span>
                  <span v-if="scope.row.sceneType == 5">店铺会员</span>
                </template>
              </el-table-column>
            </template>
            <template v-if="rowData.activityType == 63">
              <el-table-column label="来源弹窗">
                <template slot-scope="scope">
                  <span>{{ scope.row.sourcePopupName }}</span>
                </template>
              </el-table-column>
            </template>
            <el-table-column label="奖品类型">
              <template slot-scope="scope">
                <span v-if="scope.row.prizeType == 1">优惠券</span>
                <span v-if="scope.row.prizeType == 2">京豆</span>
                <span v-if="scope.row.prizeType == 4">店铺积分</span>
              </template>
            </el-table-column>
            <el-table-column prop="prizeName" label="奖品名称">
            </el-table-column>
            <el-table-column label="发放状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0"><jd-status :status="4">未知</jd-status></span>
                <span v-if="scope.row.status == 3"><jd-status :status="0">已发放</jd-status></span>
                <span v-if="scope.row.status == 4"><jd-status :status="3">发放失败
                  <el-tooltip
                  effect="dark"
                  v-if="scope.row.status == 4"
                  :content="scope.row.failReason"
                  placement="top-start"
                >
                  <i
                    style="color: #ccc"
                    v-if="scope.row.status == 4"
                    class="el-icon-question"
                  ></i>
                </el-tooltip>
                </jd-status></span>
              </template>
            </el-table-column>
            <el-table-column label="发放时间">
              <template slot-scope="scope">
                <span>{{ scope.row.joinTime }} </span>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 抽奖机会赠送记录 -->
      <el-tab-pane
        :label="evaluateType == 0 ? '抽奖机会赠送记录' : '领奖机会赠送记录'"
        name="seven"
        v-if="fitersChooseIF([20])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formComment"
          @search="searchComment"
          :formData.sync="formList"
        ></jd-form>
        <jd-button style="margin-bottom: 12px" @click="addCrowd(5)"
          >按查询结果生成人群</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="CommentList"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalComment,
            }"
            @handlePage="handlePageComment"
          >
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="nickName" label="用户昵称">
            </el-table-column>
            <el-table-column prop="creationTime" label="评价时间">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="skuId" label="SKUID"></el-table-column>
            <el-table-column prop="orderId" label="订单号"> </el-table-column>
            <el-table-column label="过滤状态">
              <template slot-scope="scope">
                <span v-if="scope.row.filterType == 0"><jd-status :status='4'>未通过</jd-status></span>
                <span v-if="scope.row.filterType == 1"><jd-status :status='0'>通过</jd-status></span>
              </template>
            </el-table-column>
            <el-table-column prop="filterRemark" label="备注"></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <jd-button type="blueText" @click="commentDetails(scope.row)"
                  >查看详情</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 拼券明细 -->
      <el-tab-pane
        label="拼券明细"
        name="eight"
        v-if="fitersChooseIF([21, 31])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formCoupon"
          @search="searchCoupon"
          :btn30="true"
          :formData.sync="formList"
        ></jd-form>
        <jd-button style="margin-bottom: 12px" @click="addCrowd(9)"
          >按查询结果生成人群</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="couponDetailsList"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalCoupon,
            }"
            @handlePage="handlePageCoupond"
          >
            <template v-if="fitersChooseIF([21])">
              <el-table-column
                :prop="chaosParams"
                :label="`用户${grayId}`"
                width="150"
              >
              </el-table-column>
              <el-table-column prop="name" label="用户昵称"> </el-table-column>
              <el-table-column prop="grantTime" label="领取时间">
              </el-table-column>
              <el-table-column prop="sellerLinkName" label="投放渠道">
              </el-table-column>
              <el-table-column prop="prizeName" label="奖励信息">
              </el-table-column>
            </template>
            <template v-if="fitersChooseIF([31])">
              <el-table-column
                :prop="chaosParams"
                :label="`用户${grayId}`"
                width="150"
              >
              </el-table-column>
              <el-table-column prop="name" label="用户昵称"> </el-table-column>
              <el-table-column prop="grantTime" label="角色">
                <template slot-scope="scope">
                  {{ scope.row.memberRole == 1 ? "分享者" : "被分享者" }}
                </template>
              </el-table-column>
              <el-table-column prop="memberType" label="用户身份">
                <template slot-scope="scope">
                  {{ scope.row | typeChinese }}
                </template>
              </el-table-column>
              <el-table-column prop="grantTime" label="领券时间">
              </el-table-column>
              <el-table-column prop="sellerLinkName" label="投放渠道">
              </el-table-column>
              <el-table-column prop="prizeInfo" label="优惠券信息">
              </el-table-column>
            </template>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 优惠券统计 -->
      <el-tab-pane
        :label="fitersRepurchase([21], '优惠券统计', '优惠券发放统计')"
        name="nine"
        v-if="fitersChooseIF([21, 31])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formSplitCoupon"
          @search="searchSplit"
          :btn30="true"
          :formData.sync="formList"
        ></jd-form>
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tree-props="{ children: 'data' }"
            :tableData="CouponStatisticsList"
            :pageInfo="
              fitersChooseIF([21])
                ? {
                    pageSize: formList.size,
                    pageNum: formList.current,
                    total: totalCouponstatistics,
                  }
                : { noShow: true }
            "
            row-key="id"
            :default-expand-all="false"
            @handlePage="handlePageCouponStatistics"
          >
            <template v-if="fitersChooseIF([21])">
              <el-table-column prop="name" label="日期"> </el-table-column>
              <el-table-column prop="grantNum" label="发放量">
              </el-table-column>
              <el-table-column prop="sellerLinkName" label="投放渠道"> </el-table-column>
            </template>
            <template v-if="fitersChooseIF([31])">
              <el-table-column prop="date" label="日期"> </el-table-column>
              <el-table-column
                :prop="item.value"
                :label="item.name"
                v-for="(item, i) in couponList"
                :key="i"
              >
              </el-table-column>
              <el-table-column prop="sellerLinkName" label="投放渠道"> </el-table-column>
            </template>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 团队详情 -->
      <el-tab-pane
        :label="fitersRepurchase([21], '团队详情', '助力详情')"
        name="ten"
        v-if="fitersChooseIF([21, 31])"
      >
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formGroupCoupon"
          @search="searchGroup"
          :btn30="true"
          :formData.sync="formList"
        ></jd-form>
        <div class="new-table-box" style="margin-top: 12px">
          <jd-table
            :loading="loading"
            :tableData="TeamDetailsList"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalTeam,
            }"
            @handlePage="handlePageTeam"
          >
            <template v-if="fitersChooseIF([21])">
              <el-table-column
                :prop="chaosParams"
                :label="`用户${grayId}`"
                width="150"
              ></el-table-column>
              <el-table-column prop="leaderName" label="团长">
              </el-table-column>
              <el-table-column prop="title" label="优惠券"> </el-table-column>
              <el-table-column prop="groupTime" label="组团时间">
              </el-table-column>
              <el-table-column prop="status" label="组团状况">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === 0">未知</span>
                  <span v-if="scope.row.status === 1">组团中</span>
                  <span v-if="scope.row.status === 2">组团成功</span>
                </template>
              </el-table-column>
              <el-table-column prop="sellerLinkName" label="投放渠道"> </el-table-column>
            </template>
            <template v-if="fitersChooseIF([31])">
              <el-table-column
                :prop="chaosParams"
                :label="`用户${grayId}`"
                width="150"
              >
              </el-table-column>
              <el-table-column prop="leaderName" label="分享者">
              </el-table-column>
              <el-table-column prop="groupTime" label="首次分享时间">
              </el-table-column>
              <el-table-column prop="status" label="拼券状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === 0"><jd-status :status="4">未知</jd-status></span>
                  <span v-if="scope.row.status === 1"><jd-status :status="1">拼券中</jd-status></span>
                  <span v-if="scope.row.status === 2"><jd-status :status="0">拼券成功</jd-status></span>
                  <span v-if="scope.row.status === 3"><jd-status :status="3">拼券失败</jd-status></span>
                </template>
              </el-table-column>
              <el-table-column prop="sellerLinkName" label="投放渠道"> </el-table-column>
            </template>
            <el-table-column label="组团成员" width="200">
              <template slot-scope="scope">
                <jd-button type="blueText" @click="viewDetails(scope.row)">{{
                  fitersRepurchase([21], "查看详情", "查看明细")
                }}</jd-button>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 1已改-->
      <!-- 参与赠送记录 -->
      <el-tab-pane
        :label="getTabText(rowData.activityType)"
        name="twelve"
        v-if="fitersChooseIF([8, 23, 24,81,82])"
      >
        <jd-form
          :form-info="
            rowData.activityType == 8
              ? inputGiftrecordInfo2
              : (rowData.activityType == 81 || rowData.activityType == 82)
              ? inputScoreRecordInfo
              : inputGiftrecordInfo
          "
          @search="searchGiftrecord"
          :formData.sync="formList"
          class="mb16"
        ></jd-form>
        <jd-button
          v-if="fitersChooseIF([23, 24])"
          style="margin-bottom: 12px"
          @click="addCrowd(7)"
          >按查询结果生成人群</jd-button
        >
        <div class="flex-spc-x mb12">
          <div>
            <jd-button type="blueLine" @click="handleAddGiftNumber">{{ (rowData.activityType == 81||rowData.activityType == 82) ? '分数变更' : '抽奖次数变更' }}</jd-button>
            <jd-button @click="isShowAddGiftNumberBatch = true" v-if="rowData.activityType != 81&&rowData.activityType != 82">抽奖次数变更（批量）</jd-button>
          </div>
          <jd-button type="text" @click="exportTask" v-if="rowData.activityType == 81||rowData.activityType == 82">导出</jd-button>
        </div>
        <jd-table
          :loading="loading"
          :tableData="GiftrecordList"
          :pageInfo="{
            pageSize: formList.size,
            pageNum: formList.current,
            total: totalGiftrecord,
          }"
          @handlePage="handlePageGiftrecord"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`" width="150">
          </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column prop="memberNick" label="会员等级" v-if="rowData.activityType == 81">
            <template slot-scope="scope">
              <span>{{scope.row.memberLevel ? levelMap[scope.row.memberLevel] || '' : scope.row.memberLevelStr}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellerLinkName" label="投放渠道"> </el-table-column>
          <el-table-column prop="taskType" :label="(rowData.activityType == 81||rowData.activityType == 82)?'任务类型':'获赠类型'">
            <template slot-scope="scope">
              <span>{{fitersTypeValue2(scope.row.taskType)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="关联订单号"> 
            <template slot-scope="scope">
              <el-tooltip
                  placement="top"
                  v-if="scope.row.taskType == 17"
                  popper-class="new-tooltip-width"
                >
                  <div slot="content">
                    <div
                      v-for="(fitem, findex) in fitersTypeValue4(scope.row)"
                      :key="'fitersTypeValue4' + findex"
                    >
                      {{ fitem }}
                    </div>
                  </div>
                  <div
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                  订单号：{{ fitersTypeValue3(scope.row) }}
                  </div>
                </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="giveTimes"
            :label="rowData.activityType == 81 || rowData.activityType == 82 ?'分数':'赠送次数'"
            v-if="rowData.activityType == 8||rowData.activityType == 81||rowData.activityType == 82"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.giveTimes }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" :label="(rowData.activityType == 81||rowData.activityType == 82) ?'获取时间':'获赠时间'"></el-table-column>
        </jd-table>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 兑换记录 -->
      <el-tab-pane
        label="兑换记录"
        name="thirteen"
        v-if="fitersChooseIF([10, 29, 30, 38,55,58,59,60,61])"
      >
        <!-- 头部表单查询 -->
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThirRED"
          @search="searchFormThir"
          :formData.sync="formList"
          v-if="fitersChooseIF([38])"
        ></jd-form>
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formAddMoney"
          @search="searchFormThir"
          :formData.sync="formList"
          v-else-if="fitersChooseIF([55])"
        ></jd-form>
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThir"
          @search="searchFormThir"
          :formData.sync="formList"
          v-else
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px; margin-right: 8px"
          @click="addCrowd(11)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          @click="getphone()"
          type="primary"
          style="margin-bottom: 12px"
          v-if="fitersChooseIF([38])"
          >导出</jd-button
        >
        <div class="new-table-box">
          <!-- 表格 -->
          <jd-table
            :loading="loading"
            :tableData="exchangeList"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalMail,
            }"
            @handlePage="handlePageExchange"
            style="width: 100%"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column prop="winOrderIds" label="关联订单" width="200" v-if="fitersChooseIF([30])">
            </el-table-column>
            <el-table-column prop="id" label="中奖ID" v-if="fitersChooseIF([55])">
            </el-table-column>
            <el-table-column prop="prizeName" label="礼品名称">
            </el-table-column>
            <el-table-column label="礼品类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
                <span v-if="scope.row.prizeType == 2"> 京豆 </span>
                <span v-if="scope.row.prizeType == 3"> 实物 </span>
                <span v-if="scope.row.prizeType == 5"> E卡 </span>
                <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                <span v-if="scope.row.prizeType == 11"> 积分加钱购 </span>
                <span v-if="scope.row.prizeType == 10">
                  {{ scope.row.activateType==2 ? '百度网盘' :'礼品卡'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="point" label="消耗积分"> </el-table-column>
            <!-- 红包专属 -->
            <el-table-column
              prop="exchangeNum"
              label="兑换红包份数"
              v-if="fitersChooseIF([38])"
            >
            </el-table-column>
            <el-table-column
              prop="exchangeTotalAmount"
              label="红包金额总数"
              v-if="fitersChooseIF([38])"
            >
            </el-table-column>
            <el-table-column prop="exchangeTime" label="兑换时间">
            </el-table-column>
            <el-table-column label="兑换状态">
              <template slot-scope="scope">
                <span v-if="scope.row.exchangeStatus == 1"
                  ><jd-status :status="0">兑换成功</jd-status></span
                >
                <span v-if="scope.row.exchangeStatus == 2">
                  <jd-status :status="3">兑换失败<img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ask.png"
                    alt=""
                    class="questionMark"
                  /></jd-status>
                </span>
                <span v-if="scope.row.exchangeStatus == 3"
                  ><jd-status :status="0">领取成功</jd-status></span
                >
                <span v-if="scope.row.exchangeStatus == 4"
                  ><jd-status :status="3">已撤回</jd-status></span
                >
                <span v-if="scope.row.exchangeStatus == 5"
                  ><jd-status :status="3">移除令牌</jd-status></span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="fitersChooseIF([55])">
              <template slot-scope="scope">
                <jd-button type="blueText" @click="removeToken(scope.row)" :disabled="scope.row.exchangeStatus == 5">移除令牌</jd-button>
                <jd-button type="blueText" @click="revocationAddMoneyGoods(scope.row)" :disabled="scope.row.exchangeStatus != 1">撤回奖品</jd-button>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 3已改 -->
      <!-- 兑换实物 -->
      <el-tab-pane
        label="兑换记录（实物）"
        name="fourteen"
        v-if="fitersChooseIF([9])"
      >
        <!-- 头部表单查询 -->
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThir9"
          @search="searchFormThir"
          :formData.sync="formList"
        ></jd-form>
        <jd-button
          style="margin-bottom: 12px; margin-right: 8px"
          @click="addCrowd(11)"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          style="margin-bottom: 12px; margin-right: 8px"
          @click="batchMark2"
          v-preventReClick
          >批量标记发货</jd-button
        >
        <jd-button
          type="text"
          @click="getphone()"
          style="float: right; margin-top: 16px"
          >导出</jd-button
        >

        <!-- 表格 -->
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="exchangeList"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalMail,
            }"
            @handlePage="handlePageExchange"
            rowKey="id"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="200"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称" width="200">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道" width="200">
            </el-table-column>
            <el-table-column prop="winOrderIds" label="关联订单" width="200">
            </el-table-column>
            <el-table-column prop="id" label="中奖id"> </el-table-column>
            <el-table-column prop="prizeName" label="礼品名称" width="200">
            </el-table-column>
            <el-table-column label="礼品类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
                <span v-if="scope.row.prizeType == 2"> 京豆 </span>
                <span v-if="scope.row.prizeType == 3"> 实物 </span>
                <span v-if="scope.row.prizeType == 5"> E卡 </span>
              </template>
            </el-table-column>
            <el-table-column prop="point" label="消耗积分" width="120">
            </el-table-column>
            <el-table-column prop="exchangeTime" label="兑换时间" width="250">
            </el-table-column>
            <el-table-column label="兑换状态" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.exchangeStatus == 1"
                  ><jd-status :status="0">兑换成功</jd-status></span
                >
                <span v-if="scope.row.exchangeStatus == 2">
                  <jd-status :status="3">兑换失败<img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ask.png"
                    alt=""
                    class="questionMark"
                  /></jd-status>
                </span>
                <span v-if="scope.row.exchangeStatus == 3"
                  ><jd-status :status="0">领取成功</jd-status></span
                >
                <span v-if="scope.row.exchangeStatus === 4">
                  <jd-status :status="4">已撤回</jd-status>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="发货状态" prop="deliveryStatus">
              <template slot-scope="scope">
                <span v-if="scope.row.deliveryStatus == 1"><jd-status :status="2">待发货</jd-status></span>
                <span v-if="scope.row.deliveryStatus == 2"><jd-status :status="0">已发货</jd-status></span>
                <span v-if="scope.row.deliveryStatus == 3"
                  ><jd-status :status="4">无需发货（非实物）</jd-status></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="receiverName" label="收货人" width="100">
              <template slot-scope="scope">
                <div class="open">
                  {{ scope.row.receiverName ? scope.row.receiverName : "-" }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverName &&
                      scope.row.receiverName.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverName', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receiverRegion" label="收货地区" width="250">
              <template slot-scope="scope">
                <div class="open">
                  {{
                    scope.row.receiverRegion ? scope.row.receiverRegion : "-"
                  }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverRegion &&
                      scope.row.receiverRegion.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverRegion', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="receiverAddress"
              label="详细地址"
              width="250"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{
                    scope.row.receiverAddress ? scope.row.receiverAddress : "-"
                  }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverAddress &&
                      scope.row.receiverAddress.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverAddress', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <!-- 收件人手机号 -->
            <el-table-column
              prop="receiverMobile"
              label="收件人手机号"
              width="120"
            >
              <template slot-scope="scope">
                <div class="open">
                  {{
                    scope.row.receiverMobile ? scope.row.receiverMobile : "-"
                  }}
                  <!-- <div
                    class="openHover"
                    v-if="
                      scope.row.receiverMobile &&
                      scope.row.receiverMobile.indexOf('*') != -1
                    "
                    @click="
                      handleDecrypt1('receiverMobile', scope.row, scope.$index)
                    "
                  >
                    展开
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="billCode" label="快递单号">
            </el-table-column>
            <el-table-column label="操作" width="220">
              <template slot-scope="scope">
                <jd-button
                  v-if="
                    scope.row.deliveryStatus == 1 &&
                    scope.row.id &&
                    scope.row.exchangeStatus != 4
                  "
                  type="blueText"
                  @click="changeShip(scope.row)"
                >
                  标记发货
                </jd-button>
                <span
                  v-else-if="
                    scope.row.deliveryStatus == 1 &&
                    scope.row.id &&
                    scope.row.exchangeStatus == 4
                  "
                  style="color: #cccccc; margin-left: 8px"
                  >标记发货</span
                >
                <jd-button
                  type="blueText"
                  v-else-if="
                    scope.row.deliveryStatus == 2 &&
                    scope.row.exchangeStatus != 4
                  "
                  @click="cancelShip(scope.row)"
                >
                  取消发货
                </jd-button>
                <span
                  v-else-if="
                    scope.row.deliveryStatus == 2 &&
                    scope.row.exchangeStatus == 4
                  "
                  style="color: #cccccc; margin-left: 8px"
                  >取消发货</span
                >
                <jd-button
                  type="blueText"
                  style="margin-left: 8px"
                  @click="handleEnterCoutierNum(scope.row)"
                  v-if="scope.row.id && scope.row.exchangeStatus != 4"
                  >录入快递单号</jd-button
                >
                <span v-else style="color: #cccccc; margin-left: 8px"
                  >录入快递单号</span
                >
                <!-- B待发货和已发货都可撤回 -->
                <jd-button
                  v-if="
                    (scope.row.deliveryStatus == 1 ||
                      scope.row.deliveryStatus == 2) &&
                    scope.row.exchangeStatus != 4
                  "
                  @click="revocationIntergralGoods(scope.row)"
                  type="blueText"
                >
                  撤回
                </jd-button>
                <span v-else style="color: #cccccc; margin-left: 8px"
                  >撤回</span
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- end -->
      <!-- 3已改 -->
      <!-- 开卡记录 -->
      <el-tab-pane label="开卡记录" name="fifteen" v-if="fitersChooseIF([32])">
        <!-- 头部表单查询 -->
        <jd-form
          style="margin-bottom: 16px"
          :form-info="formThir2"
          @search="searchFormThir2"
          :formData.sync="formList"
        ></jd-form>
        <div style="color: #fe4d45; margin-bottom: 10px">
          注意：仅记录点击【开卡】按钮后1个小时内开卡的用户
        </div>
        <jd-button
          style="margin-bottom: 13px"
          @click="addCrowd(14)"
          >按查询结果生成人群</jd-button
        >
        <!-- 表格 -->
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="exchangeList"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalMail,
            }"
            @handlePage="handlePageExchange2"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column prop="createTime" label="首次点击时间">
            </el-table-column>
            <el-table-column prop="updateTime" label="末次点击时间">
            </el-table-column>
            <el-table-column prop="openCardTime" label="开卡时间">
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- Note---邀请开发有礼C端逻辑优化 -->
      <el-tab-pane label="邀请统计" name="sevent" v-if="fitersChooseIF([5, 6])">
        <jd-form
          ref="export_fun"
          class="mb16"
          :btn30="true"
          :form-info="inputAwardThree"
          @search="searchAwardStatistics"
        />
        <jd-button type="break" style="margin-bottom: 12px" @click="addCrowd(8)"
          >按查询结果生成人群</jd-button
        >
        <div class="new-table-box">
          <jd-table
            :loading="loading"
            :tableData="invitationNum"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%;"
            :pageInfo="{
              pageNum: formList.current,
              pageSize: formList.size,
              total: totalAwardFor,
            }"
            @handlePage="handleSizeAward1All"
          >
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayId}`"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column prop="memberLevel" label="会员等级">
              <template slot-scope="scope">
                <span>{{ levelMap[scope.row.memberLevel] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道">
            </el-table-column>
            <el-table-column label="任务" v-if="isTaskPrize">
              <template slot-scope="scope">
                <span>任务{{ $toChinesNum(scope.row.taskIndex) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="joinTime" label="发起时间">
            </el-table-column>
            <el-table-column prop="num" label="成功邀请人数"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <jd-button
                  type="blueText"
                  @click="invitationDeatils(scope.row)"
                  style="text-align: left"
                  >邀请明细</jd-button
                >
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>

      <!-- 订单明细 -->
      <el-tab-pane
        label="订单明细"
        name="orderDetail"
        v-if="fitersChooseIF([9, 16, 17, 18, 19, 30, 36, 27, 28, 41,78,80])"
      >
        <jd-form
          v-if="tabName == 'orderDetail'"
          class="mb16"
          ref="orderDetailRef"
          key="orderDetailRef"
          :form-info="inputOrderDetailInfo"
          :formData.sync="orderDetaiInfolForm"
          @search="searchOrderDetail"
        >
        </jd-form>
        <!-- 京东1.77 -->
       <jd-button
          type="text"
          @click="getphone_45()"
          style="float: right; margin-top: 10px;margin-bottom:10px"
          v-permission="'hide:checkOrder:export'"
          >导出</jd-button
        >
        <orderDetailOverview ref="orderDetailOverviewRef1" :rowData="rowData"></orderDetailOverview>
        <div class="new-table-box">
          <jd-table
            :key="tableKey"
            :loading="loading"
            :tableData="orderDetailData"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%;"
            :pageInfo="{
              pageNum: orderDetailInfoPage.current,
              pageSize: orderDetailInfoPage.size,
              total: orderDetailInfoTotal,
            }"
            @handlePage="handlePageOrderDetail"
          >
            <el-table-column prop="orderId" label="订单编号"> </el-table-column>
            <el-table-column prop="rootId" label="父订单号" v-if="fitersChooseIF([27,28,41,78],'!=')">
              <template slot-scope="scope">
                {{ scope.row.rootId || '-' }}
              </template>
            </el-table-column>
            <el-table-column :prop="chaosParams" :label="`用户${grayId}`"> </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
            <!-- v-if="fitersChooseIF([19])" -->
            <el-table-column  prop="sellerLinkName" label="投放渠道"></el-table-column>
            <el-table-column v-if="fitersChooseIF([19,16,17,18])" prop="orderVenderName" label="下单店铺"></el-table-column>
            <el-table-column prop="orderStartTime" label="下单时间">
            </el-table-column>
            <el-table-column prop="paymentConfirmTime" label="付款时间">
            </el-table-column>
            <!-- 京东1.77 -->
            <el-table-column prop="skuNameList" label="商品名称" min-width="200">
              <template slot="header">
                <span>商品名称</span>
                <el-button 
                  type="text" 
                  class="header-expand-btn"
                  @click.stop="toggleGoodsNameExpand"
                >
                  【展开】
                </el-button>
              </template>
              <template slot-scope="scope">
                <div 
                  class="goods-name-text" 
                  :class="{ 'ellipsis-single': !goodsNameColumnExpanded}"
                >
                  {{ scope.row.itemName ? (Array.isArray(scope.row.itemName) ? scope.row.skuNameList.join('，') : scope.row.itemName) : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="订单金额">
              <template slot="header">
                <span>{{ popOrderStartPaymentType == 1 ? '订单金额' : '实付金额' }}</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="自营店铺为订单金额，POP店铺统计规则以活动实际设置为准"
                  placement="top"
                >
                  <span class="question_iconOne">?</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ popOrderStartPaymentType == 1 ? scope.row.orderTotalPrice : scope.row.orderPayment}}
              </template>
            </el-table-column>
            <el-table-column prop="orderStateRemark" label="订单状态">
              <template #default="{row}">
                <jd-status :status="getStatus1(row.orderStateRemark,row.orderState)">{{ row.orderStateRemark }}</jd-status> 
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 被邀请人明细 -->
      <el-tab-pane
        label="被邀请人明细"
        name="inviteeDetails"
        v-if="fitersChooseIF([5])"
      >
        <jd-form
          class="mb16"
          :form-info="inviteeDetailsInputData"
          @search="inviteeDetailsSearch"
          :btn30="true"
        >
        </jd-form>
        <el-button
          style="float: left; margin-bottom: 12px; width: 150px"
          @click="addCrowd(21)"
          >按查询结果生成人群</el-button
        >
        <jd-table
          :loading="loading"
          :pageInfo="{
            pageNum: formList.current,
            pageSize: formList.size,
            total: inviteeDetailsTotal,
          }"
          :tableData="inviteeDetailsData"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
          @handlePage="handleSizeInviteDetailAll"
        >
          <el-table-column
            :prop="inviteParams"
            :label="`邀请人用户${grayId}`"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="inviteNick" label="邀请人昵称" width="200">
          </el-table-column>
          <el-table-column
            :prop="chaosParams"
            :label="`被邀请人用户${grayId}`"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="memberNick" label="被邀请人昵称" width="200">
          </el-table-column>
          <el-table-column
            prop="sellerLinkName"
            label="投放渠道"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="isValidInvite"
            label="是否有效邀请"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                Number(scope.row.isValidInvite) == 1 ? "是" : "否"
              }}</span>
              <el-tooltip
                effect="dark"
                v-if="scope.row.isValidInvite != 1"
                :content="
                  nowActType == 1
                    ? '不满足成功入会且有付款条件'
                    : nowActType == 2
                    ? '不满足成功入会且有下单条件'
                    : '不满足成功入会'
                "
                placement="top-start"
              >
                <i
                  style="color: #ccc; margin-left: 4px; cursor: pointer"
                  v-if="scope.row.isValidInvite != 1"
                  class="el-icon-question"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orderIds" label="订单号" width="150">
            <template slot-scope="scope">
              {{ scope.row.orderIds ? scope.row.orderIds : "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="orderCount" label="订单数" width="150">
            <template slot-scope="scope">
              {{ scope.row.orderCount ? scope.row.orderCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="itemCount" label="商品件数" width="150">
            <template slot-scope="scope">
              {{ scope.row.itemCount ? scope.row.itemCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="paymentAmount" label="付款金额" width="150">
            <template slot-scope="scope">
              {{ scope.row.paymentAmount ? scope.row.paymentAmount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="邀请时间" width="250">
            <template slot-scope="scope">
              {{ scope.row.joinTime ? scope.row.joinTime : "-" }}
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>
        <!-- 入会打榜-被邀请人明细 -->
      <el-tab-pane
        label="被邀请人明细"
        name="joinInviteDetails"
        v-if="fitersChooseIF([36])&&isShowInvite"
      >
        <jd-form
          class="mb16"
          :form-info="joinInviteInputData"
          @search="joinInviteDetailsSearch"
        >
        </jd-form>
        <jd-table
          :loading="loading"
          :pageInfo="{
            pageNum: joinInviteForm.current,
            pageSize: joinInviteForm.size,
            total: joinInviteTotal,
          }"
          :tableData="joinInvitesData"
          style="width: 100%; margin: 40px auto"
          @handlePage="handlePageJoinInvite"
        >
          <el-table-column
            :prop="chaosParams"
            :label="`邀请人用户${grayId}`"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="memberNick" label="邀请人昵称" width="200">
          </el-table-column>
          <el-table-column
            :prop="inviteeChaos"
            :label="`被邀请人用户${grayId}`"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="inviteeMemberNick" label="被邀请人名称" width="200">
          </el-table-column>
          <el-table-column
            label="是否有效邀请"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
              scope.row.isValid == 1 ? "是" : "否"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderIds" label="订单号" width="150">
            <template slot-scope="scope">
              {{ scope.row.orderIds ? scope.row.orderIds : "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="订单数" width="150">
            <template slot-scope="scope">
              {{ scope.row.orderNum ? scope.row.orderNum : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="itemNum" label="商品件数" width="150">
            <template slot-scope="scope">
              {{ scope.row.itemNum ? scope.row.itemNum : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="orderPayment" label="付款金额" width="150">
            <template slot-scope="scope">
              {{ scope.row.orderPayment ? scope.row.orderPayment : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="inviteTime" label="邀请时间" width="250">
            <template slot-scope="scope">
              {{ scope.row.inviteTime ? scope.row.inviteTime : "-" }}
            </template>
          </el-table-column>
        </jd-table>
      </el-tab-pane>
      <template v-if="fitersChooseIF([46])">
        <!-- 满额有礼-参与记录 46 -->
        <el-tab-pane label="参与记录" name="fullGiftJoin">
          <joinRecord
            ref="joinRecordRef"
            :rowData="rowData"
            :sellerLinkList="sellerLinkList"
            :currentShop="currentShop"
          ></joinRecord>
        </el-tab-pane>
        <el-tab-pane label="领奖记录" name="fullGiftAward">
          <awardRecord
            ref="awardRecordRef"
            :rowData="rowData"
            :sellerLinkList="sellerLinkList"
            :currentShop="currentShop"
            :levelList="levelList"
            :levelMap="levelMap"
          ></awardRecord>
        </el-tab-pane>
        <el-tab-pane label="实物奖品名单" name="fullGiftPhy">
          <physicalAward
            ref="physicalAwardRef"
            :rowData="rowData"
            :currentShop="currentShop"
            :sellerLinkList="sellerLinkList"
            :prizeNames="physicalPrizes"
            :shopList="shopList"
            :levelList="levelList"
            :levelMap="levelMap"
            @editAddress="editAddress"
            @openPhysicalBatchShipment="physicalBatchShipment"
          ></physicalAward>
        </el-tab-pane>
      </template>
      <!-- 拼团砍价 -->
      <template v-if="fitersChooseIF([69])">
        <el-tab-pane label="参与记录" name="bargainJoinRecord">
          <bargainJoinRecord
            ref="bargainJoinRecord"
            :rowData="rowData"
            :sellerLinkList="sellerLinkList"
            :currentShop="currentShop"
          ></bargainJoinRecord>
        </el-tab-pane>
        <el-tab-pane label="砍价记录" name="bargainRecord">
          <bargainRecord
            ref="bargainRecord"
            :rowData="rowData"
            :sellerLinkList="sellerLinkList"
            :currentShop="currentShop"
          ></bargainRecord>
        </el-tab-pane>
      </template>

      <!-- 1已改 -->
      <!-- 入会用户转化分析 -->
      <el-tab-pane label="入会用户转化分析" v-if="fitersChooseIF([67,70],'!=')"  name="conversionAnalysis">
        <div class="conversion">
          <jd-tip>
            <div>
              分析在本次活动入会的粉丝在一段时间内的转化数据，转化数据不区分订单类型及不排除本次活动下单的订单，仅2024-11-12
              后创建的活动支持
            </div>
          </jd-tip>
        </div>
        <jd-form
          :form-info="inputConversionInfo"
          @search="searchConversionFun"
          :emitReset="true"
          @reset="resetConversionFun"
          ref="export_funRef"
          class="mt16 mb16"
        >
          <template slot="statDaysNum">
            <el-input
              placeholder="请输入"
              v-model="conversionForm.statDaysNum"
              class="conversion-statDaysNum"
              @input="
                conversionForm.statDaysNum = getNumberData(1, $event, 0, 1, 30)
              "
            >
              <span slot="suffix">天内的订单</span>
            </el-input>
            <!-- <span style="color: #333333;font-weight: 500;"> 内的订单</span> -->
          </template>
          <template slot="orderMoney">
            <el-select
              v-model="conversionForm.statType"
              class="conversion-statType"
            >
              <el-option label="累计下单金额(付款)" :value="0"></el-option>
              <el-option label="累计下单金额(成交)" :value="1"></el-option>
            </el-select>
            <el-select
              v-model="conversionForm.compareType"
              class="conversion-compareType"
            >
              <el-option label="大于等于" :value="0"></el-option>
              <el-option label="小于等于" :value="1"></el-option>
            </el-select>
            <el-input
              placeholder="请输入"
              v-model="conversionForm.orderAmount"
              class="conversion-orderMoney"
              @input="
                conversionForm.orderAmount = getNumberData(
                  1,
                  $event,
                  0,
                  1,
                  999999
                )
              "
            ></el-input>
          </template>
        </jd-form>
        <jd-button
          class="mb12"
          :disabled="conversionData.length == 0"
          @click="addCrowd(18)"
          >按查询结果生成人群</jd-button
        >
        <jd-table
          :loading="loading"
          :tableData="conversionData"
          :pageInfo="{
            pageNum: conversionPage.current,
            pageSize: conversionPage.size,
            total: conversionPage.total,
          }"
          @handlePage="handlePageConversion"
        >
          <el-table-column :prop="chaosParams" :label="`用户${grayId}`"> </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称"></el-table-column>
          <!-- v-if="fitersChooseIF([46,19])" -->
          <el-table-column prop="sellerLinkName" label="投放渠道" ></el-table-column>
          <el-table-column prop="openCardTime" label="入会时间">
          </el-table-column>
          <el-table-column prop="payOrderNum" label="下单订单数" align="right">
          </el-table-column>
          <el-table-column
            prop="commitOrderNum"
            label="成交订单数"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="statPayOrderAmount"
            label="累计下单金额(付款)"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="statDealOrderAmount"
            label="累计下单金额(成交)"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="avgPayOrderAmount"
            label="客单价(付款)"
            align="right"
          >
          </el-table-column>
        </jd-table>
      </el-tab-pane>

      <el-tab-pane label="参与转化分析" v-if="fitersChooseIF([89])" name="participateConversionAnalysis">
        <participateConversionAnalysis  v-if="activeName == 'participateConversionAnalysis'" :rowData="rowData" :inputInfo.sync="inputParticipateConversionAnalysis"/>
      </el-tab-pane>

      <!-- 定时开奖-幸运值获取记录 -->
      <el-tab-pane
        label="幸运值获取记录"
        name="luckRecord"
        v-if="fitersChooseIF([48])"
      >
        <jd-form
          class="mb16"
          ref="physicalAwardFormRef"
          :form-info="inputLuck"
          @search="
            (val) => {
              searchLuckForm({ ...formLuck, ...val });
            }
          "
        />
        <div class="flex-spc-x">
          <jd-button
            type="break"
            style="margin-bottom: 16px"
            @click="addCrowd(30)"
            :disabled="!luckTable.length"
            >按查询结果生成人群</jd-button
          >
          <jd-button
              type="text"
              @click="searchHp_export"
              v-preventReClick
              >导出</jd-button
            >
        </div>
  
        <div class="new-table-box">
 
          <jd-table
            :loading="loading"
            :tableData="luckTable"
            :pageInfo="{
              pageNum: formLuck.current,
              pageSize: formLuck.size,
              total: totalLuck,
            }"
            style="width: 100%;"
            @handlePage="handleLuck"
          >
            <el-table-column prop="memberNick" label="用户昵称">
            </el-table-column>
            <el-table-column :prop="pinToXid" :label="`用户${grayId}`">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道" ></el-table-column>
            <el-table-column prop="taskType" label="任务类型">
              <template slot-scope="scope">
                <span v-if="scope.row.taskType == 1">每日签到</span>
                <span v-else-if="scope.row.taskType == 2">浏览店铺</span>
                <span v-else-if="scope.row.taskType == 3">浏览商品</span>
                <span v-else-if="scope.row.taskType == 4">加购商品</span>
                <span v-else-if="scope.row.taskType == 5">浏览会场</span>
                <span v-else-if="scope.row.taskType == 6">关注店铺</span>
                <span v-else-if="scope.row.taskType == 7">加入会员</span>
                <span v-else-if="scope.row.taskType == 9">分享商品</span>
                <span v-else-if="scope.row.taskType == 10">分享店铺</span>
                <span v-else-if="scope.row.taskType == 11">分享活动</span>
                <span v-else-if="scope.row.taskType == 12">预约商品</span>
                <span v-else-if="scope.row.taskType == 16">积分兑换</span>
                <span v-else-if="scope.row.taskType == 17">购买商品</span>
                <span v-else-if="scope.row.taskType == 18">邀请好友入会</span>
                <span v-else-if="scope.row.taskType == 23">搜索关键词</span>
              </template>
            </el-table-column>
            <el-table-column prop="relOrderIds" label="关联订单号">
              <template slot-scope="scope">
                <span v-if="scope.row.relOrderIds">{{
                  scope.row.relOrderIds
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="giveTimes" label="幸运值"></el-table-column>
            <el-table-column prop="joinTime" label="获取时间">
              <template slot-scope="scope">
                <span v-if="scope.row.joinTime">{{ scope.row.joinTime }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 满额有礼活动 -->
      <template v-if="fitersChooseIF([46,87])">
        <!-- 满额有礼-参与记录 46 -->
        <el-tab-pane label="订单明细" name="fullGiftOrder">
          <orderDetail ref="orderDetailRef" @exportFn="getphone_45" :rowData="rowData" :shopList="shopList" :sellerLinkList="sellerLinkList"></orderDetail>
        </el-tab-pane>
      </template>
      <!-- BI店铺礼包订单明细 -->
      <el-tab-pane label="订单明细" name="biOrderDetailTab" v-if="fitersChooseIF([63])">
        <biOrderDetail
          ref="biOrderDetailRef"
          :activityId="activityId"
          :inputInfo.sync="inputBiOrderDetail"
          :sourcePopupList="sourcePopupList"
          v-if="activeName=='biOrderDetailTab'"
          :rowData="rowData"
        ></biOrderDetail>
      </el-tab-pane>
      <el-tab-pane label="商品明细" name="fullGiftGoodsOrder" v-if="fitersChooseIF([46,16])&&isShowGoodsDetail">
        <goodsDetail ref="goodsDetailRef" :rowData="rowData" v-if="activeName=='fullGiftGoodsOrder'" :shopList="shopList" :sellerLinkList="sellerLinkList"></goodsDetail>
      </el-tab-pane>
      <!-- 试用反馈详情 -->
      <el-tab-pane
        label="试用反馈详情"
        name="trialDetail"
        v-if="fitersChooseIF([51])"
      >
        <jd-form
          class="mb16"
          :form-info="trialDetailForm"
          @search="searchZeroTrialDetail"
        ></jd-form>
        <div class="mb12 flex-spc-x">
          <jd-button
            type="break"
            @click="addCrowd(36)"
            style="display:block"
            :disabled="!zeroTrialDetailTable.length"
            >按查询结果生成人群</jd-button
          >
          <jd-button
            type="text"     
            @click="exportZeroTrialDetailFn"
            v-preventReClick
            :disabled="!zeroTrialDetailTable.length"
            >导出</jd-button
            >
        </div>
        <div class="new-table-box">
          <jd-table
            ref="trialTable"
            :tableData="zeroTrialDetailTable"
            :loading="loading"
            :pageInfo="{
              pageNum: formZeroDetailList.current,
              pageSize: formZeroDetailList.size,
              total: totalZeroTrial,
            }"
            @handlePage="handleSizeZeroTrialDetail"
          >
            <el-table-column prop="memberNick" label="用户昵称" min-width="90">
            </el-table-column>
            <el-table-column :prop="pinToXid" :label="`用户${grayId}`" min-width="90">
            </el-table-column>
            <el-table-column prop="sellerLinkName" label="投放渠道" min-width="90">
            </el-table-column>
            <el-table-column
              prop="prizeName"
              label="申请试用奖品名称"
              min-width="90"
            >
            </el-table-column>
            <el-table-column prop="submitTime" label="提交时间" min-width="90">
            </el-table-column>
            <!-- 动态列 -->
            <el-table-column
              v-for="question in dynamicColumns"
              :key="question"
              :label="question"
              width="220"
            >
              <template #default="scope">
                <div
                  @click="showImage(scope.row.answerVOList, question, $event)"
                  v-html="getAnswer(scope.row.answerVOList, question)"
                ></div>
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- 锁权订单明细 -->
      <el-tab-pane
        label="锁权订单明细"
        name="lockRecordRecord"
        v-if="fitersChooseIF([45])"
      >
        <jd-form
          :form-info="orderDetailForm"
          @search="searchLockFormOrder"
          ref="lockRecordRecordRef"
          class="mb16"
        ></jd-form>
        <jd-button
          type="text"
          @click="getphone_36()"
          style="float: right; margin-top: 10px;margin-bottom:10px"
          v-permission="'hide:checkOrder:export'"
          >导出</jd-button
        >
        <div class="new-table-box">
          <jd-table
            class="lock-order-table"
            :key="tableKey"
            :loading="loading"
            :tableData="lockOrderData"
            row-key="id"
            :pageInfo="{
                pageNum: formLockOrder.current,
                pageSize: formLockOrder.size,
                total: lockOrderTotal,
              }"
              @handlePage="handleSizeLockOrderDetail"
          >
            <el-table-column prop="orderId" label="订单号">
            </el-table-column>
            <el-table-column prop="rootId" label="父订单号">
              <template slot-scope="scope">
                {{ scope.row.rootId || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="chaosPin" :label="`用户${grayId}`" width="150">
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称" width="150">
            </el-table-column>
            <el-table-column prop="orderStartTime" label="下单时间">
             </el-table-column>
             <el-table-column prop="paymentConfirmTime" label="付款时间">
            </el-table-column>
            <el-table-column prop="skuNameList" label="商品名称" min-width="200">
              <template slot="header">
                <span>商品名称</span>
                <jd-button 
                  type="blueText" 
                  class="header-expand-btn"
                  @click.stop="toggleGoodsNameExpand1"
                >
                  【展开】
                </jd-button>
              </template>
              <template slot-scope="scope">
                <div 
                  class="goods-name-text" 
                  :class="{ 'ellipsis-single': !goodsNameColumnExpanded1}"
                >
                  {{ scope.row.itemName ? (Array.isArray(scope.row.itemName) ? scope.row.skuNameList.join('，') : scope.row.itemName) : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="orderPrice" label="订单金额"> </el-table-column>
            <el-table-column label="订单状态">
              <template #default="{row}">
                <jd-status :status="getStatus1(row.orderStateRemark,row.orderStatus)">{{ row.orderStateRemark }}</jd-status> 
              </template>
            </el-table-column>
          </jd-table>
        </div>
      </el-tab-pane>
      <!-- Note----结束 -->
    </el-tabs>
    <!-- 团队弹框 -->
    <jd-dialog
      :title="fitersRepurchase([21], '组团明细', '拼券明细')"
      :visible.sync="dialogGroup"
      width="1200px"
      @close="dialogGroup = false"
      :isShowSure="false"
      :isShowCancel="false"
    >
      <div class="new-table-box">
        <jd-table :tableData="CouponMember" :pageInfo="{ noShow: true }">
          <template v-if="fitersChooseIF([21])">
            <el-table-column prop="name" label="成员">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <div class="imgurl">
                    <img :src="scope.row.avatar" alt="" />
                  </div>
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="joinTime" label="入团时间">
            </el-table-column>
            <el-table-column prop="group" label="角色"> </el-table-column>
          </template>
          <template v-if="fitersChooseIF([31])">
            <el-table-column prop="name" label="用户昵称">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <div class="imgurl">
                    <img :src="scope.row.avatar" alt="" />
                  </div>
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="joinTime" label="助力时间">
            </el-table-column>
          </template>
        </jd-table>
      </div>
    </jd-dialog>

    <!-- Note--邀请明细弹框 -->
    <el-dialog
      title="助力明细"
      :visible.sync="dialogDeatils"
      width="1200px"
      @close="dialogDeatils = false"
    >
      <div class="new-table-box">
        <el-table
          v-loading="loading1"
          :data="CouponMember1"
          stripe
          style="width: 100%"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <el-table-column prop="memberNick" label="用户昵称">
          </el-table-column>
          <el-table-column
            prop="isOpenCard"
            label="入会状态"
            v-if="rowData.activityType == 5"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.isOpenCard == 1 ? "已入会" : "未入会" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="openCardTime"
            label="入会时间"
            v-if="rowData.activityType == 5"
          >
          </el-table-column>
          <el-table-column
            prop="joinTime"
            label="关注时间"
            v-if="rowData.activityType == 6"
          >
          </el-table-column>
        </el-table>
      </div>
      <!-- 表格分页 -->
      <div class="new-pagination-page" style="margin-top: 16px">
        <el-pagination
          style="text-align: right"
          @size-change="handleSizeExchangeStatics"
          background
          @current-change="handleCurrentExchangeStatics"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList1.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          :current-page="formList1.current"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 导出弹框 -打榜有礼导出弹框 -->
    <jd-dialog
      v-if="dialogExprot"
      :title="fitersChooseIF([36, 37]) ? '导出' : '身份验证'"
      custom-class="system-dialog"
      :visible.sync="dialogExprot"
      :width="fitersChooseIF([36, 37]) ? '500px' : '600px'"
      @close="dialogExprot = false"
    >
      <el-form
        :model="loginUserInfo"
        ref="formRef"
        label-width="100px"
        class="form-box new-input-box"
      >
        <!-- 手机号 -->
        <el-form-item
          :label="fitersChooseIF([36, 37]) ? '手机号码：' : '手机号：'"
          :label-class="fitersChooseIF([36, 37]) ? 'item-label2' : 'item-label'"
        >
          <el-input
            v-model="loginUserInfo.mobile"
            disabled
            placeholder="请输入..."
            style="width: 290px"
          />
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item
          :label="fitersChooseIF([36, 37]) ? '手机验证码：' : '验证码：'"
          :label-class="fitersChooseIF([36, 37]) ? 'item-label2' : 'item-label'"
        >
          <el-input
            v-model="code"
            placeholder="请输入"
            style="width: 177px; margin-right: 12px"
          />
          <jd-button type="blue" :disabled="codeDisabled" @click="getCode">
            {{ codeMsg }}
          </jd-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <template v-if="fitersChooseIF([36])">
          <jd-button
            type="blue"
            @click="
              getApi_Exprot2(
                tabName == 'twenty-one' ? 2 : tabName == 'twenty' ? 3 : 1
              )
            "
            >确认</jd-button
          >
          <jd-button @click="dialogExprot = false">取消</jd-button>
        </template>
        <template
          v-else-if="
            fitersChooseIF([37]) &&
            tabName != 'seventeen' &&
            tabName != 'sixteen'
          "
        >
          <jd-button
            type="blue"
            @click="
              getApi_Exprot3(
                tabName == 'sendReBuyPay'
                  ? 2
                  : tabName == 'sendReBuyRePay'
                  ? 3
                  : 1
              )
            "
            >确认</jd-button
          >
          <jd-button @click="dialogExprot = false">取消</jd-button>
          <!-- 1是数据统计、2是派样下单、3是回购下单记录 -->
        </template>
        <template v-else>
          <jd-button type="blue" @click="getApi_Exprot()">确定</jd-button>
          <jd-button style="margin-left: 8px" @click="dialogExprot = false"
            >取消</jd-button
          >
        </template>
      </div>
    </jd-dialog>

    <evaluation-dialog
      v-model="commentDioag"
      :commentItem="commentItem"
      @dialogClose="dialogClose"
    />

    <el-dialog
      title="身份验证"
      width="420px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="form-box new-input-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="phone"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 170px; margin-right: 12px"
            ></el-input>
            <el-button
              type="primary"
              :disabled="codeDisabled"
              @click="getCodeInit"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <jd-button type="break" style="margin-right: 8px" @click="savePhone()"
          >确定</jd-button
        >
        <jd-button @click="visible = false">取消</jd-button>
      </div>
    </el-dialog>
    <jd-dialog
      title="加购详情"
      :visible.sync="addCartDetailShow"
      width="650px"
      @close="addCartDetailShow = false"
      :isShowSure="false"
      :isShowCancel="false"
    >
      <div class="new-table-box">
        <jd-table :tableData="addCartDetailData" stripe>
          <el-table-column label="商品">
            <template slot-scope="scope">
              <div class="addCartDetail">
                <div style="padding: 10px 0"><img :src="scope.row.logo" /></div>
                <div>
                  <div>{{ scope.row.title }}</div>
                  <div>skuid：{{ scope.row.skuId }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="addCartTime"
            label="加购时间"
            width="200"
          ></el-table-column>
        </jd-table>
      </div>
    </jd-dialog>

    <jd-dialog
      title="修改收货信息"
      custom-class="system-dialog"
      :visible.sync="lockTakeGoodsVisible"
      width="520px"
      @close="lockTakeGoodsVisible = false"
    >
      <el-form
        :model="takeGoodsForm"
        ref="takeGoodsFormRef"
        label-width="120px"
        class="form-box new-input-box"
      >
        <el-form-item label="姓名：" prop="receiverName">
          <el-input
            v-model="takeGoodsForm.receiverName"
            placeholder="请输入..."
            style="width: 290px"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号码：" prop="receiverMobile">
          <el-input
            v-model="takeGoodsForm.receiverMobile"
            placeholder="请输入..."
            style="width: 290px"
          ></el-input>
        </el-form-item>

        <el-form-item label="地区：" prop="receiverAddress">
          <el-cascader
            v-model="takeGoodsForm.receiverAddress"
            :options="pcaTextArr"
            :placeholder="
              takeGoodsForm.receiverAddress.join('/') || '请选择地区'
            "
            style="width: 290px"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="详细地址：" prop="detailedAddress">
          <el-input
            v-model="takeGoodsForm.detailedAddress"
            placeholder="请输入..."
            style="width: 290px"
          ></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <jd-button type="blue" style="margin-left: 8px" @click="setTakeGoods"
          >确定</jd-button
        >
        <jd-button @click="lockTakeGoodsVisible = false">取消</jd-button>
      </template>
    </jd-dialog>

    <lock-batch-dialog
      v-if="batchLockVisible"
      :visible="batchLockVisible"
      :activityId="rowData.id"
      @close="batchLockClose"
    ></lock-batch-dialog>

    <!-- 录入快递单号弹窗 -->
    <jd-dialog
      title="录入快递单号"
      width="420px"
      :visible.sync="enterCoutierNumShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
    >
      <el-form
        :model="enterCoutierFrom"
        label-width="86px"
        class="new-input-box"
      >
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="enterCoutierSubmit"
          >确定</jd-button
        >
        <jd-button @click="blankEnterCoutierNum">取消</jd-button>
      </template>
    </jd-dialog>

    <!-- 游戏次数变更 1.58 -->
    <jd-dialog
      title="游戏次数变更"
      width="420px"
      :visible.sync="changeFrequencyShow"
      @close="changeFrequencyShow = false"
      class="enter_coutier_num_dialog"
    >
     <el-form :model="reissueGameTaskBalanceFrom" label-width="120px">
      <el-form-item :label="`用户${searchGrayId}：`" required>
          <el-input v-model="reissueGameTaskBalanceFrom.openId" :placeholder="`请输入用户${searchGrayId}`"></el-input>
      </el-form-item>
      <el-form-item label="补发次数：" required>
          <el-input-number
            :precision="0"
            :step="1"
            v-model="reissueGameTaskBalanceFrom.balance"
            :min="1">
          </el-input-number>
      </el-form-item>
    </el-form>
      <template #footer>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="changeFrequencySubmit"
          >确定</jd-button
        >
        <jd-button @click="changeFrequencyShow = false">取消</jd-button>
      </template>
    </jd-dialog>
    <!-- end -->

    <!-- 游戏次数变更（批量） -->
    <jd-dialog
      title="批量发货"
      width="580px"
      :visible.sync="gameShow"
      @close="physicalBatchShipmentClose1"
      class="physical_batch_shipment_dialog"
    >
      <el-form
        :model="physicalBatchShipmentFrom1"
        label-width="120px"
        class="new-input-box"
      >
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile1"
            :on-success="handleUpload1"
            :show-file-list="false"
            :data="
              fitersChooseIF([36])
                ? { activityId: activityId }
                : { activityId: activityId, type: 1 }
            "
            class="upload-demo"
            :drag="true"
            multiple
            with-credentials
            :action="'/jd-hd-web/lockRight/markingSendStatusBatch/fileUpload'"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 下载模板按钮 -->
      <div class="download_template_box" style="margin-top:4px">
        <jd-button type="blue" @click="handleDownloadTemplate1"
          >下载模板</jd-button
        >
      </div>
     <template #footer>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="changeFrequencySubmit1"
          >确定</jd-button
        >
        <jd-button @click="changeFrequencyShow = false">取消</jd-button>
      </template>
    </jd-dialog>



    <!-- 批量标记发货 -->
    <batch-upload
      v-if="batchMarkVisible"
      :visible="batchMarkVisible"
      action="/jd-hd-web/PointActivityAnalyticController/markingSendStatusBatch/fileUpload"
      @close="batchMarkClose"
    ></batch-upload>
    <!-- 打榜有礼： 批量发货弹窗 -->
    <jd-dialog
      title="批量发货"
      width="580px"
      :visible.sync="physicalBatchShipmentShow"
      @close="physicalBatchShipmentClose1"
      :isShowSure="false"
      :isShowCancel="false"
      class="physical_batch_shipment_dialog"
    >
      <el-form
        :model="physicalBatchShipmentFrom"
        label-width="120px"
        class="new-input-box"
      >
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile"
            :on-success="handleUpload"
            :show-file-list="false"
            :data="
              fitersChooseIF([36])
                ? { activityId: activityId }
                : { activityId: activityId, type: 1 }
            "
            class="upload-demo"
            :drag="true"
            multiple
            with-credentials
            :action="'/jd-hd-web/lockRight/markingSendStatusBatch/fileUpload'"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- 下载模板按钮 -->
      <div class="download_template_box">
        <jd-button type="blue" @click="handleDownloadTemplate"
          >下载模板</jd-button
        >
      </div>
      <div class="downloadMsgBox">
        <p>
          导入成功{{ downloadResData.successNum || 0 }}条，导入失败{{
            downloadResData.failNum || 0
          }}条，导入失败相关{{
            fitersChooseIF([36]) ? `用户${searchGrayId}` : "用户昵称"
          }}：
        </p>
        <div class="downloadUser">
          <div
            class="downloaditem"
            v-for="(item, index) in downloadUserList"
            :key="index"
          >
            {{ index + 1 + ". " }}{{ item }}
          </div>
        </div>
      </div>
      <div class="physical_batch_shipment_dialog_floor">
        <!-- <jd-button @click="physicalBatchShipmentClose">关闭</jd-button> -->
        <!-- <el-button type="primary" @click="physicalBatchShipmentSubmit"
          >确认</el-button
        > -->
      </div>
    </jd-dialog>

    <!-- 打榜有礼实物发货弹窗 -->
    <jd-dialog
      title="发货信息"
      width="420px"
      v-if="sendOutGoodsShow"
      :visible.sync="sendOutGoodsShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
      @confirm="goodsEnterCoutierSubmit"
    >
      <el-form
        :model="sendOutGoodsForm"
        label-width="86px"
        class="new-input-box"
      >
        <el-form-item label="快递单号">
          <el-input
            placeholder="请输入"
            v-model="enterCoutierNum"
            style="width: 280px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
    </jd-dialog>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="crowCondition"
      :activityType="
        activeName == 'conversionAnalysis' ? -1 : rowData.activityType
      "
      :source="source"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose"
    />
     <!-- 批量上传晒单资料弹窗 -->
      <el-dialog
         title="批量上传晒单资料"
         :visible.sync="showUploadShowDataDialog"
         width="508px"
         @close="handleUploadShowDataClose"
        >
          <div>选择文件：</div>
          <div style="padding: 20px 0;">
               <div class="form-item">
                  <!-- :limit="1" -->
                  <el-upload
                      ref="uploadXlsSku"
                      class="uploadFile"
                      :action="`/jd-hd-web/show-product/userProfile/${rowData.id}/import`"
                      :show-file-list="false"
                      :data="{activityId:rowData.id}"
                       accept=".csv, .xls, .xlsx"
                      :before-upload="beforeUploadXls"
                      :on-success="handleUploadXlsSku"
                      :on-error="handleError"
                     >
                        <jd-button size="small" type="primary">{{ uploadShowDataForm.fileName || '点击上传文件' }}</jd-button>
                      </el-upload>
                    </div>
                    <div style="margin-top: 15px; padding: 10px; background-color: #f5f7fa; border-radius: 4px; font-size: 12px; color: #606266;">
                      <p style="margin-bottom: 5px;">1. 下载模板后编辑：支持输入明文{{ searchGrayId }} <a href="javascript:void(0)" @click="downloadTemplate" style="color: #409eff;">点击下载模板</a></p>
                      <p>2. 支持csv、xls、xlsx.格式上传，大小限制在50Mb内。</p>
                    </div>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <jd-button @click="showUploadShowDataDialog = false">取消</jd-button>
                    <jd-button :disabled="fourse" size="small" type="primary"  @click="handleUploadSubmit">确定</jd-button>
                  </div>
      </el-dialog>
    <!-- 生成报表 -->
    <generate
      :control="control1"
      v-if="control1"
      @transData="(val) => (control1 = val)"
      @transData1="getphone1"
    ></generate>
    <generate
      :control="control2"
      v-if="control2"
      @transData="(val) => (control2 = val)"
      @transData1="getphone2"
    ></generate>
    <generate
      :control="control3"
      v-if="control3"
      @transData="(val) => (control3 = val)"
      @transData1="getphone3"
    ></generate>
    <generate
      :control="control4"
      v-if="control4"
      @transData="(val) => (control4 = val)"
      @transData1="getphone4"
    ></generate>
    <generate
      :control="control7"
      v-if="control7"
      @transData="(val) => (control7 = val)"
      @transData1="getphone7"
    ></generate>
    <!-- 数据统计-活动统计-导出 -->
    <generate
      :control="control8"
      v-if="control8"
      @transData="(val) => (control8 = val)"
      @transData1="getphone8"
    ></generate>
    <!-- 情书贺卡导出 -->
    <generate
      :control="control9"
      v-if="control9"
      @transData="(val) => (control9 = val)"
      @transData1="getphone9"
    ></generate>
    <!-- 0元试用参与记录导出 -->
    <generate
      :control="control10"
      v-if="control10"
      @transData="(val) => (control10 = val)"
      @transData1="getphone10"
    ></generate>
    <!-- 试用反馈详情导出 -->
    <generate
      :control="control11"
      v-if="control11"
      @transData="(val) => (control11 = val)"
      @transData1="getphone11"
    ></generate>
    <!-- 试用复购参与记录导出 -->
    <generate 
      :control = 'control12' 
      v-if="control12" 
      @transData="(val) => (control12 = val)"
      @transData1 = 'getphone12'
    ></generate>
    <!-- 试用礼领奖记录导出 -->
    <generate 
      :control = 'control13' 
      v-if="control13" 
      @transData="(val) => (control13 = val)"
      @transData1 = 'getphone13'
    ></generate>
    <generate 
      :control = 'control14' 
      v-if="control14" 
      @transData="(val) => (control14 = val)"
      @transData1 = 'getphone14'
    ></generate>
    <!-- 数据统计导出 -->
    <generate 
      :control = 'control15' 
      v-if="control15" 
      @transData="(val) => (control15 = val)"
      @transData1 = 'getphone15'
    ></generate>
    <!-- 抽卡记录 -->
    <generate 
      :control = 'control16' 
      v-if="control16" 
      @transData="(val) => (control16 = val)"
      @transData1 = 'getphone16'
    ></generate>
    <!-- 幸运值获取记录-定时开奖导出 -->
    <generate
      :control = 'control17' 
      v-if="control17" 
      @transData="(val) => (control17 = val)"
      @transData1 = 'getphone17' >
    </generate>
    <!-- 开团记录 -->
    <generate 
      :control = 'control18' 
      v-if="control18" 
      @transData="(val) => (control18 = val)"
      @transData1 = 'getphone18'
    ></generate>
    <!-- 被邀请人明细导出 -->
    <generate 
      :control = 'control19' 
      v-if="control19" 
      @transData="(val) => (control19 = val)"
      @transData1 = 'getphone19'
    ></generate>
    <!-- 任务完成记录导出 -->
    <generate 
      :control = 'control20' 
      v-if="control20" 
      @transData="(val) => (control20 = val)"
      @transData1 = 'getphone20'
    ></generate>
    <!-- 粉丝发卡导出 -->
    <generate 
      :control = 'control21' 
      v-if="control21" 
      @transData="(val) => (control21 = val)"
      @transData1 = 'getphone21'
    ></generate>
    <!-- 入会有礼导出 -->
    <generate 
      :control = 'control22' 
      v-if="control22" 
      @transData="(val) => (control22 = val)"
      @transData1 = 'getphone22'
    ></generate>
    <!-- 销售 -->
    <generate 
      :control = 'control26' 
      v-if="control26" 
      @transData="(val) => (control26 = val)"
      @transData1 = 'getphone26'
    ></generate>
    <!-- 销售参与记录导出 -->
    <generate 
      :control = 'control27' 
      v-if="control27" 
      @transData="(val) => (control27 = val)"
      @transData1 = 'getphone27'
    ></generate>
    <!-- 生命 -->
    <generate 
      :control = 'control28' 
      v-if="control28" 
      @transData="(val) => (control28 = val)"
      @transData1 = 'getphone28'
    ></generate>
    <!-- 门票支付记录 -->
    <generate 
      :control = 'control29' 
      v-if="control29" 
      @transData="(val) => (control29 = val)"
      @transData1 = 'getphone29'
    ></generate>
    <!-- 出价记录 -->
    <generate 
      :control = 'control30' 
      v-if="control30" 
      @transData="(val) => (control30 = val)"
      @transData1 = 'getphone30'
    ></generate>
    <!-- 成交记录 -->
    <generate 
      :control = 'control31' 
      v-if="control31" 
      @transData="(val) => (control31 = val)"
      @transData1 = 'getphone31'
    ></generate>
    <!-- 趣味游戏 -->
    <generate 
      :control = 'control32' 
      v-if="control32" 
      @transData="(val) => (control32 = val)"
      @transData1 = 'getphone32'
    ></generate>
    <!-- 购物车锦鲤 -->
    <generate 
      :control = 'control33' 
      v-if="control33" 
      @transData="(val) => (control33 = val)"
      @transData1 = 'getphone33'
    ></generate>
    <!-- 购物车锦鲤邀请记录 -->
    <generate 
      :control = 'control34' 
      v-if="control34" 
      @transData="(val) => (control34 = val)"
      @transData1 = 'getphone34'
    ></generate>
    <!-- 固定价参与记录导出 -->
    <generate 
      :control = 'control35' 
      v-if="control35" 
      @transData="(val) => (control35 = val)"
      @transData1 = 'getphone35'
    ></generate>
    <!-- 锁权订单明细 -->
    <generate 
      :control = 'control36' 
      v-if="control36" 
      @transData="(val) => (control36 = val)"
      @transData1 = 'getphone36'
    ></generate>
    <generate 
      :control = 'control37' 
      v-if="control37" 
      @transData="(val) => (control37 = val)"
      @transData1 = 'getphone37'
    ></generate>
    <generate 
      :control = 'control38' 
      v-if="control38" 
      @transData="(val) => (control38 = val)"
      @transData1 = 'getphone38'
    ></generate>
    <!-- 晒单有礼-资料导出 -->
    <generate 
      :control = 'control45' 
      v-if="control45" 
      @transData="(val) => (control45 = val)"
      @transData1 = 'getphone45'
    ></generate>


    <!-- 晒单有礼-审核 -->
    <ProcessInfo
      v-model="isShowProcessInfoDialog"
      :controlType="processControlType"
      :rowData="processRowData"
      :activityId="rowData.id"
      :proccessSelection="proccessSelectionArr"
      @update="_getUserProfileList"
      :isShowAuditResult="isShowAuditResult"
    />
    <!-- 晒单有礼-上传审核结果 -->
    <UploadProccessResult
      v-model="isShowUploadProccess"
      action="/jd-hd-web/show-product/userProfile/upload"
      :activityId="rowData.id"
      @update="_getUserProfileList"
    />

    <div class="bigImg" v-if="dialogImageUrl">
      <img :src="dialogImageUrl" alt="" />
      <i class="el-icon-circle-close" @click="closeBigImg"></i>
    </div>
    <!-- 导出字段设置弹窗 -->
    <export-field-setting-dialog
      :visible.sync="exportSettingDialog"
      :export-fields-data="exportFieldsData"
      :export-field-loading="exportFieldLoading"
      @save="handleExportFieldsSave"
      @close="handleExportFieldsClose"
    />
    <!-- 定时开奖 -->
    <jd-dialog
      title="标记中奖"
      custom-class="system-dialog"
      :visible.sync="isShowSignWin"
      width="550px"
      @close="isShowSignWin = false"
    >
      <jd-tip>
        针对开奖方式为“商家手动审核开奖”有效，仅支持标记剩余库存大于0的奖品
      </jd-tip>
      <el-form style="margin-top: 10px">
        <el-form-item label="中奖奖品" required>
          <el-select
            v-model="selectPrize"
            style="width: 280px"
            placeholder="请选择奖品"
            v-if="cumulativeType == 0"
          >
            <el-option
              v-for="item in signWinPrizeList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
          <div v-else>
            <el-select
              v-model="selectStep"
              style="width: 130px; margin-right: 6px"
              placeholder="请选择奖品池"
              @change="selectPrize = ''"
            >
              <el-option
                v-for="item in prizeSettingListStep"
                :key="item.taskIndex"
                :label="'阶梯 ' + item.taskIndex"
                :value="item.taskIndex"
              ></el-option>
            </el-select>
            <el-select
              v-model="selectPrize"
              style="width: 200px"
              placeholder="请选择奖品"
            >
              <el-option
                v-for="item in stepPrizePool"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <jd-button type="blue" @click="signWin(freeTrialStatusVisibleRow, 4)"
          >确认标记</jd-button
        >
        <jd-button @click="isShowSignWin = false">取消</jd-button>
      </div>
    </jd-dialog>
    <!-- 试用复购详情 -->
    <jd-dialog
      title="参与订单详情"
      custom-class="system-dialog"
      :visible.sync="isShowTrial"
      width="900px"
      :isShowSure="false"
      :isShowCancel="false"
      @close="isShowSignWin = false"
    >
    <div class="new-table-box">
        <jd-table
          :tableData="trialDetailData"
        >
          <el-table-column
            prop="orderId"
            label="订单号"
          ></el-table-column>
          <el-table-column
            prop="orderTime"
            label="下单时间"
          ></el-table-column>
          <el-table-column
            prop="confirmationTime"
            label="确认收货时间"
          ></el-table-column>
          <el-table-column
            prop="skuId"
            label="商品sku"
          ></el-table-column>
          <el-table-column
            prop="orderAmount"
            label="订单金额"
          ></el-table-column>
        </jd-table>
      </div>
    </jd-dialog>

    <!-- 1.58 -->
    <jd-dialog
      title="游戏明细"
      custom-class="system-dialog"
      :visible.sync="numbersGamsVisible"
      width="900px"
      :isShowSure="false"
      :isShowCancel="false"
      @close="numbersGamsVisible = false"
      >
      <div class="new-table-box" style='margin-bottom: 15px' v-if="prizeGetTypes == 0">
        <jd-table
          :tableData="gameDetail"
        >
          <el-table-column
            prop="createTime"
            label="游戏时间"
          ></el-table-column>
          <el-table-column
            prop="isPass"
            label="是否达到分值"
          >
          <template slot-scope="scope">
            {{ scope.row.isPass == 1 ? '是' :scope.row.isPass == 0 ? '否':'' }}
          </template>
         </el-table-column>
          <el-table-column
            prop="score"
            label="分值"
          ></el-table-column>
          <el-table-column
            prop="isDraw"
            label="是否抽奖"
          >
         <template slot-scope="scope">
            {{ scope.row.isDraw == 1 ? '是' :scope.row.isDraw == 0 ? '否':'' }}
          </template> 
          </el-table-column>
          <el-table-column
            prop="isWin"
            label="是否中奖"
          >
          <template slot-scope="scope">
            {{ scope.row.isWin == 1 ? '是' :scope.row.isWin == 0 ? '否':'' }}
          </template> 
         </el-table-column>
        </jd-table>
      </div>
      <div class="new-table-box" style='margin-bottom: 15px' v-if="prizeGetTypes == 1">
        <jd-table
          :tableData="gameDetail1"
        >
          <el-table-column
            prop="createTime"
            label="游戏时间"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="分值类型"
          >
            <template slot-scope="scope">
               {{ scope.row.type == 1 ? '奖品兑换' :scope.row.type == 0 ? '游戏获取':'' }}
            </template> 
          </el-table-column>
          <el-table-column
            prop="score"
            label="分值"
          ></el-table-column>
        </jd-table>
        <div style="margin-top:16px">
          剩余分值合计：
          <span style='color:red'>{{remainScores}}</span>
        </div>
      </div>
    </jd-dialog>






    <!--0元试用-标记中奖  -->
    <jd-dialog
      title="提示"
      custom-class="system-dialog"
      :visible.sync="freeTrialStatusVisible"
      width="450px"
      @close="freeTrialStatusVisible = false"
      @confirm="freeTrialMarkWin"
    >
      <div v-loading="markLoading">
        <div style="text-align: center; margin: 30px 0">是否标记为中奖人？</div>
      </div>
    </jd-dialog>
    <trialReport
      :visible.sync="isDialogVisible"
      :currenttrailReport="currenttrailReport"
    ></trialReport>
    <show-image
      :visible.sync="showImageDialog"
      :image-url="currentImageUrl"
    ></show-image>
    <!-- 修改用户资料弹窗 -->
     <!-- :expendFields="postOrderInfoTable[infoNamesIndex]" -->
    <EditShowDataDialog
      :visible.sync="showEditDialog"
      :initial-data="currentEditData"
      :type="editDialogType"
      @close="handleEditClose"
      @updateList="handleUpdateList"
      :activityId="rowData.id"
      :ruleFieldsList="postRuleFieldsList"
      :expendFields="expendFields"
    />
    <!-- 标记发放随单发订单号 -->
    <jd-dialog
      title="标记发放"
      width="420px"
      :visible.sync="isShowOrder"
      @close="closeOrder"
    >
      <el-form
        :model="orderFrom"
        label-width="auto"
        :rules="orderFormRules"
        ref="orderFormRef"
        class="new-input-box"
      >
        <el-form-item label="随单发订单号：" prop="sendWithOrderId" required>
          <el-input
            placeholder=""
            v-model="orderFrom.sendWithOrderId"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <jd-button @click="closeOrder">取消</jd-button>
        <jd-button
          type="blue"
          @click="orderSubmit"
          >确定标记发放</jd-button
        >
      </template>
    </jd-dialog>
    <!-- 打榜有礼/积分锁权-订单详情 -->
    <rankOrderDetail :currentId="currentId" :activityId="rowData.id" v-if="isShowOrderDetail" @closeDialog="isShowOrderDetail = false" :currentPin="currentPin" :lockType="lockType"></rankOrderDetail>
     <!-- 抽奖次数变更 -->
    <addGiftNumber v-if="isShowAddGiftNumber" :titleText="titleText" :unitText="unitText" :activityId="rowData.id" @close="handleCloseAddGiftNumber"></addGiftNumber>
    <!-- 抽奖次数变更（批量） -->
    <addGiftNumberBatch v-if="isShowAddGiftNumberBatch" :activityId="rowData.id" @close="handleCloseAddGiftNumberBatch"></addGiftNumberBatch>

    <!-- 游戏次数变更 -->
    <addGiftNumberOne v-if="isShowAddGiftNumberOne" :unitText="unitText"  :titleText="opportunityText" :activityId="rowData.id" @close="handleCloseAddGiftNumberOne"></addGiftNumberOne>
    <!-- 游戏次数变更（批量） -->
    <addGiftNumberBatchOne v-if="isShowAddGiftNumberBatchOne" :titleText="opportunityText" :activityId="rowData.id" @close="handleCloseAddGiftNumberBatchOne"></addGiftNumberBatchOne>
    <!-- 补发奖品 -->
    <reissueHdPrize v-if="isShowSendPrize" :searchCond="searchCond" :otherSaearch="otherSaearch" :valueRow="rowData" :isShowSendPrize="isShowSendPrize"  @close="isShowSendPrize = false" @createFn="getCreateFn"></reissueHdPrize>
  </div>
</template>

<script>
import generate from "@/components/generate_report.vue";
import inputForm from "@/components/jhk/inputForm";
import evaluationDialog from "./evaluationDialog/evaluationDialog.vue";
import lockBatchDialog from "./lockBatchDialog.vue";
import crowdDialog from "./crowd-Dialog.vue";
import batchUpload from "../list/components/batchUpload.vue";
import prizeList from "./components/prize-preview.vue";
import trialReport from "./components/_components/trialReport.vue";
import showImage from "@/views/interactiveMarketing/activity/components/_components/showImage.vue";
import rankOrderDetail from "./components/rankOrderDetail.vue";
import statisticsYunqi from "./statisticsYunqi/index.vue";
import addGiftNumber from "./components/addGiftNumber.vue"
import addGiftNumberBatch from "./components/addGiftNumberBatch.vue"
import addGiftNumberOne from "./components/addGiftNumber.vue"
import addGiftNumberBatchOne from "./components/addGiftNumberBatch.vue"
import {
  getCoupon,
  openCardRecord,
  appointment,
  lockSendStatus,
  updateReceiveAddress,
  markingSendStatusLockRight,
  pointsExchangeQuash,
  getFieldJsonConfig,
  saveFieldJsonConfig,
  markingStatus,
  markWinTrial,
  removeUserPromoToken,
  userLifeCycle,
  resendPoints,
  writeReceiveAddress,
  cancelMarkSendWithOrder,
  importReceiverMobiles
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import {
  markingSendStatus,
  orderDetailPage,
  memConvAnalysis,
  purchaseActivityWithdraw,
  getTimePrizeDetail,
  quashAddMoney,
  getCollectCardDetail,
  getBiStoreGiftDetail,
  orderRankDetail,
  pointOrderDetailPage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import statisticsData from "@/mixin/activity_statistics_new.js";
import ProcessInfo from "./components/processInfo.vue";
import UploadProccessResult from "./components/uploadProccessResult.vue";
import { pcaTextArr } from "element-china-area-data";
import bargainJoinRecord from "./components/bargainJoinRecord.vue";
import bargainRecord from "./components/bargainRecord.vue";
import joinRecord from "./components/joinRecord.vue";
import awardRecord from "./components/awardRecord.vue";
import orderDetail from "./components/orderDetail.vue";
import physicalAward from "./components/physicalAward.vue";
import exportFieldSettingDialog from "@/views/interactiveMarketing/activity/components/activity_data_statistics_new/_components/exportFieldSettingDialog.vue";
import questionnaireRecords from "./components/questionnaireRecords.vue";
import photoContestRecord from "./components/photoContestRecord.vue";
import { getSellerInfo } from "@/api/jhk/sellerController.js"
import shopCheckInApply from "./components/shopCheckInApply.vue";
import checkInDetail from "./components/checkInDetail.vue";
import orderTable from "./components/orderTable.vue";
import EditShowDataDialog from './components/_components/shareDataDialog.vue';
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { getShopInfo } from "@/api/sellerController";
// 导入 trialRebuySummary 配置
import { trialRebuySummary } from './components/data.js';
import { customSellerLinkPage } from "@/api/jhk/activityController";
import { getShopList } from "@/api/public";
import birthInfo from "./components/birthInfo.vue";
import collectOpportunitiesRecord from "./components/collectOpportunitiesRecord.vue";
import wishingPoolRecord from "./components/wishingPoolRecord.vue"
import xhsParticipateRecord from "./components/xhsRecord/xhsParticipateRecord.vue"
import buildingGiftRecord from "./components/buildingGiftRecord.vue"
import participateRecord from "./components/collectPointRecord/participateRecord.vue"
import calendarCheckIn from "./components/participateRecordCom/calendarCheckIn.vue"
import clockInDetails from "./components/participateRecordCom/clockInDetails.vue"
import goodsDetail from "./components/goodsDetail.vue";
import orderDetailOverview from "./components/orderDetailOverview.vue"
import biOrderDetail from "./components/biOrderDetail.vue";
import versatileAnswersRecord from "./components/participateRecordCom/versatileAnswersRecord.vue"
import { useGrayId } from "@/common/hook.js"

import answerQuestionSparticipationRecord from "./components/participateRecordCom/answerQuestionSparticipationRecord.vue"
import recommendedDetails from "./components/participateRecordCom/recommendedDetails.vue"
import redemptionHistory from "./components/pointsRedemptionCoupon/redemptionHistory.vue"
import participateConversionAnalysis from "./components/pointsRedemptionCoupon/participateConversionAnalysis.vue"
import reissueHdPrize from "./components/reissueHdPrize.vue"
export default {
  mixins: [statisticsData],
  components: {
    inputForm,
    evaluationDialog,
    lockBatchDialog,
    crowdDialog,
    generate,
    batchUpload,
    prizeList,
    ProcessInfo,
    UploadProccessResult,
    joinRecord,
    awardRecord,
    orderDetail,
    physicalAward,
    exportFieldSettingDialog,
    questionnaireRecords,
    trialReport,
    showImage,
    shopCheckInApply,
    checkInDetail,
    EditShowDataDialog,
    rankOrderDetail,
    statisticsYunqi,
    addGiftNumber,
    addGiftNumberBatch,
    orderTable,
    bargainJoinRecord,
    bargainRecord,
    addGiftNumberOne,
    addGiftNumberBatchOne,
    birthInfo,
    collectOpportunitiesRecord,
    wishingPoolRecord,
    goodsDetail,
    xhsParticipateRecord,
    buildingGiftRecord,
    participateRecord,
    clockInDetails,
    photoContestRecord,
    calendarCheckIn,
    versatileAnswersRecord,
    orderDetailOverview,
    biOrderDetail,
    versatileAnswersRecord,
    answerQuestionSparticipationRecord,
    recommendedDetails,
    redemptionHistory,
    participateConversionAnalysis,
    reissueHdPrize
  },
  props: {
    rowData: {
      type: Object,
      default: {},
    },
    ids1: {
      type: String,
      default: "",
    },
    // 用于区分是不是打榜有礼
    isChongBang: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const labelStatus = this.fitersRepurchase(
      [16, 17, 18, 27,79,81,82,84,85],
      "发放状态：",
      "中奖状态："
    );
    const labelWait = this.fitersRepurchase(
      [16, 17, 18, 27],
      "待领取",
      "未中奖"
    );
    const valueWait = this.fitersRepurchase([16, 17, 18, 27], -1, 1);
    const labelWin = this.fitersRepurchase(
      [16, 17, 18, 27],
      "待发放",
      "已中奖"
    );
    const labelDate =
      (this.rowData && this.rowData.activityType) == 41
        ? "发放时间："
        : this.fitersRepurchase(
            [16, 17, 18, 27, 44, 69,78],
            "领奖时间：",
            "参与时间："
          );
    return {
      otherSaearch: null,
      searchCond: null,
      allWinPeoples: 0,//公共：总计中奖人数
      trialWinPeoples: 0,//试用礼：总计中奖人数
      rankWinPeoples: 0,//打榜礼：总计中奖人数
      isShowSendPrize: false,
      searPhoneStr: "",
      formDataPhoneStr: "",
      orderDetaiInfolForm: {
        pin: "",
        orderId: "",
        orderState: "",
        startTime: "",
        endTime: "",
        sellerLinkId: "",
        orderVenderId: "",
        memberNick: "",
        activityId: this.rowData.id,
      },
      sourcePopupList: [],
      inputBiOrderDetail:  [
        {
          // 初始值仅占位，真实标签由 watch.grayId 在 computed 就绪后写入
          label: "用户pin：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户pin,精确查询",
        },
        {
          label: "订单编号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单状态：",
          prop: "orderState",
          value: "",
          type: "Select",
          options: [
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
          multiple: true,
        },
        {
          label: "下单时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          startTime: '',
          endTime: '',
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
      ],
      actTypeMap: [36,45,48,52,53,68,80],
      isShowExtraWinRecord: false,
      titleText: "抽奖次数",
      unitText: "变更次数",
      isShowAddScore: false,
      evaluateType: 0,
      // 商品名称列展开状态：false=收起显示1行，true=展开显示2行
      goodsNameColumnExpanded: false,
      // 表格刷新key，用于强制刷新表格表头
      tableKey: 0,
      // 商品名称列展开状态：false=收起显示1行，true=展开显示2行
      goodsNameColumnExpanded1: false,
      isShowInvite: false,//打榜有礼：是否为入会打榜
      remainScores:0,
      prizeGetTypes:'',
      gameDetail:[],
      gameDetail1:[],
      joinGameRecordTable:[],
      joinGameRecordTotal:0,
      cardInviteRecordTable:[],
      cardInviteRecordTotal:0,
      numbersGamsVisible: false,
      //1.58机会获取记录
      reissueGameTaskBalanceFrom:{
        openId:"",
        balance:1,
      },
      gameShow:false,
      changeFrequencyShow:false,
      exchangeListTwelve:[],
      exchangeListEleven:[],
      inputCardListTableChange:[],
      inputCardTotal:0,
      totalMailEleven:0,
      totalMailTwelve:0,
      isShowAddGiftNumber: false,
      isShowAddGiftNumberBatch: false,
      isShowAddGiftNumberOne: false,
      isShowAddGiftNumberBatchOne: false,
      physicalPrizes: [],
      ParticipatLockTableGift:[],
      totalParticipatLockGift:0,
      goodsRecordTableCardLife:[],
      goodsRecordTableCardLife1:[
        {
          'chaosPin':11111
        }
      ],
      totalLifeRecords:0,
      rankingRecordsTable:[],
      totalRankingRecords:0,
      totalOrderDetail:0,
      control26:false,
      control27:false,
      salesRankSummaryTable:{
        orderTotalCount:null,
        orderTotalAmount:null,
        itemTotalCount:null
      },
      orderDetailTable:[],
      ranksTable: [],
      ParticipatLockTablesalesDetail:[],
      ParticipatLockTablesales:[],
      ParticipatLockTableFans:[],
      totalParticipatSalesDetail:0,
      totalParticipatSales:0,
      totalParticipatLockFans:0,
      completionRecord:[],
      completionRecordTotalAward:0,
      inviteesData:[],
      inviteesDataTotal:0,
      totalTeam:0,
      teamList:[],
      expendFields: [],
      staticInfoNamesInfo: [],
      infoNamesIndex: 0,
      goodsRecordTableCard:[],
      goodsRecordTableChange:[],
      opportunity:[],
      opportunityTotal:0,
      gachaRecoeds:[],
      currentId: -1,
      currentPin: "",
      lockType: 0,
      lockOrderData: [],
      lockOrderTotal: 0,
      isShowOrderDetail: false,
      shopList: [],
      sellerLinkList: [],
      awardTableTrial:[],
      awardTableTrialOne:[],
      trialDetailData:[],//试用复购
      isShowTrial:false,
      markLoading: false,
      totalZeroTrial: 0,
      currentImageUrl: "",
      showImageDialog: false,
      dynamicColumns: [], //题目
      freeTrialStatusVisible: false,
      freeTrialStatusRow: {},
      isDialogVisible: false,
      currenttrailReport: {},
      defaultIndex: 0,
      pcaTextArr,
      nowActType: 0,
      prizeNames: [],
      isShowAuditResult: true, //审核备注展示
      dialogImageUrl: "",
      source: "",
      crowdSearchForm: {},
      control1: false,
      control2: false,
      control3: false,
      control4: false,
      control5: false,
      control6: false,
      control7: false,
      control8: false,
      control9: false,
      control10: false,
      control11: false,
      control12: false,
      control13: false,
      control14: false,
      control15: false,
      control16: false,
      control17: false,
      control18: false,
      control19: false,
      control20: false, // 任务完成记录导出
      control21: false, // 粉丝参与记录导出
      control22: false, // 入会有礼导出
      control28:false, // 销售参与记录导出
      control29:false, // 门票支付记录导出
      control30:false, // 出价记录导出
      control31:false, // 成交记录导出
      control32:false, // 趣味游戏导出
      control33:false, // 购物车锦鲤导出
      control34:false, // 购物车锦鲤邀请记录导出
      control35:false, // 固定价参与记录导出
      control36:false, // 锁权订单明细导出
      control37:false, // 0元试用订单明细导出
      control38:false, // 试用复购订单明细导出
      control45:false, // 晒单有礼-资料导出
      billetExportType: '1', // 1: 参与记录, 2: 获取记录
      isShowCrowdDialog: false,
      lockTakeGoodsVisible: false,
      // 销售打榜-榜单实况相关数据
      expandedRows: [], // 存储展开的行ID
      totalOrderCount: 0, // 订单数量统计
      totalOrderAmount: 0, // 订单金额统计
      totalProductCount: 0, // 商品件数统计
      takeGoodsForm: {
        receiverName: "",
        receiverMobile: "",
        receiverAddress: [],
        detailedAddress: "",
      },
      formListLockOrder:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListEleven:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListTwelve:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      batchLockVisible: false,
      // 收货信息
      takeGoodsTable: [],
      totalTakeGoods: 0,
      // note--锁权记录
      lockRightTable: [],
      totalLockRight: 0,
      // note--加购记录
      addCartTable: [],
      totalAddCart: 0,
      //补签卡
      signInTableSupplementary:[],
      totalSignInSupplementary:0,
      // 数据总览tabs
      switchIndex: "1",
      tabMap: {
        '1': '互动参与',
        '2': '浏览店铺',
        '3': '浏览商品',
        '4': '下单',
        '5': '入会',
        '6': '中奖',
      },
      // 加购记录查询条件
      inputDataAddCart: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
        {           
            label: "投放渠道：",          
            prop: "sellerLinkId",          
            type: "Select",          
            placeholder: "请选择",          
            value: "",          
           options: this.sellerLinkList && this.sellerLinkList.length > 0 ? this.sellerLinkList.map(item => ({ label: item.sellerLinkName, value: item.id          })) : [{ label: "全部", value: "" }]},
        {
          label: "中奖状态：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已中奖", value: 1 },
            { label: "未中奖", value: 0 },
          ],
        },
        {
          // name: "加购时间：",
          // myDate: true,
          // val: ["startTime", "endTime"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "加购时间：",
          type: "DateRange",
          prop: "addCartTime",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],
      fourse:true,
      // 弹窗
      addCartDetailShow: false,
      addCartDetailData: [],
      // note--结束
      dialogDeatils: false,
      isTaskPrize: false, // 是否为任务奖品类型
      taskIndex: "", // 任务标值
      CouponMember1: [],
      RuleFieldsList: [],
      multipleSelection: [],
      tableShopData: [],
      dialogGroup: false,

      // 晒单有礼
      isShowUploadProccess: false, //上传审核结果弹窗
      proccessSelectionArr: [], //批量选择
      processRowData: {},
      isShowProcessInfoDialog: false, //审核弹窗
      processControlType: "single", //审核弹窗类型，批量审核，单个审核
      postUserStaticsInfo: {
        //用户资料信息汇总
        totalSubmitNum: 0, //共提交
        lastSubmitNum: 0, //昨日提交
        passNum: 0, //通过份数
        unProcessNum: 0, //待审核份数
        failNum: 0, //拒绝份数
      },
      postRuleFieldsList: [], //用户资料信息
      totalPostOrderUserInfo: 10,
      postOrderInfoTable: [], //用户资料-晒单有礼
      // 晒单有礼-用户资料
      postOrdersInfoInput: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "订单号：",
          prop: "orderId",
          placeholder: "请输入",
          type: "Input",
        },
        // {
        //   name: "提交时间：",
        //   myDate: true,
        //   val: ["createStartTime", "createEndTime"],
        //   startPlaceholder: "选择日期时间",
        //   endPlaceholder: "选择日期时间",
        // },
        {
          label: "提交时间：",
          type: "DateRange",
          prop: "createTime",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
        },
        {
          label: "审核状态：",
          prop: "processStatus",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待审核", value: 0 },
            { label: "已通过", value: 1 },
            { label: "已驳回", value: 2 },
          ],
        },
        {
          // name: "审核时间：",
          // myDate: true,
          // val: ["processStartTime", "processEndTime"],
          // startPlaceholder: "选择日期时间",
          // endPlaceholder: "选择日期时间",
          label: "审核时间：",
          type: "DateRange",
          prop: "processTime",
          dateType: "datetime",
          startKey: "processStartTime",
          endKey: "processEndTime",
        },
        {
          label: "订单状态：",
          prop: "orderState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
           { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
        },

      ],

      joinSummary: [
        {
          value: "actPv", // 对应tableTotal的字段
          name: "PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动的累计来访PV", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "actUv",
          name: "UV",
          tips: true,
          tipsName: "活动的累计来访UV，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "participatePv",
          name: "参与次数",
          tips: true,
          tipsName:
            "符合活动参与行为的用户参与次数汇总，用户可能在活动中参与多次，根据活动类型而定",
          color: "#F4ACB9",
        },
        {
          value: "participateUv",
          name: "参与人数",
          tips: true,
          tipsName:
            "符合活动参与行为的用户数汇总、包括但不限于：抽奖、领奖、分享、签到等，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "participateAvg",
          name: "人均参与次数",
          tips: true,
          tipsName: "参与次数/参与人数。",
          color: "#C2CDDE",
        },
        {
          value: "participateRate",
          name: "参与率",
          tips: true,
          tipsName: "参与人数 / UV",
          color: "#96AA08",
        },
        {
          value: "cartPv",
          name: "加购次数",
          tips: false,
          tipsName: "加购了活动指定商品的累计次数",
          color: "#C2D1C8",
        },
        {
          value: "cartUv",
          name: "加购人数",
          tips: false,
          tipsName: "加购了活动指定商品的累计人数，多日不去重",
          color: "#D39595",
        },
        {
          value: "sharePv",
          name: "分享次数",
          tips: false,
          tipsName: "活动中进行分享的次数",
          color: "#B8C7F3",
        },
        {
          value: "shareUv",
          name: "分享人数",
          tips: false,
          tipsName: "活动中进行分享的人数，单日去重，多日不去重",
          color: "#A7878E",
        },
      ],
      stoneSummary: [
        {
          value: "scanshopPv",
          name: "浏览店铺次数",
          tips: false,
          tipsName: "累计从活动页跳转并浏览店铺PV",
          color: "#EFB37E",
        },
        {
          value: "scanshopUv",
          name: "浏览店铺人数",
          tips: false,
          tipsName: "累计从活动页跳转并浏览店铺UV，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "scanshopRate",
          name: "浏览率",
          tips: false,
          tipsName: "浏览店铺人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "followshopUv",
          name: "新增店铺关注人数",
          tips: false,
          tipsName: "活动中累计关注店铺的人数，不去重",
          color: "#F2D0B5",
        },
        {
          value: "followshopPv",
          name: "新增店铺关注次数",
          tips: false,
          tipsName: "活动中累计关注店铺的次数",
          color: "#C2CDDE",
        },
        {
          value: "followshopRate",
          name: "店铺关注率",
          tips: false,
          tipsName: "新增店铺关注人数/ 参与人数",
          color: "#96AA08",
        },
      ],
      goodsSummary: [
        {
          value: "scanskuPv",
          name: "浏览商品次数",
          tips: false,
          tipsName: "活动中浏览任意商品的次数",
          color: "#EFB37E",
        },
        {
          value: "scanskuUv",
          name: "浏览商品人数",
          tips: false,
          tipsName: "活动中浏览任意商品的人数，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "scanskuRate",
          name: "浏览商品率",
          tips: false,
          tipsName: "浏览商品人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "followskuUv",
          name: "商品关注人数",
          tips: false,
          tipsName: "活动中关注了任意商品的累计人数，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "followskuPv",
          name: "商品关注次数",
          tips: false,
          tipsName: "活动中关注了任意商品的累计次数",
          color: "#C2CDDE",
        },
        {
          value: "followSkuRate",
          name: "商品关注率",
          tips: false,
          tipsName: "商品关注人数 / 参与人数",
          color: "#96AA08",
        },
      ],
      orderSummary: [
        {
          value: "orderPayGmv",
          name: "下单GMV(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的按订单金额汇总",
          color: "#EFB37E",
        },
        {
          value: "orderPayNum",
          name: "下单人数(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的用户数",
          color: "#B2A8DA",
        },
        {
          value: "orderPayQuantity",
          name: "总下单数(付款)",
          tips: false,
          tipsName: "活动时间范围内，活动中累计产生订单的订单数汇总",
          color: "#F4ACB9",
        },
        {
          value: "price",
          name: "客单价",
          tips: false,
          tipsName: "下单GMV(付款) / 下单人数(付款)",
          color: "#F2D0B5",
        },
        {
          value: "orderQuantityAvg",
          name: "平均单量",
          tips: false,
          tipsName: "总下单数(付款) / 下单人数(付款)",
          color: "#C2CDDE",
        },
        {
          value: "orderConversionRate",
          name: "下单转化率",
          tips: false,
          tipsName: "下单人数(付款) / 参与人数",
          color: "#96AA08",
        },
        {
          value: "newOpenCardOrderQuantity",
          name: "新增会员下单人数",
          tips: false,
          tipsName: "活动中新增入会的用户，在活动中累计产生订单的用户数",
          color: "#3498DB",
        },
        {
          value: "oldOpenCardOrderNum",
          name: "老会员下单人数",
          tips: false,
          tipsName: "非活动中入会的会员用户（参与活动用户中为会员身份的用户数量减去新增入会用户），在活动中累计产生订单的用户数",
          color: "#E74C3C",
        },
        {
          value: "newOpenCardOrderGmv",
          name: "新增会员下单金额",
          tips: false,
          tipsName: "活动中新增入会的用户，在活动中累计产生订单的付款金额",
          color: "#9B59B6",
        },
        {
          value: "oldOpenCardOrderGmv",
          name: "老会员下单金额",
          tips: false,
          tipsName: "非活动中入会的会员用户（参与活动用户中为会员身份的用户数量减去新增入会用户），在活动中累计产生订单的付款金额",
          color: "#F39C12",
        },
        // TODO: 需要确认字段
        // {
        //   value: "orderConversionRate",
        //   name: "新增会员下单人数",
        //   tips: false,
        //   tipsName: "活动中新增入会的用户，在活动中累计产生订单的用户数；",
        //   color: "#3498DB",
        // },
        // {
        //   value: "orderConversionRate",
        //   name: "老会员下单人数",
        //   tips: false,
        //   tipsName: "非活动中入会的会员用户，在活动中累计产生订单的用户数；",
        //   color: "#E74C3C",
        // },
        // {
        //   value: "orderConversionRate",
        //   name: "新增会员下单金额",
        //   tips: false,
        //   tipsName: "活动中新增入会的用户，在活动中累计产生订单的付款金额；",
        //   color: "#9B59B6",
        // },
        // {
        //   value: "orderConversionRate",
        //   name: "老会员下单金额",
        //   tips: false,
        //   tipsName: "非活动中入会的会员用户，在活动中累计产生订单的付款金额",
        //   color: "#F39C12",
        // },
      ],
      fanSummary: [
        {
          value: "newOpenCardNum",
          name: "新增入会人数",
          tips: false,
          tipsName: "活动中新增入会的用户人数，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "openCardConversionRate",
          name: "入会转化率",
          tips: false,
          tipsName: "新增会员人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "newOpenCardOrderNum",
          name: "新增会员下单人数",
          tips: false,
          tipsName:
            "活动中新增入会的用户且进行下单的人数，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "newOpenCardOrderGmv1",
          name: "新增会员下单GMV(付款)",
          tips: false,
          tipsName: "活动中新增入会在本次活动期间符合下单条件的GMV",
          color: "#C2CDDE",
        },
        {
          value: "newOpenCardOrderQuantity1",
          name: "新增会员下单数(付款)",
          tips: false,
          tipsName: "活动中新增入会在本次活动期间符合下单条件的下单次数",
          color: "#96AA08",
        },
        {
          value: "newOpenCardPrize",
          name: "新增会员客单价",
          tips: false,
          tipsName: "新增粉丝下单GMV(付款) / 新增粉丝下单人数",
          color: "#C2D1C8",
        },
      ],
      prizeSummary: [
        {
          value: "accumulateWinTimes",
          name: "累计中奖次数",
          tips: false,
          tipsName: "活动中累计中奖的次数",
          color: "#EFB37E",
        },
        {
          value: "accumulateWinNum",
          name: "累计中奖人数",
          tips: false,
          tipsName: "活动中累计中奖的人数，单日去重，多日不去重",
          color: "#B2A8DA",
        },
        {
          value: "winRate",
          name: "中奖率",
          tips: false,
          tipsName: "累计中奖人数 / 参与人数",
          color: "#F4ACB9",
        },
        {
          value: "accumulateReceiveNum",
          name: "累计领奖人数",
          tips: false,
          tipsName: "活动中累计领奖的人数，单日去重，多日不去重",
          color: "#F2D0B5",
        },
        {
          value: "receiveRate",
          name: "领奖率",
          tips: false,
          tipsName: "累计领奖人数/中奖人数",
          color: "#C2CDDE",
        },
      ],
      tatal_num: {
        users: 0, //活动参与用户15天内下单用户量
        ordNum: 0, //活动参与⽤户15天内下单订单总量
        gmv: 0, //活动参与⽤户15天内下单转化金额(元)
        ordRate: 0, //活动参与⽤户15天内下单转化率
      },
      hostList: [
        {
          name: "下单用户量",
          nameOne: 100,
        },
        {
          name: "下单订单总量",
          nameOne: 100,
        },
        {
          name: "下单金额",
          nameOne: 100,
        },
        {
          name: "下单转化率",
          nameOne: 100,
        },
      ],
      loading: false,
      activeName: "firstNew",
      activityTable: [],
      goodsRecordTable: [],
      getRecordList: [],
      signInTable: [],
      signInTableInfo: [
        {
          label: "用户pin（加密）",
          prop: "chaosPin",
          width: 150,
        },
        {
          label: "用户昵称",
          prop: "memberNick",
          width: 200,
        },
        {
          label: "签到时间",
          prop: "signTime",
          width: 200,
        },
        {
          label: "投放渠道",
          prop: "sellerLinkName",
          width: 200,
        },
        {
          label: "累计签到次数(含历史记录)",
          prop: "cumulativeTimes",
          width: 200,
          align: "right",
        },
        {
          label: "连续签到次数(不含历史记录)",
          prop: "sequenceTimes",
          align: "right",
        },
      ],
      //TODO: 补签卡获取记录
      signInTableInfoSupplementary: [
        {
          label: "用户昵称",
          prop: "memberNick",
          width: 400,
        },
        {
          label: "用户pin",
          prop: "chaosPin",
          width: 150,
        },
        {
          label: "投放渠道",
          prop: "sellerLinkName",
          width: 400,
        },
        {
          label: "获取时间",
          prop: "joinTime",
          width: 400,
        },
        {
          label: "任务类型",
          prop: "taskTypeStr",
          width: 400,
          formatter: (row) => {
            return row.taskTypeStr === '开卡入会' ? '加入会员' : row.taskTypeStr;
          }
        },
        {
          label: "赠送次数",
          prop: "giveTimes",
          width: 400,
        },
      ],

      awardTable: [],
      awardTable1: [
        {
          a: 1,
        },
      ],
      distributionTable: [],
      inkindTable: [],
      userInfoTable: [],
      GiftrecordList: [],
      invitationNum: [], //邀请统计
      queryForm: {
        evaluateTime: "7",
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      postForm: {
        startDate: "",
        endDate: "",
        channelCode: "",
        sellerLinkId: ""
      },
      batchTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "商品详情",
          value: 1001,
        },
        {
          label: "店铺首页",
          value: 1002,
        },
        {
          label: "会员二级页",
          value: 1003,
        },
        {
          label: "推广页",
          value: 1004,
        },
        {
          label: "其他",
          value: 1005,
        },
      ],
      tableTotal: {
        pv: 0, //会员中心首页PV
        uv: 0, //会员中心首页uv
        // incrJoinNumber: [], //参与人数今日增量
        joinNumber: 0, //参与人数
        joinTimes: 0, //参与人次
        perJoinNumber: 0, //人均参与次数
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //折线图数据
      loading1: false,
      myCharts: null,
      chartEffectDetail: [],
      chartEffectDetailInfo: [
        {
          label: "日期",
          prop: "dateTime",
        },
      ],
      totalNum: 0,
      totalAward: 0,
      totalSignIn: 0,
      totalInkind: 0,
      totalUserInfo: 0,
      totalDistribution: 0, //发放记录
      totalCoupon: 0,
      totalCouponstatistics: 0,
      totalTeam: 0,
      totalComment: 0,
      totalParticipat: 0,
      totalParticipatLock: 0,
      totalParticipatOpenWin: 0,
      totalParticipatLockOrder:0,
      totalParticipatLockTrial:0,
      totalAwardTs:0,
      totalAwardTsOne:0,
      totalLuck: 0,
      totalMemberUpGrade: 0,
      totalBilletDoux: 0, //参与记录(情书贺卡)
      totalBilletReceive: 0, //获取记录(情书贺卡)
      totalGiftrecord: 0,
      totalAwardFor: 0,
      totalRecord: 0,
      inviteeDetailsTotal: 0,
      joinInviteTotal: 0,
      joinInvitesData: [],
      formList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      activityId: this.rowData.id,
      formList1: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListRecord: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListLock: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListLockTrial:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      //粉丝
      formListLockFans:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formLockOrder:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListTras:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formListTrasOne:{
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formOpenWin: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      formLuck: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
        taskType: "",
        memberNick: null,
      },
      formZeroList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
        mobile: "",
        regionList: [],
        pin: "",
        prizeName: "",
        isWin: "",
        grantStatus: "",
        isAddress: "",
        joinStartTime: "",
        joinEndTime: "",
        grantStartTime: "",
        grantEndTime: "",
        level: "",
      },
      formZeroDetailList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      joinInviteForm: {
        size: 10,
        current: 1,
        pin: "",
        inviteePin: "",
        isValid: "",
        inviteStartTime: this.getDateStr(-30) + " 00:00:00",
        inviteEndTime: this.getDateStr(0) + " 23:59:59"
      },
      formExtra: {
        current:1,
        size: 10,
        pin: "",
        memberNick: "",
        prizeType: "",
        status: "",
        winTimeStart: "",
        winTimeEnd: "",
        id: this.rowData.id,
        prizeObjectType: 1,
        prizeName: "",
        winNumMinLimit: "",
        winNumMaxLimit: "",
      },
      inputData: [],
      inputDataList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "签到时间：",
          type: "DateRange",
          prop: "signTime",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime", // 如果是同一个字段，前后时间一样写
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      //TODO:补签卡获取记录
      inputDataListSupplementary: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
             {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "获取时间：",
          type: "DateRange",
          prop: "signTime",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime", // 如果是同一个字段，前后时间一样写
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "任务类型：",
          prop: "taskType",
          placeholder: "请选择任务类型",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 13 },
            { label: "加购商品", value: 4 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "浏览会场", value: 5 },
            { label: "预约商品", value: 12 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
            { label: "加入会员", value: 7 },
            { label: "关注店铺", value: 6 },
          ],
        },
      ],
      inputParticipat: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          prop: "participateTime",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "得分：",
          type: "InputDouble",
          startKey: "startScore",
          endKey: "endScore",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
        },
        {
          label: "是否通关：",
          prop: "isPass",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否抽奖：",
          prop: "isDraw",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否中奖：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
              {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
      ],
      inputMemberUpGrade2: [
        // 会员升级礼参与记录
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          prop: "participateTime",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "是否发生升级：",
          prop: "isUpgrades",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "最新访问活动时间：",
          type: "DateRange",
          prop: "latestJoinTime",
          dateType: "datetime",
          startKey: "latestJoinStartTime",
          endKey: "latestJoinEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "是否领取奖品：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
      ],
      // 0元试用参与记录
      zeroTrialForm: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户pin：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "level",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "中奖状态：",
          prop: "isWin",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未中奖", value: 0 },
            { label: "已中奖", value: 1 },
          ],
        },
        {
          label: "发放状态：",
          prop: "grantStatus",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "", },
            { label: "待发放", value: 7 },
            { label: "已发放", value: 3 },
            { label: "已失效", value: 8 },
            { label: "发放失败", value: 4 },
          ],
        },
        {
          label: "是否填写地址：",
          prop: "isAddress",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "", },
            { label: "已填写", value: 1 },
            { label: "未填写", value: 0 },
          ],
        },
        {
          label: "报名时间：",
          type: "DateRange",
          prop: "joinTime",
          dateType: "datetime",
          startKey: "joinStartTime",
          endKey: "joinEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "grantStartTime",
          endKey: "grantEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "手机号：",
          slot: "mobileSlot",
        },
        {
          label: "收货地址城市：",
          prop: "cites",
          type: "City1",
          value: "",
          customKey: "regionList",
          customValue: [],
        }
      ],
      billetInput: [], // 情书贺卡参与记录
      formBilletDoux: [
        // 情书贺卡参与记录
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "是否完成制作：",
          prop: "finishedFlag",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
      ],
      trialDetailForm: [
        // 0元试用试用反馈详情
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户pin：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "试用奖品名称：",
          prop: "prizeName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "提交时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
        },
      ],
      billetReceive: [], // 情书贺卡获取记录
      formBilletReceive: [
        // 情书贺卡获取记录
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "用户手机：",
          prop: "receiverMobile",
          type: "Input",
          placeholder: "请输入",
        },
      ],
      inputParticipatLockInfo: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "是否符合中奖条件：",
          prop: "isPass",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "符合", value: 1 },
            { label: "不符合", value: 0 },
          ],
        },
        {
          label: "是否领取奖品：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已领取", value: 1 },
            { label: "未领取", value: 0 },
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "winStartTime",
          endKey: "winEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      orderTrial: [ // 正装/试用订单明细
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "订单号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单状态：",
          prop: "orderStateList",
          type: "Select",
          options: [
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
          multiple: true,
        },
        {
          label: "下单时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "orderStartTime",
          endKey: "orderEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        }
      ],
      orderDetailForm: [ // 情书贺卡获取记录
        {
          label: "用户PIN：",
          prop: "customerPin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "父订单号：",
          prop: "rootId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单状态：",
          prop: "orderStateList",
          type: "Select",
          options: [
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
          multiple: true,
        },
        {
          label: "下单时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "orderStartTime",
          endKey: "orderEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        }
      ],
    //TODO:销售打榜
      inputParticipatSalesRanking: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "joinStartTime",
          endKey: "joinEndTime",
          type: "DateRange",
        },
      ],
      //试用复购-参与记录
      inputParticipatLockTrial: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          type: "DateRange",
        },
        {
          label: "订单号：",
          prop: "orderId",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "是否获得试用礼：",
          prop: "isGetTrialGift",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否获得正装礼：",
          prop: "isGetFormalGift",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "商品SKU：",
          prop: "skuId",
          placeholder: "请输入",
          type: "Input",
        },
      ],
      //打包一口价
      inputParticipatLockFixedPrice: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "joinTimeStart",
          endKey: "joinTimeEnd",
          type: "DateRange",
        }
      ],
      //粉丝
      inputParticipatLockFans: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "是否中奖：",
          prop: "isPass",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否领取奖品：",
          prop: "isWin",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已领取", value: 1 },
            { label: "未领取", value: 0 },
          ],
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          type: "DateRange",
        },
      ],

      //入会
      inputParticipatLockGift: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "是否符合中奖条件：",
          prop: "isPass",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否领取奖品：",
          prop: "isWin",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已领取", value: 1 },
            { label: "未领取", value: 0 },
          ],
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          type: "DateRange",
        },
      ],

      //销售打榜订单明细
      inputParticipatSalesRankingDetail: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "订单编号：",
          prop: "orderId",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "父订单号：",
          prop: "rootId",
          placeholder: "请输入",
          type: "Input",
        },
         {
          label: "订单状态：",
          prop: "orderState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
           { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
        },
        {
          label: "下单时间：",
          dateType: "datetime",
          startKey: "orderStartTime",
          endKey: "orderEndTime",
          type: "DateRange",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        }
      ],

      //生命周期参与记录
      inputParticipatSaleslife: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          type: "DateRange",
        },
      ],
      //购物车锦鲤邀请记录
      inputCardInviteInfo:[
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "助力时间：",
          dateType: "datetime",
          startKey: "assistTimeStart",
          endKey: "assistTimeEnd",
          type: "DateRange",
        },
      ],

      //趣味游戏参与记录
      inputFunGameInfo:[
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "首次参与时间：",
          dateType: "datetime",
          startKey: "firstStartTime",
          endKey: "firstEndTime",
          type: "DateRange",
        },
        {
          label: "最新参与时间：",
          dateType: "datetime",
          startKey: "lastStartTime",
          endKey: "lastEndTime",
          type: "DateRange",
        },
      ],
      //购物车锦鲤
      inputCardInfo:[
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "joinTimeStart",
          endKey: "joinTimeEnd",
          type: "DateRange",
        },
        {
          label: "满足抽奖条件：",
          prop: "isPass",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
      ],
      inputOpenWin: [
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          name: "参与时间：",
          myDate: true,
          val: ["createStartTime", "createEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否中奖：",
          val: "isPass",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "是否领取奖品：",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已领取", id: 1 },
            { label: "未领取", id: 0 },
          ],
        },
        {
          name: "是否填写地址：",
          val: "isFillAddress",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已填写", id: 1 },
            { label: "未填写", id: 0 },
          ],
        },
      ],
      inputOpenWinInfo: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "是否中奖：",
          prop: "isPass",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否领取奖品：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已领取", value: 1 },
            { label: "未领取", value: 0 },
          ],
        },
        {
          label: "是否填写地址：",
          prop: "isFillAddress",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已填写", value: 1 },
            { label: "未填写", value: 0 },
          ],
        },
      ],
      // 幸运值获取记录
      inputLuck: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "获取时间：",
          type: "DateRange",
          dateType: "datetime",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          startKey: "createStartTime",
          endKey: "createEndTime",
          defalutLimit: true,
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "获取方式：",
          prop: "taskType",
          placeholder: "请选择任务类型",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 3 },
            { label: "加购商品", value: 4 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "浏览会场", value: 5 },
            { label: "预约商品", value: 12 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
            { label: "邀请好友入会", value: 18 },
            { label: "加入会员", value: 7 },
            { label: "关注店铺", value: 6 },
            { label: "搜索关键词", value: 23 },
          ],
        },
      ],
      inputAwardList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: labelStatus,
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: labelWait, value: valueWait },
            { label: labelWin, value: 2 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
            { label: "已失效", value: 8 },
          ],
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: labelDate,
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMinLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      inputMemberUpGradeList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户pin, 精确查询",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "sendStartTime",
          endKey: "sendEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: labelStatus,
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已中奖", value: 2 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
            { label: "已失效", value: 8 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      inputPrizeLockList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户pin, 精确查询",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "sendStartTime",
          endKey: "sendEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "中奖状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已中奖", value: 2 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
            { label: "已失效", value: 8 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      inputAwardList1: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
                 {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: this.fitersRepurchase(
            [16, 17, 18, 27],
            "发放状态：",
            "中奖状态："
          ),
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            {
              label: this.fitersRepurchase(
                [16, 17, 18, 27],
                "待领取",
                "未中奖"
              ),
              value: this.fitersRepurchase([16, 17, 18, 27], -1, 1),
            },
            {
              label: this.fitersRepurchase(
                [16, 17, 18, 27],
                "待发放",
                "已中奖"
              ),
              value: 2,
            },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
          ],
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "中奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      // 打榜有礼领奖记录form表单数据
      inputAwardFiften: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "中奖名次：",
          prop: "rank",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "未知", value: 0 },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京豆E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "京豆PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "谢谢参与", value: 9 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖状态：",
          prop: "status",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "未中奖", value: 1 },
            { label: "已中奖", value: 2 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
            { label: "待发放", value: 7 },
          ],
        },
        {
          // name: "参与时间：",
          // myDate: true,
          // val: ["createTimeStart", "createTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createTimeStart",
          endKey: "createTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          // name: "发放时间：",
          // myDate: true,
          // // type: 'date',
          // // valueFormat2: "yyyy-MM-dd 23:59:59",
          // val: ["sendTimeStart", "sendTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "sendTimeStart",
          endKey: "sendTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      // 额外奖品领奖记录
      inputAwardExtra: [
      {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未知", value: 0 },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京豆E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "京豆PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "谢谢参与", value: 9 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "中奖状态：",
          prop: "status",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未中奖", value: 1 },
            { label: "已中奖", value: 2 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
            { label: "待发放", value: 7 },
          ],
        },
        {
          label: "中奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "winTimeStart",
          endKey: "winTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      // 派样下订单记录表单
      inputSendBuyPay: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "商品SKU：",
          prop: "skuId",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "商品名称：",
          prop: "skuName",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "订单号：",
          prop: "orderId",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "录入收货信息：",
          prop: "isCommitAddress",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: null },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "付款时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "orderTimeStart",
          endKey: "orderTimeEnd",
          // myDate: true,
          // val: ["orderTimeStart", "orderTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
        },
        {
          // name: "收货时间：",
          // myDate: true,
          // val: ["receiveTimeStart", "receiveTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "收货时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "receiveTimeStart",
          endKey: "receiveTimeEnd",
        },
      ],
      // 派样下单记录表格数据
      sendBuyPayTable: [],
      // 派样下单表格总数
      totalSendBuyPayCount: 0,
      // 回购下单记录表单
      inputSendBuyRePay: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "商品SKU：",
          prop: "skuId",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "商品名称：",
          prop: "skuName",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "订单号：",
          prop: "orderId",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "商品金额：",
          // connector: "-",
          // iptArr: [
          //   { val: "orderPaymentStart", placeholder: "请输入" },
          //   { val: "orderPaymentEnd", placeholder: "请输入" },
          // ],
          // inputType: number
          type: "InputDouble",
          startKey: "orderPaymentStart",
          endKey: "orderPaymentEnd",
          startPlaceholder: "请输入",
          inputType: "number",
          endPlaceholder: "请输入",
        },
        {
          label: "是否中奖：",
          prop: "isWin",
          placeholder: "请选择",
          value: "",
          type: "Select",
          options: [
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "录入收货信息：",
          prop: "isCommitAddress",
          placeholder: "请选择",
          value: "",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "付款时间：",
          // myDate: true,
          // val: ["orderTimeStart", "orderTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          type: "DateRange",
          dateType: "datetime",
          startKey: "orderTimeStart",
          endKey: "orderTimeEnd",
        },
        {
          label: "收货时间：",
          // myDate: true,
          // val: ["receiveTimeStart", "receiveTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          type: "DateRange",
          dateType: "datetime",
          startKey: "receiveTimeStart",
          endKey: "receiveTimeEnd",
        },
      ],
      // 回购下单记录表格数据
      sendBuyRePayTable: [],
      // 回购下单表格总数
      totalSendBuyRePayCount: 0,

      inputLockRight: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "满足中奖门槛：",
          prop: "isPass",
          placeholder: "请选择",
          type: "Select",
          value: null,

          options: [
            { label: "全部", value: null },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "录入收货信息：",
          prop: "isEnter",
          placeholder: "请选择",
          type: "Select",
          value: null,
          options: [
            { label: "全部", value: null },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        // {
        //   name: "下单期间订单数：",
        //   iptArr: [
        //     { val: "buyOrderNumMin", placeholder: "请输入" },
        //     { val: "buyOrderNumMax", placeholder: "请输入" },
        //   ],
        // },
        {
          label: "下单期间订单数：",
          type: "InputDouble",
          startKey: "buyOrderNumMin",
          endKey: "buyOrderNumMax",
          startPlaceholder: "请输入",
          inputType: "number",
          endPlaceholder: "请输入",
        },
        // {
        //   name: "下单期间总额：",
        //   iptArr: [
        //     { val: "buyMoneyMin", placeholder: "请输入" },
        //     { val: "buyMoneyMax", placeholder: "请输入" },
        //   ],
        // },
        {
          label: "下单期间总额：",
          type: "InputDouble",
          startKey: "buyMoneyMin",
          endKey: "buyMoneyMax",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
        },
        // {
        //   name: "锁权时间：",
        //   myDate: true,
        //   val: ["createTimeStart", "createTimeEnd"],
        //   startPlaceholder: "开始日期",
        //   endPlaceholder: "结束日期",
        // },
        {
          label: "计划时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createTimeStart",
          endKey: "createTimeEnd",
        },
      ],
      inputTakeGoods: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "录入时间：",
          // myDate: true,
          // val: ["inputTimeStart", "inputTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          type: "DateRange",
          dateType: "datetime",
          startKey: "inputTimeStart",
          endKey: "inputTimeEnd",
        },
      ],
      formAwardOne: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "发放状态：",
          prop: "status",
          type: "Select",
          options: [
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
          ],
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          type: "Select",
          options: [
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "店铺积分", value: 4 },
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],
      inputAwardTwo: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          // name: "预约时间：",
          // myDate: true,
          // val: ["startTime", "endTime"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "预约时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
        },
        {
          label: "发货状态：",
          prop: "status",
          placeholder: "请选择",
          value: "",
          type: "Select",
          options: [
            { label: "全部", value: "" },
            { label: "未发货", value: "2,7" },
            { label: "已发货", value: "5" },
          ],
        },
        {
          label: "是否填写地址：",
          prop: "isFillAddress",
          placeholder: "请选择",
          value: "",
          type: "Select",
          options: [
            { label: "全部", id: "" },
            { label: "已填写", id: 1 },
            { label: "未填写", id: 0 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      inputAwardThree: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "发起时间：",
          type: "DateRange",
          dateType: "datetime",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardFour: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
        {
          label: "手机号码：",
          prop: "mobile",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "发放状态：",
          prop: "sendStatus",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "待发放", value: 0 },
            { label: "已发放", value: 1 },
            { label: "已失效", value: 2 },
          ],
        },
        {
          label: "发货状态：",
          prop: "deliveryStatus",
          type: "Select",
          value: "",
          placeholder: "请选择",
          options: [
            { label: "全部", value: null },
            { label: "未发货", value: 0 },
            { label: "已发货", value: 1 },
          ],
        },
        {
          // name: "创建时间：",
          // myDate: true,
          // val: ["createTimeStart", "createTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "创建时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createTimeStart",
          endKey: "createTimeEnd",
        },
        {
          // name: "发放时间：",
          // myDate: true,
          // val: ["sendTimeStart", "sendTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "sendTimeStart",
          endKey: "sendTimeEnd",
        },
        {
          // name: "发货时间：",
          // myDate: true,
          // val: ["deliveryTimeStart", "deliveryTimeEnd"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          label: "发货时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "deliveryTimeStart",
          endKey: "deliveryTimeEnd",
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      inputInkindList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "发放状态：",
          prop: "prizeStatus",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
          { label: "全部", value: "" },
            { label: "待发放", value: 2 },
            { label: "已发放", value: 3 },
            { label: "已失效", value: 8 },
          ],
        },
        {
          label: "发货状态：",
          prop: "status",
          placeholder: "请选择",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "未发货", value: '2,7' },
            { label: "已发货", value: '5' },
          ],
        },
        // {
        //   label: "创建时间：",
        //   type: "DateRange",
        //   dateType: "datetime",
        //   startKey: "createTimeStart",
        //   endKey: "createTimeEnd",
        // },
        // {
        //   label: "发放时间：",
        //   type: "DateRange",
        //   dateType: "datetime",
        //   startKey: "sendTimeStart",
        //   endKey: "sendTimeEnd",
        // },
        // {
        //   label: "发货时间：",
        //   type: "DateRange",
        //   dateType: "datetime",
        //   startKey: "deliveryTimeStart",
        //   endKey: "deliveryTimeEnd",
        // },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
      ],
      inputAwardTrial: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "nickName",
          type: "Input",
          placeholder: "请输入",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "发放状态：",
          prop: "sendStatusList",
          type: "Select",
          options: [
            // { label: "全部", id: "", defaultValue: [""]},
            { label: "未发放", value: "0" },
            { label: "已失效", value: "1" },
            { label: "已发放", value: "2" },
            { label: "发放失败", value: "3" }
          ],
          multiple: true,
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          placeholder: "请选择",
          type: "Select",
          options: [
            { label: "优惠卷", value: "1" },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "winStartTime",
          endKey: "winEndTime",
        }, 
        {
          label: "关联订单状态：",
          prop: "orderStateList",
          placeholder: "请选择",
          type: "Select",
          options: [
            // { label: "全部", id: "", defaultValue: [""] },
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
          multiple: true,
        },
        {
          label: "订单号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "是否获得正装礼：",
          prop: "isWin",
          placeholder: "请选择",
          type: "Select",
          value:"",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      inputAwardTrialOne: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "nickName",
          type: "Input",
          placeholder: "请输入",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "发放状态：",
          prop: "sendStatusList",
          type: "Select",
          options: [
            // { label: "全部", id: "", defaultValue: [""]},
            { label: "未发放", value: "0" },
            { label: "已失效", value: "1" },
            { label: "已发放", value: "2" },
            { label: "发放失败", value: "3" }
          ],
          multiple: true,
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          placeholder: "请选择",
          type: "Select",
          options: [
            { label: "全部", value: "" },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "京东PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "winStartTime",
          endKey: "winEndTime",
        }, 
        {
          label: "关联订单状态：",
          prop: "orderStateList",
          placeholder: "请选择",
          type: "Select",
          options: [
            // { label: "全部", id: "", defaultValue: [""] },
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
          multiple: true,
        },
        {
          label: "订单号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "是否获得试用礼：",
          prop: "isWin",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      inputInkind: [
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          name:
            (this.rowData.activityType == 41 || this.rowData.activityType == 52)
              ? "发货时间"
              : this.fitersRepurchase(
                  [16, 17, 18, 27, 28, 19],
                  "领奖时间：",
                  "中奖时间："
                ),
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发货状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          label: "是否提交地址：",
          prop: "commitAddressFlag",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
      ],
      inputInkidNeedAwardList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label:
            this.rowData.activityType == 41
              ? "发货时间："
              : this.fitersRepurchase(
                  [16, 17, 18, 27, 28, 19],
                  "领奖时间：",
                  "中奖时间："
                ),
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发货状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          label: "是否提交地址：",
          prop: "commitAddressFlag",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
        {
          label: "关联订单状态：",
          prop: "orderState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: ""},
            { label: "等待付款", value: "等待付款" },
            { label: "暂停", value: "暂停" },
            { label: "等待出库", value: "等待出库" },
            { label: "等待发货", value: "等待发货" },
            { label: "完成", value: "完成" },
            { label: "取消", value: "取消" },
            { label: "锁定", value: "锁定" },
            { label: "等待确认收货", value: "等待确认收货" },
            { label: "未知", value: "未知" },
          ],
        },
        {
          label: "订单号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: this.fitersRepurchase([19, 28], "中奖状态：", "发放状态："),
          prop: "prizeStatus",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: this.fitersRepurchase(
            [19, 28],
            [
              { label: "全部", value: "" },
              { label: "未中奖", value: 1 },
              { label: "已中奖", value: 2 },
              { label: "已发放", value: 3 },
              { label: "发放失败", value: 4 },
              { label: "已失效", value: 8 },
            ],
            [
              { label: "全部", value: "" },
              { label: "待领取", value: -1 },
              { label: "待发放", value: 2 },
              { label: "已发放", value: 3 },
              { label: "发放失败", value: 4 },
              { label: "已失效", value: 8 },
            ]
          ),
          notShow: this.fitersRepurchase([8], true, false)
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
      ],

      inputMemberUpGradeMaterialList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户pin, 精确查询",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "发货时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "grantStartTime",
          endKey: "grantEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发货状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          label: "是否提交地址：",
          prop: "commitAddressFlag",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
      ],
      zeroPrizeListForm: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户pin, 精确查询",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "中奖时间：",
          myDate: true,
          prop: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "发货状态：",
          prop: "status",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "", },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          label: "是否提交地址：",
          prop: "commitAddressFlag",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "", },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
      ],
      inputUserInfo: [
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入用户PIN",
          type: "Input",
        },
        {
          label: "时间范围：",
          // myDate: true,
          // val: ["startTime", "endTime"],
          // startPlaceholder: "开始日期",
          // endPlaceholder: "结束日期",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
      ],
      formCoupon: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: this.fitersRepurchase([21], "领取时间：", "参与时间："),
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],
      formSplitCoupon: [
        {
          label: "统计时间：",
          type: "DateRange",
          dateType: "date",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          placeholder: "请选择投放渠道",
          options: [],
        },
      ],
      formGroupCoupon: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          placeholder: "请选择投放渠道",
          options: [],
        },
        {
          label: "统计时间：",
          type: "DateRange",
          dateType: "date",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],
      formComment: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "nickName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "订单号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "评价时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
        {
          label: "过滤状态：",
          prop: "filterType",
          type: "Select",
          options: [
            { label: "未通过", value: 0 },
            { label: "通过", value: 1 },
          ],
        },
      ],
      inputGiftrecord: [
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "获赠类型：",
          val: "taskType",
          placeholder: "请输入",
          selectArr: [
            { label: "每日打卡", id: 1 },
            { label: "浏览店铺", id: 2 },
            { label: "浏览商品", id: 3 },
            { label: "加购商品", id: 4 },
            { label: "浏览会场", id: 5 },
            { label: "关注店铺", id: 6 },
            { label: "开卡入会", id: 7 },
            { label: "好友助力", id: 8 },
          ],
        },
        {
          name: "获赠时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputGiftrecordInfo: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "获赠类型：",
          prop: "taskType",
          type: "Select",
          options: [
            { label: "每日打卡", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 3 },
            { label: "加购商品", value: 4 },
            { label: "浏览会场", value: 5 },
            { label: "关注店铺", value: 6 },
            { label: "开卡入会", value: 7 },
            { label: "好友助力", value: 8 },
          ],
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          placeholder: "请选择"
        },
        {
          label: "获赠时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      // 大转盘
      inputGiftrecord2: [
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "获赠类型：",
          val: "taskType",
          placeholder: "请输入",
          selectArr: [
            { label: "全部", id: "" },
            { label: "每日签到", id: 1 },
            { label: "浏览店铺", id: 2 },
            { label: "浏览商品", id: 13 },
            { label: "加购商品", id: 4 },
            { label: "分享商品", id: 9 },
            { label: "分享店铺", id: 10 },
            { label: "分享活动", id: 11 },
            { label: "好友助力", id: 8 },
            { label: "浏览会场", id: 5 },
            { label: "预约商品", id: 12 },
            { label: "首次赠送", id: 14 },
            { label: "每日赠送", id: 15 },
            { label: "积分兑换", id: 16 },
            { label: "购买商品", id: 17 },
          ],
        },
        {
          name: "获赠时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputGiftrecordInfo2: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "获赠类型：",
          prop: "taskType",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 13 },
            { label: "加购商品", value: 4 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "好友助力", value: 8 },
            { label: "浏览会场", value: 5 },
            { label: "预约商品", value: 12 },
            { label: "首次赠送", value: 14 },
            { label: "每日赠送", value: 15 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
            { label: "加入会员", value: 7 },
            { label: "预售下单", value: 20 },
            { label: "手动变动", value: 19 },

          ],
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          placeholder: "请选择"
        },
        {
          label: "获赠时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      inputScoreRecordInfo: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          placeholder: "请选择"
        },
        {
          label: "任务类型：",
          prop: "taskType",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "加购商品", value: 4 },
            { label: "浏览会场", value: 5 },
            { label: "好友助力", value: 8 },
            { label: "加入会员", value: 7 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "预约商品", value: 12 },
            { label: "浏览商品", value: 13 },
            { label: "首次赠送", value: 14 },
            { label: "每日赠送", value: 15 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
            { label: "邀请好友入会", value: 18 },
            { label: "手动变动", value: 19 },
            { label: "预售下单", value: 20 },
            { label: "搜索关键词", value: 23 },
          ],
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "获取时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      inputResignRecordInfo: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          placeholder: "请选择"
        },
        {
          label: "任务类型：",
          prop: "taskType",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "加购商品", value: 4 },
            { label: "浏览会场", value: 5 },
            { label: "好友助力", value: 8 },
            { label: "加入会员", value: 7 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "预约商品", value: 12 },
            { label: "浏览商品", value: 13 },
            { label: "首次赠送", value: 14 },
            { label: "每日赠送", value: 15 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
            { label: "邀请好友入会", value: 18 },
            { label: "手动变动", value: 19 },
            { label: "预售下单", value: 20 },
            { label: "搜索关键词", value: 23 },
          ],
          placeholder: "请输入",
        },
        {
          label: "获取时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      inputredemptionHistory: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "兑换状态：",
          prop: "status",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
          ],
        },
        {
          label: "兑换时间：",
          type: "DateRange",
          startTime: "",
          endTime: "",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],

      inviteeDetailsInputData: [
        {
          label: "邀请人用户PIN：",
          prop: "invitePin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "邀请人昵称：",
          prop: "inviteNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "被邀请人用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "被邀请人昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "是否有效邀请：",
          prop: "isValidInvite",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: ""},
            { label: "是", value: "1" },
            { label: "否", value: "0" },
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          placeholder: "请选择"
        },
        {
          label: "邀请时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 入会打榜：被邀请人明细
      joinInviteInputData: [
        {
          label: "邀请人用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "被邀请人用户PIN：",
          prop: "inviteePin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "是否有效邀请：",
          prop: "isValid",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: ""},
            { label: "是", value: "1" },
            { label: "否", value: "0" },
          ],
        },
        {
          label: "邀请时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          startKey: "inviteStartTime",
          endKey: "inviteEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],

      //TODO:1.51被邀请人明细
      invitees: [
        {
          label: "邀请人：",
          prop: "pinOrNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "被邀请人：",
          prop: "invitePinOrNick",
          type: "Input",
          placeholder: "请输入",
        },
        // {
        //   label: "投放渠道：",
        //   prop: "sellerLinkId",
        //   type: "Select",
        //   value: "",
        //   options: [],
        //   placeholder: "请选择"
        // },
        {
          label: "团队名称：",
          prop: "teamName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "邀请时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],

      inviteeDetailsData: [],
      inviteeDetailsPage: {
        current: 1,
        size: 10,
        total: 0,
      },

      orderDetailInfoPage: {
        current: 1,
        size: 10,
      },
      orderDetailInfoTotal: 0,
      conversionPage: {
        current: 1,
        size: 10,
        total: 0,
      },
      inputOrderDetail: [
        {
          name: "用户PIN",
          val: "pin",
          placeholder: "请输入用户Pin,精确查询",
        },
        {
          name: "订单编号",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: "订单状态",
          val: "orderState",
          selectArr: [
            { label: "未付款", id: "WAIT_PAYMENT" },
            { label: "等待出库", id: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", id: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", id: "FINISHED_L" },
            { label: "已取消", id: "TRADE_CANCELED" },
            { label: "退货", id: "LOCKED" },
            { label: "暂停", id: "PAUSE" },
          ],
          multiple: true,
        },
        {
          name: "下单时间",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
      ],
      inputOrderDetailInfo: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户Pin,精确查询",
        },
        {
          label: "订单编号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "父订单号：",
          prop: "rootId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单状态：",
          prop: "orderState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          multiple: true,
          options: [
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
        },
        {
          label: "下单时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          // notShow: this.fitersChooseIF([19]) ? false : true
        },
        {
          label: "下单店铺：",
          prop: "orderVenderId",
          type: "Select",
          value: "",
          options: [],
          notShow: this.fitersChooseIF([19,46,16,17,18]) ? false : true
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          placeholder: "请输入",
          type: "Input",
        }
      ],
      inputConversion: [
        {
          name: "统计活动入会后",
          val: "statDaysNum",
          slot: true,
        },
        {
          name: "订单金额",
          val: "orderMoney",
          slot: true,
        },
        {
          name: "入会时间",
          myDate: true,
          val: ["openCardStartTime", "openCardEndTime"],
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
      ],
      inputParticipateConversionAnalysis:[
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户Pin,精确查询",
        },
        {
          label: "订单编号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单状态：",
          prop: "orderState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
        },
        {
          label: "下单时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
      ],
      inputConversionInfo: [
        {
          label: "统计活动入会后：",
          slot: "statDaysNum",
        },
        {
          label: "订单金额：",
          slot: "orderMoney",
        },
        {
          label: "入会时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "openCardStartTime",
          endKey: "openCardEndTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
          style: { 'margin-right': "500px !important" },
          // notShow: this.fitersChooseIF([19,46]) ? false : true
        },
      ],
      conversionForm: {
        statDaysNum: 30,
        statType: 0,
        compareType: 0,
        orderAmount: null,
      },
      hasDefaultValue: false,
      defaultValueText: "",
      conversionData: [],
      orderDetailData: [],
      couponDetailsList: [],
      CouponStatisticsList: [],
      TeamDetailsList: [],
      CommentList: [],
      CouponMember: [],
      ParticipatTable: [],
      ParticipatLockTable: [],
      ParticipatLockTableTrial:[],
      ParticipatLockTableTrialOrder:[],
      ParticipatOpenWinTable: [],
      luckTable: [],
      MemberUpGradeTable: [],
      BilletDouxTable: [], // 参与记录(情书贺卡)表格数据
      BilletReceiveTable: [], // 获取记录(情书贺卡)表格数据
      commentItem: {},
      commentDioag: false,
      zeroTrialTable: [],
      zeroTrialDetailTable: [],
      totalZeroTrial: 0,
      dialogExprot: false,
      codeMsg: "获取验证码",
      code: "",
      phone: "",
      successMsg: "",
      // timer: "",
      countdown: 60,
      codeDisabled: false,
      ExprotData: "",
      // 验证码
      opentime: true,
      visible: false,
      timer: null, //验证码定时
      saveDisable: false,

      // 兑换记录
      formThir: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "兑换时间：",
          type: "DateRange",
          startTime: '',
          endTime: '',
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
        {
          label: "兑换状态：",
          prop: "exchangeStatus",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "兑换成功", value: 1 },
            { label: "兑换失败", value: 2 },
            { label: "已撤回", value: 4 },
          ],
        },
      ],
      // 兑换记录-积分加钱购
      formAddMoney: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "兑换时间：",
          type: "DateRange",
          startTime: "",
          endTime: "",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
        {
          label: "兑换状态：",
          prop: "exchangeStatus",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "已兑换", value: 1 },
            { label: "移除令牌", value: 5 },
            { label: "已撤回", value: 4 },
          ],
        },
      ],
      formThir9: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "兑换时间：",
          type: "DateRange",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
        {
          label: "兑换状态：",
          prop: "exchangeStatus",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "兑换成功", value: 1 },
            { label: "兑换失败", value: 2 },
            { label: "已撤回", value: 4 },
          ],
        },
        {
          label: "发货状态：",
          prop: "deliveryStatus",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "待发货", value: 1 },
            { label: "已发货", value: 2 },
          ],
        },
        {
          label: "是否提交地址：",
          prop: "commitAddressFlag",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "", defaultValue: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
      ],
      //门票支付记录
      formThir10: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "用户PIN：",
          prop: "customerPin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "支付时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "payStartTime",
          endKey: "payEndTime",
          defalutLimit: true,
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
      ],
      formThir11: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "是否成交：",
          prop: "isPass",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "已成交", value: 1 },
            { label: "未成交", value: 0 },
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "出价时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "bidTimeStart",
          endKey: "bidTimeEnd",
          defalutLimit: true,
        },
        {
          label: "成交时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "passTimeStart",
          endKey: "passTimeEnd",
          defalutLimit: true,
        },
      ],
      formThir12: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "支付状态：",
          prop: "payStatus",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "已支付", value: 1 },
            { label: "待支付", value: 0 },
            { label: "逾期未支付", value: 2 }
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "成交时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "passTimeStart",
          endKey: "passTimeEnd",
          defalutLimit: true,
        },
        {
          label: "支付时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "payTimeStart",
          endKey: "payTimeEnd",
          defalutLimit: true,
        },
      ],
      formThirRED: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "兑换状态：",
          prop: "exchangeStatus",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "兑换成功", value: 1 },
            { label: "兑换失败", value: 2 },
          ],
        },
        {
          label: "兑换时间：",
          type: "DateRange",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],
      formThir2: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        }, 
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "开卡时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "openCardTimeStart",
          endKey: "openCardTimeEnd",
          defalutLimit: true,
        },
      ],
      formThir3: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "中奖状态：",
          prop: "isWin",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "已中奖", value: 1 },
            { label: "未中奖", value: 0 },
            { label: "待开奖", value: 2 },
          ],
        },
        {
          label: "预约时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],
      birthInfoFormList: [
        {
          label: "用户PIN：",
          prop: "customerPin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "登记时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "registerStartTime",
          endKey: "registerEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "生日时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "birthStartTime",
          endKey: "birthEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      collectInfoFormList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "获取方式：",
          prop: "taskType",
          placeholder: "请选择获取方式",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "许愿赠送", value: 21 },
            { label: "手动变动", value: 19 },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 3 },
            { label: "加购商品", value: 4 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "浏览会场", value: 5 },
            { label: "预约商品", value: 12 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
            { label: "加入会员", value: 7 },
            { label: "关注店铺", value: 6 },
            { label: "预售商品", value: 20 },
          ],
        },
        {
          label: "获取时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
      ],
      getRecordFormInfo: [
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "京东PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖状态：",
          prop: "status",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已中奖", value: 2 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "领奖类型：",
          prop: "prizeObjectType",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "生日奖品", value: 0},
            { label: "兜底奖品", value: 1 },
          ],
        },
        {
          label: "生日奖池：",
          prop: "birthGiftPrize",
          type: "Input",
          placeholder: "请输入，多个奖品用,隔开查询",
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      exchangeList: [],
      exchangeListTen:[],
      totalMail: 0,
      totalMailTen: 0,
      couponList: [],
      formList2: {},
      ParticipatLockTableFixedPrice: [],
      totalParticipatLockFixedPrice: 0,
      // 控制录入快递单号弹窗
      enterCoutierNumShow: false,
      // 快递单号
      enterCoutierNum: "",
      // 弹窗表单标识
      enterCoutierFrom: {},
      // 录入快递单号当前行数据存储
      enterCoutierRowData: {},
      // -------打榜有礼数据开始---------
      // 活动统计表头数据
      chongBangTableColumnList: [
        { label: "日期", prop: "statsDate", width: "200" },
        { label: "活动PV", prop: "pv" },
        { label: "活动UV", prop: "uv" },
        { label: "新增入会人数", prop: "openCardNum" },
        { label: "新增关注人数", prop: "followNum" },
        { label: "分享人数", prop: "shareNum" },
        { label: "分享次数", prop: "shareTime" },
        { label: "参与人数", prop: "joinNum" },
        {
          label: "参与人数（有下单）",
          prop: "joinBuyNum",
          width: "210",
        },
        { label: "已付款GMV", prop: "orderAmt" },
        {
          label: "成交订单数（已付款）",
          prop: "orderPayNum",
          width: "210",
        },
        {
          label: "成交商品数（已付款）",
          prop: "orderPayItemNum",
          width: "210",
        },
        {
          label: "成交订单数（已收货）",
          prop: "orderFinishNum",
          width: "210",
        },
        { label: "成交商品数（已收货）", prop: "orderItemNum", width: "210" },
        {
          label: "参与成功人数（下单有效金额达到入榜金额）",
          prop: "winNum",
          width: "300",
        },
        { label: "已领奖人数", prop: "receiveNum" },
      ],
      // 折线图颜色数据
      colorList: [
        "#FF0000",
        "#00FF00",
        "#0000FF",
        "#FFFF00",
        "#FF00FF",
        "#00FFFF",
        "#FF4500",
        "#8B4513",
        "#2E8B57",
        "#4B0082",
        "#800000",
        "#008000",
        "#000080",
        "#808000",
        "#800080",
        "#008080",
        "#DC143C",
        "#FF8C00",
        "#00FF7F",
        "#7B68EE",
        "#8A2BE2",
        "#A52A2A",
        "#20B2AA",
        "#FFD700",
        "#ADFF2F",
        "#7FFFD4",
        "#6A5ACD",
        "#40E0D0",
        "#FF6347",
        "#FF69B4",
        "#B0C4DE",
        "#DAA520",
        "#48D1CC",
        "#9370DB",
        "#2F4F4F",
        "#FFA07A",
        "#BA55D3",
        "#7CFC00",
        "#87CEEB",
        "#778899",
      ],
      // 小部件管理折线图颜色数组
      colorsList: [
        "#FF5733",
        "#33FF57",
        "#5733FF",
        "#FF33A1",
        "#A1FF33",
        "#33A1FF",
        "#FFBB33",
        "#33FFBB",
        "#BB33FF",
        "#FF3366",
        "#66FF33",
        "#3366FF",
        "#FF8C33",
        "#33FF8C",
        "#8C33FF",
        "#FF3366",
        "#66FF33",
        "#3366FF",
        "#FFB333",
        "#33FFB3",
        "#B333FF",
        "#FF3366",
        "#66FF33",
        "#3366FF",
      ],

      // 打榜有礼数据总览数据集合
      dataScreenList: [
        { name: "活动PV", value: "pv" },
        { name: "活动UV", value: "uv" },
        { name: "新增入会人数", value: "openCardNum" },
        { name: "新增关注人数", value: "followNum" },
        { name: "分享人数", value: "shareNum" },
        { name: "分享次数", value: "shareTime" },
        { name: "参与人数", value: "joinNum" },
        { name: "参与人数（有下单）", value: "joinBuyNum" },
        { name: "已付款GMV", value: "orderAmt" },
        { name: "成交订单数（已付款）", value: "orderPayNum" },
        { name: "成交商品数（已付款）", value: "orderPayItemNum" },
        { name: "成交订单数（已收货）", value: "orderFinishNum" },
        { name: "成交商品数（已收货）", value: "orderItemNum" },
        {
          name: "参与成功人数（下单有效金额达到入榜金额）",
          value: "winNum",
        },
        { name: "已领奖人数", value: "receiveNum" },
      ],
      // 派样回购礼数据总览数据集合
      sendReBuydataScreenList: [
        { name: "活动PV", value: "pv" },
        { name: "活动UV", value: "uv" },
        { name: "新增关注人数", value: "followNum" },
        { name: "活动入会人数", value: "openCardNum" },
        { name: "分享人数", value: "shareNum" },
        { name: "分享次数", value: "shareTime" },
        {
          name: "派样付款金额",
          value: "sendBuyOrderAmt",
          tipsName: "派样下单且付款的商品金额（非实付金额）",
        },
        {
          name: "派样付款件数",
          value: "sendBuyItemNum",
          tipsName: "派样下单且付款的商品件数",
        },
        {
          name: "派样付款人数",
          value: "sendBuyNum",
          tipsName: "派样下单且付款的人数",
        },
        {
          name: "活动入会派样付款人数",
          value: "openCardSendBuyNum",
          tipsName: "通过活动入会，派样商品付款的人数",
        },
        {
          name: "活动入会派样付款件数",
          value: "openCardSendBuyItemNum",
          tipsName: "通过活动入会，派样商品付款的商品件数",
        },
        {
          name: "活动入会派样付款金额",
          value: "openCardSendBuyOrderAmt",
          tipsName: "通过活动入会，派样商品的商品金额（非实付金额）",
        },
        {
          name: "派样收货金额",
          value: "enterSendBuyOrderAmt",
          tipsName: "派样商品付款且收货的商品金额（非实付金额）",
        },
        {
          name: "派样收货件数",
          value: "enterSendBuyItemNum",
          tipsName: "派样商品付款且收货的商品件数",
        },
        {
          name: "派样收货人数",
          value: "enterSendBuyNum",
          tipsName: "派样商品付款且收货的人数",
        },
        {
          name: "活动入会派样收货人数",
          value: "openCardEnterSendBuyOrderAmt",
          tipsName: "通过活动入会且派样商品收货的用户",
        },
        {
          name: "活动入会派样收货件数",
          value: "openCardEnterSendBuyItemNum",
          tipsName: "通过活动入会且派样商品收货的商品件数",
        },
        {
          name: "活动入会派样收货金额",
          value: "openCardEnterSendBuyOrderAmt",
          tipsName: "通过活动入会且派样商品收货的商品金额（非实付金额）",
        },
        {
          name: "回购付款金额",
          value: "reBuyOrderAmt",
          tipsName: "回购商品付款的商品金额（非实付金额）",
        },
        {
          name: "回购付款件数",
          value: "reBuyItemNum",
          tipsName: "回购商品付款的件数",
        },
        {
          name: "回购付款人数",
          value: "reBuyNum",
          tipsName: "回购商品付款的人数",
        },
        {
          name: "活动入会回购付款人数",
          value: "openCardReBuyNum",
          tipsName: "通过活动入会，回购商品付款的人数",
        },
        {
          name: "活动入会回购付款件数",
          value: "openCardReBuyItemNum",
          tipsName: "通过活动入会，完成派样付款、回购付款的件数",
        },
        {
          name: "活动入会回购付款金额",
          value: "openCardReBuyOrderAmt",
          tipsName: "通过活动入会，回购商品付款的商品金额（非实付金额）",
        },
        {
          name: "回购收货金额",
          value: "enterReBuyOrderAmt",
          tipsName: "回购商品付款且收货的商品金额（非实付金额）",
        },
        {
          name: "回购收货件数",
          value: "enterReBuyItemNum",
          tipsName: "回购商品付款且收货的商品件数",
        },
        {
          name: "回购收货人数",
          value: "enterReBuyNum",
          tipsName: "回购商品付款且收货的人数",
        },
        {
          name: "活动入会回购收货人数",
          value: "openCardEnterReBuyNum",
          tipsName: "通过活动入会，回购商品付款且收货的人数",
        },
        {
          name: "活动入会回购收货件数",
          value: "openCardEnterReBuyItemNum",
          tipsName: "通过活动入会，回购商品付款且收货的商品件数",
        },
        {
          name: "活动入会回购收货金额",
          value: "openCardEnterReBuyOrderAmt",
          tipsName: "通过活动入会，回购商品付款且收货的商品金额（非实付金额）",
        },
        {
          name: "付款回购率",
          value: "orderReBuyRate",
          tipsName: "回购付款人数/派样付款人数",
        },
        {
          name: "收货回购率",
          value: "enterReBuyRate",
          tipsName: "回购收货人数/派样收货人数",
        },
        { name: "填写收货地址人数", value: "enterNum" },
        { name: "中奖人数", value: "winNum" },
      ],
      // 派样回购礼数据统计表头数据
      sendReBuyTableColumnList: [
        { label: "日期", prop: "statsDate", width: "200" },
        { label: "活动PV", prop: "pv" },
        { label: "活动UV", prop: "uv" },
        { label: "新增店铺关注人数", prop: "followNum" },
        { label: "新增入会人数", prop: "openCardNum" },
        { label: "分享人数", prop: "shareNum" },
        { label: "分享次数", prop: "shareTime" },
        { label: "派样付款金额", prop: "sendBuyOrderAmt" },
        { label: "派样付款件数", prop: "sendBuyItemNum" },
        { label: "派样付款人数", prop: "sendBuyNum" },
        {
          label: "活动入会派样付款人数",
          prop: "openCardSendBuyNum",
          width: "200",
        },
        {
          label: "活动入会派样付款件数",
          prop: "openCardSendBuyItemNum",
          width: "200",
        },
        {
          label: "活动入会派样付款金额",
          prop: "openCardSendBuyOrderAmt",
          width: "200",
        },
        { label: "派样收货金额", prop: "enterSendBuyOrderAmt" },
        { label: "派样收货件数", prop: "enterSendBuyItemNum" },
        { label: "派样收货人数", prop: "enterSendBuyNum" },
        {
          label: "活动入会派样收货人数",
          prop: "openCardEnterSendBuyNum",
          width: "200",
        },
        {
          label: "活动入会派样收货件数",
          prop: "openCardEnterSendBuyItemNum",
          width: "200",
        },
        {
          label: "活动入会派样收货金额",
          prop: "openCardEnterSendBuyOrderAmt",
          width: "200",
        },
        { label: "回购付款金额", prop: "reBuyOrderAmt" },
        { label: "回购付款件数", prop: "reBuyItemNum" },
        { label: "回购付款人数", prop: "reBuyNum" },
        {
          label: "活动入会回购付款人数",
          prop: "openCardReBuyNum",
          width: "200",
        },
        {
          label: "活动入会回购付款件数",
          prop: "openCardReBuyItemNum",
          width: "200",
        },
        {
          label: "活动入会回购付款金额",
          prop: "openCardReBuyOrderAmt",
          width: "200",
        },
        { label: "回购收货金额", prop: "enterReBuyOrderAmt" },
        { label: "回购收货件数", prop: "enterReBuyItemNum" },
        { label: "回购收货人数", prop: "enterReBuyNum" },
        {
          label: "活动入会回购收货人数",
          prop: "openCardEnterReBuyNum",
          width: "200",
        },
        {
          label: "活动入会回购收货件数",
          prop: "openCardEnterReBuyItemNum",
          width: "200",
        },
        {
          label: "活动入会回购收货金额",
          prop: "openCardEnterReBuyOrderAmt",
          width: "200",
        },
        { label: "付款回购率", prop: "orderReBuyRate" },
        { label: "收货回购率", prop: "enterReBuyRate" },
        { label: "填写收货地址人数", prop: "enterNum", width: "200" },
        { label: "中奖人数", prop: "winNum" },
      ],
      // 派样下单记录表头
      sendBuyList: [
        { label: "订单号", prop: "orderId" },
        { label: "付款时间", prop: "orderStartTime" },
        { label: "收货时间", prop: "orderEndTime" },
      ],
      // 回购下单记录表头
      sendReBuyList: [
        { label: "付款时间", prop: "orderStartTime" },
        { label: "收货时间", prop: "orderEndTime" },
      ],

      // 实物奖品查询表单数据
      inputInkindInfo2: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "发放时间：",
          type: "DateRange",
          startKey: "sendTimeStart",
          dateType: "datetime",
          endKey: "sendTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发货时间：",
          type: "DateRange",
          startKey: "deliveryTimeStart",
          endKey: "deliveryTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          dateType: "datetime",
          defalutLimit: true,
        },
        {
          label: "是否提交地址",
          prop: "commitAddressFlag",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
        {
          label: "中奖状态：",
          prop: "prizeStatus",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未中奖", value: 1 },
            { label: "已中奖", value: 2 },
            { label: "待发放", value: 7 },
            { label: "已发放", value: 3 },
            { label: "发放失败", value: 4 },
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: []
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "下单店铺：",
          prop: "orderVenderId",
          type: "Select",
          value: "",
          options: [],
        }
      ],

      inputInkindInfo4: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "发放状态：",
          prop: "status1",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          label: "发货状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: []
        },
        {
          label: "创建时间：",
          type: "DateRange",
          startKey: "sendTimeStart",
          dateType: "datetime",
          endKey: "sendTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发放时间：",
          type: "DateRange",
          startKey: "sendTimeStart",
          dateType: "datetime",
          endKey: "sendTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发货时间：",
          type: "DateRange",
          startKey: "deliveryTimeStart",
          endKey: "deliveryTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          dateType: "datetime",
          defalutLimit: true,
        }
      ],

      //TODO:抽卡记录
      inputInkindInfo5: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "卡片名称：",
          prop: "cardId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择投放渠道",
          value: "",
          options: [],
        },
        {
          label: "抽卡时间：",
          type: "DateRange",
          startKey: "startTime",
          dateType: "datetime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],

      //TODO:集卡抽卡机会记录
       inputInkindInfo6: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "获奖时间：",
          type: "DateRange",
          startKey: "startTime",
          dateType: "datetime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "获赠类型：",
          prop: "taskType",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: "1" },
            { label: "浏览店铺", value: "2" },
            { label: "浏览商品", value: "3" },
            { label: "加购商品", value: "4" },
            { label: "分享商品", value: "9" },
            { label: "分享店铺", value: "10" },
            { label: "分享活动", value: "11" },
            { label: "浏览会场", value: "5" },
            { label: "预约商品", value: "12" },
            { label: "积分兑换", value: "16" },
            { label: "购买商品", value: "17" },
            { label: "邀请好友入会", value: "18" },
            { label: "加入会员", value: "7" },
            { label: "好友助力", value: "8" },
            { label: "关注店铺", value: "6" },
            { label: "搜索关键词", value: "23" },
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择投放渠道",
          value: "",
          options: [],
        },
  
      ],

      //TODO:1.58:机会获取记录
      funGame1: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择投放渠道",
          value: "",
          options: [],
        },
        {
          label: "获赠类型：",
          prop: "taskType",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 13 },
            { label: "加购商品", value: 4 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "好友助力", value: 8 },
            { label: "浏览会场", value: 5 },
            { label: "预约商品", value: 12 },
            { label: "首次赠送", value: 14 },
            { label: "每日赠送", value: 15 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 }
          ],
        },
        {
          label: "获奖时间：",
          type: "DateRange",
          startKey: "startTime",
          dateType: "datetime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],

      //TODO:组队瓜分奖品记录
      inputInkindInfo8: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择投放渠道",
          value: "",
          options: [],
        },
        {
          label: "奖品名称：",
          prop: "prizeName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "是否成团：",
          prop: "isFinish",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已成团", value: "1" },
            { label: "未成团", value: "0" },
          ],
        },
       {
          label: "是否领取奖品：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已领取", value: "1" },
            { label: "未领取", value: "0" },
          ],
        },
        {
          label: "开团时间：",
          type: "DateRange",
          startKey: "createStartTime",
          dateType: "datetime",
          endKey: "createEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "成团时间：",
          type: "DateRange",
          startKey: "finishStartTime",
          dateType: "datetime",
          endKey: "finishEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],

      //TODO:组队瓜分任务完成记录
      taskCompletion: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
          {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择投放渠道",
          value: "",
          options: [],
        },
        {
          label: "任务归属：",
          prop: "type",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "团长任务", value: "2" },
            { label: "团员任务", value: "3" },
          ],
        },
        {
          label: "任务类型：",
          prop: "taskType",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "加入会员", value: "7" },
            { label: "关注店铺", value: "6" },
            { label: "购买商品", value: "17" },
            { label: "预约商品", value: "12" },
            { label: "浏览商品", value: "13" },
            { label: "浏览店铺", value: "2" },
          ],
        },
        {
          label: "任务完成时间：",
          type: "DateRange",
          startKey: "startTime",
          dateType: "datetime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      //TODO:参与用户卡片详情
      inputInkindInfo7: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择投放渠道",
          value: "",
          options: [],
        },
      ],
      inputInkindInfo3: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: this.sellerLinkList && this.sellerLinkList.length > 0 ? [{ label: "全部", value: "" }, ...this.sellerLinkList.map(item => ({ label: item.sellerLinkName, value: item.id }))] : [{ label: "全部", value: "" }],
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "发货状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已发货", value: "5" },
            { label: "未发货", value: "2,7" },
          ],
        },
        {
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "sendTimeStart",
          endKey: "sendTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发货时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "deliveryTimeStart",
          endKey: "deliveryTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "是否提交地址：",
          prop: "commitAddressFlag",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已提交", value: 1 },
            { label: "未提交", value: 0 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [],
          multiple: true,
        },
        {
          label: "中奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "下单店铺：",
          prop: "orderVenderId",
          type: "Select",
          value: "",
          options: [],
        }
      ],
      // 领奖记录表头数据
      chongBangAwardList: [
        // { label: "用户PIN", prop: "pin", width: "200" },
        { label: "用户昵称", prop: "memberNick", width: "170" },
        { label: "中奖ID", prop: "id", width: "170" },
        { label: "活动名称", prop: "activityName" },
        { label: "总订单金额（已付款）", prop: "totalPayMoney", width: "180" },
        { label: "总订单笔数（已付款）", prop: "orderPayNum", width: "180" },
        {
          label: "总订单金额（已收货）",
          prop: "totalFinishMoney",
          width: "180",
        },
        {
          label: "总订单笔数（已收货）",
          prop: "orderFinishNum",
          width: "180",
        },
        {
          label: "是否填写地址",
          prop: "isEnterStr",
          width: "180",
        },
        { label: "奖品类型", prop: "prizeTypeStr" },
        { label: "奖品名称", prop: "prizeName" },
        { label: "补发奖品名称", prop: "compensationPrizeName" },
        { label: "订单号", prop: "orderIdStr" },
        { label: "随单发订单号", prop: "orderId" },
        { label: "中奖状态", prop: "statusStr" },
        { label: "参与时间", prop: "joinTime", width: "200" },
        { label: "中奖名次", prop: "rank", width: "200" },
        { label: "领奖时间", prop: "winTime", width: "200" },
        { label: "发放时间", prop: "grantTime", width: "200" },
      ],
      chongBangExraAwardList: [
        // { label: "用户PIN", prop: "pin", width: "200" },
        { label: "用户昵称", prop: "memberNick", width: "170" },
        { label: "中奖ID", prop: "id", width: "170" },
        { label: "活动名称", prop: "activityName" },
        { label: "奖品类型", prop: "prizeTypeStr" },
        { label: "奖品名称", prop: "prizeName" },
        { label: "补发奖品名称", prop: "compensationPrizeName" },
        { label: "中奖状态", prop: "statusStr" },
        { label: "中奖时间", prop: "winTime", width: "200" },
      ],
      // 实物奖品名单
      chongBangPhysicalList: [
        // { label: "用户PIN", prop: "pinInfo", width: "200" },
        // { label: "用户昵称", prop: "memberNick" },
        // { label: "奖品名称", prop: "prizeTitle" },
        // { label: "姓名", prop: "receiverNameInfo" },
        // { label: "手机号码", prop: "mobileInfo" },
        // { label: "地区", prop: "decryptReceiverAddress" },
        // { label: "详细地址", prop: "detailedAddressInfo" },
        { label: "发放时间", prop: "sendTime", width: "200" },
        { label: "中奖状态", prop: "prizeStatus" },
        { label: "发货状态", prop: "deliveryStatusStr" },
        { label: "快递单号", prop: "billCode" },
        { label: "发货时间", prop: "deliveryTime", width: "200" },
      ],
      // 生日有礼-实物奖品名单
      chongBangPhysicalList2: [
        { label: "发放时间", prop: "sendTime", width: "200" },
        { label: "发货状态", prop: "statusStr" },
        { label: "快递单号", prop: "billCode" },
        { label: "发货时间", prop: "grantTime", width: "200" },
      ],
      // 批量发货弹窗
      fileList: [],
      // 批量发放请求头设置
      physicalBatchShipmentHeaderOdj: {},
      physicalBatchShipmentShow: false,
      physicalBatchShipmentFrom: {},
      physicalBatchShipmentFrom1: {},
      // 发货弹窗
      sendOutGoodsShow: false,
      // 导入结果集合
      downloadResData: {
        successNum: 0,
        failNum: 0,
      },
      // 导入失败用户列表
      downloadUserList: [],
      sendOutGoodsForm: {
        id: "",
        billCode: "",
        isUpdatePrizeStatus: true,
      },
      // -----------打榜有礼数据结束-------------
      tabName: "",
      actTab: "",
      batchMarkVisible: false,
      memberAnalysisSearchQuery: {},
      currentShop: "", // 当前店铺
      exportSettingDialog: false, // 导出设置弹窗
      exportType: 0, // 导出类型 0全部导出 1部分导出
      exportFieldLoading: false, // 导出字段加载状态
      selectedFields: [], // 已选中的字段
      tempExportFieldsData: [], // 添加临时导出字段数据副本(确保在点击弹窗的确认按钮时才修改数据状态)
      // 导出字段设置
      exportFieldsData: [
        {
          label: "基础信息",
          export: true,
          group: "基础信息",
          disabled: true,
          children: [
            {
              label: "活动名称",
              export: true,
              prop: "activityName",
              disabled: true,
            },
            {
              label: "活动类型",
              export: true,
              prop: "activityType",
              disabled: true,
            },
            {
              label: "活动时间",
              export: true,
              prop: "activityTime",
              disabled: true,
            },
            {
              label: "统计时间",
              export: true,
              prop: "statisticsTime",
              disabled: true,
            },
          ],
        },
        {
          label: "互动参与",
          export: false,
          group: "互动参与",
          children: [
            {
              label: "活动PV",
              export: false,
              prop: "actPv",
            },
            {
              label: "活动UV",
              export: false,
              prop: "actUv",
            },
            {
              label: "参与次数",
              export: false,
              prop: "participatePv",
            },
            {
              label: "参与人数",
              export: false,
              prop: "participateUv",
            },
            {
              label: "人均参与次数",
              export: false,
              prop: "participateAvg",
            },
            {
              label: "参与率",
              export: false,
              prop: "participateRate",
            },
            {
              label: "加购次数",
              export: false,
              prop: "cartPv",
            },
            {
              label: "加购人数",
              export: false,
              prop: "cartUv",
            },
            {
              label: "分享次数",
              export: false,
              prop: "sharePv",
            },
            {
              label: "分享人数",
              export: false,
              prop: "shareUv",
            },
          ],
        },
        {
          label: "浏览店铺",
          export: false,
          group: "浏览店铺",
          children: [
            {
              label: "浏览店铺次数",
              export: false,
              prop: "scanshopPv",
            },
            {
              label: "浏览店铺人数",
              export: false,
              prop: "scanshopUv",
            },
            {
              label: "浏览率",
              export: false,
              prop: "scanshopRate",
            },
            {
              label: "新增店铺关注人数",
              export: false,
              prop: "followshopUv",
            },
            {
              label: "新增店铺关注次数",
              export: false,
              prop: "followshopPv",
            },
            {
              label: "店铺关注率",
              export: false,
              prop: "followshopRate",
            },
          ],
        },
        {
          label: "浏览商品",
          export: false,
          group: "浏览商品",
          children: [
            {
              label: "浏览商品次数",
              export: false,
              prop: "scanskuPv",
            },
            {
              label: "浏览商品人数",
              export: false,
              prop: "scanskuUv",
            },
            {
              label: "浏览商品率",
              export: false,
              prop: "scanskuRate",
            },
            {
              label: "商品关注人数",
              export: false,
              prop: "followskuUv",
            },
            {
              label: "商品关注次数",
              export: false,
              prop: "followskuPv",
            },
            {
              label: "商品关注率",
              export: false,
              prop: "followSkuRate",
            },
          ],
        },
        {
          label: "下单",
          export: false,
          group: "下单",
          children: [
            {
              label: "下单GMV（付款）",
              export: false,
              prop: "orderPayGmv",
            },
            {
              label: "下单人数（付款）",
              export: false,
              prop: "orderPayNum",
            },
            {
              label: "总下单数（付款）",
              export: false,
              prop: "orderPayQuantity",
            },
            {
              label: "客单价",
              export: false,
              prop: "price",
            },
            {
              label: "平均单量",
              export: false,
              prop: "orderQuantityAvg",
            },
            {
              label: "下单转化率",
              export: false,
              prop: "orderConversionRate",
            },
            {
              label: "新增会员下单人数",
              export: false,
              prop: "newOpenCardOrderQuantity",
            },
            {
              label: "老会员下单人数",
              export: false,
              prop: "oldOpenCardOrderNum",
            },
            {
              label: "新增会员下单金额",
              export: false,
              prop: "newOpenCardOrderGmv",
            },
            {
              label: "老会员下单金额",
              export: false,
              prop: "oldOpenCardOrderGmv",
            },
          ],
        },
        {
          label: "入会",
          export: false,
          group: "入会",
          children: [
            {
              label: "新增入会人数",
              export: false,
              prop: "newOpenCardNum",
            },
            {
              label: "入会转化率",
              export: false,
              prop: "openCardConversionRate",
            },
            {
              label: "新增会员下单人数",
              export: false,
              prop: "newOpenCardOrderNum",
            },
            {
              label: "新增会员下单GMV（付款）",
              export: false,
              prop: "newOpenCardOrderGmv1",
            },
            {
              label: "新增会员下单数（付款）",
              export: false,
              prop: "newOpenCardOrderQuantity1",
            },
            {
              label: "新增会员客单价",
              export: false,
              prop: "newOpenCardPrize",
            },
          ],
        },
        {
          label: "中奖",
          export: false,
          group: "中奖",
          children: [
            {
              label: "累计中奖次数",
              export: false,
              prop: "accumulateWinTimes",
            },
            {
              label: "累计中奖人数",
              export: false,
              prop: "accumulateWinNum",
            },
            {
              label: "中奖率",
              export: false,
              prop: "winRate",
            },
            {
              label: "累计领奖人数",
              export: false,
              prop: "accumulateReceiveNum",
            },
            {
              label: "领奖率",
              export: false,
              prop: "receiveRate",
            },
          ],
        },
      ],
      myFormInfo: [
        {
          label: "统计时间：",
          slot: "evaluateTime",
        },
        {
          label: "投放渠道：",
          prop: "deliveryChannel",
          slot: "deliveryChannel",
          notShow: true
        },
        // {
        //   label: "投放渠道：",
        //   prop: "sellerLinkId",
        //   type: "Select",
        //   value: "",
        //   options: [],
        //   // notShow: this.fitersChooseIF([19,46]) ? false : true
        // },
      ],
      memberAnalysisSearchQuery: {},
      currentShop: "", // 当前店铺
      freeTrialStatusVisibleRow: {},
      isShowSignWin: false, // 定时开奖-标记中奖
      selectPrize: "", // 选择奖品
      cumulativeType: 0, // 奖品池类型
      signWinPrizeList: [], // 统一奖品
      prizeSettingListStep: [], // 阶梯奖品
      selectStep: "", // 选择阶梯
      trialItem:[],
      trialRebuySummary: trialRebuySummary,
      isPlatformSeller: false,
      showEditDialog: false, // 修改用户资料弹窗
      currentEditData: {},
      levelList: [], // 会员等级列表
      editDialogType: 'add',
      showUploadShowDataDialog: false, // 控制批量上传晒单资料弹窗显示
      uploadShowDataForm: { // 批量上传晒单资料表单数据
        file: null,
        fileName: ''
      },
      reissuePointsLoading: false,
      inputWishingPoolInfo: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "joinStartTime",
          endKey: "joinEndTime",
          type: "DateRange",
        },
        {
          label: "是否抽奖：",
          prop: "isDraw",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "奖品类型：",
          prop: "prizeTypes",
          type: "Select",
          placeholder: "请选择",
          multiple: true,
          options: [
            { label: "全部", value: [] },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeName",
          type: "Input",
          placeholder: "请输入",
        },
      ],
      inputBuildingGiftInfo:[
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          type: "DateRange",
        },
        {
          label: "是否符合中奖条件：",
          prop: "isPass",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "奖品类型：",
          prop: "prizeTypes",
          type: "Select",
          placeholder: "请选择",
          value: [],
          multiple: true,
          options: [
            { label: "全部", value: [] },
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 },
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "奖品名称：",
          prop: "prizeName",
          type: "Input",
          placeholder: "请输入",
        },
      ],
      isShowOrder: false, // 随单发订单号弹窗显示
      orderFrom: {
        sendWithOrderId: "",
        recordId: "",
      },
      orderFormRules: {
        sendWithOrderId: [
          { required: true, message: "请输入随单发订单号", trigger: "blur" },
        ],
      },
      inputXhsInfo: [
        {
          label: "用户昵称：",
          prop: "nickName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          type: "DateRange",
        },
        {
          label: "审核状态：",
          prop: "processStatus",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待提交", value: -1 },
            { label: "待审核", value: 0 },
            { label: "通过", value: 1},
            { label: "驳回", value: 2},
          ],
        }
      ],
      inputCollectPointInfo: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "是否中奖：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否领奖：",
          prop: "isReceive",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否提交地址：",
          prop: "is_commit_address",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "参与时间：",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          type: "DateRange",
        },
      ],
      inputCalendarCheckInInfo: [
        {
          label: "用户昵称：",
          prop: "nickName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "首次打卡时间：",
          dateType: "datetime",
          startKey: "firstSignStartTime",
          endKey: "firstSignEndTime",
          type: "DateRange",
        },
        {
          label: "最新打卡时间：",
          dateType: "datetime",
          startKey: "lastSignStartTime",
          endKey: "lastSignEndTime",
          type: "DateRange",
        },
      ],
      inputClockInDetailsInfo: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "打卡时间：",
          dateType: "datetime",
          startKey: "signTimeStart",
          endKey: "signTimeEnd",
          type: "DateRange",
        },
        {
          label: "审核时间：",
          dateType: "datetime",
          startKey: "auditTimeStart",
          endKey: "auditTimeEnd",
          type: "DateRange",
        },
        {
          label: "审核状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待审核", value: 0 },
            { label: "审核通过", value: 1},
            { label: "审核拒绝", value: 2},
          ],
        }
      ],
      inputVersatileAnswersInfo: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "答题时间：",
          dateType: "datetime",
          startKey: "answerStartTime",
          endKey: "answerEndTime",
          type: "DateRange",
        },
        {
          label: "是否达标：",
          prop: "isPass",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否中奖：",
          prop: "isWin",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
      ],
      inputAnswerQuestionSparticipationRecordInfo:[
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [],
        },
        {
          label: "开始答题时间：",
          dateType: "datetime",
          startKey: "startTimeBegin",
          endKey: "startTimeEnd",
          type: "DateRange",
        },
        {
          label: "结束答题时间：",
          dateType: "datetime",
          startKey: "submitTimeBegin",
          endKey: "submitTimeEnd",
          type: "DateRange",
        },
        // 会员等级
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "是否完成答题：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "用户标签：",
          prop: "userTagKeyword",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "是否加购：",
          prop: "isAddCart",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否下单：",
          prop: "isOrder",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "是否付款：",
          prop: "isPay",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        // 关联商品
        {
          label: "关联商品：",
          prop: "relatedSkuIds",
          slot: "relatedSkuIds",
        },
        {
          label: "关联订单号：",
          prop: "orderId",
          placeholder: "请输入",
          type: "Input",
        },
      ],
      inputRecommendedDetailsInfo:[
        // 关联商品
        {
          label: "指定商品：",
          prop: "skuIds",
          slot: "skuIds",
        },
        {
          label: "商品标签：",
          prop: "tagKeyword",
          placeholder: "请输入",
          type: "Input",
        },
        {
          label: "统计时间：",
          dateType: "datetime",
          startKey: "statTimeBegin",
          endKey: "statTimeEnd",
          type: "DateRange",
        },
      ]
    };
  },
  filters: {
    typeChinese(val) {
      let arr = [
        "全部",
        "平台新用户",
        "品类新用户",
        "店铺新用户",
        "店铺近180天未下单客户",
        "店铺已购客户",
        "未入户用户",
        "开卡会员",
      ];
      if (val.memberRole == 1) {
        return "-";
      }
      const tempList = val.memberType.split(",");
      let str = "";
      tempList.map((item) => {
        str = str + "," + arr[Number(item)];
      });
      str = str.slice(1, str.length);
      return str;
    },
  },
  computed: {
  // 获取所有唯一的卡片名称
    uniqueCardNames() {
          const cardNames = new Set();
          // 遍历goodsRecordTableCard中的每条记录
          this.goodsRecordTableCard.forEach(record => {
            if (record.cardList && Array.isArray(record.cardList)) {
              // 遍历每条记录的cardList
              record.cardList.forEach(card => {
                if (card.cardName) {
                  cardNames.add(card.cardName);
                }
              });
            }
          });
          // 转换为数组并返回
          return Array.from(cardNames);
    },
    uniqueCardNamesLife(){
      const columnName = [];
      // 遍历goodsRecordTableCard中的每条记录
      this.goodsRecordTableCardLife.forEach((record,index) => {
        if (index == 0 && record.stages && Array.isArray(record.stages)) {
          // 遍历每条记录的cardList
          record.stages.forEach(card => {
            if (card.columnName) {
              columnName.push(card);
            }
          });
        }
      });
      return columnName
    },
    loginUserInfo() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    isShowYunqi(){
      return this.permissions.indexOf('activity:manage:yunqi:stats') != -1;
    },
    isShowGoodsDetail(){
      return this.permissions.indexOf('activity:manage:sku:stats') != -1;
    },
    // 数据总览
    dataSummary() {
      let list = [];
      if (this.switchIndex == 1) {
        list = this.joinSummary;
      } else if (this.switchIndex == 2) {
        list = this.stoneSummary;
      } else if (this.switchIndex == 3) {
        list = this.goodsSummary;
      } else if (this.switchIndex == 4) {
        list = this.orderSummary;
      } else if (this.switchIndex == 5) {
        list = this.fanSummary;
      } else if (this.switchIndex == 6) {
        list = this.prizeSummary;
      }
      if(this.fitersChooseIF([52],'!=')){
        this.chartEffectDetailInfo = [
          {
            label: "日期",
            prop: "dateTime",
            width: 140
          },
          ...list.map((item) => ({
            label: item.name,
            prop: item.value,
            align: "right",
          })),
        ];
      }else{
        this.chartEffectDetailInfo = [
          {
            label: "日期",
            prop: "statsDate",
          },
          ...this.trialRebuySummary.map((item) => ({
            label: item.name,
            prop: item.value,
            align: "right",
            width:180,
          })),
        ];
      }
      
      return list;
    },
    // 生成人群参数
    crowCondition() {
      console.log(this.rowData.activityType,'9999999');
      
      if (this.activeName == "conversionAnalysis") {
        return this.memberAnalysisSearchQuery;
      } else {
        if (this.rowData.activityType == 39) {
          return this.formListRecord;
        } else if (this.rowData.activityType == 45) {
          return this.formListLock;
        } else if(this.rowData.activityType == 70){
           if(this.activeName == "payRecord"){
             return this.formList;
           }else if(this.activeName == "outRecord"){
             return this.formListEleven;
           }else if(this.activeName == "dealRecord"){
             return this.formListTwelve;
           }else if(this.activeName == "third"){
             return this.formList;
           }else if(this.activeName == "four"){
             return this.formList;
           }
        } else if (this.activeName == "thirdTis") {
          // 试用领奖记录
          return { ...this.formListTras, winType: 0 };
        } else if (this.activeName == "thirdTisOne") {
          // 正装领奖记录
          return { ...this.formListTrasOne, winType: 1 };
        } else if(this.activeName == "twenty-two") {
          return this.formExtra;
        } else if(this.activeName == "zeroTrial"){
          return this.formZeroList;
        } else {
          return this.formList;
        }
      }
    },
    stepPrizePool() {
      let prizeList = this.prizeSettingListStep.filter(
        (item) => item.taskIndex == this.selectStep
      );
      if (prizeList.length > 0) {
        return prizeList[0].table;
      } else {
        return [];
      }
    },
    getAnswerText(){
      return (row)=>{
        let text = ''
        if(row.extraQuestion&&row.extraQuestion.type==1) {
          row.extraQuestion.options.some(item => {
            if(row.extraQuestionAnswer.optionIds&&item.optionId == row.extraQuestionAnswer.optionIds[0]){
              text = item.description
            }
          })
        } else if(row.extraQuestion&&row.extraQuestion.type==2) {
          if(row.extraQuestionAnswer.optionIds&&row.extraQuestionAnswer.optionIds.length>0) {
            const list = row.extraQuestion.options.filter(item => {
              return row.extraQuestionAnswer.optionIds.includes(Number(item.optionId))
            })
            const descriptions = list.map(item => item.description).join(",")
            text = `<div>${descriptions}</div>` 
          }
        } else {
          text = row.extraQuestionAnswer&&row.extraQuestionAnswer.submitInputText ? row.extraQuestionAnswer.submitInputText : '-'
        }
        return text;
      }
    },
    getData() {
      const types = {
        1: "单选题",
        2: "多选题",
        3: "填空题"
      }
      const isMusts = {
        0: "非不填",
        1: "必填"
      }
      if(this.goodsRecordTable.length>0&&this.goodsRecordTable[0].extraQuestionAnswer) {
       return `${types[this.goodsRecordTable[0].extraQuestion.type]}(${isMusts[this.goodsRecordTable[0].extraQuestion.isMust]}): ${this.goodsRecordTable[0].extraQuestionAnswer.title}`
      } else {
        return '未设置附加信息收集'
      }
    },
    // 会员等级映射表
    levelMap() {
      const map = {};
      map[0] = '非会员'
      this.levelList.forEach(item => {
        map[item.value] = item.label;
      });
      return map;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    commonChongBangPhysicalList() {
      return this.rowData.activityType == 39 ? this.chongBangPhysicalList2 : this.chongBangPhysicalList
    },
    opportunityText() {
      const textType = {
        23: "抽奖次数",
        24: "抽奖次数",
        39: "收集次数",
        71: "游戏次数",
        76: "补发许愿币",
      }
      return textType[this.rowData.activityType] || ''
    },
    unitText() {
      return this.rowData.activityType == 76 ? "许愿币数量" : "变更次数"
    },
    allShopList() {
      return this.$store.state.shopList
    },
    getNewMaterialInputData() {
      const { activityType } = this.rowData;
      const isNeedMemberUpGrade = [44, 47, 48, 53].includes(activityType);
      const isFitInkindCondition = this.fitersChooseIF([
        8, 16, 17, 18, 19, 27, 28, 44, 47, 48, 51,53,71,76
      ]);
      let optionsArr = [];
      if (!isFitInkindCondition) {
        optionsArr = this.inputInkindList;
      }
      if ([51].includes(activityType)){
        optionsArr = this.zeroPrizeListForm
      }
      optionsArr = isNeedMemberUpGrade
        ? this.inputMemberUpGradeMaterialList
        : this.inputInkidNeedAwardList;
      optionsArr = JSON.parse(JSON.stringify(optionsArr));
      const orderVenderIdIndex = optionsArr.findIndex(item => item.prop == "orderVenderId");
      if(orderVenderIdIndex == -1) {
        optionsArr.push(
          {
            label: "下单店铺：",
            prop: "orderVenderId",
            type: "Select",
            value: "",
            options: this.shopList.map((item)=>{
              return {
                label: item.shopTitle,
                value: item.venderId
              }
            })
          },
        )
      }
      if(!optionsArr.find(item => item.startKey == "startTime")) {
        optionsArr.push(
          {
            label: "中奖时间：",
            type: "DateRange",
            dateType: "datetime",
            startKey: "startTime",
            endKey: "endTime",
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            defalutLimit: true,
          },
        )
      }
      return optionsArr;
    },
    grayId() {
      return useGrayId(this)
    },
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
    inviteParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'inviteChaosPin'
    },
    pinToXid() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'pin'
    },
    inviteeChaos() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'inviteeChaosPin'
    },
    inviteChaos() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'inviteChaosPin'
    },
    assistChaos() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'assistChaosPin'
    },
    customerId() {
      return this.$store.getters.loginUserInfo.isGray ? 'customerXid' : 'customerPin'
    },
    inviteId() {
      return this.$store.getters.loginUserInfo.isGray ? 'inviteXid' : 'invitePin'
    },
    inviteeId() {
      return this.$store.getters.loginUserInfo.isGray ? 'inviteeXid' : 'inviteePin'
    },
    minId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'mixPin'
    }
  },
  watch: {
    grayId: {
      handler(val) {
        // grayId 为 computed，data() 初始化时尚不可用；此处同步更新搜索表单标签
        this.getTablePinText(val)
      },
      immediate: true,
    },
    searchGrayId: {
      handler(val) {
        // grayId 为 computed，data() 初始化时尚不可用；此处同步更新搜索表单标签
        this.getPinText(val)
        this.inviteeDetailsInputData.forEach(item => {
          if(item.prop=='invitePin') {
            item.label = item.label.replace(/pin/ig,val)
            item.prop = val=='xid' ? 'inviteXid':'invitePin'
          } else if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig,val)
            item.prop = val
          }
        })
        this.joinInviteInputData.forEach(item => {
          if(item.prop=='inviteePin') {
            item.label = item.label.replace(/pin/ig,val)
            item.prop = val=='xid' ? 'inviteeXid':'inviteePin'
          } else if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig,val)
            item.prop = val
          }
        })
      },
      immediate: true,
    },
    switchIndex() {
      this.initChart();
    },
    isShowYunqi:{
      handler(newVal) {
        if(newVal) {
          this.activeName = "firstNew"
        } else {
          this.activeName = "first"
        }
      },
      immediate: true
    }
  },
  async created() {
    this.timeChange();
    await this.queryTotal();
    await this.initChart(); //折线图
    this.getCustomSellerLinkPage();
    this.getAllShopList();
    //下单转化数据
    this.getShopGiftParticipateConver();
    if(this.fitersChooseIF([68])) {  
     userLifeCycle(this.formList.activityId).then((res)=>{
      if (this.fitersChooseIF([68])) {
        // 构建选项数组，默认包含"全部"选项
        const options = [{ label: "全部", value: "" }];
        
        // 从接口返回的数据中提取阶段信息
        if (res.data) {
          res.data.forEach(stage => {
            options.push({
              label: stage.stageName ,
              value: stage.stageIndex
            });
          });
        }
        
      this.inputAwardList.push(
        {
          label: "中奖阶段：",
          prop: "stageIndex",
          type: "Select",
          value: "",
          options: options,
         }
       );
      }    
       }).catch(()=>{})
    }

    // 调用集卡详情接口
    if(this.rowData.activityType == 62) {
    try {
      const res = await getCollectCardDetail({ id: this.rowData.id });
      // console.log('集卡详情数据:', res.data.collectCardList);
      
      // 从接口返回的collectCardList中提取卡片名称和ID，动态设置选项
      if (res.data && res.data.collectCardList && Array.isArray(res.data.collectCardList)) {
        // 清空原有选项（保留"全部"选项）
        this.inputInkindInfo5 = this.inputInkindInfo5.map(item => {
          if (item.prop === 'cardId') {
            return {
              ...item,
              options: [
                { label: "全部", value: "" },
                ...res.data.collectCardList.map(card => ({
                  label: card.title,  // 使用卡片的标题作为选项标签
                  value: card.id     // 使用卡片的ID作为选项值
                }))
              ]
            };
          }
          return item;
        });
      }
    } catch (error) {
      console.error('获取集卡详情失败:', error);
    }
    }
    if (this.rowData.activityType == 24) this.inputParticipat.splice(2, 1);
    if (this.fitersChooseIF([16, 17, 18, 19, 27, 28])) {
      this.inputInkindList.push(
        {
          label: "关联订单状态：",
          prop: "orderState",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", id: "" },
            { label: "等待付款", id: "等待付款" },
            { label: "暂停", id: "暂停" },
            { label: "等待出库", id: "等待出库" },
            { label: "等待发货", id: "等待发货" },
            { label: "完成", id: "完成" },
            { label: "取消", id: "取消" },
            { label: "锁定", id: "锁定" },
            { label: "等待确认收货", id: "等待确认收货" },
            { label: "未知", id: "未知" },
          ],
        },
        {
          label: "订单号：",
          prop: "orderId",
          placeholder: "请输入",
        }
      );
      this.$nextTick(() => {
        this.$refs.export_fun_swRef.reData();
      });
      this.inputAwardList[2].options.push({ label: "已失效", value: 8 });
      this.inputAwardList.push(
        {
          label: "关联订单状态：",
          prop: "orderState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "等待付款", value: "等待付款" },
            { label: "暂停", value: "暂停" },
            { label: "等待出库", value: "等待出库" },
            { label: "等待发货", value: "等待发货" },
            { label: "完成", value: "完成" },
            { label: "取消", value: "取消" },
            { label: "锁定", value: "锁定" },
            { label: "等待确认收货", value: "等待确认收货" },
            { label: "未知", value: "未知" },
          ],
        },
        {
          label: "订单号：",
          prop: "unlockOrderId",
          placeholder: "请输入",
          type: "Input",
        }
      );
      // 下单抽奖添加白名单
      // if (this.fitersChooseIF([19])) {
        this.inputAwardList.push({
          label: "是否白名单：",
          prop: "isWhite",
          type: "Select",
          value: "",
          options: [
            { label: "不限", value: "" },
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        // {
        //   label: "投放渠道：",
        //   prop: "sellerLinkId",
        //   type: "Select",
        //   value: "",
        //   options: [],
        // },
        );
      // }
      if(this.fitersChooseIF([16,17,18], '!=')) {
        this.inputAwardList.push({
          label: "下单店铺：",
          prop: "orderVenderId",
          type: "Select",
          value: "",
          options: [],
        })
      }
      this.$nextTick(() => {
        this.$refs.inputAwardOneRef.reData();
      });
    }
    // 晒单有礼新增订单号
    if (this.fitersChooseIF([41])) {
      this.inputAwardList.push({
        label: "订单号：",
        prop: "unlockOrderIds",
        placeholder: "请输入订单号，多个请使用英文“，”进行隔开",
        type: "Input",
      });
    }
    if (this.fitersChooseIF([31])) {
      this.formCoupon.splice(0, 1);
      this.formGroupCoupon.push({
        label: "拼券状态：",
        prop: "status",
        type: "Select",
        options: [
          { label: "全部", value: null },
          { label: "拼券中", value: 1 },
          { label: "拼券失败", value: 3 },
          { label: "拼券成功", value: 2 },
        ],
      });
      const { data: res } = await getCoupon(this.rowData.id);
      this.couponList = res;
    }
    if (this.fitersChooseIF([32])) {
      this.formCoupon.splice(0, 1);
      this.getopenCardRecord();
    }
    if (this.fitersChooseIF([33])) {
      this.getappointment();
    }
    // if (this.fitersChooseIF([16, 17, 18, 23, 24, 27, 28, 31])) {
    //   let param = {
    //     label: "奖品名称：",
    //     prop: "prizeIds",
    //     type: "Select",
    //     placeholder: "请选择",
    //     options: [],
    //     multiple: true,
    //   };
    //   this.inputAwardList.splice(this.getinputAwardListPriceIndex(), 0, param);
    // }
    // if(this.fitersChooseIF([19,46])) {
      // if(this.fitersChooseIF([19])) {
        // this.inputInkidNeedAwardList.push({
        //   label: "投放渠道：",
        //   prop: "sellerLinkId",
        //   type: "Select",
        //   value: "",
        //   options: []
        // })
      // }
 
    // } 
    if(this.fitersChooseIF([35])) {
      this.myFormInfo.some((item)=>{
        if(item.prop=='deliveryChannelCustomize') {
          item.notShow = false
        }
      })
    }
    if(this.rowData.activityType == 20) {
      this.evaluateType = this.rowData.ruleInfo ? JSON.parse(this.rowData.ruleInfo).activityType || 0 : 0
    }
    if(this.rowData.activityType == 36) {
      const objInfo = this.rowData.ruleInfo ? JSON.parse(this.rowData.ruleInfo) : {}
      this.isShowExtraWinRecord = objInfo ? objInfo.isExtraPrizes : false;
      this.popOrderStartPaymentType = objInfo ? objInfo.popOrderStartPaymentType : 0;
      this.getJoinRankDetail()
    }
    if(this.rowData.activityType == 76) {
        this.funGame1.forEach((item)=>{
          if(item.prop=='taskType') {
            item.options = [
            { label: "全部", value: "" },
            { label: "每日签到", value: 1 },
            { label: "浏览店铺", value: 2 },
            { label: "浏览商品", value: 13 },
            { label: "加购商品", value: 4 },
            { label: "分享商品", value: 9 },
            { label: "分享店铺", value: 10 },
            { label: "分享活动", value: 11 },
            { label: "好友助力", value: 8 },
            { label: "浏览会场", value: 5 },
            { label: "预约商品", value: 12 },
            { label: "首次赠送", value: 14 },
            { label: "每日赠送", value: 15 },
            { label: "积分兑换", value: 16 },
            { label: "购买商品", value: 17 },
            { label: "赠送许愿币", value: 22 }
          ]
          }
        })
    }
    // BI店铺弹窗新增来源弹窗
    if(this.rowData.activityType == 63) {
        let optionList = [{ label: "全部", value: "" }]
        const res = await getBiStoreGiftDetail(this.rowData.id);
        const lists =  res.data.ruleDTO.popupList || []
        if(lists.length > 0) {  
          lists.forEach((item,index)=>{
            let obj = {
              label: "",
              value: item.id
            }
            if(item.popupType==1) {
              obj.label = `弹窗${index+1}`
            }else if(item.popupType==2) {
              obj.label = "兜底弹窗"
            }
            optionList.push(obj)
          })
          this.sourcePopupList = optionList
        }
        this.formAwardOne.push({
          label: "来源弹窗：",
          prop: "biShopGiftPopupId",
          type: "Select",
          value: "",
          options: optionList,
        })
        this.$nextTick(() => {
          this.$refs.sendRecordRef.reData();
        });
      }
    // 入会有礼新下单店铺
    // if(this.rowData.activityType == 66) {
      const list =this.allShopList.length>0? this.allShopList.map((item)=>{
        return {
          label: item.shopTitle,
          value: item.venderId
        }
      }) : []
      const formObj = [{
        label: "中奖时间：",
        type: "DateRange",
        dateType: "datetime",
        startKey: "startTime",
        endKey: "endTime",
        startPlaceholder: "开始日期",
        endPlaceholder: "结束日期",
        defalutLimit: true,
      },{
        label: "下单店铺：",
        prop: "orderVenderId",
        type: "Select",
        placeholder: "请选择",
        value: "",
        options: list
      }]
      list.unshift({ label: "全部", value: "" })
       
    // }
    if(this.rowData.activityType == 36 || this.rowData.activityType == 45 || this.rowData.activityType == 52 || this.rowData.activityType == 68 || this.rowData.activityType == 80) {
      this.inputInkindList.push(...formObj)
    }
    if(this.rowData.activityType == 48 || this.rowData.activityType == 53) {
      this.inputMemberUpGradeMaterialList.push(...formObj)
    }
    this.getPrizeNameList(); //获取奖品名称列表
    // 京获客旗舰版调用京获客的 current接口判断用户是否可以生成人群
    getSellerInfo().then(res => {
      if (res.code == 1) {
        this.isPlatformSeller = res && res.data.isPlatformSeller
      }
    })
    querymemberLevel()
      .then((res) => {
        this.levelList = res.data.map((item, index) => {
          return {
            label: item.customerLevelName,
            value: index + 1
          }
        });
        this.$nextTick(() => {
          // 更新0元试用表单的会员等级选项
          const memberLevelIndex = this.zeroTrialForm.findIndex(item => item.prop === 'level');
          if (memberLevelIndex !== -1) {
            this.zeroTrialForm[memberLevelIndex].options = [ { label: "全部", value: ""},{label: "非会员", value: "0"},...this.levelList];
          }
          
          // 同步更新定时开奖参与记录的会员等级选项
          const formLuckIndex = this.inputOpenWinInfo.findIndex(item => item.prop === 'memberLevel');
          if (formLuckIndex !== -1) {
            this.inputOpenWinInfo[formLuckIndex].options = [ { label: "全部", value: ""},{label: "非会员", value: "0"},...this.levelList];
          }
          // 同步更新中奖记录/领奖记录查询区域的会员等级选项
          ['inputAwardList', 'inputMemberUpGradeList', 'inputPrizeLockList', 'inputAwardList1', 'inputAwardTwo', 'inputAwardThree', 'inputAwardFour'].forEach(formKey => {
            const idx = this[formKey].findIndex(item => item.prop === 'memberLevel');
            if (idx !== -1) {
              this[formKey][idx].options = [ { label: "全部", value: ""},{label: "非会员", value: "0"},...this.levelList];
            }
          });
          // 同步更新实物奖品名单查询区域的会员等级选项
          ['inputInkindList', 'inputInkind', 'inputInkidNeedAwardList', 'inputMemberUpGradeMaterialList', 'zeroPrizeListForm'].forEach(formKey => {
            const idx = this[formKey].findIndex(item => item.prop === 'memberLevel');
            if (idx !== -1) {
              this[formKey][idx].options = [ { label: "全部", value: ""},{label: "非会员", value: "0"},...this.levelList];
            }
          });
          if(this.rowData.activityType==81||this.rowData.activityType==82||this.rowData.activityType==87) {
            // 集分冲榜参与记录会员等级选项
            const collectPointIndex = this.inputCollectPointInfo.findIndex(item => item.prop === 'memberLevel');
            if (collectPointIndex !== -1) {
              this.inputCollectPointInfo[collectPointIndex].options = [ { label: "全部", value: ""},{label: "非会员", value: 0},...this.levelList];
            }
            // 分数获取记录会员等级选项
            const scoreRecordIndex = this.inputScoreRecordInfo.findIndex(item => item.prop === 'memberLevel');
            if (scoreRecordIndex !== -1) {
              this.inputScoreRecordInfo[scoreRecordIndex].options = [ { label: "全部", value: ""},{label: "非会员", value: 0},...this.levelList];
            }

            const constQuestionSparticipationRecordIndex = this.inputAnswerQuestionSparticipationRecordInfo.findIndex(item => item.prop === 'memberLevel');
            if (constQuestionSparticipationRecordIndex !== -1) {
              this.inputAnswerQuestionSparticipationRecordInfo[constQuestionSparticipationRecordIndex].options = [ { label: "全部", value: ""},{label: "非会员", value: 0},...this.levelList];
            }
          }
        });
      })
      .catch((res) => { });
  },
  mounted() {
    this.selectCurrentShop();
    // 获取导出字段
    this.getExportFieldJsonConfig();

    if(this.rowData.activityType==89){
      this.activeName = "first"
    }
    
  },
  methods: {
    getPinText(val) {
      const formObjects =[this.inputBiOrderDetail,this.inputDataAddCart,this.postOrdersInfoInput,this.inputDataList,
      this.inputDataListSupplementary,this.inputParticipat,this.inputMemberUpGrade2,this.zeroTrialForm,this.formBilletDoux,this.trialDetailForm,
      this.formBilletReceive,this.inputParticipatLockInfo,this.orderTrial,this.orderDetailForm,this.inputParticipatSalesRanking,this.inputParticipatLockTrial,
      this.inputParticipatLockFixedPrice,this.inputParticipatLockFans,this.inputParticipatLockGift,this.inputParticipatSalesRankingDetail,this.inputParticipatSaleslife,
      this.inputCardInviteInfo,this.inputFunGameInfo,this.inputCardInfo,this.inputOpenWinInfo,this.inputLuck,this.inputAwardList,this.inputMemberUpGradeList,
      this.inputPrizeLockList,this.inputAwardList1,this.inputAwardFiften,this.inputAwardExtra,this.inputSendBuyPay,this.inputLockRight,this.inputTakeGoods,this.formAwardOne,
      this.inputAwardTwo,this.inputAwardThree,this.inputAwardFour,this.inputInkindList,this.inputAwardTrial,this.inputAwardTrialOne,this.inputInkind,this.inputInkidNeedAwardList,
      this.inputMemberUpGradeMaterialList,this.zeroPrizeListForm,this.inputUserInfo,this.formCoupon,this.formGroupCoupon,this.formComment,this.inputGiftrecord,this.inputGiftrecordInfo,
      this.inputGiftrecord2,this.inputGiftrecordInfo2,this.inputScoreRecordInfo,this.inputResignRecordInfo,this.inputOrderDetail,this.inputOrderDetailInfo,
      this.formThir,this.formAddMoney,this.formThir9,this.formThir10,this.formThir11,this.formThir12,this.formThirRED,this.formThir2,this.formThir3,this.birthInfoFormList,this.collectInfoFormList,this.getRecordFormInfo,
      this.inputInkindInfo2,this.inputInkindInfo4,this.inputInkindInfo5,this.inputInkindInfo6,this.funGame1,this.inputInkindInfo8,this.taskCompletion,this.inputInkindInfo7,this.inputInkindInfo3,
      this.inputWishingPoolInfo,this.inputBuildingGiftInfo,this.inputXhsInfo,this.inputCollectPointInfo,this.inputCalendarCheckInInfo,this.inputClockInDetailsInfo,this.inputVersatileAnswersInfo
    ]
      formObjects.forEach((formObj) => {
        if (Array.isArray(formObj)) {
          formObj.forEach((item) => {
            if(item.prop == "pin") {
              item.label = `用户${val}：`
              item.prop = val
              item.placeholder = item.placeholder.replace(/pin/ig,val)
            } else if(item.prop == "customerPin") {
              item.label = `用户${val}：`
              item.prop = val=='xid' ? 'xid' : 'customerPin'
            }
          });
        }
      });
    },
    getTablePinText(val) {
      const formObjects =[this.signInTableInfo,this.signInTableInfoSupplementary]
      formObjects.forEach((formObj) => {
        if (Array.isArray(formObj)) {
          formObj.forEach((item) => {
            if(item.prop == "pin") {
              item.label = `用户${val}：`
              item.prop = val=='xid'?'chaosXid':'chaosPin'
            }
          });
        }
      });
    },
    beforeUploadXlsZeroTrial(file) {
      const fileSize = file.size / 1024 / 1024 < 2;
      if (!fileSize) {
        this.message.warning("上传文件大小不能超过 2MB!");
        return false;
      }
      let forms = new FormData();
      forms.append("file", file);
      importReceiverMobiles(forms).then((res) => {
        if (res.code == 1) {
          this.$message.success("上传成功");
          // 转为换行符
          this.searPhoneStr = res.data.join("\n");
        } else {
          this.$message.error(res.message);
        }
      });
      return false;
    },
    handleDownloadPhoneTemplate() {
      let url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%8B%E6%9C%BA%E5%8F%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
    },
    getCreateFn() {
      if(this.activeName == 'third') {
        this.winningRecord();
      } else if(this.activeName == 'thirdTis') {
        this.trailLin();
      } else if(this.activeName == 'thirdTisOne') {
        this.trailLinOne(); 
      } else if(this.activeName == 'twenty-one' || this.activeName == 'twenty-two') { 
        this.getWinRecord();
      }
    },
    handleSendPrize() {
      this.isShowSendPrize = true
    },
    // 取消标记中奖
    handleCancelMarkWin(row) {
      this.$confirm('确认取消标记中奖吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
      //  调用接口
      try {
       const res = await cancelMarkSendWithOrder({recordId:row.id})
       if(res.code==1){
        this.getZeroTrial()
        }else{
          this.$message.error(res.message)
        }
      } catch (error) {
      }
      });
    },
    
    complate() {
      const value = this.searPhoneStr.split("\n").filter((item) => item);
      if (value.length > 3000) {
        return this.$message.warning("最多输入3000个");
      }
      this.formDataPhoneStr = this.searPhoneStr
        .split("\n")
        .filter((item) => item)
        .join(",");
      this.$refs.idPopper.doClose();
    },
    handleDownloadTemplate() {
      let url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E8%AE%A2%E5%8D%95%E5%8F%91%E9%80%81_%E8%AE%A2%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
    },
    handlePhoneInput(value) {
      // 使用正则表达式来确保只有数字被输入
      this.searPhoneStr = value.replace(/[^\n0-9]/g, "");
    },
    handleBatchQuery() {
      this.searPhoneStr = this.formDataPhoneStr.split(",").join("\n");
    },
    handleToTabCb(val) {
      this.activeName = val
      this.handleClick({
        name: val
      })
    },
    getTabText(type) {
      let text = ""
      if(type==8) {
        text = "抽奖机会赠送记录"
      } else if(type==81 || type==82) {
        text = "分数获取记录"
      } else {
        text = "参与赠送记录"
      }
      return text
    },
    handleAddGiftNumber() {
      this.isShowAddGiftNumber = true
      if(this.rowData.activityType == 81||this.rowData.activityType == 82) {
        this.unitText = "变更分数"
        this.titleText = "分数"
      } else {
        this.unitText = "变更次数"
        this.titleText = "抽奖次数"
      }
    },
    limitSelectable(row) {
      return row.prizeType!=14;
    },
   async getJoinRankDetail() {
    const obj = this.rowData.ruleInfo ? JSON.parse(this.rowData.ruleInfo) : {rankActivityType: 0}
    this.isShowInvite = obj.rankActivityType
    if(this.isShowInvite==1){
      this.chongBangAwardList = [
        { label: "用户昵称", prop: "memberNick", width: "170" },
        { label: "中奖ID", prop: "id", width: "170" },
        { label: "活动名称", prop: "activityName" },
        { label: "总订单金额（已付款）", prop: "totalPayMoney", width: "180" },
        { label: "总订单笔数（已付款）", prop: "orderPayNum", width: "180" },
        {
          label: "总订单金额（已收货）",
          prop: "totalFinishMoney",
          width: "180",
        },
        {
          label: "总订单笔数（已收货）",
          prop: "orderFinishNum",
          width: "180",
        },
        { label: "邀请人数", prop: "inviteNum" },
        { label: "有效邀请人数", prop: "validInviteNum" },
        { label: "奖品类型", prop: "prizeTypeStr" },
        { label: "奖品名称", prop: "prizeName" },
        { label: "补发奖品名称", prop: "compensationPrizeName" },
        { label: "订单号", prop: "orderIdStr" },
        { label: "中奖状态", prop: "statusStr" },
        { label: "参与时间", prop: "joinTime", width: "200" },
        { label: "领奖时间", prop: "winTime", width: "200" },
        { label: "发放时间", prop: "grantTime", width: "200" },
      ]
    }
    },
    //1.58
    changeFrequencySubmit(){
      console.log('1.58');
    },
     changeFrequencySubmit1(){
      console.log('1.58');
    },
    frequency() {
       this.changeFrequencyShow = true;
    },
    frequencyOne() {
      this.gameShow = true;
    },
    numbersGams(val){
       this.prizeGetTypes = val.prizeGetType
       this.numbersGamsVisible = true
       this.gameDetailChang(val)
    },
    physicalBatchShipmentClose1() {
      this.physicalBatchShipmentShow1 = false;
      this.downloadResData1 = {};
      this.downloadUserList1 = [];
      this.handleClick(this.actTab);
    },
    reissuePoints(row) {
      this.reissuePointsLoading = true;
      resendPoints({
        recordId: row.id
      }).then(res=>{
        this.reissuePointsLoading = false;
        if(res.code == 1){
          this.$message.success("补发积分成功")
          this.winningRecord()
        }else{
          this.$message.warning(res.message)
        }
      }).catch((err) => {
        console.log(err)
        this.reissuePointsLoading = false;
      });
    },
    handleCloseAddGiftNumberBatch(flag) {
      this.isShowAddGiftNumberBatch = false
      if(flag) {
        this.getGameTaskRecord()
      }
    },
    handleCloseAddGiftNumber(flag) {
      this.isShowAddGiftNumber = false
      if(flag) {
        this.getGameTaskRecord()
      }
    },
    handleCloseAddGiftNumberBatchOne(flag) {
      this.isShowAddGiftNumberBatchOne = false
      if(flag) {
        this.funGameList()
      }
    },
    handleCloseAddGiftNumberOne(flag) {
      this.isShowAddGiftNumberOne = false
      if(flag) {
        this.funGameList()
      }
    },
    // 上传失败
    handleError(err) {
      this.$message.error("上传失败");
   },
    // 点击团员人数跳转到被邀请人明细tab
    goToInviteDetail(row) {
      // 设置标记，表示是从开团记录跳转过来的，避免在tab切换时清空表单
      this.fromTeamRecord = true;
      
      // 设置查询参数
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pinOrNick = row[this.searchGrayId] || '';
      this.formList.teamName = row.teamName || '';
      
      this.$nextTick(() => {
        // 切换到被邀请人明细tab
        this.activeName = 'inviteesDetail';
        
        // 等待DOM更新完成后设置表单数据
        setTimeout(() => {
          // 获取表单组件引用并设置数据 - jd-form组件使用内部的searchData对象
          // 注意：根据之前的修改，ref名称已更改为inputAwardTeamInvitees
          if (this.$refs.inputAwardTeamInvitees) {
            // 使用setFormData方法设置表单数据
            this.$refs.inputAwardTeamInvitees.setFormData({
              pinOrNick: row[this.searchGrayId] || '',
              teamName: row.teamName || ''
            });
           }
           // 触发查询
           this.toGetInviteDetailOne();
         }, 100); // 添加短暂延迟确保表单组件完全加载
       });
     },
     // 根据卡片名称获取对应的数量
     getCardNum(cardList, cardName) {
          if (!cardList || !Array.isArray(cardList)) {
            return 0;
          }
          // 查找匹配的卡片并返回数量
          const card = cardList.find(item => item.cardName === cardName);
          return card ? card.count : 0;
        },
      getstageName(cardList,stageIndex, cardName) {
          if (!cardList || !Array.isArray(cardList)) {
            return 0;
          }
          // 查找匹配的卡片并返回数量
          const card = cardList.filter(item => item.stageIndex == stageIndex).find(item => item.columnName === cardName);
          return card ? card.value : 0;
      },
     // 获取当前行的卡片名称列表
     getRowCardNames(row) {
          if (!row || !row.cardList || !Array.isArray(row.cardList)) {
            return [];
          }
          return row.cardList.map(card => card.cardName);
      },
     //获取列表
    getRowstageName(row,stageIndex) {
      if (!row || !row.stages || !Array.isArray(row.stages)) {
        return [];
      }
      return row.stages.filter(item => item.stageIndex == stageIndex).map(card => card.columnName);
    },
    // 批量上传晒单资料弹窗显示方法
    uploadShowData() {
      this.showUploadShowDataDialog = true;
    },
    
    // 处理文件选择变化
    handleFileChange(file) {
      // 检查文件大小（50MB限制）
      const maxSize = 50 * 1024 * 1024; // 50MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过50MB');
        return;
      }
      
      // 保存文件信息
      this.uploadShowDataForm.file = file;
      this.uploadShowDataForm.fileName = file.name;
    },
    
    // 处理弹窗关闭
    handleUploadShowDataClose() {
      // 重置表单数据
      this.uploadShowDataForm = {
        file: null,
        fileName: ''
      };
    },
    
    // 下载模板
    downloadTemplate() {
       this.downloadShowDataTemplate()
    },
    
    // 处理上传提交
    handleUploadSubmit() {
      // 文件已上传，关闭弹窗
      this.showUploadShowDataDialog = false;
    },
    
    // 查看订单详情
    handleCheckOrderDetail(row,type){
      this.currentId = row.recordId
      this.currentPin = row[this.searchGrayId]
      this.lockType = type
      this.isShowOrderDetail = true
    },
    getAllShopList() {
      getShopList().then(res=>{
        if(res.code == 1){
          this.shopList = res.data&&res.data[0] != null ? res.data : [];
          this.shopList.unshift({
            venderId: "",
            shopTitle: "全部"
          })
          const list = this.shopList.map((item)=>{
            return {
              label: item.shopTitle,
              value: item.venderId
            }
          })
          this.inputOrderDetailInfo.some((item)=>{
            if(item.prop=='orderVenderId') {
              item.options = list
            }
          })
          this.inputAwardList.some((item)=>{
            if(item.prop=='orderVenderId') {
              item.options = list
            }
          })
          this.inputInkindInfo3.some((item)=>{
            if(item.prop=='orderVenderId') {
              item.options = list
            }
          })
          this.inputInkindInfo2.some((item)=>{
            if(item.prop=='orderVenderId') {
              item.options = list
            }
          })
        }
      }).catch(()=>{
     
      })
    },
    getCustomSellerLinkPage() {
      customSellerLinkPage({
        current: 1,
        size: 10000,
        activityId: this.rowData.id,
      }).then((res)=>{
        if(res.code==1) {
          this.sellerLinkList = res.data.records || [];
          this.sellerLinkList.unshift({
            id: "",
            sellerLinkName: "全部"
          },
          {
            id: "0",
            sellerLinkName: "默认渠道"
           },
        )
          const list = this.sellerLinkList.map((item)=>{
            return {
              label: item.sellerLinkName,
              value: item.id
            }
          })
          // 处理所有包含sellerLinkId的表单对象
          const formObjects = [
            this.myFormInfo,
            this.inputConversionInfo,
            this.inputOrderDetailInfo,
            this.inputAwardList,
            this.inputInkidNeedAwardList,
            this.inputMemberUpGradeList,
            this.inputDataAddCart,
            this.inputParticipat,
            this.inputParticipatLockInfo,
            this.inputParticipatLockTrial,
            this.inputOpenWinInfo,
            this.inputLuck,
            this.inputAwardList1,
            this.inputAwardFiften,
            this.inputSendBuyPay,
            this.inputSendBuyRePay,
            this.inputLockRight,
            this.inputTakeGoods,
            this.inputAwardThree,
            this.inputAwardTwo,
            this.inputAwardTrial,
            this.inputAwardTrialOne,
            this.inputAwardFour,
            this.inputGiftrecordInfo,
            this.inputGiftrecordInfo2,
            this.inputDataList,
            this.inputUserInfo,
            this.inputInkindInfo2,
            this.inputInkindInfo3,
            this.inputInkindInfo5,
            this.inputInkindInfo6,
            this.inputInkindInfo7,
            this.inputGiftrecord,
            this.inputGiftrecord2,
            this.postOrdersInfoInput,
            this.inviteeDetailsInputData,
            this.inputInkindList,
            this.formSplitCoupon,
            this.formGroupCoupon,
            this.zeroPrizeListForm,
            this.inputMemberUpGradeMaterialList,
            this.formCoupon,
            this.trialDetailForm,
            this.zeroTrialForm,
            this.formBilletDoux,
            this.orderTrial,
            this.formBilletReceive,
            this.inputPrizeLockList,
            this.inputMemberUpGrade2,
            this.getRecordFormInfo,
            this.formComment,
            this.formThirRED,
            this.formThir9,
            this.formThir,
            this.formAddMoney,
            this.inputDataListSupplementary,
            this.inputInkindInfo8,
            this.taskCompletion,
            this.invitees,
            this.inputParticipatLockFans,
            this.inputParticipatLockGift,
            this.inputParticipatSalesRankingDetail,
            this.funGame1,
            this.inputFunGameInfo,
            this.formThir10,
            this.formThir11,
            this.formThir12,
            this.birthInfoFormList,
            this.collectInfoFormList,
            this.inputWishingPoolInfo,
            this.inputBuildingGiftInfo,
            this.inputXhsInfo,
            this.inputCollectPointInfo,
            this.inputScoreRecordInfo,
            this.inputCalendarCheckInInfo,
            this.inputClockInDetailsInfo,
            this.inputResignRecordInfo,
            this.inputVersatileAnswersInfo,
            this.inputAnswerQuestionSparticipationRecordInfo,
            this.inputParticipateConversionAnalysis,
          ];
          
          // 遍历所有表单对象，为包含sellerLinkId的字段设置options
          formObjects.forEach((formObj) => {
            if (Array.isArray(formObj)) {
              formObj.forEach((item) => {
                if (item.prop == 'sellerLinkId') {
                  item.options = list;
                }
              });
            }
          });
        }
      })
    },
    getStatus(e){
      return {
        0:2,
        1:4,
        2:0,
        3:3,
      }[e]
    },
    getStatus1(tips,orderState){
      if(tips=='已完成' || orderState=='FINISHED_L'){
        return 0
      }else if(tips=='等待出库' || orderState=='WAIT_SELLER_STOCK_OUT' || tips == '等待确认收货' || orderState=='WAIT_GOODS_RECEIVE_CONFIRM'){
        return 1
      }else if(tips=='未付款' || orderState=='WAIT_PAYMENT'){
        return 2
      }else if(tips=='退货' || orderState=='LOCKED' || tips=='暂停' || orderState=='PAUSE'){
        return 3
      }else if(tips=='已取消' || orderState=='TRADE_CANCELED'){
        return 4
      }
    },
    //试用复购详情
    trialDetail(val){
      this.trialDetailData=val;
      this.isShowTrial = true;
    },
    getAnswer(answerList, question) {
      const answer = answerList.find((item) => item.type === question);
      if (answer) {
        // 如果是图片上传题，返回图片标签
        if (question.includes("图片上传题") && answer.content) {
          // 使用逗号分隔多个图片地址
          const imageUrls = answer.content.split(",").map((url) => url.trim());
          // 生成图片标签
          const imagesHtml = imageUrls
            .map((url, index) => {
              return `
              <div class="image-container" style="display: inline-block; position: relative; margin-right: 10px;">
                <img src="${url}" alt="图片" data-index="${index}" data-url="${url}" style="width: 50px; height: 50px; cursor:pointer;">
                <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                  <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
                </div>
              </div>
            `;
            })
            .join("");
          return imagesHtml;
        } else if (question.includes("图片选择题") && answer.content) {
          // 如果是图片选择题，返回单个图片标签
          return `
            <div class="image-container" style="display: inline-block; position: relative;">
              <img src="${answer.content}" alt="图片" data-url="${answer.content}" style="width: 50px; height: 50px; cursor:pointer;">
              <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
              </div>
            </div>
          `;
        } else {
          // 其他类型返回内容
          return answer.content || "-";
        }
      }
      return "-";
    },
    showImage(answerList, question, event) {
      const answer = answerList.find((item) => item.type === question);
      // 检查是否有内容
      if (!answer || !answer.content) {
        return;
      }
      // 找到被点击的元素
      let target = event.target;

      // 如果点击的是放大镜图标，找到对应的图片
      if (target.className === "el-icon-zoom-in") {
        target = target.closest(".image-container").querySelector("img");
      }
      // 确保点击的是图片元素或其容器
      if (target.tagName === "IMG") {
        // 从自定义属性中获取图片URL
        const imageUrl = target.getAttribute("data-url");

        if (imageUrl) {
          this.currentImageUrl = imageUrl;
          this.showImageDialog = true;
        }
      } else if (target.classList.contains("image-overlay")) {
        // 如果点击的是遮罩层，找到对应的图片
        const img = target.parentElement.querySelector("img");
        if (img) {
          const imageUrl = img.getAttribute("data-url");
          if (imageUrl) {
            this.currentImageUrl = imageUrl;
            this.showImageDialog = true;
          }
        }
      }
    },
    beforeUploadXls(file) {
      const fileSize = file.size / 1024 / 1024 < 50;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 50MB!");
        return  false;
      }
    },
    handleUploadXlsSku(res) {
      this.$refs.uploadXlsSku.clearFiles();
      if (res.code != 1) {
        this.$refs.uploadXlsSku.clearFiles()
        this.$message.error(res.message)
        this.fourse = true
        return
      }else{
         this.$message.success(res.message)
         this.fourse = false
         this.showUploadShowDataDialog = false;
         this.searchPostUserInfo({});
      }
    },
    // 标记中奖
    freeTrialMarkWin() {
      const row = this.freeTrialStatusRow
      const param = {
        recordId: row.id,
      };
      this.markLoading = true;
      markWinTrial(param)
        .then((res) => {
          if (res.code == 1) {
            this.getZeroTrial();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
          this.markLoading = false;
          this.freeTrialStatusVisible = false;
        })
        .catch((err) => {
          this.markLoading = false;
        });
    },
    // 打开试用报告弹窗
    openDialog(row) {
      this.isDialogVisible = true;
      this.currenttrailReport = row
    },
    searchInkind_export_fun() {
      this.export_get(this.$refs.export_fun_swRef.getSearchForm());
    },

    //TODO:1.49迭代幸运值获取记录
    // searchHp_export() {
    //   this.export_get(this.$refs.export_fun_swRef.getSearchForm());
    // },

    selectCurrentShop() {
      getShopInfo().then((res) => {
        let { shopTitle = "" } = res.data || {};
        this.currentShop = shopTitle;
      });
    },
    getinputAwardListPriceIndex() {
      return (
        this.inputAwardList.findIndex((item) => item.prop == "prizeType") + 1
      );
    },
    handleToGoods(id) {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/goodsManagement",
        query: {
          id,
          tabActive: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    getStaticInfoNames(item, staticInfoNames) {
      let value = "";
      if (staticInfoNames && Array.isArray(staticInfoNames)) {
        staticInfoNames.forEach((cItem) => {
          if (cItem.name == item.name) {
            value = cItem.value;
          }
        });
      }
      return value;
    },
    formatExtendInfo(extendInfo) {
      return JSON.parse(extendInfo);
    },
    onPoccessSelectable(row, index) {
      // 已通过的不能再选择
      if (row.processStatus != 1) {
        return true;
      } else {
        return false;
      }
    },
    // 晒单有礼-批量选择审核列表
    handlePoccessSelectionChange(val) {
      this.proccessSelectionArr = val;
    },
    // 晒单有礼-审核
    onHandleProcess(row) {
      console.log("row>>", row);
      this.isShowProcessInfoDialog = true;
      if (row) {
        this.processControlType = "single";
        // 扩展字段
        row.parseExtendInfo = row.extendInfo
          ? JSON.parse(row.extendInfo)
          : null;
        // console.log(row.extendInfo)
        this.processRowData = { ...row };
      } else {
        this.processControlType = "batch";
      }
    },

    closeBigImg() {
      this.dialogImageUrl = "";
    },
    // 放大图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
    },
    showextendInfo(obj) {
      let obj1 = obj ? JSON.parse(obj) : {};
      let arr = [];
      for (const key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          let keys = key;
          let isImg = false;
          let val = "";
          if (this.isLink(obj1[key]).flag) {
            isImg = true;
          }
          console.log(this.isLink(obj1[key]), "4444");
          val = this.isLink(obj1[key]).newVal;
          arr.push({ prop: keys, keys: val, isImg });
        }
      }
      return arr;
    },
    isLink(val) {
      let newVal = "";
      let flag = false;
      let reg = new RegExp(/^http|https?:\/\//);
      if (val.indexOf("[") != -1) {
        flag = reg.test(val);
        newVal = JSON.parse(val);
      } else {
        newVal = val;
      }
      return { flag, newVal };
    },
    addCrowd(val) {
      // 如果版本为京获客旗舰版需要校验用户时候有该按钮权限
      if (this.softType == 1 && !this.$store.getters.isJhkPlatformSeller) {
        return this.$message.warning("您不满足使用该功能，请联系专属客服了解~")
      }
      this.source = val;
      this.isShowCrowdDialog = true;
      // 用户分析默认值
      if (val == 18) {
        this.hasDefaultValue = true;
        this.defaultValueText = "入会用户转化分析";
      } else if (
        [26].includes(val) ||
        ([29].includes(val) && this.activeName == "openWinRecord")
      ) {
        this.hasDefaultValue = true;
        this.defaultValueText = "参与记录";
      }else if(val == 37){
        this.hasDefaultValue = true;
        this.defaultValueText = "参与记录";
      } else if (val == 30) {
        this.hasDefaultValue = true;
        this.defaultValueText = "幸运值获取记录";
      } else if (val == 34) {
        this.hasDefaultValue = true;
        if (this.tabName == "zeroTrial") {
          this.defaultValueText = "参与记录";
        }
      }
      // 晒单有礼-默认值
      if (this.rowData.activityType == 41) {
        this.hasDefaultValue = true;
        let txtMap = {
          20: "用户资料",
          3: "中奖记录",
          4: "实物奖品名单",
        };
        this.defaultValueText = txtMap[val];
      } else if (this.rowData.activityType == 45 && val == 3) {
        this.hasDefaultValue = true;
        this.defaultValueText = this.tabName == "twenty-one" ? "领奖记录(冲榜)" : "领奖记录(额外奖品)";
      }
      // 试用反馈详情
      if (this.tabName == "trialDetail") {
        this.hasDefaultValue = true;
        this.defaultValueText = "试用反馈详情";
      }
      if (this.rowData.activityType == 69 && val == 3) {
        this.hasDefaultValue = true;
        this.defaultValueText = "领奖记录";
      }
      if(this.rowData.activityType == 39) {
        this.hasDefaultValue = true;
        if(val == 52) {
        this.defaultValueText = "登记生日"
        } else if(val==7) {
          this.defaultValueText = "收集机会获取记录"
        } else if(val==3) {
          this.defaultValueText = "生日有礼领奖记录"
        }
      }
      if(this.rowData.activityType == 82 && this.tabName == "twelve") {
        this.hasDefaultValue = true;
        this.defaultValueText = "补签卡获取记录 ";
      }
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    // 实物奖品名单导出
    goodsExportDialog() {
      if (this.rowData.activityType == 39) {
        this.control2 = true;
      } else {
        this.control3 = true;
      }
    },
    getRewardExport(){
      this.control2 = true;
    },  
    // 导出数据
    async exportFn() {
      this.control1 = true;
    },
    async exportFn2() {
      this.control7 = true;
    },
    // 固定价参与记录导出
    async exportFnFixedPrice() {
      this.control35 = true;
    },
    exportZeroTrialFn() {
      this.control10 = true;
    },
    exportZeroTrialDetailFn() {
      this.control11 = true;
    },
    exportFnTrial(){
      this.control12 = true;
    },
    export_get_trial(){
      this.control13 = true;
    },
    export_get_trial_one(){
      this.control14 = true;
    },
    export_static(){
      this.control15 = true;
    },
    // 抽卡记录导出
    exportFnGacha(){
      this.control16 = true;
    },
    //幸运值获取记录-定时开奖导出
    searchHp_export(){
      this.control17 = true;
    },
    //开团记录导出
    async exportFnGachaTeam() {
      this.control18 = true;
    },
    //被邀请人明细
    async exportFnGachaTree() {
      this.control19 = true;
    },
    //任务完成记录导出
    async exportTask() {
      this.control20 = true;
    },
    // 粉丝发卡
    async exportFans() {
      this.control21 = true;

    },
    //入会有礼
    async exporGift() {
      this.control22 = true;
    },
    async exportFn3(type) {
      this.billetExportType = type;
      this.control9 = true;
    },
    getphone1(val) {
      this.exportTheData(val);
    },
    getphone2(val) {
      this.getApi_Exprot(val);
    },
    getphone3(val) {
      this.getApi_Exprot2(
        (this.tabName == "twenty-one" || this.tabName == "twenty-two") ? 2 : this.tabName == "twenty" ? 3 : 1,
        val
      );
    },
    getphone4(val) {
      this.savePhone(val);
    },
    getphone7(val) {
      this.exportTheData2(val);
    },
    getphone8(val) {
      this.exportTheDataStatic(val);
    },
    getphone9(val) {
      this.exportTheData3(val);
    },
    getphone10(val) {
      this.exportZeroTrial(val);
    },
    getphone11(val) {
      this.exportZeroTrialDetail(val);
    },
    getphone12(val) {
      this.exportZeroTrialDetailTiral(val);
    },
    getphone13(val) {
      this.exportZeroTrialDetailTirals(val);
    },
    getphone14(val) {
      this.exportZeroTrialDetailTiralsOne(val);
    },
    getphone15(val) {
      this.exportTableStatic(val);
    },
    getphone16(val) {
      this.exportGachaRecords(val);
    },
    // 幸运值获取记录-定时开奖导出
    getphone17(val) {
      this.exportLuckValue(val);
    },
    //开团记录导出
    getphone18(val) {
      this.exportTeamSharePrizeRecords(val);
    },
    //被邀请人明细导出
    getphone19(val) {
      this.exportGachaTreeRecords(val);
    },
    // 任务完成记录导出
    getphone20(val) {
      this.exportTaskRecords(val);
    },
    //销售
    getphone26(val) {
      this.exportRansRecords(val);
    },
    //粉丝打卡
     getphone21(val) {
      this.exportTaskRecordsFans(val);
    },
    //入会有礼导出
    getphone22(val) {
      this.exportGiftRecords(val);
    },
    //销售
    exportRanksTable(){
       this.control26 = true;
    },
    // 处理销售导出回调
    getphone27(val) {
      // 可以在这里添加额外的处理逻辑
       this.exportRansRecordsOne(val);
    },
    //生命
    getphone28(val) {
      // 可以在这里添加额外的处理逻辑
       this.exportRansRecordsLifes(val);
    },
    //门票支付记录导出
    getphone29(val) {
      this.exportBilletDouxTen(val);
    },
    //锁权
    getphone_36(){
       this.control36 = true;
    },
    getphone_37(){
       this.control37 = true;
    },
    // 出价记录导出
    getphone30(val) {
      this.exportBilletDouxEleven(val);
    },
    // 成交记录导出
    getphone31(val) {
      this.exportBilletDouxTwelve(val);
    },
    //趣味游戏
    getphone32 (val){
      this.exportFunGameRecords(val)
    },
    // 购物车锦鲤
    getphone33 (val){
      this.exportCardRecordRecords(val)
    },
    // 购物车锦鲤邀请记录
    getphone34 (val){
      this.exportCardInviteRecords(val)
    },
    // 固定价参与记录导出
    getphone35 (val){
      this.exportFixedPriceRecords(val)
    },
    // 锁权订单明细导出
    getphone36 (val){
       this.exportLockOrderRecords(val)
    },
    getphone45 (val){
       this.exportPublic(val)
    },
    getphone37 (val){
       this.exportTrialRecords(val)
    },
    getphone38 (val){
       this.exportsalesRankRecords(val)
    },
    getphone_29(){
      this.control29 = true;
    },
    getphone_38(){
      this.control38 = true;
    },
    getphone_45(val){
      if(this.rowData.activityType==46) {
        this.formOrderDetailQuery = {...val}
      }
      this.control45 = true;
    },
    getphone_30(){
      this.control30 = true;
    },
    getphone_31(){
      this.control31 = true;
    },
    // 销售参与记录导出
    exportRanks(val) {
      this.control27 = true;
    },
    //生命
    exportLifes(val) {
      this.control28 = true;
    },
    // 趣味游戏导出
    exportFunGame(val) {
      this.control32 = true;
    },
    //购物车锦鲤
    exportCardRecord(val) {
      this.control33 = true;
    },
    //购物车锦鲤邀请记录
    exportCardInvite(val) {
      this.control34 = true;
    },
    editAddress(row) {
      console.log(row);
      this.takeGoodsForm.id = row.id;
      this.takeGoodsForm.isFillAddress = row.isFillAddress;
      if(row.isFillAddress == "未填写") {
        this.takeGoodsForm.id = row.recordId;
        this.takeGoodsForm.receiverName = "";
        this.takeGoodsForm.receiverMobile = "";
        this.takeGoodsForm.detailedAddress = "";
        this.takeGoodsForm.receiverAddress = [];
        this.lockTakeGoodsVisible = true;
        return;
      }
      this.$decryptBatch
        .decrypt([
          row.decryptMemberNick || row.decryptReceiverName,
          row.decryptMobile || row.decryptReceiverMobile,
          row.decryptReceiverAddress,
          row.decryptDetailedAddress,
          row.encryptProvince,
          row.encryptCity,
          row.encryptDistrict,
        ])
        .then((res) => {
          if (res.code == 1) {
            let data = res.data;
            this.takeGoodsForm.receiverName = data[0];
            this.takeGoodsForm.receiverMobile = data[1];
            this.takeGoodsForm.detailedAddress = data[3];
            this.takeGoodsForm.receiverAddress = [data[4], data[5], data[6]];
            console.log(this.takeGoodsForm.receiverAddress);
            this.lockTakeGoodsVisible = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    setTakeGoods() {
      if (!this.takeGoodsForm.receiverName) {
        return this.$message.info("请输入姓名");
      } else if (!this.takeGoodsForm.receiverMobile) {
        return this.$message.info("请输入手机号码");
      } else if (this.takeGoodsForm.receiverAddress.length == 0) {
        return this.$message.info("请输入地区");
      } else if (!this.takeGoodsForm.detailedAddress) {
        return this.$message.info("请输入详细地址");
      }
      let postData = {};
      let reqAip = updateReceiveAddress;
      if(this.takeGoodsForm.isFillAddress == "未填写") {
        postData = {
          ...this.takeGoodsForm,
          province: this.takeGoodsForm.receiverAddress[0],
          city: this.takeGoodsForm.receiverAddress[1],
          district: this.takeGoodsForm.receiverAddress[2],
          receiverAddress: this.takeGoodsForm.receiverAddress.join("/"),
        }
        reqAip = writeReceiveAddress;
      } else {
        postData = {
          ...this.takeGoodsForm,
          province: this.takeGoodsForm.receiverAddress[0],
          city: this.takeGoodsForm.receiverAddress[1],
          district: this.takeGoodsForm.receiverAddress[2],
          receiverAddress: this.takeGoodsForm.receiverAddress.join("/"),
        };
      }
      delete postData.isFillAddress;
      reqAip(postData).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.lockTakeGoodsVisible = false;
          // 满额处理
          if(this.rowData.activityType == 46) {
            this.$refs.physicalAwardRef.getList();
          } else if(this.fitersChooseIF([36, 39,62])) {
            // 打榜有礼、生日有礼、集卡有礼
            this.getGoodsRecord();
          } else {
            // 公用
            this.takeGoodsRecord();
            this.inKingRecord();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 单个发货
    sendGoods(row) {
      let billCode = row.billCode || null;
      this.$prompt("快递单号：", "发货信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "lock_message_box",
        inputValue: billCode,
        inputValidator: (value) => {
          if (!value) {
            this.$message({
              type: "info",
              message: "请输入快递单号",
            });
            return "";
          }
        },
      })
        .then(({ value }) => {
          if (!value) {
            this.$message({
              type: "info",
              message: "请输入快递单号",
            });
            return false;
          } else {
            lockSendStatus({ id: row.id, billCode: value }).then((res) => {
              if (res.code == 1) {
                // 刷新列表
                this.winningRecord();
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            });
          }
        })
        .catch(() => {});
    },
    // 确权 中奖记录批量发货
    batchLock() {
      this.batchLockVisible = true;
    },
    // 确权 中奖记录批量发货
    batchLockClose() {
      this.winningRecord();
      this.batchLockVisible = false;
    },
    // 跳转至商品详情页
    jumpTo() {},
    //Note----邀请明细
    // invitationDeatils(val){
    //   this.dialogDeatils = true;
    // },
    handlePageExchange2(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      // this.getopenCardRecord()
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    handleCurrentExchange2(val) {
      this.formList.current = val;
      // this.getopenCardRecord()
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    handleSizeExchange2(val) {
      this.formList.size = val;
      // this.getopenCardRecord()
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    searchFormThir2(val) {
      this.formList2 = val;
      if (this.rowData.activityType == 32) {
        this.getopenCardRecord();
      } else if (this.rowData.activityType == 33) {
        this.getappointment();
      }
    },
    getopenCardRecord() {
      var obj = {
        ...this.formList,
        id: this.rowData.id,
        memberNick: this.formList2.memberNick,
        createTimeStart: this.formList2.createTimeStart,
        createTimeEnd: this.formList2.createTimeEnd,
        openCardTimeStart: this.formList2.openCardTimeStart,
        openCardTimeEnd: this.formList2.openCardTimeEnd,
      };
      openCardRecord(obj).then((res) => {
        this.exchangeList = res.data.records;
        this.totalMail = Number(res.data.total);
      });
    },
    getappointment() {
      var obj = {
        ...this.formList,
        memberNick: this.formList2.memberNick,
        isWin: this.formList2.isWin,
        startTime: this.formList2.startTime,
        endTime: this.formList2.endTime,
      };
      appointment(obj).then((res) => {
        this.exchangeList = res.data.records;
        this.totalMail = Number(res.data.total);
      });
    },
    // 监听录入快递单号按钮
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.$forceUpdate();
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    // 输入框限制输入数字
    // enterCoutierInputLimit(value) {
    //   // console.log("input", value);
    //   this.enterCoutierNum = Number(value.replace(/[^\d]/g, ""));
    // },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    // 录入快递单号提交
    enterCoutierSubmit() {
      let params = {
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      };
      // console.log("enterCoutierRowData", this.enterCoutierRowData);
      // console.log("录入快递单信息参数", params);
      let fn = markingSendStatusLockRight;
      if (this.rowData.activityType == 9) {
        fn = markingSendStatus;
        params.recordId = this.enterCoutierRowData.id;
      } else {
        params.id = this.enterCoutierRowData.id;
      }
      fn(params)
        .then((res) => {
          console.log("markingSendStatusLockRight", res);
          if (res.code == 1) {
            if (this.rowData.activityType == 9) {
              this.$message.success("录入快递单号成功");
              this.getList();
            } else {
              this.inKingRecord();
            }
            // 标记发货
            // this.markIss(this.enterCoutierRowData).then(()=>{
            // 置空录入快递单号输入框
            this.blankEnterCoutierNum();
            // });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("录入快递单号失败");
        });
    },
    // 打榜有礼领奖记录标记发放
    chongBangAwardMark(row) {
      this.markIss(row);
    },
    // 打榜有礼发货弹框回调
    // 录入快递单号提交
    goodsEnterCoutierSubmit() {
      let params = {
        id: this.enterCoutierRowData.id,
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      };
      // console.log("enterCoutierRowData", this.enterCoutierRowData);
      // console.log("录入快递单信息参数", params);
      markingSendStatusLockRight(params)
        .then((res) => {
          console.log("markingSendStatusLockRight", res);
          if (res.code == 1) {
            // 标记发货
            // this.markIss(this.enterCoutierRowData).then(()=>{
            // 置空录入快递单号输入框
            this.blankEnterCoutierNum();
            // 刷新列表
            this.getGoodsRecord();
            // });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("录入快递单号失败");
        });
    },

    // 打榜有礼实物标记发货
    chongBangPhysicalMark(row) {
      // 回显数据
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.sendOutGoodsShow = true;
    },
    // 打榜有礼批量发货
    physicalBatchShipment() {
      // console.log("1111");
      this.physicalBatchShipmentShow = true;
    },
    physicalBatchShipmentClose() {
      this.physicalBatchShipmentShow = false;
      this.downloadResData = {};
      this.downloadUserList = [];
      this.handleClick(this.actTab);
      // TODO: 清空上传信息
      // this.downloadResData = {};
      // this.downloadUserList  = [];
    },
    // 打榜有礼批量发货弹框确认按钮
    physicalBatchShipmentSubmit() {
      // TODO: 清空上传列表，刷新表格
      // this.fileList = [];
      this.downloadResData = {};
      this.downloadUserList = [];
      // this.searchInkind();
    },
    // 上传文件回调
    handleUpload(res) {
      console.log("res", res);
      // 上传文件
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.downloadResData = res.data;
        this.downloadUserList = res.data.failUserName;
      } else {
        this.$message.error(res.message);
      }
    },
    handleUpload1(res) {
      console.log("res", res);
      // 上传文件
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.downloadResData1 = res.data;
        this.downloadUserList1 = res.data.failUserName;
      }
    },
    // 上传文件处理
    beforeUploadFile(file) {
      this.loading = true;
    },
    beforeUploadFile1(file) {
      this.loading = true;
    },
    chongBangExport() {
      this.chongBangExportDialogShow = true;
      // export_get
    },
    // 下载模板
    handleDownloadTemplate() {
      let url = "";
      if (this.fitersChooseIF([36])) {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx";
      } else {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      }
      let fileName = "实物奖品名单批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    handleDownloadTemplate1() {
      let url = "";
      if (this.fitersChooseIF([36])) {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx";
      } else {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      }
      let fileName = "实物奖品名单批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // 切换商品名称列展开/收起状态 - 直接操作DOM，按钮固定不销毁，事件不会丢失
    toggleGoodsNameExpand(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      // 切换状态变量，控制表格内容行的展开/收起
      this.goodsNameColumnExpanded = !this.goodsNameColumnExpanded;
      // 直接修改按钮文字，同步状态
      e.target.innerText = this.goodsNameColumnExpanded ? '【收起】' : '【展开】';
    },
    // 锁权订单表格单独的展开切换
    toggleGoodsNameExpand1(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      // 切换状态变量
      this.goodsNameColumnExpanded1 = !this.goodsNameColumnExpanded1;
      // 直接修改当前点击按钮的文字，不用找所有按钮，精准修改
      e.target.innerText = this.goodsNameColumnExpanded1 ? '【收起】' : '【展开】';
    },
    getOrderDetail() {
      this.loading = true;
      const params = {
        ...this.orderDetailInfoPage,
        ...this.orderDetaiInfolForm,
      }
      let orderApi = orderDetailPage;
      if(this.fitersChooseIF([9])) {
        orderApi = pointOrderDetailPage;
      }
      orderApi(params)
        .then((res) => {
          this.loading = false;
          this.orderDetailData = res.data.records;
          this.orderDetailInfoTotal = Number(res.data.total);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 订单明细搜索
    searchOrderDetail() {
      if(this.orderDetaiInfolForm.orderState && this.orderDetaiInfolForm.orderState.length) {
        // 不等于全部
        if(!this.orderDetaiInfolForm.orderState.some((item) => !item)) {
          this.orderDetaiInfolForm.orderState = this.orderDetaiInfolForm.orderState.join(",");
        }
      }
       if (this.orderDetaiInfolForm && this.orderDetaiInfolForm.orderVenderId&&this.fitersChooseIF([19,16,17,18])) {
        this.orderDetaiInfolForm.orderVenderId = this.orderDetaiInfolForm.orderVenderId;
      }
      // 保存查询参数到data，导出时使用
      this.formOrderDetailQuery = {...this.orderDetailInfoPage,...this.orderDetaiInfolForm};
      this.$refs.orderDetailOverviewRef1.getDataOverview({...this.orderDetailInfoPage,...this.orderDetaiInfolForm});
      this.getOrderDetail();
    },
    handlePageOrderDetail({pageNum,pageSize}) {
      this.orderDetailInfoPage.current = pageNum; 
      this.orderDetailInfoPage.size = pageSize;
      this.getOrderDetail()
    },
    searchConversionFun(data) {
      this.conversionPage.size = 10;
      this.conversionPage.current = 1;
      this.searchConversion(data);
    },
    resetConversionFun() {
      this.conversionForm.statDaysNum = 30;
      this.conversionForm.statType = 0;
      this.conversionForm.compareType = 0;
      this.conversionForm.orderAmount = null;
      this.conversionPage.size = 10;
      this.conversionPage.current = 1;
      this.$refs.export_funRef.reData();
      this.searchConversion({
        openCardStartTime: this.getDateStr(-30) + " 00:00:00",
        openCardEndTime: this.getDateStr(0) + " 23:59:59"
      });
    },
    // 入会分析
    searchConversion(val) {
      // 重置
      this.loading = true;
      const { size, current } = this.conversionPage;
      const query = {
        size,
        current,
        activityId: this.rowData.id,
        statType: this.conversionForm.statType,
        compareType: this.conversionForm.compareType,
        source: this.fitersChooseIF([9, 10, 29, 30, 38]) ? 2 : 1
      };
      if (this.conversionForm.statDaysNum) {
        query.statDaysNum = this.conversionForm.statDaysNum;
      }
      if (this.conversionForm.orderAmount) {
        query.orderAmount = this.conversionForm.orderAmount;
      }
      if (val && val.openCardStartTime) {
        query.openCardStartTime = val.openCardStartTime;
      }
      if (val && val.openCardEndTime) {
        query.openCardEndTime = val.openCardEndTime;
      }
      query.sellerLinkId = val.sellerLinkId;
      this.memberAnalysisSearchQuery = query;
      memConvAnalysis(query)
        .then((res) => {
          this.loading = false;
          this.conversionData = res.data.records;
          this.conversionPage.total = Number(res.data.total);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 入会用户转化分析-数量
    handleSizeConversion(size) {
      this.conversionPage.size = size;
      this.searchConversion();
    },
    // 入会用户转化分析-页数
    handleCurrentConversion(current) {
      this.conversionPage.current = current;
      this.searchConversion();
    },
    handlePageConversion(pageInfo) {
      this.conversionPage.size = pageInfo.pageSize;
      this.conversionPage.current = pageInfo.pageNum;
      this.searchConversion(this.memberAnalysisSearchQuery);
    },

    // 切换版本
    triggerVersion() {
      this.$emit("triggerVersion", false);
    },
    // 撤回发货（积分兑换）
    revocationIntergralGoods(row) {
      this.$confirm(
        `您的订单状态为${
          row.deliveryStatus === 1 ? "待发货" : "已发货"
        }，是否进行撤回！`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass: "iconfont iconicon-jinggao1",
          customClass: "reverse-buttons",
        }
      ).then((res) => {
        pointsExchangeQuash({
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("撤回成功");
            this.getList();
          } else {
            this.$message.success(res.message);
          }
        });
      });
    },
    // 撤回发货（实物奖品）
    revocationDeliverGoods(row) {
      this.$confirm(
        `您的奖品状态为${
          row.prizeStatus === 2 || row.prizeStatus === 7 ? "未发放" : "已发放"
        }，是否进行撤回！`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass: "iconfont iconicon-jinggao1",
          customClass: "reverse-buttons",
        }
      ).then((res) => {
        purchaseActivityWithdraw({
          recordId: row.recordId,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("撤回奖品成功");
            this.inKingRecord();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 撤回奖品（积分加钱购）
    revocationAddMoneyGoods(row) {
      this.$confirm('确定撤回用户兑奖资格？',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass: "iconfont iconicon-jinggao1",
          customClass: "reverse-buttons",
        }
      ).then((res) => {
        quashAddMoney({
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("撤回奖品成功");
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 移除令牌
    removeToken(row) {
      this.$confirm('确定移除用户的令牌资格？',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass: "iconfont iconicon-jinggao1",
          customClass: "reverse-buttons",
        }
      ).then((res) => {
        removeUserPromoToken({
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("移除用户令牌资格成功");
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 获取领奖/中奖记录的表单配置
    getNewRewardInputData() {
      let self = this;
      function getInputConfig() {
        // 会员升级礼
        if ([44, 47, 48, 53,79,81,82].includes(self.rowData.activityType)) {
          return self.inputMemberUpGradeList;
        } else if (self.rowData.activityType == 45) {
          return self.inputPrizeLockList;
        } else {
          return self.inputAwardList;
        }
      }
      return this.rowData.activityType != 5
        ? getInputConfig()
        : this.inputAwardList1;
    },
    getMaterialInputData() {
      let self = this;
      function getInputConfig2() {
        // 会员升级礼
        if ([44, 47, 48, 53].includes(self.rowData.activityType)) {
          return self.inputMemberUpGradeMaterial;
        } else if (self.rowData.activityType == 51) {
          // 0元试用
          return self.zeroPrizeListForm;
        } else {
          return self.inputInkidNeedAward;
        }
      }
      return this.fitersChooseIF([16, 18, 17, 19, 27, 28, 44, 47, 48, 51])
        ? getInputConfig2()
        : this.inputInkind;
    },
    // 获取导出字段配置
    getExportFieldJsonConfig() {
      this.exportFieldLoading = true;
      getFieldJsonConfig()
        .then((res) => {
          this.exportFieldLoading = false;
          if (res.code == 200 || res.code == 1) {
            try {
              if (!res.data || res.data === "" || res.data === "undefined") {
                return;
              }
              if (
                !res.data.fieldJson ||
                res.data.fieldJson === "" ||
                res.data.fieldJson === "undefined"
              ) {
                return;
              }
              // 解析返回的 JSON 字符串
              const savedFields = JSON.parse(res.data.fieldJson);
              // 创建一个 Set，用于快速查找需要勾选的字段
              const selectedPropsSet = new Set();
              savedFields.forEach((field) => {
                selectedPropsSet.add(field.prop);
              });

              // 更新 exportFieldsData 中的 export 状态
              this.exportFieldsData.forEach((group) => {
                if (group.children) {
                  group.children.forEach((child) => {
                    // 如果这个字段的 prop 在接口返回的数据中，就勾选它
                    if (selectedPropsSet.has(child.prop)) {
                      child.export = true;
                    } else {
                      // 如果没有找到，说明它没有被选中（除了默认必选的字段）
                      if (!child.disabled) {
                        child.export = false;
                      }
                    }
                  });
                  // 更新父级分组的 export 状态
                  this.updateParentExportStatus2(group);
                }
              });
              console.log("导出字段配置已更新：", this.exportFieldsData);
            } catch (error) {
              console.log("--- error:---", error);
              this.$message.error("解析导出字段配置失败");
            }
          }
        })
        .catch((err) => {
          this.exportFieldLoading = false;
          this.$message.error("获取导出字段配置失败");
        });
    },
    // 当子项都勾选了, 父项也勾选
    updateParentExportStatus2(group) {
      if (group.children && group.children.length > 0) {
        // 检查是否有子项被选中
        const hasSelectedChildren = group.children.some(
          (child) => child.export
        );
        // 检查是否所有子项都被选中
        const allChildrenSelected = group.children.every(
          (child) => child.export
        );
        if (allChildrenSelected) {
          group.export = true;
        } else if (hasSelectedChildren) {
          // 部分选中状态，可以根据需要设置为 false 或保持当前状态
          group.export = false;
        } else {
          group.export = false;
        }
      }
    },
    exportRule(type, row) {
      if (type == "setting") {
        console.log("导出字段设置");
        this.exportSettingDialog = true;
      }
      if (type == "exportAll") {
        if (this.queryForm.evaluateTime == 0) {
          if (!this.postForm.startDate || !this.postForm.endDate) {
            this.$message.warning("自定义时间不能为空");
            return;
          }
        }
        this.exportType = 0;
        this.control8 = true;
      }
      if (type == "exportSetting") {
        console.log("按设置导出");
        if (this.queryForm.evaluateTime == 0) {
          if (!this.postForm.startDate || !this.postForm.endDate) {
            this.$message.warning("自定义时间不能为空");
            return;
          }
        }
        this.exportType = 1;
        this.control8 = true;
      }
    },
    // 处理导出字段保存
    handleExportFieldsSave(tempExportFieldsData) {
      // 将临时数据保存到正式数据
      this.exportFieldsData = JSON.parse(JSON.stringify(tempExportFieldsData));
      const selectedFields = this.generateExportFields(this.exportFieldsData);
      console.log("--- selectedFields:---", selectedFields);
      // 调用保存接口
      let params = {
        fieldJson: JSON.stringify(selectedFields),
        type: 1,
      };
      this.exportFieldLoading = true;
      saveFieldJsonConfig(params)
        .then((res) => {
          this.exportSettingDialog = false;
          if (res.code == 200 || res.code == 1) {
            this.$message.success("保存成功");
            // 重新获取导出字段配置
            this.getExportFieldJsonConfig();
          }
        })
        .catch((err) => {
          this.$message.error("保存失败");
          this.exportSettingDialog = false;
        });
    },
    // 处理导出字段弹窗关闭
    handleExportFieldsClose() {
      this.exportSettingDialog = false;
    },
    // 生成导出字段列表的通用方法
    generateExportFields(fieldsData) {
      if (!fieldsData || !Array.isArray(fieldsData)) {
        return [];
      }
      const selectedFields = [];
      fieldsData.forEach((parent) => {
        // 过滤掉group为'基础信息'的父级数据
        if (parent.group === "基础信息") {
          return;
        }
        if (parent.export && !parent.children) {
          selectedFields.push({
            prop: parent.prop,
            label: parent.label,
            group: parent.group || "",
          });
        }
        if (parent.children) {
          parent.children.forEach((child) => {
            if (child.export) {
              selectedFields.push({
                prop: child.prop,
                label: child.label,
                group: parent.group || "",
              });
            }
          });
        }
      });
      return selectedFields;
    },
    // 定时开奖-标记中奖
    showWinDialog(row) {
      this.freeTrialStatusVisibleRow = row;
      this.selectPrize = "";
      this.selectStep = "";
      this.isShowSignWin = true;
      this.getPrizeListFn();
    },
    // 定时开奖-奖品列表
    getPrizeListFn() {
      getTimePrizeDetail(this.rowData.id).then((res) => {
        let { ruleDto, pointActivityPrizeDTOList } = res.data;
        let prizeList = pointActivityPrizeDTOList.filter(
          (item) => item.prizeObjectType != 1
        );
        this.cumulativeType = ruleDto.prizeSettingType;
        if (ruleDto.prizeSettingType == 0) {
          this.signWinPrizeList = prizeList;
        } else {
          this.prizeSettingListStep = ruleDto.stepList.map((item) => {
            return {
              ...item,
              table: pointActivityPrizeDTOList.filter(
                (list) => list.taskIndex == item.taskIndex
              ),
            };
          });
        }
      });
    },
    // 确认标记
    signWin(row) {
      const param = {
        // pin: row.pin,
        [this.searchGrayId]: row[this.searchGrayId],
        prizeId: this.selectPrize,
        activityId: this.rowData.id,
        recordId: row.id,
      };
      markingStatus(param)
        .then((res) => {
          if (res.code != 1) {
            this.$message.error(res.message);
          } else {
            this.$message.success(res.message);
            this.isShowSignWin = false;
            this.getParticipationOpenWin();
          }
        })
        .catch((res) => {
          this.$message.error(res.data.message);
        });
    },
    // 跳转幸运值记录
    goToLuckList(row) {
      this.activeName = "luckRecord";
      this.$nextTick(() => {
        if (this.$refs.inputLuckRef) {
          this.$refs.inputLuckRef.form.memberNick = row.memberNick;
        }
        this.formLuck.memberNick = row.memberNick
        this.getLuckList()
      })
    },
    // 跳转幸运值记录
    goToCheckInDetail(row){
      this.activeName = 'checkInDetail'
      this.$nextTick(()=>{
        if(this.$refs.checkInDetailRef){
          this.$refs.checkInDetailRef.initSearch(row);
        }
      })
    },
    // 添加晒单资料
    addShowData() {
      this.showEditDialog = true;
      this.editDialogType = 'add';
      this.currentEditData = {};
    },
    // 修改资料
    editShowData(row, index) {
      console.log("--- ~ row:---", row)
      this.$decryptBatch
        .decrypt([
          row.mobile,
          row.address,
          row.detailedAddress,
          row.name
        ])
        .then((res) => {
          if (res.code == 1) {
            this.currentEditData = {
              id: row.id,
              "customerPin": row[this.chaosParams],
              "memberNick": row.chaosMemberNick,
              "name": res.data[3],
              "orderId": row.orderId,
              "address": res.data[1],
              "mobile": res.data[0],
              "detailedAddress": res.data[2],
              "commentImage": row.commentImage,
            };
            this.infoNamesIndex = index;
            if (row.staticInfoNames) {
              this.expendFields = this.postOrderInfoTable[this.infoNamesIndex]
            } else {
              this.expendFields = { staticInfoNames: this.staticInfoNamesInfo }
            }
            this.editDialogType = 'edit';
            this.showEditDialog = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    handleEditClose() {
      this.showEditDialog = false;
    },
    handleUpdateList() {
      this.searchPostUserInfo({});
    },
    toggleRow(row) {
      if (this.expandedRows.includes(row.id)) {
        // 如果已经展开，则收起
        this.expandedRows = this.expandedRows.filter(id => id !== row.id);
      } else {
        // 如果未展开，则展开
        this.expandedRows.push(row.id);
      }
    },
    // 处理行展开状态变化
    handleRowExpand(row, expandedRows) {
      this.expandedRows = expandedRows.map(item => item.id);
    }
  },
};
</script>
<style lang="scss">
.el-popover {
  min-width: 100px !important;
}
.lock_message_box {
  .el-message-box__content {
    display: flex;
    align-items: center;
    padding: 20px 60px !important;
  }
  .el-message-box__container {
    width: 80px;
    text-align: right;
  }
  .el-message-box__input {
    flex: 1;
    padding-top: 0;
  }
  .el-message-box__errormsg {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.y1,
.y2,
.y3,
.y4 {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 17px;
  margin-right: 5px;
}
.y1 {
  color: #5b5b5b;
  background-color: #f1f1f1;
}
.y2 {
  color: #02b1ff;
  background: #e6f7ff;
}
.y3 {
  color: #f56c6c;
  background-color: #fef0f0;
}
.y4 {
  color: #67c23a;
  background-color: #f0f9eb;
}

.commend-img-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .commend-img {
    width: 50px;
    height: 50px;
    margin-right: 4px;
    margin-top: 4px;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
  }
}
.user-info-statics {
  display: flex;
  align-items: center;
  font-weight: 600;
  .user-info-statics-item {
    font-weight: 400;
    margin-left: 10px;
    color: #333;
    font-size: 14px;
  }
}
.conversion {
  margin-bottom: 15px;
  &-compareType,
  &-orderMoney {
    width: 110px;
    margin-right: 300px;
  }
  &-statDaysNum,
  &-statType {
    width: 290px;
  }
  &-compareType {
    margin: 0px 10px;
  }
}
.award-title {
  font-weight: bold;
  margin-bottom: 16px;
}
.data-title-wrap {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  .back_text {
    margin-left: 10px;
    color: #2768ff;
    cursor: pointer;
  }
}
.switch {
  margin-top: 16px;
  &-tabs {
    /deep/.el-tabs__header {
      margin-bottom: 0px;
    }
  }
}
// el-table__header-wrapper"
.actName {
  margin-top: 16px;
  // padding: 0 0 0 24px;
  display: flex;
  &_img {
    width: 60px;
    height: 60px;
  }
  &_info {
    div {
      margin-top: 14px;
    }
  }
}
.delivery {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
}
.backBtn {
  margin-left: 20px;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background: rgba(254, 77, 69, 0.1);
  }
  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background: rgba(254, 77, 69, 0.1);
  }
}
.keepBtn {
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #fe4d45;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-label2 {
        display: inline-block;
        width: 100px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: right;
  }
}
.imgurl {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-right: 7px;
  img {
    width: 80px;
  }
}
.referenceButton {
  cursor: pointer;
  &:hover {
    color: #7b61ff;
  }
}
.referencePopover {
  display: flex;
  span {
    display: block;
    margin-right: 20px;
  }
  span:last-child {
    margin-right: 0px;
  }
}
.decryptHover {
  display: none;
  margin-left: 4px;
  background: none;
}
.decrypt {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
.decrypt:hover .decryptHover {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background: none;
}

.question_iconOne {
  width: 13px;
  height: 13px;
  display: inline-block;
  line-height: 13px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 4px;
  color: #ccc;
}
.titClass {
  padding: 36px 24px;
  // margin: 35px;
  margin-bottom: 25px;
  background: #fafafa;
  opacity: 1;
  display: flex;
  align-items: center;
  line-height: 22px;
  position: relative;
  .titClassOne {
    margin: 0px 100px 0px 30px;
  }
  .down {
    margin-right: 30px;
  }
  .borderU {
    position: absolute;
    width: 1px;
    height: 110px;
    background: #f3f3f3;
    left: 122px;
  }
}
.acitvityAll {
  background: #fff;
  // padding-bottom: 20px;
  // border-radius: 0 0 16px 16px;
  padding: 16px;
  height: 100%;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      cursor: default;
    }
  }
  .formSty {
    margin-top: 24px;
    height: calc(100% - 160px);
    ::v-deep(.el-tabs__content) {
      height: calc(100% - 40px);
      overflow-y: auto;
      // scrollbar-width: none;
      // -ms-overflow-style: none;
      // &::-webkit-scrollbar {
      //   width: 0;
      //   height: 0;
      //   display: none;
      // }
    }
    .question_icon {
      width: 15px;
      height: 15px;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #ccc;
      font-size: 14px !important;
      font-weight: normal !important;
      margin-left: 4px;
    }

    .section-right-content-box {
      height: 100%;
      // min-width: 1000px;
      // border-bottom: 6px;
      // padding: 15px 28px 30px 28px;
      // background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      // opacity: 1;
      // -webkit-box-sizing: border-box;
      // -moz-box-sizing: border-box;
      // box-sizing: border-box;
      // margin: 0 20px 20px 20px;
      .tabList {
        display: flex;
        box-sizing: border-box;
        height: 36px;
        line-height: 35px;
        // margin-top: 20px;
        color: #666;
        font-size: 14px;
        margin: 20px 0;
        span {
          margin-right: 3px;
          width: 106px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          vertical-align: middle;
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          border-radius: 2px 2px 0px 0px;
          border: 1px solid #dddddd;
          text-align: center;
        }
        .active {
          position: relative;
          transition: all 0.2s;
          color: #7b61ff;
          border-bottom: none;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            top: 0;
            height: 2px;
            background: #7b61ff;
            border-radius: 6px 6px 0px 0px;
          }
        }
        i {
          flex: 1;
          border-bottom: 1px solid #dddddd;
          margin-left: -3px;
        }
      }
      .b1 {
        width: 98px;
        height: 32px;
        color: #fff;
        border: 1px solid #fe4d45;
        background-color: #fe4d45;
        &:hover {
          opacity: 0.8;
        }
      }
      .b2 {
        width: 98px;
        height: 32px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fe4d45;
          background-color: #fe4d45;
        }
      }
      .background {
        height: 32px;
        background: rgba(250, 250, 250, 1);
        opacity: 1;
        line-height: 32px;
        padding-left: 12px;
        .title {
          display: inline-block;
          width: 2px;
          height: 14px;
          background: #fe4d45;
          opacity: 1;
          border-radius: 3px;
          vertical-align: middle;
        }
        .tips {
          width: 56px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
          vertical-align: middle;
        }
      }

      .overview1 {
        padding: 26px 30px 22px 30px;
        width: 20%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;
        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }
        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 29px;
          color: #1f1f1f;
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }
      /** 打榜有礼 */
      .overview2 {
        padding: 26px 30px 22px 30px;
        width: 18%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;
        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }
        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 29px;
          // color: #2768FF;
          color: #1f1f1f;
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }

      .chart {
        // flex: 1;
        height: 380px;
        min-width: 1100px;
      }
      .chart2 {
        // flex: 1;
        height: 450px;
        min-width: 1100px;
      }
    }
  }
  /deep/ .el-table .two-line {
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

/* 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 118, 0, 0.1);
  margin-left: 10px;
  font-size: 14px;
  // font-family: "Microsoft YaHei";
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 118, 0, 1);
}
.hug-send {
  // overflow: hidden;
  margin-top: 10px;
  height: 32px;
  display: flex;
  align-items: center;

  .send-left {
    float: left;
    height: 32px;
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }
  .send-right {
    float: left;
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
    width: 280px;
    height: 100%;
    .send-ipnut {
      display: flex;
      width: 100%;
      height: 32px;
      line-height: 32px;
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      text-indent: 6px;
    }
  }
  .send-right2 {
    height: 32px;
    // border-bottom: 2px solid rgba(245, 245, 245, 1);
  }
  .codeBtn {
    width: 170px;
    display: inline-block;
    line-height: 32px;
    height: 32px;
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    color: rgba(51, 51, 51, 1);
    outline-style: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding-left: 6px;
  }
  .getNumber {
    display: inline-block;
    width: 100px;
    // border: none;
    // background: none;
    outline-style: none;
    color: #7b61ff;
    line-height: 32px;
    color: #fff;
    background: #7b61ff;
    border: 1px solid #7b61ff;
    margin-left: 10px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
  }
  .getNumber-Disabled {
    color: rgba(51, 51, 51, 0.2) !important;
    border-color: rgba(51, 51, 51, 0.2) !important;
    cursor: no-drop;
  }
  .msg {
    font-size: 14px;
    // font-family: "Microsoft YaHei";
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 14px;
    color: #7b61ff;
    text-align: center;
  }
}
.dialogExprot-btn {
  width: 100%;
  display: inline-flex;
  justify-content: center;
  > span {
    display: inline-flex;
    width: 98px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 14px;
    border-radius: 5px;
    margin-right: 8px;
    cursor: pointer;
  }
  > span:nth-of-type(1) {
    background: #7b61ff;
    color: #fff;
    border-color: #7b61ff;
  }
}
.addCartDetail {
  display: flex;
  align-items: center;
  img {
    max-width: 60px;
    border-radius: 5px;
  }
  > div:nth-of-type(1) {
    flex: 1;
  }
  > div:nth-of-type(2) {
    flex: 5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //设置超出几行省略内容
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.goodsInfo {
  padding: 5px 0;
  display: flex;
  align-items: center;
  &_logo {
    display: flex;
    width: 80px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 70px;
      border-radius: 4px;
    }
  }
  &_text {
    flex: 1;
    color: #666666;
    cursor: pointer;
    margin-left: 5px;
    a {
      color: #666666;
      margin-top: 5px;
    }
  }
}
.enter_coutier_num_dialog {
  .enter_coutier_num_dialog_floor {
    text-align: right;
    width: 100%;
    // height: 50px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
}

.physical_batch_shipment_dialog {
  .upload-demo {
    /deep/ .el-upload .el-upload-dragger {
      width: 250px;
    }
  }
  .download_template_box {
    position: absolute;
    right: 24px;
    top: 17%;
  }
  .downloadMsgBox {
    width: 100%;
    min-height: 100px;
  }
  .physical_batch_shipment_dialog_floor {
    text-align: right;
    width: 100%;
    // height: 50px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
}
.info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 8px;
  .img-parent {
    margin-left: 4px;
    margin-top: 4px;
    // margin-right: 8px;
    height: 50px;
    position: relative;
    display: inline-block;
    &:hover {
      cursor: pointer;
      .mask {
        opacity: 1;
      }
    }
    .mask {
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      // width: 84px;
      // height: 50px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: all 0.3s;
      i {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
      }
    }
    .info-img {
      width: 50px;
      height: 50px;
      // margin-right: 12px;
    }
  }
}
.bigImg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 99;
  img {
    height: 80%;
  }
  i {
    cursor: pointer;
    margin-top: 12px;
    font-size: 25px;
    color: #fff;
  }
}
.remark-tip {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; //设置超出几行省略内容
  text-overflow: ellipsis;
  overflow: hidden;
}
.flex-box {
  display: flex;
}
.export-style {
  text-align: right;
}
.active-tip {
  color: #f89f39;
}

.width-160 {
  width: 156px;
}

.margin-r8 {
  margin-right: 8px;
}
.ml2 {
  margin-left: 2px;
}
/deep/ .image-container:hover .image-overlay {
  display: flex !important;
}

.operate-wrap{
  margin-bottom: 12px;
}

/* 禁用状态颜色置灰样式 */
.disabled-style {
  color: #C0C4CC !important;
  cursor: not-allowed !important;
}
.demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .export-btn {
    text-align: right;
  }
.order-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

/* 商品名称列展开收起样式 */
.header-expand-btn {
  padding: 0 0 0 4px !important;
  font-size: 12px !important;
  color: #3159FF !important;
}

.goods-name-text {
  word-break: break-all;
  line-height: 20px;
}

/* 收起状态：单行省略 */
.goods-name-text.ellipsis-single {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .firstNewTab .el-tabs__header {
  padding-left: 16px;
}
.upload-box {
  margin-top: 16px;
  display: flex;
  justify-content: end;
}
.id-icon {
  cursor: pointer;
  width: 18px;
  height: 18px;
  margin-top: 4px;
  margin-top: 7px;
}
/* 展开状态：显示2行省略 */
// .goods-name-text.ellipsis-double {
//   display: -webkit-box;
//   -webkit-box-orient: vertical;
//   -webkit-line-clamp: 2;
//   line-clamp: 2;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
</style>
